(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree1fe"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree1fe"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jIgWH", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e59f457751cca0bb$export$ffb0004e005737fa; }, function (v) { return $e59f457751cca0bb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e59f457751cca0bb$export$34b9dba7ce09269b; }, function (v) { return $e59f457751cca0bb$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e59f457751cca0bb$export$25062201e9e25d76; }, function (v) { return $e59f457751cca0bb$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e59f457751cca0bb$export$ffb0004e005737fa;
var $e59f457751cca0bb$export$34b9dba7ce09269b;
var $e59f457751cca0bb$export$25062201e9e25d76;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
var $e59f457751cca0bb$var$k = Symbol.for("react.element"), $e59f457751cca0bb$var$l = Symbol.for("react.fragment"), $e59f457751cca0bb$var$m = Object.prototype.hasOwnProperty, $e59f457751cca0bb$var$n = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e59f457751cca0bb$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e59f457751cca0bb$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e59f457751cca0bb$var$m.call(a, b) && !$e59f457751cca0bb$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e59f457751cca0bb$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e59f457751cca0bb$var$n.current
    };
}
$e59f457751cca0bb$export$ffb0004e005737fa = $e59f457751cca0bb$var$l;
$e59f457751cca0bb$export$34b9dba7ce09269b = $e59f457751cca0bb$var$q;
$e59f457751cca0bb$export$25062201e9e25d76 = $e59f457751cca0bb$var$q;

});
parcelRegister("dQFEZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4SjaJ"));

});
parcelRegister("4SjaJ", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $38cb13c5a0250553$export$dca3b0875bd9a954; }, function (v) { return $38cb13c5a0250553$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $38cb13c5a0250553$export$16fa2f45be04daa8; }, function (v) { return $38cb13c5a0250553$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $38cb13c5a0250553$export$ffb0004e005737fa; }, function (v) { return $38cb13c5a0250553$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $38cb13c5a0250553$export$e2c29f18771995cb; }, function (v) { return $38cb13c5a0250553$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $38cb13c5a0250553$export$221d75b3f55bb0bd; }, function (v) { return $38cb13c5a0250553$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $38cb13c5a0250553$export$5f8d39834fd61797; }, function (v) { return $38cb13c5a0250553$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $38cb13c5a0250553$export$74bf444e3cd11ea5; }, function (v) { return $38cb13c5a0250553$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $38cb13c5a0250553$export$ae55be85d98224ed; }, function (v) { return $38cb13c5a0250553$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $38cb13c5a0250553$export$3ba232387fd5d6dd; }, function (v) { return $38cb13c5a0250553$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $38cb13c5a0250553$export$e530037191fcd5d7; }, function (v) { return $38cb13c5a0250553$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $38cb13c5a0250553$export$fd42f52fd3ae1109; }, function (v) { return $38cb13c5a0250553$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $38cb13c5a0250553$export$c8a8987d4410bf2d; }, function (v) { return $38cb13c5a0250553$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $38cb13c5a0250553$export$d38cd72104c1f0e9; }, function (v) { return $38cb13c5a0250553$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $38cb13c5a0250553$export$7d1e3a5e95ceca43; }, function (v) { return $38cb13c5a0250553$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $38cb13c5a0250553$export$257a8862b851cb5b; }, function (v) { return $38cb13c5a0250553$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $38cb13c5a0250553$export$a8257692ac88316c; }, function (v) { return $38cb13c5a0250553$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $38cb13c5a0250553$export$488013bae63b21da; }, function (v) { return $38cb13c5a0250553$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $38cb13c5a0250553$export$7c73462e0d25e514; }, function (v) { return $38cb13c5a0250553$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $38cb13c5a0250553$export$7568632d0d33d16d; }, function (v) { return $38cb13c5a0250553$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $38cb13c5a0250553$export$88948ce120ea2619; }, function (v) { return $38cb13c5a0250553$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $38cb13c5a0250553$export$35808ee640e87ca7; }, function (v) { return $38cb13c5a0250553$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $38cb13c5a0250553$export$fae74005e78b1a27; }, function (v) { return $38cb13c5a0250553$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e; }, function (v) { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $38cb13c5a0250553$export$6a7bc4e911dc01cf; }, function (v) { return $38cb13c5a0250553$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $38cb13c5a0250553$export$6d9c69b0de29b591; }, function (v) { return $38cb13c5a0250553$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $38cb13c5a0250553$export$f680877a34711e37; }, function (v) { return $38cb13c5a0250553$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $38cb13c5a0250553$export$d5a552a76deda3c2; }, function (v) { return $38cb13c5a0250553$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $38cb13c5a0250553$export$aaabe4eda9ed9969; }, function (v) { return $38cb13c5a0250553$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $38cb13c5a0250553$export$e5c5a5f917a5871c; }, function (v) { return $38cb13c5a0250553$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $38cb13c5a0250553$export$1538c33de8887b59; }, function (v) { return $38cb13c5a0250553$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $38cb13c5a0250553$export$13e3392192263954; }, function (v) { return $38cb13c5a0250553$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $38cb13c5a0250553$export$b8f5890fc79d6aca; }, function (v) { return $38cb13c5a0250553$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $38cb13c5a0250553$export$60241385465d0a34; }, function (v) { return $38cb13c5a0250553$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $38cb13c5a0250553$export$306c0aa65ff9ec16; }, function (v) { return $38cb13c5a0250553$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $38cb13c5a0250553$export$7b286972b8d8ccbf; }, function (v) { return $38cb13c5a0250553$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $38cb13c5a0250553$export$83d89fbfd8236492; }, function (v) { return $38cb13c5a0250553$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $38cb13c5a0250553$export$dca3b0875bd9a954;
var $38cb13c5a0250553$export$16fa2f45be04daa8;
var $38cb13c5a0250553$export$ffb0004e005737fa;
var $38cb13c5a0250553$export$e2c29f18771995cb;
var $38cb13c5a0250553$export$221d75b3f55bb0bd;
var $38cb13c5a0250553$export$5f8d39834fd61797;
var $38cb13c5a0250553$export$74bf444e3cd11ea5;
var $38cb13c5a0250553$export$ae55be85d98224ed;
var $38cb13c5a0250553$export$3ba232387fd5d6dd;
var $38cb13c5a0250553$export$e530037191fcd5d7;
var $38cb13c5a0250553$export$fd42f52fd3ae1109;
var $38cb13c5a0250553$export$c8a8987d4410bf2d;
var $38cb13c5a0250553$export$d38cd72104c1f0e9;
var $38cb13c5a0250553$export$7d1e3a5e95ceca43;
var $38cb13c5a0250553$export$257a8862b851cb5b;
var $38cb13c5a0250553$export$a8257692ac88316c;
var $38cb13c5a0250553$export$488013bae63b21da;
var $38cb13c5a0250553$export$7c73462e0d25e514;
var $38cb13c5a0250553$export$7568632d0d33d16d;
var $38cb13c5a0250553$export$88948ce120ea2619;
var $38cb13c5a0250553$export$35808ee640e87ca7;
var $38cb13c5a0250553$export$fae74005e78b1a27;
var $38cb13c5a0250553$export$dc8fbce3eb94dc1e;
var $38cb13c5a0250553$export$6a7bc4e911dc01cf;
var $38cb13c5a0250553$export$6d9c69b0de29b591;
var $38cb13c5a0250553$export$f680877a34711e37;
var $38cb13c5a0250553$export$d5a552a76deda3c2;
var $38cb13c5a0250553$export$aaabe4eda9ed9969;
var $38cb13c5a0250553$export$e5c5a5f917a5871c;
var $38cb13c5a0250553$export$1538c33de8887b59;
var $38cb13c5a0250553$export$13e3392192263954;
var $38cb13c5a0250553$export$b8f5890fc79d6aca;
var $38cb13c5a0250553$export$60241385465d0a34;
var $38cb13c5a0250553$export$306c0aa65ff9ec16;
var $38cb13c5a0250553$export$7b286972b8d8ccbf;
var $38cb13c5a0250553$export$83d89fbfd8236492;
"use strict";
var $38cb13c5a0250553$var$l = Symbol.for("react.element"), $38cb13c5a0250553$var$n = Symbol.for("react.portal"), $38cb13c5a0250553$var$p = Symbol.for("react.fragment"), $38cb13c5a0250553$var$q = Symbol.for("react.strict_mode"), $38cb13c5a0250553$var$r = Symbol.for("react.profiler"), $38cb13c5a0250553$var$t = Symbol.for("react.provider"), $38cb13c5a0250553$var$u = Symbol.for("react.context"), $38cb13c5a0250553$var$v = Symbol.for("react.forward_ref"), $38cb13c5a0250553$var$w = Symbol.for("react.suspense"), $38cb13c5a0250553$var$x = Symbol.for("react.memo"), $38cb13c5a0250553$var$y = Symbol.for("react.lazy"), $38cb13c5a0250553$var$z = Symbol.iterator;
function $38cb13c5a0250553$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $38cb13c5a0250553$var$z && a[$38cb13c5a0250553$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $38cb13c5a0250553$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $38cb13c5a0250553$var$C = Object.assign, $38cb13c5a0250553$var$D = {};
function $38cb13c5a0250553$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
$38cb13c5a0250553$var$E.prototype.isReactComponent = {};
$38cb13c5a0250553$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$38cb13c5a0250553$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $38cb13c5a0250553$var$F() {}
$38cb13c5a0250553$var$F.prototype = $38cb13c5a0250553$var$E.prototype;
function $38cb13c5a0250553$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
var $38cb13c5a0250553$var$H = $38cb13c5a0250553$var$G.prototype = new $38cb13c5a0250553$var$F;
$38cb13c5a0250553$var$H.constructor = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$var$C($38cb13c5a0250553$var$H, $38cb13c5a0250553$var$E.prototype);
$38cb13c5a0250553$var$H.isPureReactComponent = !0;
var $38cb13c5a0250553$var$I = Array.isArray, $38cb13c5a0250553$var$J = Object.prototype.hasOwnProperty, $38cb13c5a0250553$var$K = {
    current: null
}, $38cb13c5a0250553$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $38cb13c5a0250553$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$38cb13c5a0250553$var$J.call(b, d) && !$38cb13c5a0250553$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $38cb13c5a0250553$var$K.current
    };
}
function $38cb13c5a0250553$var$N(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $38cb13c5a0250553$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $38cb13c5a0250553$var$l;
}
function $38cb13c5a0250553$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $38cb13c5a0250553$var$P = /\/+/g;
function $38cb13c5a0250553$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $38cb13c5a0250553$var$escape("" + a.key) : b.toString(36);
}
function $38cb13c5a0250553$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $38cb13c5a0250553$var$l:
                case $38cb13c5a0250553$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $38cb13c5a0250553$var$Q(h, 0) : d, $38cb13c5a0250553$var$I(c) ? (e = "", null != a && (e = a.replace($38cb13c5a0250553$var$P, "$&/") + "/"), $38cb13c5a0250553$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($38cb13c5a0250553$var$O(c) && (c = $38cb13c5a0250553$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($38cb13c5a0250553$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($38cb13c5a0250553$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $38cb13c5a0250553$var$Q(k, g);
        h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    }
    else if (f = $38cb13c5a0250553$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $38cb13c5a0250553$var$Q(k, g++), h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $38cb13c5a0250553$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $38cb13c5a0250553$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $38cb13c5a0250553$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $38cb13c5a0250553$var$U = {
    current: null
}, $38cb13c5a0250553$var$V = {
    transition: null
}, $38cb13c5a0250553$var$W = {
    ReactCurrentDispatcher: $38cb13c5a0250553$var$U,
    ReactCurrentBatchConfig: $38cb13c5a0250553$var$V,
    ReactCurrentOwner: $38cb13c5a0250553$var$K
};
function $38cb13c5a0250553$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$38cb13c5a0250553$export$dca3b0875bd9a954 = {
    map: $38cb13c5a0250553$var$S,
    forEach: function forEach(a, b, e) {
        $38cb13c5a0250553$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $38cb13c5a0250553$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $38cb13c5a0250553$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$38cb13c5a0250553$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$38cb13c5a0250553$export$16fa2f45be04daa8 = $38cb13c5a0250553$var$E;
$38cb13c5a0250553$export$ffb0004e005737fa = $38cb13c5a0250553$var$p;
$38cb13c5a0250553$export$e2c29f18771995cb = $38cb13c5a0250553$var$r;
$38cb13c5a0250553$export$221d75b3f55bb0bd = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$export$5f8d39834fd61797 = $38cb13c5a0250553$var$q;
$38cb13c5a0250553$export$74bf444e3cd11ea5 = $38cb13c5a0250553$var$w;
$38cb13c5a0250553$export$ae55be85d98224ed = $38cb13c5a0250553$var$W;
$38cb13c5a0250553$export$3ba232387fd5d6dd = $38cb13c5a0250553$var$X;
$38cb13c5a0250553$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $38cb13c5a0250553$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $38cb13c5a0250553$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$38cb13c5a0250553$var$J.call(b, f) && !$38cb13c5a0250553$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$38cb13c5a0250553$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $38cb13c5a0250553$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $38cb13c5a0250553$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$38cb13c5a0250553$export$c8a8987d4410bf2d = $38cb13c5a0250553$var$M;
$38cb13c5a0250553$export$d38cd72104c1f0e9 = function(a) {
    var b = $38cb13c5a0250553$var$M.bind(null, a);
    b.type = a;
    return b;
};
$38cb13c5a0250553$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$38cb13c5a0250553$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$v,
        render: a
    };
};
$38cb13c5a0250553$export$a8257692ac88316c = $38cb13c5a0250553$var$O;
$38cb13c5a0250553$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $38cb13c5a0250553$var$T
    };
};
$38cb13c5a0250553$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$38cb13c5a0250553$export$7568632d0d33d16d = function(a) {
    var b = $38cb13c5a0250553$var$V.transition;
    $38cb13c5a0250553$var$V.transition = {};
    try {
        a();
    } finally{
        $38cb13c5a0250553$var$V.transition = b;
    }
};
$38cb13c5a0250553$export$88948ce120ea2619 = $38cb13c5a0250553$var$X;
$38cb13c5a0250553$export$35808ee640e87ca7 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useCallback(a, b);
};
$38cb13c5a0250553$export$fae74005e78b1a27 = function(a) {
    return $38cb13c5a0250553$var$U.current.useContext(a);
};
$38cb13c5a0250553$export$dc8fbce3eb94dc1e = function() {};
$38cb13c5a0250553$export$6a7bc4e911dc01cf = function(a) {
    return $38cb13c5a0250553$var$U.current.useDeferredValue(a);
};
$38cb13c5a0250553$export$6d9c69b0de29b591 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useEffect(a, b);
};
$38cb13c5a0250553$export$f680877a34711e37 = function() {
    return $38cb13c5a0250553$var$U.current.useId();
};
$38cb13c5a0250553$export$d5a552a76deda3c2 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useImperativeHandle(a, b, e);
};
$38cb13c5a0250553$export$aaabe4eda9ed9969 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useInsertionEffect(a, b);
};
$38cb13c5a0250553$export$e5c5a5f917a5871c = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useLayoutEffect(a, b);
};
$38cb13c5a0250553$export$1538c33de8887b59 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useMemo(a, b);
};
$38cb13c5a0250553$export$13e3392192263954 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useReducer(a, b, e);
};
$38cb13c5a0250553$export$b8f5890fc79d6aca = function(a) {
    return $38cb13c5a0250553$var$U.current.useRef(a);
};
$38cb13c5a0250553$export$60241385465d0a34 = function(a) {
    return $38cb13c5a0250553$var$U.current.useState(a);
};
$38cb13c5a0250553$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useSyncExternalStore(a, b, e);
};
$38cb13c5a0250553$export$7b286972b8d8ccbf = function() {
    return $38cb13c5a0250553$var$U.current.useTransition();
};
$38cb13c5a0250553$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("bJtXW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $88ab244363eded38$export$71511d61b312f219; });
function $88ab244363eded38$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("gZreO", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0331271bace68e97$export$ae55be85d98224ed; }, function (v) { return $0331271bace68e97$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0331271bace68e97$export$d39a5bbd09211389; }, function (v) { return $0331271bace68e97$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0331271bace68e97$export$882461b6382ed46c; }, function (v) { return $0331271bace68e97$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0331271bace68e97$export$466bfc07425424d5; }, function (v) { return $0331271bace68e97$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0331271bace68e97$export$cd75ccfd720a3cd4; }, function (v) { return $0331271bace68e97$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0331271bace68e97$export$fa8d919ba61d84db; }, function (v) { return $0331271bace68e97$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0331271bace68e97$export$757ceba2d55c277e; }, function (v) { return $0331271bace68e97$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0331271bace68e97$export$b3890eb0ae9dca99; }, function (v) { return $0331271bace68e97$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0331271bace68e97$export$502457920280e6be; }, function (v) { return $0331271bace68e97$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0331271bace68e97$export$c78a37762a8d58e1; }, function (v) { return $0331271bace68e97$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0331271bace68e97$export$dc54d992c10e8a18; }, function (v) { return $0331271bace68e97$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0331271bace68e97$export$83d89fbfd8236492; }, function (v) { return $0331271bace68e97$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $bJtXW = parcelRequire("bJtXW");
var $0331271bace68e97$export$ae55be85d98224ed;
var $0331271bace68e97$export$d39a5bbd09211389;
var $0331271bace68e97$export$882461b6382ed46c;
var $0331271bace68e97$export$466bfc07425424d5;
var $0331271bace68e97$export$cd75ccfd720a3cd4;
var $0331271bace68e97$export$fa8d919ba61d84db;
var $0331271bace68e97$export$757ceba2d55c277e;
var $0331271bace68e97$export$b3890eb0ae9dca99;
var $0331271bace68e97$export$502457920280e6be;
var $0331271bace68e97$export$c78a37762a8d58e1;
var $0331271bace68e97$export$dc54d992c10e8a18;
var $0331271bace68e97$export$83d89fbfd8236492;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");

var $1iyD5 = parcelRequire("1iyD5");
function $0331271bace68e97$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0331271bace68e97$var$da = new Set, $0331271bace68e97$var$ea = {};
function $0331271bace68e97$var$fa(a, b) {
    $0331271bace68e97$var$ha(a, b);
    $0331271bace68e97$var$ha(a + "Capture", b);
}
function $0331271bace68e97$var$ha(a, b) {
    $0331271bace68e97$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0331271bace68e97$var$da.add(b[a]);
}
var $0331271bace68e97$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0331271bace68e97$var$ja = Object.prototype.hasOwnProperty, $0331271bace68e97$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0331271bace68e97$var$la = {}, $0331271bace68e97$var$ma = {};
function $0331271bace68e97$var$oa(a) {
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$ma, a)) return !0;
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$la, a)) return !1;
    if ($0331271bace68e97$var$ka.test(a)) return $0331271bace68e97$var$ma[a] = !0;
    $0331271bace68e97$var$la[a] = !0;
    return !1;
}
function $0331271bace68e97$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0331271bace68e97$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0331271bace68e97$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0331271bace68e97$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0331271bace68e97$var$ra = /[\-:]([a-z])/g;
function $0331271bace68e97$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0331271bace68e97$var$z.xlinkHref = new $0331271bace68e97$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0331271bace68e97$var$ta(a, b, c, d) {
    var e = $0331271bace68e97$var$z.hasOwnProperty(b) ? $0331271bace68e97$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0331271bace68e97$var$qa(b, c, e, d) && (c = null), d || null === e ? $0331271bace68e97$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0331271bace68e97$var$ua = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0331271bace68e97$var$va = Symbol.for("react.element"), $0331271bace68e97$var$wa = Symbol.for("react.portal"), $0331271bace68e97$var$ya = Symbol.for("react.fragment"), $0331271bace68e97$var$za = Symbol.for("react.strict_mode"), $0331271bace68e97$var$Aa = Symbol.for("react.profiler"), $0331271bace68e97$var$Ba = Symbol.for("react.provider"), $0331271bace68e97$var$Ca = Symbol.for("react.context"), $0331271bace68e97$var$Da = Symbol.for("react.forward_ref"), $0331271bace68e97$var$Ea = Symbol.for("react.suspense"), $0331271bace68e97$var$Fa = Symbol.for("react.suspense_list"), $0331271bace68e97$var$Ga = Symbol.for("react.memo"), $0331271bace68e97$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0331271bace68e97$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0331271bace68e97$var$Ja = Symbol.iterator;
function $0331271bace68e97$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0331271bace68e97$var$Ja && a[$0331271bace68e97$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0331271bace68e97$var$A = Object.assign, $0331271bace68e97$var$La;
function $0331271bace68e97$var$Ma(a) {
    if (void 0 === $0331271bace68e97$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0331271bace68e97$var$La = b && b[1] || "";
    }
    return "\n" + $0331271bace68e97$var$La + a;
}
var $0331271bace68e97$var$Na = !1;
function $0331271bace68e97$var$Oa(a, b) {
    if (!a || $0331271bace68e97$var$Na) return "";
    $0331271bace68e97$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0331271bace68e97$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0331271bace68e97$var$Ma(a) : "";
}
function $0331271bace68e97$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0331271bace68e97$var$Ma(a.type);
        case 16:
            return $0331271bace68e97$var$Ma("Lazy");
        case 13:
            return $0331271bace68e97$var$Ma("Suspense");
        case 19:
            return $0331271bace68e97$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0331271bace68e97$var$Oa(a.type, !1), a;
        case 11:
            return a = $0331271bace68e97$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0331271bace68e97$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0331271bace68e97$var$ya:
            return "Fragment";
        case $0331271bace68e97$var$wa:
            return "Portal";
        case $0331271bace68e97$var$Aa:
            return "Profiler";
        case $0331271bace68e97$var$za:
            return "StrictMode";
        case $0331271bace68e97$var$Ea:
            return "Suspense";
        case $0331271bace68e97$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0331271bace68e97$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0331271bace68e97$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0331271bace68e97$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0331271bace68e97$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0331271bace68e97$var$Qa(a.type) || "Memo";
        case $0331271bace68e97$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0331271bace68e97$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0331271bace68e97$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0331271bace68e97$var$Qa(b);
        case 8:
            return b === $0331271bace68e97$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0331271bace68e97$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0331271bace68e97$var$Ua(a) {
    var b = $0331271bace68e97$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0331271bace68e97$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0331271bace68e97$var$Ua(a));
}
function $0331271bace68e97$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0331271bace68e97$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0331271bace68e97$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0331271bace68e97$var$Ya(a, b) {
    var c = b.checked;
    return $0331271bace68e97$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0331271bace68e97$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0331271bace68e97$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0331271bace68e97$var$ab(a, b) {
    b = b.checked;
    null != b && $0331271bace68e97$var$ta(a, "checked", b, !1);
}
function $0331271bace68e97$var$bb(a, b) {
    $0331271bace68e97$var$ab(a, b);
    var c = $0331271bace68e97$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0331271bace68e97$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0331271bace68e97$var$cb(a, b.type, $0331271bace68e97$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0331271bace68e97$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0331271bace68e97$var$cb(a, b, c) {
    if ("number" !== b || $0331271bace68e97$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0331271bace68e97$var$eb = Array.isArray;
function $0331271bace68e97$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0331271bace68e97$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0331271bace68e97$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0331271bace68e97$var$p(91));
    return $0331271bace68e97$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0331271bace68e97$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0331271bace68e97$var$p(92));
            if ($0331271bace68e97$var$eb(c)) {
                if (1 < c.length) throw Error($0331271bace68e97$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0331271bace68e97$var$Sa(c)
    };
}
function $0331271bace68e97$var$ib(a, b) {
    var c = $0331271bace68e97$var$Sa(b.value), d = $0331271bace68e97$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0331271bace68e97$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0331271bace68e97$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0331271bace68e97$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0331271bace68e97$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0331271bace68e97$var$mb, $0331271bace68e97$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0331271bace68e97$var$mb = $0331271bace68e97$var$mb || document.createElement("div");
        $0331271bace68e97$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0331271bace68e97$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0331271bace68e97$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0331271bace68e97$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0331271bace68e97$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0331271bace68e97$var$pb).forEach(function(a) {
    $0331271bace68e97$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0331271bace68e97$var$pb[b] = $0331271bace68e97$var$pb[a];
    });
});
function $0331271bace68e97$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0331271bace68e97$var$pb.hasOwnProperty(a) && $0331271bace68e97$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0331271bace68e97$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0331271bace68e97$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0331271bace68e97$var$tb = $0331271bace68e97$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0331271bace68e97$var$ub(a, b) {
    if (b) {
        if ($0331271bace68e97$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0331271bace68e97$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0331271bace68e97$var$p(62));
    }
}
function $0331271bace68e97$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0331271bace68e97$var$wb = null;
function $0331271bace68e97$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0331271bace68e97$var$yb = null, $0331271bace68e97$var$zb = null, $0331271bace68e97$var$Ab = null;
function $0331271bace68e97$var$Bb(a) {
    if (a = $0331271bace68e97$var$Cb(a)) {
        if ("function" !== typeof $0331271bace68e97$var$yb) throw Error($0331271bace68e97$var$p(280));
        var b = a.stateNode;
        b && (b = $0331271bace68e97$var$Db(b), $0331271bace68e97$var$yb(a.stateNode, a.type, b));
    }
}
function $0331271bace68e97$var$Eb(a) {
    $0331271bace68e97$var$zb ? $0331271bace68e97$var$Ab ? $0331271bace68e97$var$Ab.push(a) : $0331271bace68e97$var$Ab = [
        a
    ] : $0331271bace68e97$var$zb = a;
}
function $0331271bace68e97$var$Fb() {
    if ($0331271bace68e97$var$zb) {
        var a = $0331271bace68e97$var$zb, b = $0331271bace68e97$var$Ab;
        $0331271bace68e97$var$Ab = $0331271bace68e97$var$zb = null;
        $0331271bace68e97$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0331271bace68e97$var$Bb(b[a]);
    }
}
function $0331271bace68e97$var$Gb(a, b) {
    return a(b);
}
function $0331271bace68e97$var$Hb() {}
var $0331271bace68e97$var$Ib = !1;
function $0331271bace68e97$var$Jb(a, b, c) {
    if ($0331271bace68e97$var$Ib) return a(b, c);
    $0331271bace68e97$var$Ib = !0;
    try {
        return $0331271bace68e97$var$Gb(a, b, c);
    } finally{
        if ($0331271bace68e97$var$Ib = !1, null !== $0331271bace68e97$var$zb || null !== $0331271bace68e97$var$Ab) $0331271bace68e97$var$Hb(), $0331271bace68e97$var$Fb();
    }
}
function $0331271bace68e97$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0331271bace68e97$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0331271bace68e97$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)));
    return c;
}
var $0331271bace68e97$var$Lb = !1;
if ($0331271bace68e97$var$ia) try {
    var $0331271bace68e97$var$Mb = {};
    Object.defineProperty($0331271bace68e97$var$Mb, "passive", {
        get: function get() {
            $0331271bace68e97$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
    window.removeEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
} catch (a) {
    $0331271bace68e97$var$Lb = !1;
}
function $0331271bace68e97$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0331271bace68e97$var$Ob = !1, $0331271bace68e97$var$Pb = null, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, $0331271bace68e97$var$Sb = {
    onError: function onError(a) {
        $0331271bace68e97$var$Ob = !0;
        $0331271bace68e97$var$Pb = a;
    }
};
function $0331271bace68e97$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Ob = !1;
    $0331271bace68e97$var$Pb = null;
    $0331271bace68e97$var$Nb.apply($0331271bace68e97$var$Sb, arguments);
}
function $0331271bace68e97$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Tb.apply(this, arguments);
    if ($0331271bace68e97$var$Ob) {
        if ($0331271bace68e97$var$Ob) {
            var l = $0331271bace68e97$var$Pb;
            $0331271bace68e97$var$Ob = !1;
            $0331271bace68e97$var$Pb = null;
        } else throw Error($0331271bace68e97$var$p(198));
        $0331271bace68e97$var$Qb || ($0331271bace68e97$var$Qb = !0, $0331271bace68e97$var$Rb = l);
    }
}
function $0331271bace68e97$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0331271bace68e97$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0331271bace68e97$var$Xb(a) {
    if ($0331271bace68e97$var$Vb(a) !== a) throw Error($0331271bace68e97$var$p(188));
}
function $0331271bace68e97$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0331271bace68e97$var$Vb(a);
        if (null === b) throw Error($0331271bace68e97$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0331271bace68e97$var$Xb(e), a;
                if (f === d) return $0331271bace68e97$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0331271bace68e97$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0331271bace68e97$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0331271bace68e97$var$p(190));
    }
    if (3 !== c.tag) throw Error($0331271bace68e97$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0331271bace68e97$var$Zb(a) {
    a = $0331271bace68e97$var$Yb(a);
    return null !== a ? $0331271bace68e97$var$$b(a) : null;
}
function $0331271bace68e97$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0331271bace68e97$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0331271bace68e97$var$ac = $1iyD5.unstable_scheduleCallback, $0331271bace68e97$var$bc = $1iyD5.unstable_cancelCallback, $0331271bace68e97$var$cc = $1iyD5.unstable_shouldYield, $0331271bace68e97$var$dc = $1iyD5.unstable_requestPaint, $0331271bace68e97$var$B = $1iyD5.unstable_now, $0331271bace68e97$var$ec = $1iyD5.unstable_getCurrentPriorityLevel, $0331271bace68e97$var$fc = $1iyD5.unstable_ImmediatePriority, $0331271bace68e97$var$gc = $1iyD5.unstable_UserBlockingPriority, $0331271bace68e97$var$hc = $1iyD5.unstable_NormalPriority, $0331271bace68e97$var$ic = $1iyD5.unstable_LowPriority, $0331271bace68e97$var$jc = $1iyD5.unstable_IdlePriority, $0331271bace68e97$var$kc = null, $0331271bace68e97$var$lc = null;
function $0331271bace68e97$var$mc(a) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberRoot) try {
        $0331271bace68e97$var$lc.onCommitFiberRoot($0331271bace68e97$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0331271bace68e97$var$oc = Math.clz32 ? Math.clz32 : $0331271bace68e97$var$nc, $0331271bace68e97$var$pc = Math.log, $0331271bace68e97$var$qc = Math.LN2;
function $0331271bace68e97$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0331271bace68e97$var$pc(a) / $0331271bace68e97$var$qc | 0) | 0;
}
var $0331271bace68e97$var$rc = 64, $0331271bace68e97$var$sc = 4194304;
function $0331271bace68e97$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0331271bace68e97$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0331271bace68e97$var$tc(h) : (f &= g, 0 !== f && (d = $0331271bace68e97$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0331271bace68e97$var$tc(g) : 0 !== f && (d = $0331271bace68e97$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0331271bace68e97$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0331271bace68e97$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0331271bace68e97$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0331271bace68e97$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0331271bace68e97$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0331271bace68e97$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0331271bace68e97$var$yc() {
    var a = $0331271bace68e97$var$rc;
    $0331271bace68e97$var$rc <<= 1;
    0 === ($0331271bace68e97$var$rc & 4194240) && ($0331271bace68e97$var$rc = 64);
    return a;
}
function $0331271bace68e97$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0331271bace68e97$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0331271bace68e97$var$oc(b);
    a[b] = c;
}
function $0331271bace68e97$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0331271bace68e97$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0331271bace68e97$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0331271bace68e97$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0331271bace68e97$var$C = 0;
function $0331271bace68e97$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0331271bace68e97$var$Ec, $0331271bace68e97$var$Fc, $0331271bace68e97$var$Gc, $0331271bace68e97$var$Hc, $0331271bace68e97$var$Ic, $0331271bace68e97$var$Jc = !1, $0331271bace68e97$var$Kc = [], $0331271bace68e97$var$Lc = null, $0331271bace68e97$var$Mc = null, $0331271bace68e97$var$Nc = null, $0331271bace68e97$var$Oc = new Map, $0331271bace68e97$var$Pc = new Map, $0331271bace68e97$var$Qc = [], $0331271bace68e97$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0331271bace68e97$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0331271bace68e97$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0331271bace68e97$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0331271bace68e97$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0331271bace68e97$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0331271bace68e97$var$Pc.delete(b.pointerId);
    }
}
function $0331271bace68e97$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0331271bace68e97$var$Cb(b), null !== b && $0331271bace68e97$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0331271bace68e97$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0331271bace68e97$var$Lc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0331271bace68e97$var$Mc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0331271bace68e97$var$Nc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0331271bace68e97$var$Oc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0331271bace68e97$var$Pc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0331271bace68e97$var$Vc(a) {
    var b = $0331271bace68e97$var$Wc(a.target);
    if (null !== b) {
        var c = $0331271bace68e97$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0331271bace68e97$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0331271bace68e97$var$Ic(a.priority, function() {
                        $0331271bace68e97$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0331271bace68e97$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0331271bace68e97$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0331271bace68e97$var$wb = d;
            c.target.dispatchEvent(d);
            $0331271bace68e97$var$wb = null;
        } else return b = $0331271bace68e97$var$Cb(c), null !== b && $0331271bace68e97$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0331271bace68e97$var$Zc(a, b, c) {
    $0331271bace68e97$var$Xc(a) && c.delete(b);
}
function $0331271bace68e97$var$$c() {
    $0331271bace68e97$var$Jc = !1;
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Lc) && ($0331271bace68e97$var$Lc = null);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Mc) && ($0331271bace68e97$var$Mc = null);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Nc) && ($0331271bace68e97$var$Nc = null);
    $0331271bace68e97$var$Oc.forEach($0331271bace68e97$var$Zc);
    $0331271bace68e97$var$Pc.forEach($0331271bace68e97$var$Zc);
}
function $0331271bace68e97$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0331271bace68e97$var$Jc || ($0331271bace68e97$var$Jc = !0, $1iyD5.unstable_scheduleCallback($1iyD5.unstable_NormalPriority, $0331271bace68e97$var$$c)));
}
function $0331271bace68e97$var$bd(a) {
    function b(b) {
        return $0331271bace68e97$var$ad(b, a);
    }
    if (0 < $0331271bace68e97$var$Kc.length) {
        $0331271bace68e97$var$ad($0331271bace68e97$var$Kc[0], a);
        for(var c = 1; c < $0331271bace68e97$var$Kc.length; c++){
            var d = $0331271bace68e97$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$ad($0331271bace68e97$var$Lc, a);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$ad($0331271bace68e97$var$Mc, a);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$ad($0331271bace68e97$var$Nc, a);
    $0331271bace68e97$var$Oc.forEach(b);
    $0331271bace68e97$var$Pc.forEach(b);
    for(c = 0; c < $0331271bace68e97$var$Qc.length; c++)d = $0331271bace68e97$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0331271bace68e97$var$Qc.length && (c = $0331271bace68e97$var$Qc[0], null === c.blockedOn);)$0331271bace68e97$var$Vc(c), null === c.blockedOn && $0331271bace68e97$var$Qc.shift();
}
var $0331271bace68e97$var$cd = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$dd = !0;
function $0331271bace68e97$var$ed(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 1, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$gd(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 4, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$fd(a, b, c, d) {
    if ($0331271bace68e97$var$dd) {
        var e = $0331271bace68e97$var$Yc(a, b, c, d);
        if (null === e) $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c), $0331271bace68e97$var$Sc(a, d);
        else if ($0331271bace68e97$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0331271bace68e97$var$Sc(a, d), b & 4 && -1 < $0331271bace68e97$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0331271bace68e97$var$Cb(e);
                null !== f && $0331271bace68e97$var$Ec(f);
                f = $0331271bace68e97$var$Yc(a, b, c, d);
                null === f && $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0331271bace68e97$var$hd(a, b, d, null, c);
    }
}
var $0331271bace68e97$var$id = null;
function $0331271bace68e97$var$Yc(a, b, c, d) {
    $0331271bace68e97$var$id = null;
    a = $0331271bace68e97$var$xb(d);
    a = $0331271bace68e97$var$Wc(a);
    if (null !== a) {
        if (b = $0331271bace68e97$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0331271bace68e97$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0331271bace68e97$var$id = a;
    return null;
}
function $0331271bace68e97$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0331271bace68e97$var$ec()){
                case $0331271bace68e97$var$fc:
                    return 1;
                case $0331271bace68e97$var$gc:
                    return 4;
                case $0331271bace68e97$var$hc:
                case $0331271bace68e97$var$ic:
                    return 16;
                case $0331271bace68e97$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ld = null, $0331271bace68e97$var$md = null;
function $0331271bace68e97$var$nd() {
    if ($0331271bace68e97$var$md) return $0331271bace68e97$var$md;
    var a, b = $0331271bace68e97$var$ld, c = b.length, d, e = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0331271bace68e97$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0331271bace68e97$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0331271bace68e97$var$pd() {
    return !0;
}
function $0331271bace68e97$var$qd() {
    return !1;
}
function $0331271bace68e97$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0331271bace68e97$var$pd : $0331271bace68e97$var$qd;
        this.isPropagationStopped = $0331271bace68e97$var$qd;
        return this;
    }
    $0331271bace68e97$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $bJtXW._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $0331271bace68e97$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $bJtXW._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $0331271bace68e97$var$pd);
        },
        persist: function persist() {},
        isPersistent: $0331271bace68e97$var$pd
    });
    return b;
}
var $0331271bace68e97$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0331271bace68e97$var$td = $0331271bace68e97$var$rd($0331271bace68e97$var$sd), $0331271bace68e97$var$ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    view: 0,
    detail: 0
}), $0331271bace68e97$var$vd = $0331271bace68e97$var$rd($0331271bace68e97$var$ud), $0331271bace68e97$var$wd, $0331271bace68e97$var$xd, $0331271bace68e97$var$yd, $0331271bace68e97$var$Ad = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0331271bace68e97$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0331271bace68e97$var$yd && ($0331271bace68e97$var$yd && "mousemove" === a.type ? ($0331271bace68e97$var$wd = a.screenX - $0331271bace68e97$var$yd.screenX, $0331271bace68e97$var$xd = a.screenY - $0331271bace68e97$var$yd.screenY) : $0331271bace68e97$var$xd = $0331271bace68e97$var$wd = 0, $0331271bace68e97$var$yd = a);
        return $0331271bace68e97$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $0331271bace68e97$var$xd;
    }
}), $0331271bace68e97$var$Bd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ad), $0331271bace68e97$var$Cd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    dataTransfer: 0
}), $0331271bace68e97$var$Dd = $0331271bace68e97$var$rd($0331271bace68e97$var$Cd), $0331271bace68e97$var$Ed = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    relatedTarget: 0
}), $0331271bace68e97$var$Fd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ed), $0331271bace68e97$var$Gd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Hd = $0331271bace68e97$var$rd($0331271bace68e97$var$Gd), $0331271bace68e97$var$Id = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0331271bace68e97$var$Jd = $0331271bace68e97$var$rd($0331271bace68e97$var$Id), $0331271bace68e97$var$Kd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    data: 0
}), $0331271bace68e97$var$Ld = $0331271bace68e97$var$rd($0331271bace68e97$var$Kd), $0331271bace68e97$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0331271bace68e97$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0331271bace68e97$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0331271bace68e97$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0331271bace68e97$var$Od[a]) ? !!b[a] : !1;
}
function $0331271bace68e97$var$zd() {
    return $0331271bace68e97$var$Pd;
}
var $0331271bace68e97$var$Qd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $0331271bace68e97$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0331271bace68e97$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0331271bace68e97$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0331271bace68e97$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0331271bace68e97$var$Rd = $0331271bace68e97$var$rd($0331271bace68e97$var$Qd), $0331271bace68e97$var$Sd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0331271bace68e97$var$Td = $0331271bace68e97$var$rd($0331271bace68e97$var$Sd), $0331271bace68e97$var$Ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0331271bace68e97$var$zd
}), $0331271bace68e97$var$Vd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ud), $0331271bace68e97$var$Wd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Xd = $0331271bace68e97$var$rd($0331271bace68e97$var$Wd), $0331271bace68e97$var$Yd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0331271bace68e97$var$Zd = $0331271bace68e97$var$rd($0331271bace68e97$var$Yd), $0331271bace68e97$var$$d = [
    9,
    13,
    27,
    32
], $0331271bace68e97$var$ae = $0331271bace68e97$var$ia && "CompositionEvent" in window, $0331271bace68e97$var$be = null;
$0331271bace68e97$var$ia && "documentMode" in document && ($0331271bace68e97$var$be = document.documentMode);
var $0331271bace68e97$var$ce = $0331271bace68e97$var$ia && "TextEvent" in window && !$0331271bace68e97$var$be, $0331271bace68e97$var$de = $0331271bace68e97$var$ia && (!$0331271bace68e97$var$ae || $0331271bace68e97$var$be && 8 < $0331271bace68e97$var$be && 11 >= $0331271bace68e97$var$be), $0331271bace68e97$var$ee = String.fromCharCode(32), $0331271bace68e97$var$fe = !1;
function $0331271bace68e97$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0331271bace68e97$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0331271bace68e97$var$ie = !1;
function $0331271bace68e97$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0331271bace68e97$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0331271bace68e97$var$fe = !0;
            return $0331271bace68e97$var$ee;
        case "textInput":
            return a = b.data, a === $0331271bace68e97$var$ee && $0331271bace68e97$var$fe ? null : a;
        default:
            return null;
    }
}
function $0331271bace68e97$var$ke(a, b) {
    if ($0331271bace68e97$var$ie) return "compositionend" === a || !$0331271bace68e97$var$ae && $0331271bace68e97$var$ge(a, b) ? (a = $0331271bace68e97$var$nd(), $0331271bace68e97$var$md = $0331271bace68e97$var$ld = $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0331271bace68e97$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0331271bace68e97$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0331271bace68e97$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0331271bace68e97$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0331271bace68e97$var$ne(a, b, c, d) {
    $0331271bace68e97$var$Eb(d);
    b = $0331271bace68e97$var$oe(b, "onChange");
    0 < b.length && (c = new $0331271bace68e97$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0331271bace68e97$var$pe = null, $0331271bace68e97$var$qe = null;
function $0331271bace68e97$var$re(a) {
    $0331271bace68e97$var$se(a, 0);
}
function $0331271bace68e97$var$te(a) {
    var b = $0331271bace68e97$var$ue(a);
    if ($0331271bace68e97$var$Wa(b)) return a;
}
function $0331271bace68e97$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0331271bace68e97$var$we = !1;
if ($0331271bace68e97$var$ia) {
    var $0331271bace68e97$var$xe;
    if ($0331271bace68e97$var$ia) {
        var $0331271bace68e97$var$ye = "oninput" in document;
        if (!$0331271bace68e97$var$ye) {
            var $0331271bace68e97$var$ze = document.createElement("div");
            $0331271bace68e97$var$ze.setAttribute("oninput", "return;");
            $0331271bace68e97$var$ye = "function" === typeof $0331271bace68e97$var$ze.oninput;
        }
        $0331271bace68e97$var$xe = $0331271bace68e97$var$ye;
    } else $0331271bace68e97$var$xe = !1;
    $0331271bace68e97$var$we = $0331271bace68e97$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0331271bace68e97$var$Ae() {
    $0331271bace68e97$var$pe && ($0331271bace68e97$var$pe.detachEvent("onpropertychange", $0331271bace68e97$var$Be), $0331271bace68e97$var$qe = $0331271bace68e97$var$pe = null);
}
function $0331271bace68e97$var$Be(a) {
    if ("value" === a.propertyName && $0331271bace68e97$var$te($0331271bace68e97$var$qe)) {
        var b = [];
        $0331271bace68e97$var$ne(b, $0331271bace68e97$var$qe, a, $0331271bace68e97$var$xb(a));
        $0331271bace68e97$var$Jb($0331271bace68e97$var$re, b);
    }
}
function $0331271bace68e97$var$Ce(a, b, c) {
    "focusin" === a ? ($0331271bace68e97$var$Ae(), $0331271bace68e97$var$pe = b, $0331271bace68e97$var$qe = c, $0331271bace68e97$var$pe.attachEvent("onpropertychange", $0331271bace68e97$var$Be)) : "focusout" === a && $0331271bace68e97$var$Ae();
}
function $0331271bace68e97$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0331271bace68e97$var$te($0331271bace68e97$var$qe);
}
function $0331271bace68e97$var$Ee(a, b) {
    if ("click" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0331271bace68e97$var$He = "function" === typeof Object.is ? Object.is : $0331271bace68e97$var$Ge;
function $0331271bace68e97$var$Ie(a, b) {
    if ($0331271bace68e97$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0331271bace68e97$var$ja.call(b, e) || !$0331271bace68e97$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0331271bace68e97$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0331271bace68e97$var$Ke(a, b) {
    var c = $0331271bace68e97$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0331271bace68e97$var$Je(c);
    }
}
function $0331271bace68e97$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0331271bace68e97$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0331271bace68e97$var$Me() {
    for(var a = window, b = $0331271bace68e97$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0331271bace68e97$var$Xa(a.document);
    }
    return b;
}
function $0331271bace68e97$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0331271bace68e97$var$Oe(a) {
    var b = $0331271bace68e97$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0331271bace68e97$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0331271bace68e97$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0331271bace68e97$var$Ke(c, f);
                var g = $0331271bace68e97$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0331271bace68e97$var$Pe = $0331271bace68e97$var$ia && "documentMode" in document && 11 >= document.documentMode, $0331271bace68e97$var$Qe = null, $0331271bace68e97$var$Re = null, $0331271bace68e97$var$Se = null, $0331271bace68e97$var$Te = !1;
function $0331271bace68e97$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0331271bace68e97$var$Te || null == $0331271bace68e97$var$Qe || $0331271bace68e97$var$Qe !== $0331271bace68e97$var$Xa(d) || (d = $0331271bace68e97$var$Qe, "selectionStart" in d && $0331271bace68e97$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0331271bace68e97$var$Se && $0331271bace68e97$var$Ie($0331271bace68e97$var$Se, d) || ($0331271bace68e97$var$Se = d, d = $0331271bace68e97$var$oe($0331271bace68e97$var$Re, "onSelect"), 0 < d.length && (b = new $0331271bace68e97$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0331271bace68e97$var$Qe)));
}
function $0331271bace68e97$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0331271bace68e97$var$We = {
    animationend: $0331271bace68e97$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0331271bace68e97$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0331271bace68e97$var$Ve("Animation", "AnimationStart"),
    transitionend: $0331271bace68e97$var$Ve("Transition", "TransitionEnd")
}, $0331271bace68e97$var$Xe = {}, $0331271bace68e97$var$Ye = {};
$0331271bace68e97$var$ia && ($0331271bace68e97$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0331271bace68e97$var$We.animationend.animation, delete $0331271bace68e97$var$We.animationiteration.animation, delete $0331271bace68e97$var$We.animationstart.animation), "TransitionEvent" in window || delete $0331271bace68e97$var$We.transitionend.transition);
function $0331271bace68e97$var$Ze(a) {
    if ($0331271bace68e97$var$Xe[a]) return $0331271bace68e97$var$Xe[a];
    if (!$0331271bace68e97$var$We[a]) return a;
    var b = $0331271bace68e97$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0331271bace68e97$var$Ye) return $0331271bace68e97$var$Xe[a] = b[c];
    return a;
}
var $0331271bace68e97$var$$e = $0331271bace68e97$var$Ze("animationend"), $0331271bace68e97$var$af = $0331271bace68e97$var$Ze("animationiteration"), $0331271bace68e97$var$bf = $0331271bace68e97$var$Ze("animationstart"), $0331271bace68e97$var$cf = $0331271bace68e97$var$Ze("transitionend"), $0331271bace68e97$var$df = new Map, $0331271bace68e97$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0331271bace68e97$var$ff(a, b) {
    $0331271bace68e97$var$df.set(a, b);
    $0331271bace68e97$var$fa(b, [
        a
    ]);
}
for(var $0331271bace68e97$var$gf = 0; $0331271bace68e97$var$gf < $0331271bace68e97$var$ef.length; $0331271bace68e97$var$gf++){
    var $0331271bace68e97$var$hf = $0331271bace68e97$var$ef[$0331271bace68e97$var$gf], $0331271bace68e97$var$jf = $0331271bace68e97$var$hf.toLowerCase(), $0331271bace68e97$var$kf = $0331271bace68e97$var$hf[0].toUpperCase() + $0331271bace68e97$var$hf.slice(1);
    $0331271bace68e97$var$ff($0331271bace68e97$var$jf, "on" + $0331271bace68e97$var$kf);
}
$0331271bace68e97$var$ff($0331271bace68e97$var$$e, "onAnimationEnd");
$0331271bace68e97$var$ff($0331271bace68e97$var$af, "onAnimationIteration");
$0331271bace68e97$var$ff($0331271bace68e97$var$bf, "onAnimationStart");
$0331271bace68e97$var$ff("dblclick", "onDoubleClick");
$0331271bace68e97$var$ff("focusin", "onFocus");
$0331271bace68e97$var$ff("focusout", "onBlur");
$0331271bace68e97$var$ff($0331271bace68e97$var$cf, "onTransitionEnd");
$0331271bace68e97$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0331271bace68e97$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0331271bace68e97$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0331271bace68e97$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0331271bace68e97$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0331271bace68e97$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0331271bace68e97$var$lf));
function $0331271bace68e97$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0331271bace68e97$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0331271bace68e97$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0331271bace68e97$var$Qb) throw a = $0331271bace68e97$var$Rb, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, a;
}
function $0331271bace68e97$var$D(a, b) {
    var c = b[$0331271bace68e97$var$of];
    void 0 === c && (c = b[$0331271bace68e97$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0331271bace68e97$var$pf(b, a, 2, !1), c.add(d));
}
function $0331271bace68e97$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0331271bace68e97$var$pf(c, a, d, b);
}
var $0331271bace68e97$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0331271bace68e97$var$sf(a) {
    if (!a[$0331271bace68e97$var$rf]) {
        a[$0331271bace68e97$var$rf] = !0;
        $0331271bace68e97$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0331271bace68e97$var$mf.has(b) || $0331271bace68e97$var$qf(b, !1, a), $0331271bace68e97$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0331271bace68e97$var$rf] || (b[$0331271bace68e97$var$rf] = !0, $0331271bace68e97$var$qf("selectionchange", !1, b));
    }
}
function $0331271bace68e97$var$pf(a, b, c, d) {
    switch($0331271bace68e97$var$jd(b)){
        case 1:
            var e = $0331271bace68e97$var$ed;
            break;
        case 4:
            e = $0331271bace68e97$var$gd;
            break;
        default:
            e = $0331271bace68e97$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0331271bace68e97$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0331271bace68e97$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0331271bace68e97$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0331271bace68e97$var$Jb(function() {
        var _$d = f, _$e = $0331271bace68e97$var$xb(c), g = [];
        a: {
            var h = $0331271bace68e97$var$df.get(a);
            if (void 0 !== h) {
                var k = $0331271bace68e97$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0331271bace68e97$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0331271bace68e97$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0331271bace68e97$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0331271bace68e97$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0331271bace68e97$var$Vd;
                        break;
                    case $0331271bace68e97$var$$e:
                    case $0331271bace68e97$var$af:
                    case $0331271bace68e97$var$bf:
                        k = $0331271bace68e97$var$Hd;
                        break;
                    case $0331271bace68e97$var$cf:
                        k = $0331271bace68e97$var$Xd;
                        break;
                    case "scroll":
                        k = $0331271bace68e97$var$vd;
                        break;
                    case "wheel":
                        k = $0331271bace68e97$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0331271bace68e97$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0331271bace68e97$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0331271bace68e97$var$Kb(w, x), null != F && t.push($0331271bace68e97$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0331271bace68e97$var$wb && (n = c.relatedTarget || c.fromElement) && ($0331271bace68e97$var$Wc(n) || n[$0331271bace68e97$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $0331271bace68e97$var$Wc(n) : null, null !== n && (J = $0331271bace68e97$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $0331271bace68e97$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0331271bace68e97$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0331271bace68e97$var$ue(k);
                        u = null == n ? h : $0331271bace68e97$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0331271bace68e97$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0331271bace68e97$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0331271bace68e97$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0331271bace68e97$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0331271bace68e97$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0331271bace68e97$var$vf(t);
                                x = $0331271bace68e97$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0331271bace68e97$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0331271bace68e97$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $0331271bace68e97$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0331271bace68e97$var$ve;
                else if ($0331271bace68e97$var$me(h)) {
                    if ($0331271bace68e97$var$we) na = $0331271bace68e97$var$Fe;
                    else {
                        na = $0331271bace68e97$var$De;
                        var xa = $0331271bace68e97$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0331271bace68e97$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $0331271bace68e97$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0331271bace68e97$var$cb(h, "number", h.value);
            }
            xa = _$d ? $0331271bace68e97$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($0331271bace68e97$var$me(xa) || "true" === xa.contentEditable) $0331271bace68e97$var$Qe = xa, $0331271bace68e97$var$Re = _$d, $0331271bace68e97$var$Se = null;
                    break;
                case "focusout":
                    $0331271bace68e97$var$Se = $0331271bace68e97$var$Re = $0331271bace68e97$var$Qe = null;
                    break;
                case "mousedown":
                    $0331271bace68e97$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0331271bace68e97$var$Te = !1;
                    $0331271bace68e97$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($0331271bace68e97$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0331271bace68e97$var$Ue(g, c, _$e);
            }
            var $a;
            if ($0331271bace68e97$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0331271bace68e97$var$ie ? $0331271bace68e97$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0331271bace68e97$var$de && "ko" !== c.locale && ($0331271bace68e97$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0331271bace68e97$var$ie && ($a = $0331271bace68e97$var$nd()) : ($0331271bace68e97$var$kd = _$e, $0331271bace68e97$var$ld = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, $0331271bace68e97$var$ie = !0)), xa = $0331271bace68e97$var$oe(_$d, ba), 0 < xa.length && (ba = new $0331271bace68e97$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0331271bace68e97$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0331271bace68e97$var$ce ? $0331271bace68e97$var$je(a, c) : $0331271bace68e97$var$ke(a, c)) _$d = $0331271bace68e97$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $0331271bace68e97$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $0331271bace68e97$var$se(g, b);
    });
}
function $0331271bace68e97$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0331271bace68e97$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0331271bace68e97$var$Kb(a, c), null != f && d.unshift($0331271bace68e97$var$tf(a, f, e)), f = $0331271bace68e97$var$Kb(a, b), null != f && d.push($0331271bace68e97$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0331271bace68e97$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0331271bace68e97$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0331271bace68e97$var$Kb(c, f), null != k && g.unshift($0331271bace68e97$var$tf(c, k, h))) : e || (k = $0331271bace68e97$var$Kb(c, f), null != k && g.push($0331271bace68e97$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0331271bace68e97$var$xf = /\r\n?/g, $0331271bace68e97$var$yf = /\u0000|\uFFFD/g;
function $0331271bace68e97$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0331271bace68e97$var$xf, "\n").replace($0331271bace68e97$var$yf, "");
}
function $0331271bace68e97$var$Af(a, b, c) {
    b = $0331271bace68e97$var$zf(b);
    if ($0331271bace68e97$var$zf(a) !== b && c) throw Error($0331271bace68e97$var$p(425));
}
function $0331271bace68e97$var$Bf() {}
var $0331271bace68e97$var$Cf = null, $0331271bace68e97$var$Df = null;
function $0331271bace68e97$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0331271bace68e97$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0331271bace68e97$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0331271bace68e97$var$Hf = "function" === typeof Promise ? Promise : void 0, $0331271bace68e97$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0331271bace68e97$var$Hf ? function Jf(a) {
    return $0331271bace68e97$var$Hf.resolve(null).then(a).catch($0331271bace68e97$var$If);
} : $0331271bace68e97$var$Ff;
function $0331271bace68e97$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0331271bace68e97$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0331271bace68e97$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0331271bace68e97$var$bd(b);
}
function $0331271bace68e97$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0331271bace68e97$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0331271bace68e97$var$Nf = Math.random().toString(36).slice(2), $0331271bace68e97$var$Of = "__reactFiber$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Pf = "__reactProps$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$uf = "__reactContainer$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$of = "__reactEvents$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Qf = "__reactListeners$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Rf = "__reactHandles$" + $0331271bace68e97$var$Nf;
function $0331271bace68e97$var$Wc(a) {
    var b = a[$0331271bace68e97$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0331271bace68e97$var$uf] || c[$0331271bace68e97$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0331271bace68e97$var$Mf(a); null !== a;){
                if (c = a[$0331271bace68e97$var$Of]) return c;
                a = $0331271bace68e97$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0331271bace68e97$var$Cb(a) {
    a = a[$0331271bace68e97$var$Of] || a[$0331271bace68e97$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0331271bace68e97$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0331271bace68e97$var$p(33));
}
function $0331271bace68e97$var$Db(a) {
    return a[$0331271bace68e97$var$Pf] || null;
}
var $0331271bace68e97$var$Sf = [], $0331271bace68e97$var$Tf = -1;
function $0331271bace68e97$var$Uf(a) {
    return {
        current: a
    };
}
function $0331271bace68e97$var$E(a) {
    0 > $0331271bace68e97$var$Tf || (a.current = $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf], $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = null, $0331271bace68e97$var$Tf--);
}
function $0331271bace68e97$var$G(a, b) {
    $0331271bace68e97$var$Tf++;
    $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = a.current;
    a.current = b;
}
var $0331271bace68e97$var$Vf = {}, $0331271bace68e97$var$H = $0331271bace68e97$var$Uf($0331271bace68e97$var$Vf), $0331271bace68e97$var$Wf = $0331271bace68e97$var$Uf(!1), $0331271bace68e97$var$Xf = $0331271bace68e97$var$Vf;
function $0331271bace68e97$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0331271bace68e97$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0331271bace68e97$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0331271bace68e97$var$$f() {
    $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$E($0331271bace68e97$var$H);
}
function $0331271bace68e97$var$ag(a, b, c) {
    if ($0331271bace68e97$var$H.current !== $0331271bace68e97$var$Vf) throw Error($0331271bace68e97$var$p(168));
    $0331271bace68e97$var$G($0331271bace68e97$var$H, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
function $0331271bace68e97$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0331271bace68e97$var$p(108, $0331271bace68e97$var$Ra(a) || "Unknown", e));
    return $0331271bace68e97$var$A({}, c, d);
}
function $0331271bace68e97$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0331271bace68e97$var$Vf;
    $0331271bace68e97$var$Xf = $0331271bace68e97$var$H.current;
    $0331271bace68e97$var$G($0331271bace68e97$var$H, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, $0331271bace68e97$var$Wf.current);
    return !0;
}
function $0331271bace68e97$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0331271bace68e97$var$p(169));
    c ? (a = $0331271bace68e97$var$bg(a, b, $0331271bace68e97$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$G($0331271bace68e97$var$H, a)) : $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
var $0331271bace68e97$var$eg = null, $0331271bace68e97$var$fg = !1, $0331271bace68e97$var$gg = !1;
function $0331271bace68e97$var$hg(a) {
    null === $0331271bace68e97$var$eg ? $0331271bace68e97$var$eg = [
        a
    ] : $0331271bace68e97$var$eg.push(a);
}
function $0331271bace68e97$var$ig(a) {
    $0331271bace68e97$var$fg = !0;
    $0331271bace68e97$var$hg(a);
}
function $0331271bace68e97$var$jg() {
    if (!$0331271bace68e97$var$gg && null !== $0331271bace68e97$var$eg) {
        $0331271bace68e97$var$gg = !0;
        var a = 0, b = $0331271bace68e97$var$C;
        try {
            var c = $0331271bace68e97$var$eg;
            for($0331271bace68e97$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0331271bace68e97$var$eg = null;
            $0331271bace68e97$var$fg = !1;
        } catch (e) {
            throw null !== $0331271bace68e97$var$eg && ($0331271bace68e97$var$eg = $0331271bace68e97$var$eg.slice(a + 1)), $0331271bace68e97$var$ac($0331271bace68e97$var$fc, $0331271bace68e97$var$jg), e;
        } finally{
            $0331271bace68e97$var$C = b, $0331271bace68e97$var$gg = !1;
        }
    }
    return null;
}
var $0331271bace68e97$var$kg = [], $0331271bace68e97$var$lg = 0, $0331271bace68e97$var$mg = null, $0331271bace68e97$var$ng = 0, $0331271bace68e97$var$og = [], $0331271bace68e97$var$pg = 0, $0331271bace68e97$var$qg = null, $0331271bace68e97$var$rg = 1, $0331271bace68e97$var$sg = "";
function $0331271bace68e97$var$tg(a, b) {
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$ng;
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$mg;
    $0331271bace68e97$var$mg = a;
    $0331271bace68e97$var$ng = b;
}
function $0331271bace68e97$var$ug(a, b, c) {
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg;
    $0331271bace68e97$var$qg = a;
    var d = $0331271bace68e97$var$rg;
    a = $0331271bace68e97$var$sg;
    var e = 32 - $0331271bace68e97$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0331271bace68e97$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0331271bace68e97$var$rg = 1 << 32 - $0331271bace68e97$var$oc(b) + e | c << e | d;
        $0331271bace68e97$var$sg = f + a;
    } else $0331271bace68e97$var$rg = 1 << f | c << e | d, $0331271bace68e97$var$sg = a;
}
function $0331271bace68e97$var$vg(a) {
    null !== a.return && ($0331271bace68e97$var$tg(a, 1), $0331271bace68e97$var$ug(a, 1, 0));
}
function $0331271bace68e97$var$wg(a) {
    for(; a === $0331271bace68e97$var$mg;)$0331271bace68e97$var$mg = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null, $0331271bace68e97$var$ng = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null;
    for(; a === $0331271bace68e97$var$qg;)$0331271bace68e97$var$qg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$sg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$rg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null;
}
var $0331271bace68e97$var$xg = null, $0331271bace68e97$var$yg = null, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$zg = null;
function $0331271bace68e97$var$Ag(a, b) {
    var c = $0331271bace68e97$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0331271bace68e97$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0331271bace68e97$var$qg ? {
                id: $0331271bace68e97$var$rg,
                overflow: $0331271bace68e97$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0331271bace68e97$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0331271bace68e97$var$Eg(a) {
    if ($0331271bace68e97$var$I) {
        var b = $0331271bace68e97$var$yg;
        if (b) {
            var c = b;
            if (!$0331271bace68e97$var$Cg(a, b)) {
                if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
                b = $0331271bace68e97$var$Lf(c.nextSibling);
                var d = $0331271bace68e97$var$xg;
                b && $0331271bace68e97$var$Cg(a, b) ? $0331271bace68e97$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$xg = a);
            }
        } else {
            if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0331271bace68e97$var$I = !1;
            $0331271bace68e97$var$xg = a;
        }
    }
}
function $0331271bace68e97$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0331271bace68e97$var$xg = a;
}
function $0331271bace68e97$var$Gg(a) {
    if (a !== $0331271bace68e97$var$xg) return !1;
    if (!$0331271bace68e97$var$I) return $0331271bace68e97$var$Fg(a), $0331271bace68e97$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0331271bace68e97$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0331271bace68e97$var$yg)) {
        if ($0331271bace68e97$var$Dg(a)) throw $0331271bace68e97$var$Hg(), Error($0331271bace68e97$var$p(418));
        for(; b;)$0331271bace68e97$var$Ag(a, b), b = $0331271bace68e97$var$Lf(b.nextSibling);
    }
    $0331271bace68e97$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0331271bace68e97$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0331271bace68e97$var$yg = null;
        }
    } else $0331271bace68e97$var$yg = $0331271bace68e97$var$xg ? $0331271bace68e97$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0331271bace68e97$var$Hg() {
    for(var a = $0331271bace68e97$var$yg; a;)a = $0331271bace68e97$var$Lf(a.nextSibling);
}
function $0331271bace68e97$var$Ig() {
    $0331271bace68e97$var$yg = $0331271bace68e97$var$xg = null;
    $0331271bace68e97$var$I = !1;
}
function $0331271bace68e97$var$Jg(a) {
    null === $0331271bace68e97$var$zg ? $0331271bace68e97$var$zg = [
        a
    ] : $0331271bace68e97$var$zg.push(a);
}
var $0331271bace68e97$var$Kg = $0331271bace68e97$var$ua.ReactCurrentBatchConfig;
function $0331271bace68e97$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0331271bace68e97$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0331271bace68e97$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0331271bace68e97$var$p(284));
        if (!c._owner) throw Error($0331271bace68e97$var$p(290, a));
    }
    return a;
}
function $0331271bace68e97$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0331271bace68e97$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0331271bace68e97$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0331271bace68e97$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0331271bace68e97$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0331271bace68e97$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0331271bace68e97$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0331271bace68e97$var$Lg(a, b, c), d.return = a, d;
        d = $0331271bace68e97$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0331271bace68e97$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0331271bace68e97$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0331271bace68e97$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0331271bace68e97$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0331271bace68e97$var$va:
                    return c = $0331271bace68e97$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0331271bace68e97$var$Lg(a, null, b), c.return = a, c;
                case $0331271bace68e97$var$wa:
                    return b = $0331271bace68e97$var$Sg(b, a.mode, c), b.return = a, b;
                case $0331271bace68e97$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0331271bace68e97$var$eb(b) || $0331271bace68e97$var$Ka(b)) return b = $0331271bace68e97$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0331271bace68e97$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0331271bace68e97$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0331271bace68e97$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0331271bace68e97$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0331271bace68e97$var$eb(c) || $0331271bace68e97$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0331271bace68e97$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0331271bace68e97$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0331271bace68e97$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0331271bace68e97$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0331271bace68e97$var$eb(d) || $0331271bace68e97$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0331271bace68e97$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0331271bace68e97$var$Ka(h);
        if ("function" !== typeof l) throw Error($0331271bace68e97$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0331271bace68e97$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0331271bace68e97$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0331271bace68e97$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0331271bace68e97$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0331271bace68e97$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0331271bace68e97$var$ya ? (d = $0331271bace68e97$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0331271bace68e97$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0331271bace68e97$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0331271bace68e97$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0331271bace68e97$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0331271bace68e97$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0331271bace68e97$var$eb(f)) return n(a, d, f, h);
            if ($0331271bace68e97$var$Ka(f)) return t(a, d, f, h);
            $0331271bace68e97$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0331271bace68e97$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0331271bace68e97$var$Ug = $0331271bace68e97$var$Og(!0), $0331271bace68e97$var$Vg = $0331271bace68e97$var$Og(!1), $0331271bace68e97$var$Wg = $0331271bace68e97$var$Uf(null), $0331271bace68e97$var$Xg = null, $0331271bace68e97$var$Yg = null, $0331271bace68e97$var$Zg = null;
function $0331271bace68e97$var$$g() {
    $0331271bace68e97$var$Zg = $0331271bace68e97$var$Yg = $0331271bace68e97$var$Xg = null;
}
function $0331271bace68e97$var$ah(a) {
    var b = $0331271bace68e97$var$Wg.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$Wg);
    a._currentValue = b;
}
function $0331271bace68e97$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0331271bace68e97$var$ch(a, b) {
    $0331271bace68e97$var$Xg = a;
    $0331271bace68e97$var$Zg = $0331271bace68e97$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0331271bace68e97$var$dh = !0), a.firstContext = null);
}
function $0331271bace68e97$var$eh(a) {
    var b = a._currentValue;
    if ($0331271bace68e97$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0331271bace68e97$var$Yg) {
            if (null === $0331271bace68e97$var$Xg) throw Error($0331271bace68e97$var$p(308));
            $0331271bace68e97$var$Yg = a;
            $0331271bace68e97$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0331271bace68e97$var$Yg = $0331271bace68e97$var$Yg.next = a;
    }
    return b;
}
var $0331271bace68e97$var$fh = null;
function $0331271bace68e97$var$gh(a) {
    null === $0331271bace68e97$var$fh ? $0331271bace68e97$var$fh = [
        a
    ] : $0331271bace68e97$var$fh.push(a);
}
function $0331271bace68e97$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0331271bace68e97$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0331271bace68e97$var$ih(a, d);
}
function $0331271bace68e97$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0331271bace68e97$var$jh = !1;
function $0331271bace68e97$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0331271bace68e97$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0331271bace68e97$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0331271bace68e97$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0331271bace68e97$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0331271bace68e97$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0331271bace68e97$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0331271bace68e97$var$ih(a, c);
}
function $0331271bace68e97$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
function $0331271bace68e97$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0331271bace68e97$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0331271bace68e97$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0331271bace68e97$var$A({}, q, r);
                            break a;
                        case 2:
                            $0331271bace68e97$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0331271bace68e97$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0331271bace68e97$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0331271bace68e97$var$p(191, e));
            e.call(d);
        }
    }
}
var $0331271bace68e97$var$th = {}, $0331271bace68e97$var$uh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th), $0331271bace68e97$var$vh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th), $0331271bace68e97$var$wh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th);
function $0331271bace68e97$var$xh(a) {
    if (a === $0331271bace68e97$var$th) throw Error($0331271bace68e97$var$p(174));
    return a;
}
function $0331271bace68e97$var$yh(a, b) {
    $0331271bace68e97$var$G($0331271bace68e97$var$wh, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$vh, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$uh, $0331271bace68e97$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0331271bace68e97$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0331271bace68e97$var$lb(b, a);
    }
    $0331271bace68e97$var$E($0331271bace68e97$var$uh);
    $0331271bace68e97$var$G($0331271bace68e97$var$uh, b);
}
function $0331271bace68e97$var$zh() {
    $0331271bace68e97$var$E($0331271bace68e97$var$uh);
    $0331271bace68e97$var$E($0331271bace68e97$var$vh);
    $0331271bace68e97$var$E($0331271bace68e97$var$wh);
}
function $0331271bace68e97$var$Ah(a) {
    $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
    var b = $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
    var c = $0331271bace68e97$var$lb(b, a.type);
    b !== c && ($0331271bace68e97$var$G($0331271bace68e97$var$vh, a), $0331271bace68e97$var$G($0331271bace68e97$var$uh, c));
}
function $0331271bace68e97$var$Bh(a) {
    $0331271bace68e97$var$vh.current === a && ($0331271bace68e97$var$E($0331271bace68e97$var$uh), $0331271bace68e97$var$E($0331271bace68e97$var$vh));
}
var $0331271bace68e97$var$L = $0331271bace68e97$var$Uf(0);
function $0331271bace68e97$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0331271bace68e97$var$Dh = [];
function $0331271bace68e97$var$Eh() {
    for(var a = 0; a < $0331271bace68e97$var$Dh.length; a++)$0331271bace68e97$var$Dh[a]._workInProgressVersionPrimary = null;
    $0331271bace68e97$var$Dh.length = 0;
}
var $0331271bace68e97$var$Fh = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$Gh = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$Hh = 0, $0331271bace68e97$var$M = null, $0331271bace68e97$var$N = null, $0331271bace68e97$var$O = null, $0331271bace68e97$var$Ih = !1, $0331271bace68e97$var$Jh = !1, $0331271bace68e97$var$Kh = 0, $0331271bace68e97$var$Lh = 0;
function $0331271bace68e97$var$P() {
    throw Error($0331271bace68e97$var$p(321));
}
function $0331271bace68e97$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0331271bace68e97$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0331271bace68e97$var$Nh(a, b, c, d, e, f) {
    $0331271bace68e97$var$Hh = f;
    $0331271bace68e97$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0331271bace68e97$var$Fh.current = null === a || null === a.memoizedState ? $0331271bace68e97$var$Oh : $0331271bace68e97$var$Ph;
    a = c(d, e);
    if ($0331271bace68e97$var$Jh) {
        f = 0;
        do {
            $0331271bace68e97$var$Jh = !1;
            $0331271bace68e97$var$Kh = 0;
            if (25 <= f) throw Error($0331271bace68e97$var$p(301));
            f += 1;
            $0331271bace68e97$var$O = $0331271bace68e97$var$N = null;
            b.updateQueue = null;
            $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Qh;
            a = c(d, e);
        }while ($0331271bace68e97$var$Jh);
    }
    $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Rh;
    b = null !== $0331271bace68e97$var$N && null !== $0331271bace68e97$var$N.next;
    $0331271bace68e97$var$Hh = 0;
    $0331271bace68e97$var$O = $0331271bace68e97$var$N = $0331271bace68e97$var$M = null;
    $0331271bace68e97$var$Ih = !1;
    if (b) throw Error($0331271bace68e97$var$p(300));
    return a;
}
function $0331271bace68e97$var$Sh() {
    var a = 0 !== $0331271bace68e97$var$Kh;
    $0331271bace68e97$var$Kh = 0;
    return a;
}
function $0331271bace68e97$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState = $0331271bace68e97$var$O = a : $0331271bace68e97$var$O = $0331271bace68e97$var$O.next = a;
    return $0331271bace68e97$var$O;
}
function $0331271bace68e97$var$Uh() {
    if (null === $0331271bace68e97$var$N) {
        var a = $0331271bace68e97$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0331271bace68e97$var$N.next;
    var b = null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState : $0331271bace68e97$var$O.next;
    if (null !== b) $0331271bace68e97$var$O = b, $0331271bace68e97$var$N = a;
    else {
        if (null === a) throw Error($0331271bace68e97$var$p(310));
        $0331271bace68e97$var$N = a;
        a = {
            memoizedState: $0331271bace68e97$var$N.memoizedState,
            baseState: $0331271bace68e97$var$N.baseState,
            baseQueue: $0331271bace68e97$var$N.baseQueue,
            queue: $0331271bace68e97$var$N.queue,
            next: null
        };
        null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState = $0331271bace68e97$var$O = a : $0331271bace68e97$var$O = $0331271bace68e97$var$O.next = a;
    }
    return $0331271bace68e97$var$O;
}
function $0331271bace68e97$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0331271bace68e97$var$Wh(a) {
    var b = $0331271bace68e97$var$Uh(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0331271bace68e97$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0331271bace68e97$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0331271bace68e97$var$M.lanes |= m;
                $0331271bace68e97$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0331271bace68e97$var$He(d, b.memoizedState) || ($0331271bace68e97$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0331271bace68e97$var$M.lanes |= f, $0331271bace68e97$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0331271bace68e97$var$Xh(a) {
    var b = $0331271bace68e97$var$Uh(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0331271bace68e97$var$He(f, b.memoizedState) || ($0331271bace68e97$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0331271bace68e97$var$Yh() {}
function $0331271bace68e97$var$Zh(a, b) {
    var c = $0331271bace68e97$var$M, d = $0331271bace68e97$var$Uh(), e = b(), f = !$0331271bace68e97$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0331271bace68e97$var$dh = !0);
    d = d.queue;
    $0331271bace68e97$var$$h($0331271bace68e97$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0331271bace68e97$var$O && $0331271bace68e97$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0331271bace68e97$var$bi(9, $0331271bace68e97$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0331271bace68e97$var$Q) throw Error($0331271bace68e97$var$p(349));
        0 !== ($0331271bace68e97$var$Hh & 30) || $0331271bace68e97$var$di(c, b, e);
    }
    return e;
}
function $0331271bace68e97$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0331271bace68e97$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0331271bace68e97$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0331271bace68e97$var$ei(b) && $0331271bace68e97$var$fi(a);
}
function $0331271bace68e97$var$ai(a, b, c) {
    return c(function() {
        $0331271bace68e97$var$ei(b) && $0331271bace68e97$var$fi(a);
    });
}
function $0331271bace68e97$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0331271bace68e97$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0331271bace68e97$var$fi(a) {
    var b = $0331271bace68e97$var$ih(a, 1);
    null !== b && $0331271bace68e97$var$gi(b, a, 1, -1);
}
function $0331271bace68e97$var$hi(a) {
    var b = $0331271bace68e97$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0331271bace68e97$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0331271bace68e97$var$ii.bind(null, $0331271bace68e97$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0331271bace68e97$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0331271bace68e97$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0331271bace68e97$var$ji() {
    return $0331271bace68e97$var$Uh().memoizedState;
}
function $0331271bace68e97$var$ki(a, b, c, d) {
    var e = $0331271bace68e97$var$Th();
    $0331271bace68e97$var$M.flags |= a;
    e.memoizedState = $0331271bace68e97$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0331271bace68e97$var$li(a, b, c, d) {
    var e = $0331271bace68e97$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0331271bace68e97$var$N) {
        var g = $0331271bace68e97$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0331271bace68e97$var$Mh(d, g.deps)) {
            e.memoizedState = $0331271bace68e97$var$bi(b, c, f, d);
            return;
        }
    }
    $0331271bace68e97$var$M.flags |= a;
    e.memoizedState = $0331271bace68e97$var$bi(1 | b, c, f, d);
}
function $0331271bace68e97$var$mi(a, b) {
    return $0331271bace68e97$var$ki(8390656, 8, a, b);
}
function $0331271bace68e97$var$$h(a, b) {
    return $0331271bace68e97$var$li(2048, 8, a, b);
}
function $0331271bace68e97$var$ni(a, b) {
    return $0331271bace68e97$var$li(4, 2, a, b);
}
function $0331271bace68e97$var$oi(a, b) {
    return $0331271bace68e97$var$li(4, 4, a, b);
}
function $0331271bace68e97$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0331271bace68e97$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0331271bace68e97$var$li(4, 4, $0331271bace68e97$var$pi.bind(null, b, a), c);
}
function $0331271bace68e97$var$ri() {}
function $0331271bace68e97$var$si(a, b) {
    var c = $0331271bace68e97$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$ti(a, b) {
    var c = $0331271bace68e97$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$ui(a, b, c) {
    if (0 === ($0331271bace68e97$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0331271bace68e97$var$dh = !0), a.memoizedState = c;
    $0331271bace68e97$var$He(c, b) || (c = $0331271bace68e97$var$yc(), $0331271bace68e97$var$M.lanes |= c, $0331271bace68e97$var$rh |= c, a.baseState = !0);
    return b;
}
function $0331271bace68e97$var$vi(a, b) {
    var c = $0331271bace68e97$var$C;
    $0331271bace68e97$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0331271bace68e97$var$Gh.transition;
    $0331271bace68e97$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0331271bace68e97$var$C = c, $0331271bace68e97$var$Gh.transition = d;
    }
}
function $0331271bace68e97$var$wi() {
    return $0331271bace68e97$var$Uh().memoizedState;
}
function $0331271bace68e97$var$xi(a, b, c) {
    var d = $0331271bace68e97$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$zi(a)) $0331271bace68e97$var$Ai(b, c);
    else if (c = $0331271bace68e97$var$hh(a, b, c, d), null !== c) {
        var e = $0331271bace68e97$var$R();
        $0331271bace68e97$var$gi(c, a, d, e);
        $0331271bace68e97$var$Bi(c, b, d);
    }
}
function $0331271bace68e97$var$ii(a, b, c) {
    var d = $0331271bace68e97$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$zi(a)) $0331271bace68e97$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0331271bace68e97$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0331271bace68e97$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0331271bace68e97$var$hh(a, b, e, d);
        null !== c && (e = $0331271bace68e97$var$R(), $0331271bace68e97$var$gi(c, a, d, e), $0331271bace68e97$var$Bi(c, b, d));
    }
}
function $0331271bace68e97$var$zi(a) {
    var b = a.alternate;
    return a === $0331271bace68e97$var$M || null !== b && b === $0331271bace68e97$var$M;
}
function $0331271bace68e97$var$Ai(a, b) {
    $0331271bace68e97$var$Jh = $0331271bace68e97$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0331271bace68e97$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
var $0331271bace68e97$var$Rh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$P,
    useContext: $0331271bace68e97$var$P,
    useEffect: $0331271bace68e97$var$P,
    useImperativeHandle: $0331271bace68e97$var$P,
    useInsertionEffect: $0331271bace68e97$var$P,
    useLayoutEffect: $0331271bace68e97$var$P,
    useMemo: $0331271bace68e97$var$P,
    useReducer: $0331271bace68e97$var$P,
    useRef: $0331271bace68e97$var$P,
    useState: $0331271bace68e97$var$P,
    useDebugValue: $0331271bace68e97$var$P,
    useDeferredValue: $0331271bace68e97$var$P,
    useTransition: $0331271bace68e97$var$P,
    useMutableSource: $0331271bace68e97$var$P,
    useSyncExternalStore: $0331271bace68e97$var$P,
    useId: $0331271bace68e97$var$P,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Oh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: function useCallback(a, b) {
        $0331271bace68e97$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0331271bace68e97$var$ki(4194308, 4, $0331271bace68e97$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $0331271bace68e97$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $0331271bace68e97$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $0331271bace68e97$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $0331271bace68e97$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0331271bace68e97$var$xi.bind(null, $0331271bace68e97$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $0331271bace68e97$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0331271bace68e97$var$hi,
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $0331271bace68e97$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$hi(!1), b = a[0];
        a = $0331271bace68e97$var$vi.bind(null, a[1]);
        $0331271bace68e97$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $0331271bace68e97$var$M, e = $0331271bace68e97$var$Th();
        if ($0331271bace68e97$var$I) {
            if (void 0 === c) throw Error($0331271bace68e97$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0331271bace68e97$var$Q) throw Error($0331271bace68e97$var$p(349));
            0 !== ($0331271bace68e97$var$Hh & 30) || $0331271bace68e97$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0331271bace68e97$var$mi($0331271bace68e97$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0331271bace68e97$var$bi(9, $0331271bace68e97$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $0331271bace68e97$var$Th(), b = $0331271bace68e97$var$Q.identifierPrefix;
        if ($0331271bace68e97$var$I) {
            var c = $0331271bace68e97$var$sg;
            var d = $0331271bace68e97$var$rg;
            c = (d & ~(1 << 32 - $0331271bace68e97$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0331271bace68e97$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0331271bace68e97$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Ph = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$si,
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$$h,
    useImperativeHandle: $0331271bace68e97$var$qi,
    useInsertionEffect: $0331271bace68e97$var$ni,
    useLayoutEffect: $0331271bace68e97$var$oi,
    useMemo: $0331271bace68e97$var$ti,
    useReducer: $0331271bace68e97$var$Wh,
    useRef: $0331271bace68e97$var$ji,
    useState: function useState() {
        return $0331271bace68e97$var$Wh($0331271bace68e97$var$Vh);
    },
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$Uh();
        return $0331271bace68e97$var$ui(b, $0331271bace68e97$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$Wh($0331271bace68e97$var$Vh)[0], b = $0331271bace68e97$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$Yh,
    useSyncExternalStore: $0331271bace68e97$var$Zh,
    useId: $0331271bace68e97$var$wi,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Qh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$si,
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$$h,
    useImperativeHandle: $0331271bace68e97$var$qi,
    useInsertionEffect: $0331271bace68e97$var$ni,
    useLayoutEffect: $0331271bace68e97$var$oi,
    useMemo: $0331271bace68e97$var$ti,
    useReducer: $0331271bace68e97$var$Xh,
    useRef: $0331271bace68e97$var$ji,
    useState: function useState() {
        return $0331271bace68e97$var$Xh($0331271bace68e97$var$Vh);
    },
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$Uh();
        return null === $0331271bace68e97$var$N ? b.memoizedState = a : $0331271bace68e97$var$ui(b, $0331271bace68e97$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$Xh($0331271bace68e97$var$Vh)[0], b = $0331271bace68e97$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$Yh,
    useSyncExternalStore: $0331271bace68e97$var$Zh,
    useId: $0331271bace68e97$var$wi,
    unstable_isNewReconciler: !1
};
function $0331271bace68e97$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0331271bace68e97$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0331271bace68e97$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0331271bace68e97$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0331271bace68e97$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $0331271bace68e97$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$R(), e = $0331271bace68e97$var$yi(a), f = $0331271bace68e97$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$nh(a, f, e);
        null !== b && ($0331271bace68e97$var$gi(b, a, e, d), $0331271bace68e97$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$R(), e = $0331271bace68e97$var$yi(a), f = $0331271bace68e97$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$nh(a, f, e);
        null !== b && ($0331271bace68e97$var$gi(b, a, e, d), $0331271bace68e97$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $0331271bace68e97$var$R(), d = $0331271bace68e97$var$yi(a), e = $0331271bace68e97$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0331271bace68e97$var$nh(a, e, d);
        null !== b && ($0331271bace68e97$var$gi(b, a, d, c), $0331271bace68e97$var$oh(b, a, d));
    }
};
function $0331271bace68e97$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0331271bace68e97$var$Ie(c, d) || !$0331271bace68e97$var$Ie(e, f) : !0;
}
function $0331271bace68e97$var$Gi(a, b, c) {
    var d = !1, e = $0331271bace68e97$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0331271bace68e97$var$eh(f) : (e = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0331271bace68e97$var$Yf(a, e) : $0331271bace68e97$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0331271bace68e97$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0331271bace68e97$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0331271bace68e97$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0331271bace68e97$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0331271bace68e97$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0331271bace68e97$var$eh(f) : (f = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, e.context = $0331271bace68e97$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0331271bace68e97$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0331271bace68e97$var$Ei.enqueueReplaceState(e, e.state, null), $0331271bace68e97$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0331271bace68e97$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0331271bace68e97$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0331271bace68e97$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0331271bace68e97$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0331271bace68e97$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0331271bace68e97$var$Ni(a, b, c) {
    c = $0331271bace68e97$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0331271bace68e97$var$Oi || ($0331271bace68e97$var$Oi = !0, $0331271bace68e97$var$Pi = d);
        $0331271bace68e97$var$Li(a, b);
    };
    return c;
}
function $0331271bace68e97$var$Qi(a, b, c) {
    c = $0331271bace68e97$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0331271bace68e97$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0331271bace68e97$var$Li(a, b);
        "function" !== typeof d && (null === $0331271bace68e97$var$Ri ? $0331271bace68e97$var$Ri = new Set([
            this
        ]) : $0331271bace68e97$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $0331271bace68e97$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0331271bace68e97$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0331271bace68e97$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0331271bace68e97$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0331271bace68e97$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0331271bace68e97$var$mh(-1, 1), b.tag = 2, $0331271bace68e97$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0331271bace68e97$var$Wi = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$dh = !1;
function $0331271bace68e97$var$Xi(a, b, c, d) {
    b.child = null === a ? $0331271bace68e97$var$Vg(b, null, c, d) : $0331271bace68e97$var$Ug(b, a.child, c, d);
}
function $0331271bace68e97$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0331271bace68e97$var$ch(b, e);
    d = $0331271bace68e97$var$Nh(a, b, c, d, f, e);
    c = $0331271bace68e97$var$Sh();
    if (null !== a && !$0331271bace68e97$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$Zi(a, b, e);
    $0331271bace68e97$var$I && c && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Xi(a, b, d, e);
    return b.child;
}
function $0331271bace68e97$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0331271bace68e97$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0331271bace68e97$var$bj(a, b, f, d, e);
        a = $0331271bace68e97$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0331271bace68e97$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0331271bace68e97$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0331271bace68e97$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0331271bace68e97$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0331271bace68e97$var$Ie(f, d) && a.ref === b.ref) {
            if ($0331271bace68e97$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0331271bace68e97$var$dh = !0);
            else return b.lanes = a.lanes, $0331271bace68e97$var$Zi(a, b, e);
        }
    }
    return $0331271bace68e97$var$cj(a, b, c, d, e);
}
function $0331271bace68e97$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj);
            $0331271bace68e97$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= d;
    $0331271bace68e97$var$Xi(a, b, e, c);
    return b.child;
}
function $0331271bace68e97$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0331271bace68e97$var$cj(a, b, c, d, e) {
    var f = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current;
    f = $0331271bace68e97$var$Yf(b, f);
    $0331271bace68e97$var$ch(b, e);
    c = $0331271bace68e97$var$Nh(a, b, c, d, f, e);
    d = $0331271bace68e97$var$Sh();
    if (null !== a && !$0331271bace68e97$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$Zi(a, b, e);
    $0331271bace68e97$var$I && d && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Xi(a, b, c, e);
    return b.child;
}
function $0331271bace68e97$var$hj(a, b, c, d, e) {
    if ($0331271bace68e97$var$Zf(c)) {
        var f = !0;
        $0331271bace68e97$var$cg(b);
    } else f = !1;
    $0331271bace68e97$var$ch(b, e);
    if (null === b.stateNode) $0331271bace68e97$var$ij(a, b), $0331271bace68e97$var$Gi(b, c, d), $0331271bace68e97$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0331271bace68e97$var$eh(l) : (l = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, l = $0331271bace68e97$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0331271bace68e97$var$Hi(b, g, d, l);
        $0331271bace68e97$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$jh ? ("function" === typeof m && ($0331271bace68e97$var$Di(b, c, m, d), k = b.memoizedState), (h = $0331271bace68e97$var$jh || $0331271bace68e97$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0331271bace68e97$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0331271bace68e97$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0331271bace68e97$var$eh(k) : (k = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, k = $0331271bace68e97$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0331271bace68e97$var$Hi(b, g, d, k);
        $0331271bace68e97$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$jh ? ("function" === typeof y && ($0331271bace68e97$var$Di(b, c, y, d), n = b.memoizedState), (l = $0331271bace68e97$var$jh || $0331271bace68e97$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0331271bace68e97$var$jj(a, b, c, d, f, e);
}
function $0331271bace68e97$var$jj(a, b, c, d, e, f) {
    $0331271bace68e97$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0331271bace68e97$var$dg(b, c, !1), $0331271bace68e97$var$Zi(a, b, f);
    d = b.stateNode;
    $0331271bace68e97$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0331271bace68e97$var$Ug(b, a.child, null, f), b.child = $0331271bace68e97$var$Ug(b, null, h, f)) : $0331271bace68e97$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0331271bace68e97$var$dg(b, c, !0);
    return b.child;
}
function $0331271bace68e97$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0331271bace68e97$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0331271bace68e97$var$ag(a, b.context, !1);
    $0331271bace68e97$var$yh(a, b.containerInfo);
}
function $0331271bace68e97$var$lj(a, b, c, d, e) {
    $0331271bace68e97$var$Ig();
    $0331271bace68e97$var$Jg(e);
    b.flags |= 256;
    $0331271bace68e97$var$Xi(a, b, c, d);
    return b.child;
}
var $0331271bace68e97$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0331271bace68e97$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0331271bace68e97$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0331271bace68e97$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0331271bace68e97$var$G($0331271bace68e97$var$L, e & 1);
    if (null === a) {
        $0331271bace68e97$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0331271bace68e97$var$pj(g, d, 0, null), a = $0331271bace68e97$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0331271bace68e97$var$nj(c), b.memoizedState = $0331271bace68e97$var$mj, a) : $0331271bace68e97$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0331271bace68e97$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0331271bace68e97$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0331271bace68e97$var$Pg(h, f) : (f = $0331271bace68e97$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0331271bace68e97$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0331271bace68e97$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0331271bace68e97$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0331271bace68e97$var$qj(a, b) {
    b = $0331271bace68e97$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0331271bace68e97$var$sj(a, b, c, d) {
    null !== d && $0331271bace68e97$var$Jg(d);
    $0331271bace68e97$var$Ug(b, a.child, null, c);
    a = $0331271bace68e97$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0331271bace68e97$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(422))), $0331271bace68e97$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0331271bace68e97$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0331271bace68e97$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0331271bace68e97$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0331271bace68e97$var$nj(g);
        b.memoizedState = $0331271bace68e97$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0331271bace68e97$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0331271bace68e97$var$p(419));
        d = $0331271bace68e97$var$Ki(f, d, void 0);
        return $0331271bace68e97$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0331271bace68e97$var$dh || h) {
        d = $0331271bace68e97$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0331271bace68e97$var$ih(a, e), $0331271bace68e97$var$gi(d, a, e, -1));
        }
        $0331271bace68e97$var$tj();
        d = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(421)));
        return $0331271bace68e97$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0331271bace68e97$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(e.nextSibling);
    $0331271bace68e97$var$xg = b;
    $0331271bace68e97$var$I = !0;
    $0331271bace68e97$var$zg = null;
    null !== a && ($0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg, $0331271bace68e97$var$rg = a.id, $0331271bace68e97$var$sg = a.overflow, $0331271bace68e97$var$qg = b);
    b = $0331271bace68e97$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0331271bace68e97$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0331271bace68e97$var$bh(a.return, b, c);
}
function $0331271bace68e97$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0331271bace68e97$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0331271bace68e97$var$Xi(a, b, d.children, c);
    d = $0331271bace68e97$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0331271bace68e97$var$vj(a, c, b);
            else if (19 === a.tag) $0331271bace68e97$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0331271bace68e97$var$G($0331271bace68e97$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0331271bace68e97$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0331271bace68e97$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0331271bace68e97$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0331271bace68e97$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0331271bace68e97$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0331271bace68e97$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0331271bace68e97$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0331271bace68e97$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0331271bace68e97$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0331271bace68e97$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0331271bace68e97$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0331271bace68e97$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0331271bace68e97$var$kj(b);
            $0331271bace68e97$var$Ig();
            break;
        case 5:
            $0331271bace68e97$var$Ah(b);
            break;
        case 1:
            $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$cg(b);
            break;
        case 4:
            $0331271bace68e97$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0331271bace68e97$var$G($0331271bace68e97$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0331271bace68e97$var$oj(a, b, c);
                $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1);
                a = $0331271bace68e97$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0331271bace68e97$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0331271bace68e97$var$dj(a, b, c);
    }
    return $0331271bace68e97$var$Zi(a, b, c);
}
var $0331271bace68e97$var$zj, $0331271bace68e97$var$Aj, $0331271bace68e97$var$Bj, $0331271bace68e97$var$Cj;
$0331271bace68e97$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0331271bace68e97$var$Aj = function Aj() {};
$0331271bace68e97$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0331271bace68e97$var$Ya(a, e);
                d = $0331271bace68e97$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0331271bace68e97$var$A({}, e, {
                    value: void 0
                });
                d = $0331271bace68e97$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0331271bace68e97$var$gb(a, e);
                d = $0331271bace68e97$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0331271bace68e97$var$Bf);
        }
        $0331271bace68e97$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0331271bace68e97$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0331271bace68e97$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0331271bace68e97$var$Dj(a, b) {
    if (!$0331271bace68e97$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0331271bace68e97$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0331271bace68e97$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0331271bace68e97$var$S(b), null;
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0331271bace68e97$var$zh();
            $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
            $0331271bace68e97$var$E($0331271bace68e97$var$H);
            $0331271bace68e97$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0331271bace68e97$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Fj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null));
            $0331271bace68e97$var$Aj(a, b);
            $0331271bace68e97$var$S(b);
            return null;
        case 5:
            $0331271bace68e97$var$Bh(b);
            var e = $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0331271bace68e97$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                    $0331271bace68e97$var$S(b);
                    return null;
                }
                a = $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    d[$0331271bace68e97$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0331271bace68e97$var$D("cancel", d);
                            $0331271bace68e97$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], d);
                            break;
                        case "source":
                            $0331271bace68e97$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0331271bace68e97$var$D("error", d);
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "details":
                            $0331271bace68e97$var$D("toggle", d);
                            break;
                        case "input":
                            $0331271bace68e97$var$Za(d, f);
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$hb(d, f), $0331271bace68e97$var$D("invalid", d);
                    }
                    $0331271bace68e97$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0331271bace68e97$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0331271bace68e97$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0331271bace68e97$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0331271bace68e97$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0331271bace68e97$var$Of] = b;
                    a[$0331271bace68e97$var$Pf] = d;
                    $0331271bace68e97$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0331271bace68e97$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0331271bace68e97$var$D("cancel", a);
                                $0331271bace68e97$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0331271bace68e97$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0331271bace68e97$var$D("error", a);
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0331271bace68e97$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0331271bace68e97$var$Za(a, d);
                                e = $0331271bace68e97$var$Ya(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0331271bace68e97$var$A({}, d, {
                                    value: void 0
                                });
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$hb(a, d);
                                e = $0331271bace68e97$var$gb(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0331271bace68e97$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0331271bace68e97$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0331271bace68e97$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0331271bace68e97$var$ob(a, k) : "number" === typeof k && $0331271bace68e97$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0331271bace68e97$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0331271bace68e97$var$D("scroll", a) : null != k && $0331271bace68e97$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0331271bace68e97$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0331271bace68e97$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0331271bace68e97$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0331271bace68e97$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0331271bace68e97$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                c = $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
                $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0331271bace68e97$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0331271bace68e97$var$Of] = b, b.stateNode = d;
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0331271bace68e97$var$I && null !== $0331271bace68e97$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0331271bace68e97$var$Hg(), $0331271bace68e97$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0331271bace68e97$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0331271bace68e97$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0331271bace68e97$var$p(317));
                        f[$0331271bace68e97$var$Of] = b;
                    } else $0331271bace68e97$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0331271bace68e97$var$S(b);
                    f = !1;
                } else null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Fj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0331271bace68e97$var$L.current & 1) ? 0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 3) : $0331271bace68e97$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0331271bace68e97$var$S(b);
            return null;
        case 4:
            return $0331271bace68e97$var$zh(), $0331271bace68e97$var$Aj(a, b), null === a && $0331271bace68e97$var$sf(b.stateNode.containerInfo), $0331271bace68e97$var$S(b), null;
        case 10:
            return $0331271bace68e97$var$ah(b.type._context), $0331271bace68e97$var$S(b), null;
        case 17:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 19:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            f = b.memoizedState;
            if (null === f) return $0331271bace68e97$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0331271bace68e97$var$Dj(f, !1);
                else {
                    if (0 !== $0331271bace68e97$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0331271bace68e97$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0331271bace68e97$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0331271bace68e97$var$B() > $0331271bace68e97$var$Gj && (b.flags |= 128, d = !0, $0331271bace68e97$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0331271bace68e97$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0331271bace68e97$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0331271bace68e97$var$I) return $0331271bace68e97$var$S(b), null;
                    } else 2 * $0331271bace68e97$var$B() - f.renderingStartTime > $0331271bace68e97$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0331271bace68e97$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0331271bace68e97$var$B(), b.sibling = null, c = $0331271bace68e97$var$L.current, $0331271bace68e97$var$G($0331271bace68e97$var$L, d ? c & 1 | 2 : c & 1), b;
            $0331271bace68e97$var$S(b);
            return null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0331271bace68e97$var$fj & 1073741824) && ($0331271bace68e97$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0331271bace68e97$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
}
function $0331271bace68e97$var$Ij(a, b) {
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0331271bace68e97$var$zh(), $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0331271bace68e97$var$Bh(b), null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0331271bace68e97$var$p(340));
                $0331271bace68e97$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0331271bace68e97$var$E($0331271bace68e97$var$L), null;
        case 4:
            return $0331271bace68e97$var$zh(), null;
        case 10:
            return $0331271bace68e97$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0331271bace68e97$var$Jj = !1, $0331271bace68e97$var$U = !1, $0331271bace68e97$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0331271bace68e97$var$V = null;
function $0331271bace68e97$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0331271bace68e97$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0331271bace68e97$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0331271bace68e97$var$W(a, b, d);
    }
}
var $0331271bace68e97$var$Nj = !1;
function $0331271bace68e97$var$Oj(a, b) {
    $0331271bace68e97$var$Cf = $0331271bace68e97$var$dd;
    a = $0331271bace68e97$var$Me();
    if ($0331271bace68e97$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0331271bace68e97$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0331271bace68e97$var$dd = !1;
    for($0331271bace68e97$var$V = b; null !== $0331271bace68e97$var$V;)if (b = $0331271bace68e97$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0331271bace68e97$var$V = a;
    else for(; null !== $0331271bace68e97$var$V;){
        b = $0331271bace68e97$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0331271bace68e97$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(163));
            }
        } catch (F) {
            $0331271bace68e97$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0331271bace68e97$var$V = a;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
    n = $0331271bace68e97$var$Nj;
    $0331271bace68e97$var$Nj = !1;
    return n;
}
function $0331271bace68e97$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0331271bace68e97$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0331271bace68e97$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0331271bace68e97$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0331271bace68e97$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0331271bace68e97$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0331271bace68e97$var$Of], delete b[$0331271bace68e97$var$Pf], delete b[$0331271bace68e97$var$of], delete b[$0331271bace68e97$var$Qf], delete b[$0331271bace68e97$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0331271bace68e97$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0331271bace68e97$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0331271bace68e97$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0331271bace68e97$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0331271bace68e97$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Vj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Vj(a, b, c), a = a.sibling;
}
function $0331271bace68e97$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Wj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Wj(a, b, c), a = a.sibling;
}
var $0331271bace68e97$var$X = null, $0331271bace68e97$var$Xj = !1;
function $0331271bace68e97$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0331271bace68e97$var$Zj(a, b, c), c = c.sibling;
}
function $0331271bace68e97$var$Zj(a, b, c) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberUnmount) try {
        $0331271bace68e97$var$lc.onCommitFiberUnmount($0331271bace68e97$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0331271bace68e97$var$U || $0331271bace68e97$var$Lj(c, b);
        case 6:
            var d = $0331271bace68e97$var$X, e = $0331271bace68e97$var$Xj;
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Yj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Xj = e;
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Xj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0331271bace68e97$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Xj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? $0331271bace68e97$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0331271bace68e97$var$Kf(a, c), $0331271bace68e97$var$bd(a)) : $0331271bace68e97$var$Kf($0331271bace68e97$var$X, c.stateNode));
            break;
        case 4:
            d = $0331271bace68e97$var$X;
            e = $0331271bace68e97$var$Xj;
            $0331271bace68e97$var$X = c.stateNode.containerInfo;
            $0331271bace68e97$var$Xj = !0;
            $0331271bace68e97$var$Yj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0331271bace68e97$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0331271bace68e97$var$Mj(c, b, g) : 0 !== (f & 4) && $0331271bace68e97$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0331271bace68e97$var$U && ($0331271bace68e97$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0331271bace68e97$var$W(c, b, h);
            }
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 21:
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0331271bace68e97$var$U = (d = $0331271bace68e97$var$U) || null !== c.memoizedState, $0331271bace68e97$var$Yj(a, b, c), $0331271bace68e97$var$U = d) : $0331271bace68e97$var$Yj(a, b, c);
            break;
        default:
            $0331271bace68e97$var$Yj(a, b, c);
    }
}
function $0331271bace68e97$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0331271bace68e97$var$Kj);
        b.forEach(function(b) {
            var d = $0331271bace68e97$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0331271bace68e97$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0331271bace68e97$var$X = h.stateNode;
                        $0331271bace68e97$var$Xj = !1;
                        break a;
                    case 3:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Xj = !0;
                        break a;
                    case 4:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0331271bace68e97$var$X) throw Error($0331271bace68e97$var$p(160));
            $0331271bace68e97$var$Zj(f, g, e);
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0331271bace68e97$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0331271bace68e97$var$dk(b, a), b = b.sibling;
}
function $0331271bace68e97$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4) {
                try {
                    $0331271bace68e97$var$Pj(3, a, a.return), $0331271bace68e97$var$Qj(3, a);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
                try {
                    $0331271bace68e97$var$Pj(5, a, a.return);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 512 && null !== c && $0331271bace68e97$var$Lj(c, c.return);
            break;
        case 5:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 512 && null !== c && $0331271bace68e97$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0331271bace68e97$var$ob(e, "");
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0331271bace68e97$var$ab(e, f);
                    $0331271bace68e97$var$vb(h, g);
                    var l = $0331271bace68e97$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0331271bace68e97$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0331271bace68e97$var$nb(e, q) : "children" === m ? $0331271bace68e97$var$ob(e, q) : $0331271bace68e97$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0331271bace68e97$var$bb(e, f);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0331271bace68e97$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0331271bace68e97$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0331271bace68e97$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0331271bace68e97$var$Pf] = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0331271bace68e97$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0331271bace68e97$var$bd(b.containerInfo);
            } catch (t) {
                $0331271bace68e97$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            break;
        case 13:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0331271bace68e97$var$fk = $0331271bace68e97$var$B()));
            d & 4 && $0331271bace68e97$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0331271bace68e97$var$U = (l = $0331271bace68e97$var$U) || m, $0331271bace68e97$var$ck(b, a), $0331271bace68e97$var$U = l) : $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0331271bace68e97$var$V = a, m = a.child; null !== m;){
                    for(q = $0331271bace68e97$var$V = m; null !== $0331271bace68e97$var$V;){
                        r = $0331271bace68e97$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0331271bace68e97$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0331271bace68e97$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0331271bace68e97$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0331271bace68e97$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0331271bace68e97$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0331271bace68e97$var$V = y) : $0331271bace68e97$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0331271bace68e97$var$rb("display", g));
                            } catch (t) {
                                $0331271bace68e97$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0331271bace68e97$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 4 && $0331271bace68e97$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0331271bace68e97$var$ck(b, a), $0331271bace68e97$var$ek(a);
    }
}
function $0331271bace68e97$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0331271bace68e97$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0331271bace68e97$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0331271bace68e97$var$ob(e, ""), d.flags &= -33);
                    var f = $0331271bace68e97$var$Uj(a);
                    $0331271bace68e97$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0331271bace68e97$var$Uj(a);
                    $0331271bace68e97$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(161));
            }
        } catch (k) {
            $0331271bace68e97$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0331271bace68e97$var$hk(a, b, c) {
    $0331271bace68e97$var$V = a;
    $0331271bace68e97$var$ik(a, b, c);
}
function $0331271bace68e97$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0331271bace68e97$var$V;){
        var e = $0331271bace68e97$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0331271bace68e97$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0331271bace68e97$var$U;
                h = $0331271bace68e97$var$Jj;
                var l = $0331271bace68e97$var$U;
                $0331271bace68e97$var$Jj = g;
                if (($0331271bace68e97$var$U = k) && !l) for($0331271bace68e97$var$V = e; null !== $0331271bace68e97$var$V;)g = $0331271bace68e97$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0331271bace68e97$var$jk(e) : null !== k ? (k.return = g, $0331271bace68e97$var$V = k) : $0331271bace68e97$var$jk(e);
                for(; null !== f;)$0331271bace68e97$var$V = f, $0331271bace68e97$var$ik(f, b, c), f = f.sibling;
                $0331271bace68e97$var$V = e;
                $0331271bace68e97$var$Jj = h;
                $0331271bace68e97$var$U = l;
            }
            $0331271bace68e97$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0331271bace68e97$var$V = f) : $0331271bace68e97$var$kk(a, b, c);
    }
}
function $0331271bace68e97$var$kk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0331271bace68e97$var$U || $0331271bace68e97$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0331271bace68e97$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0331271bace68e97$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0331271bace68e97$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0331271bace68e97$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0331271bace68e97$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0331271bace68e97$var$p(163));
                }
                $0331271bace68e97$var$U || b.flags & 512 && $0331271bace68e97$var$Rj(b);
            } catch (r) {
                $0331271bace68e97$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$gk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$jk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0331271bace68e97$var$Qj(4, b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0331271bace68e97$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0331271bace68e97$var$Rj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0331271bace68e97$var$Rj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0331271bace68e97$var$W(b, b.return, k);
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0331271bace68e97$var$V = h;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
var $0331271bace68e97$var$lk = Math.ceil, $0331271bace68e97$var$mk = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$nk = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$ok = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$K = 0, $0331271bace68e97$var$Q = null, $0331271bace68e97$var$Y = null, $0331271bace68e97$var$Z = 0, $0331271bace68e97$var$fj = 0, $0331271bace68e97$var$ej = $0331271bace68e97$var$Uf(0), $0331271bace68e97$var$T = 0, $0331271bace68e97$var$pk = null, $0331271bace68e97$var$rh = 0, $0331271bace68e97$var$qk = 0, $0331271bace68e97$var$rk = 0, $0331271bace68e97$var$sk = null, $0331271bace68e97$var$tk = null, $0331271bace68e97$var$fk = 0, $0331271bace68e97$var$Gj = Infinity, $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Oi = !1, $0331271bace68e97$var$Pi = null, $0331271bace68e97$var$Ri = null, $0331271bace68e97$var$vk = !1, $0331271bace68e97$var$wk = null, $0331271bace68e97$var$xk = 0, $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = null, $0331271bace68e97$var$Ak = -1, $0331271bace68e97$var$Bk = 0;
function $0331271bace68e97$var$R() {
    return 0 !== ($0331271bace68e97$var$K & 6) ? $0331271bace68e97$var$B() : -1 !== $0331271bace68e97$var$Ak ? $0331271bace68e97$var$Ak : $0331271bace68e97$var$Ak = $0331271bace68e97$var$B();
}
function $0331271bace68e97$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0331271bace68e97$var$K & 2) && 0 !== $0331271bace68e97$var$Z) return $0331271bace68e97$var$Z & -$0331271bace68e97$var$Z;
    if (null !== $0331271bace68e97$var$Kg.transition) return 0 === $0331271bace68e97$var$Bk && ($0331271bace68e97$var$Bk = $0331271bace68e97$var$yc()), $0331271bace68e97$var$Bk;
    a = $0331271bace68e97$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0331271bace68e97$var$jd(a.type);
    return a;
}
function $0331271bace68e97$var$gi(a, b, c, d) {
    if (50 < $0331271bace68e97$var$yk) throw $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = null, Error($0331271bace68e97$var$p(185));
    $0331271bace68e97$var$Ac(a, c, d);
    if (0 === ($0331271bace68e97$var$K & 2) || a !== $0331271bace68e97$var$Q) a === $0331271bace68e97$var$Q && (0 === ($0331271bace68e97$var$K & 2) && ($0331271bace68e97$var$qk |= c), 4 === $0331271bace68e97$var$T && $0331271bace68e97$var$Ck(a, $0331271bace68e97$var$Z)), $0331271bace68e97$var$Dk(a, d), 1 === c && 0 === $0331271bace68e97$var$K && 0 === (b.mode & 1) && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
}
function $0331271bace68e97$var$Dk(a, b) {
    var c = a.callbackNode;
    $0331271bace68e97$var$wc(a, b);
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$Q ? $0331271bace68e97$var$Z : 0);
    if (0 === d) null !== c && $0331271bace68e97$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0331271bace68e97$var$bc(c);
        if (1 === b) 0 === a.tag ? $0331271bace68e97$var$ig($0331271bace68e97$var$Ek.bind(null, a)) : $0331271bace68e97$var$hg($0331271bace68e97$var$Ek.bind(null, a)), $0331271bace68e97$var$Jf(function() {
            0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
        }), c = null;
        else {
            switch($0331271bace68e97$var$Dc(d)){
                case 1:
                    c = $0331271bace68e97$var$fc;
                    break;
                case 4:
                    c = $0331271bace68e97$var$gc;
                    break;
                case 16:
                    c = $0331271bace68e97$var$hc;
                    break;
                case 536870912:
                    c = $0331271bace68e97$var$jc;
                    break;
                default:
                    c = $0331271bace68e97$var$hc;
            }
            c = $0331271bace68e97$var$Fk(c, $0331271bace68e97$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0331271bace68e97$var$Gk(a, b) {
    $0331271bace68e97$var$Ak = -1;
    $0331271bace68e97$var$Bk = 0;
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    var c = a.callbackNode;
    if ($0331271bace68e97$var$Hk() && a.callbackNode !== c) return null;
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$Q ? $0331271bace68e97$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0331271bace68e97$var$Ik(a, d);
    else {
        b = d;
        var e = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 2;
        var f = $0331271bace68e97$var$Jk();
        if ($0331271bace68e97$var$Q !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$Kk(a, b);
        for(;;)try {
            $0331271bace68e97$var$Lk();
            break;
        } catch (h) {
            $0331271bace68e97$var$Mk(a, h);
        }
        $0331271bace68e97$var$$g();
        $0331271bace68e97$var$mk.current = f;
        $0331271bace68e97$var$K = e;
        null !== $0331271bace68e97$var$Y ? b = 0 : ($0331271bace68e97$var$Q = null, $0331271bace68e97$var$Z = 0, b = $0331271bace68e97$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0331271bace68e97$var$xc(a), 0 !== e && (d = e, b = $0331271bace68e97$var$Nk(a, e)));
        if (1 === b) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, d), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
        if (6 === b) $0331271bace68e97$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0331271bace68e97$var$Ok(e) && (b = $0331271bace68e97$var$Ik(a, d), 2 === b && (f = $0331271bace68e97$var$xc(a), 0 !== f && (d = f, b = $0331271bace68e97$var$Nk(a, f))), 1 === b)) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, d), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0331271bace68e97$var$p(345));
                case 2:
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 3:
                    $0331271bace68e97$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0331271bace68e97$var$fk + 500 - $0331271bace68e97$var$B(), 10 < b)) {
                        if (0 !== $0331271bace68e97$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0331271bace68e97$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Pk.bind(null, a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk), b);
                        break;
                    }
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 4:
                    $0331271bace68e97$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0331271bace68e97$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0331271bace68e97$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0331271bace68e97$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Pk.bind(null, a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk), d);
                        break;
                    }
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 5:
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(329));
            }
        }
    }
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    return a.callbackNode === c ? $0331271bace68e97$var$Gk.bind(null, a) : null;
}
function $0331271bace68e97$var$Nk(a, b) {
    var c = $0331271bace68e97$var$sk;
    a.current.memoizedState.isDehydrated && ($0331271bace68e97$var$Kk(a, b).flags |= 256);
    a = $0331271bace68e97$var$Ik(a, b);
    2 !== a && (b = $0331271bace68e97$var$tk, $0331271bace68e97$var$tk = c, null !== b && $0331271bace68e97$var$Fj(b));
    return a;
}
function $0331271bace68e97$var$Fj(a) {
    null === $0331271bace68e97$var$tk ? $0331271bace68e97$var$tk = a : $0331271bace68e97$var$tk.push.apply($0331271bace68e97$var$tk, a);
}
function $0331271bace68e97$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0331271bace68e97$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0331271bace68e97$var$Ck(a, b) {
    b &= ~$0331271bace68e97$var$rk;
    b &= ~$0331271bace68e97$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0331271bace68e97$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0331271bace68e97$var$Ek(a) {
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    $0331271bace68e97$var$Hk();
    var b = $0331271bace68e97$var$uc(a, 0);
    if (0 === (b & 1)) return $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), null;
    var c = $0331271bace68e97$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0331271bace68e97$var$xc(a);
        0 !== d && (b = d, c = $0331271bace68e97$var$Nk(a, d));
    }
    if (1 === c) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, b), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
    if (6 === c) throw Error($0331271bace68e97$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    return null;
}
function $0331271bace68e97$var$Qk(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0331271bace68e97$var$K = c, 0 === $0331271bace68e97$var$K && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
    }
}
function $0331271bace68e97$var$Rk(a) {
    null !== $0331271bace68e97$var$wk && 0 === $0331271bace68e97$var$wk.tag && 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$Hk();
    var b = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    var c = $0331271bace68e97$var$ok.transition, d = $0331271bace68e97$var$C;
    try {
        if ($0331271bace68e97$var$ok.transition = null, $0331271bace68e97$var$C = 1, a) return a();
    } finally{
        $0331271bace68e97$var$C = d, $0331271bace68e97$var$ok.transition = c, $0331271bace68e97$var$K = b, 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
    }
}
function $0331271bace68e97$var$Hj() {
    $0331271bace68e97$var$fj = $0331271bace68e97$var$ej.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$ej);
}
function $0331271bace68e97$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0331271bace68e97$var$Gf(c));
    if (null !== $0331271bace68e97$var$Y) for(c = $0331271bace68e97$var$Y.return; null !== c;){
        var d = c;
        $0331271bace68e97$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0331271bace68e97$var$$f();
                break;
            case 3:
                $0331271bace68e97$var$zh();
                $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
                $0331271bace68e97$var$E($0331271bace68e97$var$H);
                $0331271bace68e97$var$Eh();
                break;
            case 5:
                $0331271bace68e97$var$Bh(d);
                break;
            case 4:
                $0331271bace68e97$var$zh();
                break;
            case 13:
                $0331271bace68e97$var$E($0331271bace68e97$var$L);
                break;
            case 19:
                $0331271bace68e97$var$E($0331271bace68e97$var$L);
                break;
            case 10:
                $0331271bace68e97$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0331271bace68e97$var$Hj();
        }
        c = c.return;
    }
    $0331271bace68e97$var$Q = a;
    $0331271bace68e97$var$Y = a = $0331271bace68e97$var$Pg(a.current, null);
    $0331271bace68e97$var$Z = $0331271bace68e97$var$fj = b;
    $0331271bace68e97$var$T = 0;
    $0331271bace68e97$var$pk = null;
    $0331271bace68e97$var$rk = $0331271bace68e97$var$qk = $0331271bace68e97$var$rh = 0;
    $0331271bace68e97$var$tk = $0331271bace68e97$var$sk = null;
    if (null !== $0331271bace68e97$var$fh) {
        for(b = 0; b < $0331271bace68e97$var$fh.length; b++)if (c = $0331271bace68e97$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0331271bace68e97$var$fh = null;
    }
    return a;
}
function $0331271bace68e97$var$Mk(a, b) {
    do {
        var c = $0331271bace68e97$var$Y;
        try {
            $0331271bace68e97$var$$g();
            $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Rh;
            if ($0331271bace68e97$var$Ih) {
                for(var d = $0331271bace68e97$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0331271bace68e97$var$Ih = !1;
            }
            $0331271bace68e97$var$Hh = 0;
            $0331271bace68e97$var$O = $0331271bace68e97$var$N = $0331271bace68e97$var$M = null;
            $0331271bace68e97$var$Jh = !1;
            $0331271bace68e97$var$Kh = 0;
            $0331271bace68e97$var$nk.current = null;
            if (null === c || null === c.return) {
                $0331271bace68e97$var$T = 1;
                $0331271bace68e97$var$pk = b;
                $0331271bace68e97$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0331271bace68e97$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0331271bace68e97$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0331271bace68e97$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0331271bace68e97$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0331271bace68e97$var$Si(f, l, b);
                            $0331271bace68e97$var$tj();
                            break a;
                        }
                        k = Error($0331271bace68e97$var$p(426));
                    }
                } else if ($0331271bace68e97$var$I && h.mode & 1) {
                    var J = $0331271bace68e97$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0331271bace68e97$var$Vi(J, g, h, f, b);
                        $0331271bace68e97$var$Jg($0331271bace68e97$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0331271bace68e97$var$Ji(k, h);
                4 !== $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 2);
                null === $0331271bace68e97$var$sk ? $0331271bace68e97$var$sk = [
                    f
                ] : $0331271bace68e97$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0331271bace68e97$var$Ni(f, k, b);
                            $0331271bace68e97$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0331271bace68e97$var$Ri || !$0331271bace68e97$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0331271bace68e97$var$Qi(f, h, b);
                                $0331271bace68e97$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0331271bace68e97$var$Sk(c);
        } catch (na) {
            b = na;
            $0331271bace68e97$var$Y === c && null !== c && ($0331271bace68e97$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0331271bace68e97$var$Jk() {
    var a = $0331271bace68e97$var$mk.current;
    $0331271bace68e97$var$mk.current = $0331271bace68e97$var$Rh;
    return null === a ? $0331271bace68e97$var$Rh : a;
}
function $0331271bace68e97$var$tj() {
    if (0 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T || 2 === $0331271bace68e97$var$T) $0331271bace68e97$var$T = 4;
    null === $0331271bace68e97$var$Q || 0 === ($0331271bace68e97$var$rh & 268435455) && 0 === ($0331271bace68e97$var$qk & 268435455) || $0331271bace68e97$var$Ck($0331271bace68e97$var$Q, $0331271bace68e97$var$Z);
}
function $0331271bace68e97$var$Ik(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 2;
    var d = $0331271bace68e97$var$Jk();
    if ($0331271bace68e97$var$Q !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Kk(a, b);
    for(;;)try {
        $0331271bace68e97$var$Tk();
        break;
    } catch (e) {
        $0331271bace68e97$var$Mk(a, e);
    }
    $0331271bace68e97$var$$g();
    $0331271bace68e97$var$K = c;
    $0331271bace68e97$var$mk.current = d;
    if (null !== $0331271bace68e97$var$Y) throw Error($0331271bace68e97$var$p(261));
    $0331271bace68e97$var$Q = null;
    $0331271bace68e97$var$Z = 0;
    return $0331271bace68e97$var$T;
}
function $0331271bace68e97$var$Tk() {
    for(; null !== $0331271bace68e97$var$Y;)$0331271bace68e97$var$Uk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Lk() {
    for(; null !== $0331271bace68e97$var$Y && !$0331271bace68e97$var$cc();)$0331271bace68e97$var$Uk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Uk(a) {
    var b = $0331271bace68e97$var$Vk(a.alternate, a, $0331271bace68e97$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0331271bace68e97$var$Sk(a) : $0331271bace68e97$var$Y = b;
    $0331271bace68e97$var$nk.current = null;
}
function $0331271bace68e97$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0331271bace68e97$var$Ej(c, b, $0331271bace68e97$var$fj), null !== c) {
                $0331271bace68e97$var$Y = c;
                return;
            }
        } else {
            c = $0331271bace68e97$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0331271bace68e97$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0331271bace68e97$var$T = 6;
                $0331271bace68e97$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0331271bace68e97$var$Y = b;
            return;
        }
        $0331271bace68e97$var$Y = b = a;
    }while (null !== b);
    0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 5);
}
function $0331271bace68e97$var$Pk(a, b, c) {
    var d = $0331271bace68e97$var$C, e = $0331271bace68e97$var$ok.transition;
    try {
        $0331271bace68e97$var$ok.transition = null, $0331271bace68e97$var$C = 1, $0331271bace68e97$var$Wk(a, b, c, d);
    } finally{
        $0331271bace68e97$var$ok.transition = e, $0331271bace68e97$var$C = d;
    }
    return null;
}
function $0331271bace68e97$var$Wk(a, b, c, d) {
    do $0331271bace68e97$var$Hk();
    while (null !== $0331271bace68e97$var$wk);
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0331271bace68e97$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0331271bace68e97$var$Bc(a, f);
    a === $0331271bace68e97$var$Q && ($0331271bace68e97$var$Y = $0331271bace68e97$var$Q = null, $0331271bace68e97$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0331271bace68e97$var$vk || ($0331271bace68e97$var$vk = !0, $0331271bace68e97$var$Fk($0331271bace68e97$var$hc, function() {
        $0331271bace68e97$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0331271bace68e97$var$ok.transition;
        $0331271bace68e97$var$ok.transition = null;
        var g = $0331271bace68e97$var$C;
        $0331271bace68e97$var$C = 1;
        var h = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 4;
        $0331271bace68e97$var$nk.current = null;
        $0331271bace68e97$var$Oj(a, c);
        $0331271bace68e97$var$dk(c, a);
        $0331271bace68e97$var$Oe($0331271bace68e97$var$Df);
        $0331271bace68e97$var$dd = !!$0331271bace68e97$var$Cf;
        $0331271bace68e97$var$Df = $0331271bace68e97$var$Cf = null;
        a.current = c;
        $0331271bace68e97$var$hk(c, a, e);
        $0331271bace68e97$var$dc();
        $0331271bace68e97$var$K = h;
        $0331271bace68e97$var$C = g;
        $0331271bace68e97$var$ok.transition = f;
    } else a.current = c;
    $0331271bace68e97$var$vk && ($0331271bace68e97$var$vk = !1, $0331271bace68e97$var$wk = a, $0331271bace68e97$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0331271bace68e97$var$Ri = null);
    $0331271bace68e97$var$mc(c.stateNode, d);
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0331271bace68e97$var$Oi) throw $0331271bace68e97$var$Oi = !1, a = $0331271bace68e97$var$Pi, $0331271bace68e97$var$Pi = null, a;
    0 !== ($0331271bace68e97$var$xk & 1) && 0 !== a.tag && $0331271bace68e97$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0331271bace68e97$var$zk ? $0331271bace68e97$var$yk++ : ($0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = a) : $0331271bace68e97$var$yk = 0;
    $0331271bace68e97$var$jg();
    return null;
}
function $0331271bace68e97$var$Hk() {
    if (null !== $0331271bace68e97$var$wk) {
        var a = $0331271bace68e97$var$Dc($0331271bace68e97$var$xk), b = $0331271bace68e97$var$ok.transition, c = $0331271bace68e97$var$C;
        try {
            $0331271bace68e97$var$ok.transition = null;
            $0331271bace68e97$var$C = 16 > a ? 16 : a;
            if (null === $0331271bace68e97$var$wk) var d = !1;
            else {
                a = $0331271bace68e97$var$wk;
                $0331271bace68e97$var$wk = null;
                $0331271bace68e97$var$xk = 0;
                if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(331));
                var e = $0331271bace68e97$var$K;
                $0331271bace68e97$var$K |= 4;
                for($0331271bace68e97$var$V = a.current; null !== $0331271bace68e97$var$V;){
                    var f = $0331271bace68e97$var$V, g = f.child;
                    if (0 !== ($0331271bace68e97$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0331271bace68e97$var$V = l; null !== $0331271bace68e97$var$V;){
                                    var m = $0331271bace68e97$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0331271bace68e97$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0331271bace68e97$var$V = q;
                                    else for(; null !== $0331271bace68e97$var$V;){
                                        m = $0331271bace68e97$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0331271bace68e97$var$Sj(m);
                                        if (m === l) {
                                            $0331271bace68e97$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0331271bace68e97$var$V = r;
                                            break;
                                        }
                                        $0331271bace68e97$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0331271bace68e97$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0331271bace68e97$var$V = g;
                    else b: for(; null !== $0331271bace68e97$var$V;){
                        f = $0331271bace68e97$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0331271bace68e97$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0331271bace68e97$var$V = x;
                            break b;
                        }
                        $0331271bace68e97$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0331271bace68e97$var$V = w; null !== $0331271bace68e97$var$V;){
                    g = $0331271bace68e97$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0331271bace68e97$var$V = u;
                    else b: for(g = w; null !== $0331271bace68e97$var$V;){
                        h = $0331271bace68e97$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0331271bace68e97$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0331271bace68e97$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0331271bace68e97$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0331271bace68e97$var$V = F;
                            break b;
                        }
                        $0331271bace68e97$var$V = h.return;
                    }
                }
                $0331271bace68e97$var$K = e;
                $0331271bace68e97$var$jg();
                if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onPostCommitFiberRoot) try {
                    $0331271bace68e97$var$lc.onPostCommitFiberRoot($0331271bace68e97$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0331271bace68e97$var$C = c, $0331271bace68e97$var$ok.transition = b;
        }
    }
    return !1;
}
function $0331271bace68e97$var$Xk(a, b, c) {
    b = $0331271bace68e97$var$Ji(c, b);
    b = $0331271bace68e97$var$Ni(a, b, 1);
    a = $0331271bace68e97$var$nh(a, b, 1);
    b = $0331271bace68e97$var$R();
    null !== a && ($0331271bace68e97$var$Ac(a, 1, b), $0331271bace68e97$var$Dk(a, b));
}
function $0331271bace68e97$var$W(a, b, c) {
    if (3 === a.tag) $0331271bace68e97$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0331271bace68e97$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0331271bace68e97$var$Ri || !$0331271bace68e97$var$Ri.has(d))) {
                a = $0331271bace68e97$var$Ji(c, a);
                a = $0331271bace68e97$var$Qi(b, a, 1);
                b = $0331271bace68e97$var$nh(b, a, 1);
                a = $0331271bace68e97$var$R();
                null !== b && ($0331271bace68e97$var$Ac(b, 1, a), $0331271bace68e97$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0331271bace68e97$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0331271bace68e97$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0331271bace68e97$var$Q === a && ($0331271bace68e97$var$Z & c) === c && (4 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T && ($0331271bace68e97$var$Z & 130023424) === $0331271bace68e97$var$Z && 500 > $0331271bace68e97$var$B() - $0331271bace68e97$var$fk ? $0331271bace68e97$var$Kk(a, 0) : $0331271bace68e97$var$rk |= c);
    $0331271bace68e97$var$Dk(a, b);
}
function $0331271bace68e97$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0331271bace68e97$var$sc, $0331271bace68e97$var$sc <<= 1, 0 === ($0331271bace68e97$var$sc & 130023424) && ($0331271bace68e97$var$sc = 4194304)));
    var c = $0331271bace68e97$var$R();
    a = $0331271bace68e97$var$ih(a, b);
    null !== a && ($0331271bace68e97$var$Ac(a, b, c), $0331271bace68e97$var$Dk(a, c));
}
function $0331271bace68e97$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0331271bace68e97$var$Yk(a, c);
}
function $0331271bace68e97$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0331271bace68e97$var$p(314));
    }
    null !== d && d.delete(b);
    $0331271bace68e97$var$Yk(a, c);
}
var $0331271bace68e97$var$Vk;
$0331271bace68e97$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0331271bace68e97$var$Wf.current) $0331271bace68e97$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0331271bace68e97$var$dh = !1, $0331271bace68e97$var$yj(a, b, c);
            $0331271bace68e97$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0331271bace68e97$var$dh = !1, $0331271bace68e97$var$I && 0 !== (b.flags & 1048576) && $0331271bace68e97$var$ug(b, $0331271bace68e97$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0331271bace68e97$var$ij(a, b);
            a = b.pendingProps;
            var e = $0331271bace68e97$var$Yf(b, $0331271bace68e97$var$H.current);
            $0331271bace68e97$var$ch(b, c);
            e = $0331271bace68e97$var$Nh(null, b, d, a, e, c);
            var f = $0331271bace68e97$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0331271bace68e97$var$Zf(d) ? (f = !0, $0331271bace68e97$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0331271bace68e97$var$kh(b), e.updater = $0331271bace68e97$var$Ei, b.stateNode = e, e._reactInternals = b, $0331271bace68e97$var$Ii(b, d, a, c), b = $0331271bace68e97$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0331271bace68e97$var$I && f && $0331271bace68e97$var$vg(b), $0331271bace68e97$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0331271bace68e97$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0331271bace68e97$var$Zk(d);
                a = $0331271bace68e97$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0331271bace68e97$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0331271bace68e97$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0331271bace68e97$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0331271bace68e97$var$$i(null, b, d, $0331271bace68e97$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0331271bace68e97$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0331271bace68e97$var$kj(b);
                if (null === a) throw Error($0331271bace68e97$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0331271bace68e97$var$lh(a, b);
                $0331271bace68e97$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0331271bace68e97$var$Ji(Error($0331271bace68e97$var$p(423)), b);
                        b = $0331271bace68e97$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0331271bace68e97$var$Ji(Error($0331271bace68e97$var$p(424)), b);
                        b = $0331271bace68e97$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.stateNode.containerInfo.firstChild), $0331271bace68e97$var$xg = b, $0331271bace68e97$var$I = !0, $0331271bace68e97$var$zg = null, c = $0331271bace68e97$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0331271bace68e97$var$Ig();
                    if (d === e) {
                        b = $0331271bace68e97$var$Zi(a, b, c);
                        break a;
                    }
                    $0331271bace68e97$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0331271bace68e97$var$Ah(b), null === a && $0331271bace68e97$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0331271bace68e97$var$Ef(d, e) ? g = null : null !== f && $0331271bace68e97$var$Ef(d, f) && (b.flags |= 32), $0331271bace68e97$var$gj(a, b), $0331271bace68e97$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0331271bace68e97$var$Eg(b), null;
        case 13:
            return $0331271bace68e97$var$oj(a, b, c);
        case 4:
            return $0331271bace68e97$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0331271bace68e97$var$Ug(b, null, d, c) : $0331271bace68e97$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$Yi(a, b, d, e, c);
        case 7:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0331271bace68e97$var$G($0331271bace68e97$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0331271bace68e97$var$He(f.value, g)) {
                        if (f.children === e.children && !$0331271bace68e97$var$Wf.current) {
                            b = $0331271bace68e97$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0331271bace68e97$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0331271bace68e97$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0331271bace68e97$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0331271bace68e97$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0331271bace68e97$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0331271bace68e97$var$ch(b, c), e = $0331271bace68e97$var$eh(e), d = d(e), b.flags |= 1, $0331271bace68e97$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0331271bace68e97$var$Ci(d, b.pendingProps), e = $0331271bace68e97$var$Ci(d.type, e), $0331271bace68e97$var$$i(a, b, d, e, c);
        case 15:
            return $0331271bace68e97$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$ij(a, b), b.tag = 1, $0331271bace68e97$var$Zf(d) ? (a = !0, $0331271bace68e97$var$cg(b)) : a = !1, $0331271bace68e97$var$ch(b, c), $0331271bace68e97$var$Gi(b, d, e), $0331271bace68e97$var$Ii(b, d, e, c), $0331271bace68e97$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0331271bace68e97$var$xj(a, b, c);
        case 22:
            return $0331271bace68e97$var$dj(a, b, c);
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
};
function $0331271bace68e97$var$Fk(a, b) {
    return $0331271bace68e97$var$ac(a, b);
}
function $0331271bace68e97$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0331271bace68e97$var$Bg(a, b, c, d) {
    return new $0331271bace68e97$var$$k(a, b, c, d);
}
function $0331271bace68e97$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0331271bace68e97$var$Zk(a) {
    if ("function" === typeof a) return $0331271bace68e97$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0331271bace68e97$var$Da) return 11;
        if (a === $0331271bace68e97$var$Ga) return 14;
    }
    return 2;
}
function $0331271bace68e97$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0331271bace68e97$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0331271bace68e97$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0331271bace68e97$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0331271bace68e97$var$ya:
            return $0331271bace68e97$var$Tg(c.children, e, f, b);
        case $0331271bace68e97$var$za:
            g = 8;
            e |= 8;
            break;
        case $0331271bace68e97$var$Aa:
            return a = $0331271bace68e97$var$Bg(12, c, b, e | 2), a.elementType = $0331271bace68e97$var$Aa, a.lanes = f, a;
        case $0331271bace68e97$var$Ea:
            return a = $0331271bace68e97$var$Bg(13, c, b, e), a.elementType = $0331271bace68e97$var$Ea, a.lanes = f, a;
        case $0331271bace68e97$var$Fa:
            return a = $0331271bace68e97$var$Bg(19, c, b, e), a.elementType = $0331271bace68e97$var$Fa, a.lanes = f, a;
        case $0331271bace68e97$var$Ia:
            return $0331271bace68e97$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0331271bace68e97$var$Ba:
                    g = 10;
                    break a;
                case $0331271bace68e97$var$Ca:
                    g = 9;
                    break a;
                case $0331271bace68e97$var$Da:
                    g = 11;
                    break a;
                case $0331271bace68e97$var$Ga:
                    g = 14;
                    break a;
                case $0331271bace68e97$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0331271bace68e97$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a), ""));
    }
    b = $0331271bace68e97$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0331271bace68e97$var$Tg(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$pj(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(22, a, d, b);
    a.elementType = $0331271bace68e97$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0331271bace68e97$var$Qg(a, b, c) {
    a = $0331271bace68e97$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$Sg(a, b, c) {
    b = $0331271bace68e97$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0331271bace68e97$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0331271bace68e97$var$zc(0);
    this.expirationTimes = $0331271bace68e97$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0331271bace68e97$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0331271bace68e97$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0331271bace68e97$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0331271bace68e97$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0331271bace68e97$var$kh(f);
    return a;
}
function $0331271bace68e97$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0331271bace68e97$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0331271bace68e97$var$dl(a) {
    if (!a) return $0331271bace68e97$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0331271bace68e97$var$Vb(a) !== a || 1 !== a.tag) throw Error($0331271bace68e97$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0331271bace68e97$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0331271bace68e97$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0331271bace68e97$var$Zf(c)) return $0331271bace68e97$var$bg(a, c, b);
    }
    return b;
}
function $0331271bace68e97$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0331271bace68e97$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0331271bace68e97$var$dl(null);
    c = a.current;
    d = $0331271bace68e97$var$R();
    e = $0331271bace68e97$var$yi(c);
    f = $0331271bace68e97$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0331271bace68e97$var$nh(c, f, e);
    a.current.lanes = e;
    $0331271bace68e97$var$Ac(a, e, d);
    $0331271bace68e97$var$Dk(a, d);
    return a;
}
function $0331271bace68e97$var$fl(a, b, c, d) {
    var e = b.current, f = $0331271bace68e97$var$R(), g = $0331271bace68e97$var$yi(e);
    c = $0331271bace68e97$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0331271bace68e97$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0331271bace68e97$var$nh(e, b, g);
    null !== a && ($0331271bace68e97$var$gi(a, e, g, f), $0331271bace68e97$var$oh(a, e, g));
    return g;
}
function $0331271bace68e97$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0331271bace68e97$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0331271bace68e97$var$il(a, b) {
    $0331271bace68e97$var$hl(a, b);
    (a = a.alternate) && $0331271bace68e97$var$hl(a, b);
}
function $0331271bace68e97$var$jl() {
    return null;
}
var $0331271bace68e97$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $0331271bace68e97$var$ll(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$ml.prototype.render = $0331271bace68e97$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0331271bace68e97$var$p(409));
    $0331271bace68e97$var$fl(a, b, null, null);
};
$0331271bace68e97$var$ml.prototype.unmount = $0331271bace68e97$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0331271bace68e97$var$Rk(function() {
            $0331271bace68e97$var$fl(null, a, null, null);
        });
        b[$0331271bace68e97$var$uf] = null;
    }
};
function $0331271bace68e97$var$ml(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0331271bace68e97$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0331271bace68e97$var$Qc.length && 0 !== b && b < $0331271bace68e97$var$Qc[c].priority; c++);
        $0331271bace68e97$var$Qc.splice(c, 0, a);
        0 === c && $0331271bace68e97$var$Vc(a);
    }
};
function $0331271bace68e97$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0331271bace68e97$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0331271bace68e97$var$pl() {}
function $0331271bace68e97$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $0331271bace68e97$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $0331271bace68e97$var$el(b, d, a, 0, null, !1, !1, "", $0331271bace68e97$var$pl);
        a._reactRootContainer = g;
        a[$0331271bace68e97$var$uf] = g.current;
        $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0331271bace68e97$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $0331271bace68e97$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $0331271bace68e97$var$bl(a, 0, !1, null, null, !1, !1, "", $0331271bace68e97$var$pl);
    a._reactRootContainer = k;
    a[$0331271bace68e97$var$uf] = k.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0331271bace68e97$var$Rk(function() {
        $0331271bace68e97$var$fl(b, k, c, d);
    });
    return k;
}
function $0331271bace68e97$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $0331271bace68e97$var$gl(g);
                h.call(_$a);
            };
        }
        $0331271bace68e97$var$fl(b, g, a, e);
    } else g = $0331271bace68e97$var$ql(c, b, a, e, d);
    return $0331271bace68e97$var$gl(g);
}
$0331271bace68e97$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0331271bace68e97$var$tc(b.pendingLanes);
                0 !== c && ($0331271bace68e97$var$Cc(b, c | 1), $0331271bace68e97$var$Dk(b, $0331271bace68e97$var$B()), 0 === ($0331271bace68e97$var$K & 6) && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$jg()));
            }
            break;
        case 13:
            $0331271bace68e97$var$Rk(function() {
                var b = $0331271bace68e97$var$ih(a, 1);
                if (null !== b) {
                    var c = $0331271bace68e97$var$R();
                    $0331271bace68e97$var$gi(b, a, 1, c);
                }
            }), $0331271bace68e97$var$il(a, 1);
    }
};
$0331271bace68e97$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0331271bace68e97$var$R();
            $0331271bace68e97$var$gi(b, a, 134217728, c);
        }
        $0331271bace68e97$var$il(a, 134217728);
    }
};
$0331271bace68e97$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$yi(a), c = $0331271bace68e97$var$ih(a, b);
        if (null !== c) {
            var d = $0331271bace68e97$var$R();
            $0331271bace68e97$var$gi(c, a, b, d);
        }
        $0331271bace68e97$var$il(a, b);
    }
};
$0331271bace68e97$var$Hc = function Hc() {
    return $0331271bace68e97$var$C;
};
$0331271bace68e97$var$Ic = function Ic(a, b) {
    var c = $0331271bace68e97$var$C;
    try {
        return $0331271bace68e97$var$C = a, b();
    } finally{
        $0331271bace68e97$var$C = c;
    }
};
$0331271bace68e97$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $0331271bace68e97$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0331271bace68e97$var$Db(d);
                        if (!e) throw Error($0331271bace68e97$var$p(90));
                        $0331271bace68e97$var$Wa(d);
                        $0331271bace68e97$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0331271bace68e97$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0331271bace68e97$var$fb(a, !!c.multiple, b, !1);
    }
};
$0331271bace68e97$var$Gb = $0331271bace68e97$var$Qk;
$0331271bace68e97$var$Hb = $0331271bace68e97$var$Rk;
var $0331271bace68e97$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0331271bace68e97$var$Cb,
        $0331271bace68e97$var$ue,
        $0331271bace68e97$var$Db,
        $0331271bace68e97$var$Eb,
        $0331271bace68e97$var$Fb,
        $0331271bace68e97$var$Qk
    ]
}, $0331271bace68e97$var$tl = {
    findFiberByHostInstance: $0331271bace68e97$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0331271bace68e97$var$ul = {
    bundleType: $0331271bace68e97$var$tl.bundleType,
    version: $0331271bace68e97$var$tl.version,
    rendererPackageName: $0331271bace68e97$var$tl.rendererPackageName,
    rendererConfig: $0331271bace68e97$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0331271bace68e97$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $0331271bace68e97$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0331271bace68e97$var$tl.findFiberByHostInstance || $0331271bace68e97$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0331271bace68e97$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0331271bace68e97$var$vl.isDisabled && $0331271bace68e97$var$vl.supportsFiber) try {
        $0331271bace68e97$var$kc = $0331271bace68e97$var$vl.inject($0331271bace68e97$var$ul), $0331271bace68e97$var$lc = $0331271bace68e97$var$vl;
    } catch (a) {}
}
$0331271bace68e97$export$ae55be85d98224ed = $0331271bace68e97$var$sl;
$0331271bace68e97$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0331271bace68e97$var$nl(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$cl(a, b, null, c);
};
$0331271bace68e97$export$882461b6382ed46c = function(a, b) {
    if (!$0331271bace68e97$var$nl(a)) throw Error($0331271bace68e97$var$p(299));
    var c = !1, d = "", e = $0331271bace68e97$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0331271bace68e97$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0331271bace68e97$var$ll(b);
};
$0331271bace68e97$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0331271bace68e97$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0331271bace68e97$var$p(268, a));
    }
    a = $0331271bace68e97$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0331271bace68e97$export$cd75ccfd720a3cd4 = function(a) {
    return $0331271bace68e97$var$Rk(a);
};
$0331271bace68e97$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$rl(null, a, b, !0, c);
};
$0331271bace68e97$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0331271bace68e97$var$nl(a)) throw Error($0331271bace68e97$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0331271bace68e97$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0331271bace68e97$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0331271bace68e97$var$ml(b);
};
$0331271bace68e97$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$rl(null, a, b, !1, c);
};
$0331271bace68e97$export$502457920280e6be = function(a) {
    if (!$0331271bace68e97$var$ol(a)) throw Error($0331271bace68e97$var$p(40));
    return a._reactRootContainer ? ($0331271bace68e97$var$Rk(function() {
        $0331271bace68e97$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0331271bace68e97$var$uf] = null;
        });
    }), !0) : !1;
};
$0331271bace68e97$export$c78a37762a8d58e1 = $0331271bace68e97$var$Qk;
$0331271bace68e97$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0331271bace68e97$var$ol(c)) throw Error($0331271bace68e97$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0331271bace68e97$var$p(38));
    return $0331271bace68e97$var$rl(a, b, c, !1, d);
};
$0331271bace68e97$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("1iyD5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2nkgC"));

});
parcelRegister("2nkgC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1bad735fa80bcaf4$export$c4744153514ff05d; }, function (v) { return $1bad735fa80bcaf4$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7; }, function (v) { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875; }, function (v) { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1bad735fa80bcaf4$export$502329bbf4b505b1; }, function (v) { return $1bad735fa80bcaf4$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1bad735fa80bcaf4$export$6e3807111c4874c4; }, function (v) { return $1bad735fa80bcaf4$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1bad735fa80bcaf4$export$c27134553091fb3a; }, function (v) { return $1bad735fa80bcaf4$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2; }, function (v) { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1bad735fa80bcaf4$export$b00a404bbd5edef2; }, function (v) { return $1bad735fa80bcaf4$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1bad735fa80bcaf4$export$8352ce38b91d0c62; }, function (v) { return $1bad735fa80bcaf4$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b; }, function (v) { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555; }, function (v) { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1bad735fa80bcaf4$export$839f9183b0465a69; }, function (v) { return $1bad735fa80bcaf4$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1bad735fa80bcaf4$export$72fdf0e06517287b; }, function (v) { return $1bad735fa80bcaf4$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1bad735fa80bcaf4$export$4b844e58a3e414b4; }, function (v) { return $1bad735fa80bcaf4$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1bad735fa80bcaf4$export$816d2913ae6b83b1; }, function (v) { return $1bad735fa80bcaf4$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1bad735fa80bcaf4$export$61bcfe829111a1d0; }, function (v) { return $1bad735fa80bcaf4$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f; }, function (v) { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1bad735fa80bcaf4$export$b5836b71941fa3ed; }, function (v) { return $1bad735fa80bcaf4$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1bad735fa80bcaf4$export$cf845f2c119da08a; }, function (v) { return $1bad735fa80bcaf4$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bad735fa80bcaf4$export$c4744153514ff05d;
var $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7;
var $1bad735fa80bcaf4$export$e26fe2ed2fa76875;
var $1bad735fa80bcaf4$export$502329bbf4b505b1;
var $1bad735fa80bcaf4$export$6e3807111c4874c4;
var $1bad735fa80bcaf4$export$c27134553091fb3a;
var $1bad735fa80bcaf4$export$33ee1acdc04fd2a2;
var $1bad735fa80bcaf4$export$b00a404bbd5edef2;
var $1bad735fa80bcaf4$export$8352ce38b91d0c62;
var $1bad735fa80bcaf4$export$d66a1c1c77bd778b;
var $1bad735fa80bcaf4$export$d3dfb8e4810cb555;
var $1bad735fa80bcaf4$export$839f9183b0465a69;
var $1bad735fa80bcaf4$export$72fdf0e06517287b;
var $1bad735fa80bcaf4$export$4b844e58a3e414b4;
var $1bad735fa80bcaf4$export$816d2913ae6b83b1;
var $1bad735fa80bcaf4$export$61bcfe829111a1d0;
var $1bad735fa80bcaf4$export$7ee8c9beb337bc3f;
var $1bad735fa80bcaf4$export$b5836b71941fa3ed;
var $1bad735fa80bcaf4$export$cf845f2c119da08a;
"use strict";
function $1bad735fa80bcaf4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1bad735fa80bcaf4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1bad735fa80bcaf4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1bad735fa80bcaf4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1bad735fa80bcaf4$var$g(C, c)) n < e && 0 > $1bad735fa80bcaf4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1bad735fa80bcaf4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1bad735fa80bcaf4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1bad735fa80bcaf4$var$l = performance;
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$l.now();
    };
} else {
    var $1bad735fa80bcaf4$var$p = Date, $1bad735fa80bcaf4$var$q = $1bad735fa80bcaf4$var$p.now();
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$p.now() - $1bad735fa80bcaf4$var$q;
    };
}
var $1bad735fa80bcaf4$var$r = [], $1bad735fa80bcaf4$var$t = [], $1bad735fa80bcaf4$var$u = 1, $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = 3, $1bad735fa80bcaf4$var$z = !1, $1bad735fa80bcaf4$var$A = !1, $1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$D = "function" === typeof setTimeout ? setTimeout : null, $1bad735fa80bcaf4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1bad735fa80bcaf4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1bad735fa80bcaf4$var$G(a) {
    for(var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t); null !== b;){
        if (null === b.callback) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t);
        else if (b.startTime <= a) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t), b.sortIndex = b.expirationTime, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, b);
        else break;
        b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
    }
}
function $1bad735fa80bcaf4$var$H(a) {
    $1bad735fa80bcaf4$var$B = !1;
    $1bad735fa80bcaf4$var$G(a);
    if (!$1bad735fa80bcaf4$var$A) {
        if (null !== $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r)) $1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J);
        else {
            var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== b && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, b.startTime - a);
        }
    }
}
function $1bad735fa80bcaf4$var$J(a, b) {
    $1bad735fa80bcaf4$var$A = !1;
    $1bad735fa80bcaf4$var$B && ($1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1);
    $1bad735fa80bcaf4$var$z = !0;
    var c = $1bad735fa80bcaf4$var$y;
    try {
        $1bad735fa80bcaf4$var$G(b);
        for($1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r); null !== $1bad735fa80bcaf4$var$v && (!($1bad735fa80bcaf4$var$v.expirationTime > b) || a && !$1bad735fa80bcaf4$var$M());){
            var d = $1bad735fa80bcaf4$var$v.callback;
            if ("function" === typeof d) {
                $1bad735fa80bcaf4$var$v.callback = null;
                $1bad735fa80bcaf4$var$y = $1bad735fa80bcaf4$var$v.priorityLevel;
                var e = d($1bad735fa80bcaf4$var$v.expirationTime <= b);
                b = $1bad735fa80bcaf4$export$c4744153514ff05d();
                "function" === typeof e ? $1bad735fa80bcaf4$var$v.callback = e : $1bad735fa80bcaf4$var$v === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
                $1bad735fa80bcaf4$var$G(b);
            } else $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
            $1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
        }
        if (null !== $1bad735fa80bcaf4$var$v) var w = !0;
        else {
            var m = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== m && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = c, $1bad735fa80bcaf4$var$z = !1;
    }
}
var $1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null, $1bad735fa80bcaf4$var$L = -1, $1bad735fa80bcaf4$var$P = 5, $1bad735fa80bcaf4$var$Q = -1;
function $1bad735fa80bcaf4$var$M() {
    return $1bad735fa80bcaf4$export$c4744153514ff05d() - $1bad735fa80bcaf4$var$Q < $1bad735fa80bcaf4$var$P ? !1 : !0;
}
function $1bad735fa80bcaf4$var$R() {
    if (null !== $1bad735fa80bcaf4$var$O) {
        var a = $1bad735fa80bcaf4$export$c4744153514ff05d();
        $1bad735fa80bcaf4$var$Q = a;
        var b = !0;
        try {
            b = $1bad735fa80bcaf4$var$O(!0, a);
        } finally{
            b ? $1bad735fa80bcaf4$var$S() : ($1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null);
        }
    } else $1bad735fa80bcaf4$var$N = !1;
}
var $1bad735fa80bcaf4$var$S;
if ("function" === typeof $1bad735fa80bcaf4$var$F) $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$F($1bad735fa80bcaf4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1bad735fa80bcaf4$var$T = new MessageChannel, $1bad735fa80bcaf4$var$U = $1bad735fa80bcaf4$var$T.port2;
    $1bad735fa80bcaf4$var$T.port1.onmessage = $1bad735fa80bcaf4$var$R;
    $1bad735fa80bcaf4$var$S = function S() {
        $1bad735fa80bcaf4$var$U.postMessage(null);
    };
} else $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$D($1bad735fa80bcaf4$var$R, 0);
};
function $1bad735fa80bcaf4$var$I(a) {
    $1bad735fa80bcaf4$var$O = a;
    $1bad735fa80bcaf4$var$N || ($1bad735fa80bcaf4$var$N = !0, $1bad735fa80bcaf4$var$S());
}
function $1bad735fa80bcaf4$var$K(a, b) {
    $1bad735fa80bcaf4$var$L = $1bad735fa80bcaf4$var$D(function() {
        a($1bad735fa80bcaf4$export$c4744153514ff05d());
    }, b);
}
$1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = 5;
$1bad735fa80bcaf4$export$e26fe2ed2fa76875 = 1;
$1bad735fa80bcaf4$export$502329bbf4b505b1 = 4;
$1bad735fa80bcaf4$export$6e3807111c4874c4 = 3;
$1bad735fa80bcaf4$export$c27134553091fb3a = null;
$1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = 2;
$1bad735fa80bcaf4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1bad735fa80bcaf4$export$8352ce38b91d0c62 = function() {
    $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J));
};
$1bad735fa80bcaf4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1bad735fa80bcaf4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1bad735fa80bcaf4$export$d3dfb8e4810cb555 = function() {
    return $1bad735fa80bcaf4$var$y;
};
$1bad735fa80bcaf4$export$839f9183b0465a69 = function() {
    return $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
};
$1bad735fa80bcaf4$export$72fdf0e06517287b = function(a) {
    switch($1bad735fa80bcaf4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1bad735fa80bcaf4$var$y;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = b;
    try {
        return a();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$4b844e58a3e414b4 = function() {};
$1bad735fa80bcaf4$export$816d2913ae6b83b1 = function() {};
$1bad735fa80bcaf4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = a;
    try {
        return b();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1bad735fa80bcaf4$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1bad735fa80bcaf4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$t, a), null === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && a === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t) && ($1bad735fa80bcaf4$var$B ? ($1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1) : $1bad735fa80bcaf4$var$B = !0, $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, c - d))) : (a.sortIndex = e, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, a), $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J)));
    return a;
};
$1bad735fa80bcaf4$export$b5836b71941fa3ed = $1bad735fa80bcaf4$var$M;
$1bad735fa80bcaf4$export$cf845f2c119da08a = function(a) {
    var b = $1bad735fa80bcaf4$var$y;
    return function() {
        var c = $1bad735fa80bcaf4$var$y;
        $1bad735fa80bcaf4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1bad735fa80bcaf4$var$y = c;
        }
    };
};

});



parcelRegister("9YznM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iqCYy = parcelRequire("iqCYy");
function $743529e864458d8f$var$emptyFunction() {}
function $743529e864458d8f$var$emptyFunctionWithReset() {}
$743529e864458d8f$var$emptyFunctionWithReset.resetWarningCache = $743529e864458d8f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iqCYy) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $743529e864458d8f$var$emptyFunctionWithReset,
        resetWarningCache: $743529e864458d8f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iqCYy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $d6a8e36fd67ba626$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $d6a8e36fd67ba626$var$ReactPropTypesSecret;

});


parcelRegister("6SnUj", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $501a54b0037ed263$export$bf730a2d8bf68b42; }, function (v) { return $501a54b0037ed263$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $501a54b0037ed263$export$bf730a2d8bf68b42;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
function $501a54b0037ed263$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $501a54b0037ed263$var$p = "function" === typeof Object.is ? Object.is : $501a54b0037ed263$var$n, $501a54b0037ed263$var$q = $dQFEZ.useSyncExternalStore, $501a54b0037ed263$var$r = $dQFEZ.useRef, $501a54b0037ed263$var$t = $dQFEZ.useEffect, $501a54b0037ed263$var$u = $dQFEZ.useMemo, $501a54b0037ed263$var$v = $dQFEZ.useDebugValue;
$501a54b0037ed263$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $501a54b0037ed263$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $501a54b0037ed263$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($501a54b0037ed263$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $501a54b0037ed263$var$q(a, c[0], c[1]);
    $501a54b0037ed263$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $501a54b0037ed263$var$v(d);
    return d;
};

});

parcelRegister("kK8g8", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $dcJGd = parcelRequire("dcJGd");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $lngen = parcelRequire("lngen");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $2nwvT._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $bJtXW._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $grujF._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2us1u._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2us1u._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $dhMkv._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $2nwvT._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $j6Mzi._)(DraftMap, Map1);
        var _super = (0, $lngen._)(DraftMap);
        function DraftMap(target, parent) {
            (0, $grujF._)(this, DraftMap);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: (0, $dcJGd._)(_this),
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $dhMkv._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $1EZOw._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $j6Mzi._)(DraftSet, Set1);
        var _super = (0, $lngen._)(DraftSet);
        function DraftSet(target, parent) {
            (0, $grujF._)(this, DraftSet);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: (0, $dcJGd._)(_this),
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $dhMkv._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $1EZOw._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("dcJGd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99cfd4696d3ae8ed$export$71511d61b312f219; });
function $99cfd4696d3ae8ed$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("grujF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf86af1e5034cb56$export$71511d61b312f219; });
function $bf86af1e5034cb56$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dhMkv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9ac25a306229a9ff$export$71511d61b312f219; });
function $9ac25a306229a9ff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ac25a306229a9ff$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $9ac25a306229a9ff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ac25a306229a9ff$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("72osQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $51fbb26672273063$export$71511d61b312f219; });
function $51fbb26672273063$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("j6Mzi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de944088b801fe33$export$71511d61b312f219; });

var $fMryZ = parcelRequire("fMryZ");
function $de944088b801fe33$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fMryZ._)(subClass, superClass);
}

});
parcelRegister("fMryZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b7d0b832e35ee57e$export$71511d61b312f219; });
function $b7d0b832e35ee57e$export$71511d61b312f219(o, p) {
    $b7d0b832e35ee57e$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7d0b832e35ee57e$export$71511d61b312f219(o, p);
}

});


parcelRegister("2nwvT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1bb6f341c8f857d6$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $aPFUy = parcelRequire("aPFUy");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $1bb6f341c8f857d6$export$71511d61b312f219(arr, i) {
    return (0, $1g4fM._)(arr) || (0, $aPFUy._)(arr, i) || (0, $2DD2t._)(arr, i) || (0, $9kJqn._)();
}

});
parcelRegister("1g4fM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0eaa95b9f3cb7234$export$71511d61b312f219; });
function $0eaa95b9f3cb7234$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("aPFUy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e2f2d8338cd036c$export$71511d61b312f219; });
function $7e2f2d8338cd036c$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("9kJqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6cb937a794637792$export$71511d61b312f219; });
function $6cb937a794637792$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2DD2t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ebd819a91fcf92e$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $1ebd819a91fcf92e$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6exmR._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6exmR._)(o, minLen);
}

});
parcelRegister("6exmR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $489def0a77882a2a$export$71511d61b312f219; });
function $489def0a77882a2a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("2us1u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1d041ee89e51af1b$export$71511d61b312f219; });

var $eYsRh = parcelRequire("eYsRh");

var $eaxdf = parcelRequire("eaxdf");

var $46sYX = parcelRequire("46sYX");

var $2DD2t = parcelRequire("2DD2t");
function $1d041ee89e51af1b$export$71511d61b312f219(arr) {
    return (0, $eYsRh._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $46sYX._)();
}

});
parcelRegister("eYsRh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae6d0dee9f5eb3eb$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $ae6d0dee9f5eb3eb$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $6exmR._)(arr);
}

});

parcelRegister("eaxdf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a50bc32ea5ddcbbf$export$71511d61b312f219; });
function $a50bc32ea5ddcbbf$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("46sYX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2fce3437f4cf1874$export$71511d61b312f219; });
function $2fce3437f4cf1874$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1EZOw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $135979cf6d0dc133$export$71511d61b312f219; });

var $8wAe0 = parcelRequire("8wAe0");

var $gyGuQ = parcelRequire("gyGuQ");

var $aFtfV = parcelRequire("aFtfV");

var $fMryZ = parcelRequire("fMryZ");
function $135979cf6d0dc133$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $135979cf6d0dc133$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $aFtfV._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $8wAe0._)(Class, arguments, (0, $gyGuQ._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fMryZ._)(Wrapper, Class);
    };
    return $135979cf6d0dc133$export$71511d61b312f219(Class);
}

});
parcelRegister("8wAe0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $634d6964686a1afa$export$71511d61b312f219; });

var $ftVlM = parcelRequire("ftVlM");

var $fMryZ = parcelRequire("fMryZ");
function $634d6964686a1afa$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $ftVlM._)()) $634d6964686a1afa$export$71511d61b312f219 = Reflect.construct;
    else $634d6964686a1afa$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fMryZ._)(instance, Class.prototype);
        return instance;
    };
    return $634d6964686a1afa$export$71511d61b312f219.apply(null, arguments);
}

});
parcelRegister("ftVlM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b4560d09ed0b6bd9$export$71511d61b312f219; });
function $b4560d09ed0b6bd9$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("gyGuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c0e0c9403f4e59d3$export$71511d61b312f219; });
function $c0e0c9403f4e59d3$export$71511d61b312f219(o) {
    $c0e0c9403f4e59d3$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c0e0c9403f4e59d3$export$71511d61b312f219(o);
}

});

parcelRegister("aFtfV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7c446d547ed0cd60$export$71511d61b312f219; });
function $7c446d547ed0cd60$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("lngen", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f8f85617d0e0b5b6$export$71511d61b312f219; });

var $gyGuQ = parcelRequire("gyGuQ");

var $ftVlM = parcelRequire("ftVlM");

var $gvVNz = parcelRequire("gvVNz");
function $f8f85617d0e0b5b6$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $ftVlM._)();
    return function _createSuperInternal() {
        var Super = (0, $gyGuQ._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gyGuQ._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gvVNz._)(this, result);
    };
}

});
parcelRegister("gvVNz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $031a439d9bd8f8b3$export$71511d61b312f219; });

var $dcJGd = parcelRequire("dcJGd");

var $bJtXW = parcelRequire("bJtXW");
function $031a439d9bd8f8b3$export$71511d61b312f219(self, call) {
    if (call && ((0, $bJtXW._)(call) === "object" || typeof call === "function")) return call;
    return (0, $dcJGd._)(self);
}

});



parcelRegister("bOebF", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $898f5e7f6bf40f0f$export$2b8d127b894957b9; }, function (v) { return $898f5e7f6bf40f0f$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $898f5e7f6bf40f0f$export$cea3a54a6425200c; }, function (v) { return $898f5e7f6bf40f0f$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $898f5e7f6bf40f0f$export$a7c73072b1a182ae; }, function (v) { return $898f5e7f6bf40f0f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $898f5e7f6bf40f0f$export$9f27bc3417b4524d; }, function (v) { return $898f5e7f6bf40f0f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $898f5e7f6bf40f0f$export$db77ccec0bb4ccac; }, function (v) { return $898f5e7f6bf40f0f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $898f5e7f6bf40f0f$export$8392c0c9d3dcbd35; }, function (v) { return $898f5e7f6bf40f0f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $898f5e7f6bf40f0f$export$ffb0004e005737fa; }, function (v) { return $898f5e7f6bf40f0f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $898f5e7f6bf40f0f$export$b624eff549462981; }, function (v) { return $898f5e7f6bf40f0f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $898f5e7f6bf40f0f$export$7897aa7841a5380c; }, function (v) { return $898f5e7f6bf40f0f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $898f5e7f6bf40f0f$export$602eac185826482c; }, function (v) { return $898f5e7f6bf40f0f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $898f5e7f6bf40f0f$export$e2c29f18771995cb; }, function (v) { return $898f5e7f6bf40f0f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $898f5e7f6bf40f0f$export$5f8d39834fd61797; }, function (v) { return $898f5e7f6bf40f0f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $898f5e7f6bf40f0f$export$74bf444e3cd11ea5; }, function (v) { return $898f5e7f6bf40f0f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $898f5e7f6bf40f0f$export$92387174baf9b227; }, function (v) { return $898f5e7f6bf40f0f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $898f5e7f6bf40f0f$export$ec112efeb987d9c6; }, function (v) { return $898f5e7f6bf40f0f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $898f5e7f6bf40f0f$export$b706b080d889d2c9; }, function (v) { return $898f5e7f6bf40f0f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $898f5e7f6bf40f0f$export$5be5a87408f70ddc; }, function (v) { return $898f5e7f6bf40f0f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $898f5e7f6bf40f0f$export$45a5e7f76e0caa8d; }, function (v) { return $898f5e7f6bf40f0f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $898f5e7f6bf40f0f$export$455c2e768291efa6; }, function (v) { return $898f5e7f6bf40f0f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $898f5e7f6bf40f0f$export$9522e17588c12572; }, function (v) { return $898f5e7f6bf40f0f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $898f5e7f6bf40f0f$export$2110ac352bb060b9; }, function (v) { return $898f5e7f6bf40f0f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $898f5e7f6bf40f0f$export$56885ab8b9c456ab; }, function (v) { return $898f5e7f6bf40f0f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $898f5e7f6bf40f0f$export$d927fcb6adf8f9de; }, function (v) { return $898f5e7f6bf40f0f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $898f5e7f6bf40f0f$export$b82d16f27459e05a; }, function (v) { return $898f5e7f6bf40f0f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $898f5e7f6bf40f0f$export$522c17b4f5e123e8; }, function (v) { return $898f5e7f6bf40f0f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $898f5e7f6bf40f0f$export$1aabd8a0274ecfd6; }, function (v) { return $898f5e7f6bf40f0f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $898f5e7f6bf40f0f$export$9b621391a187a31a; }, function (v) { return $898f5e7f6bf40f0f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $898f5e7f6bf40f0f$export$f5bbd400c2f4426f; }, function (v) { return $898f5e7f6bf40f0f$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $898f5e7f6bf40f0f$export$2b8d127b894957b9;
var $898f5e7f6bf40f0f$export$cea3a54a6425200c;
var $898f5e7f6bf40f0f$export$a7c73072b1a182ae;
var $898f5e7f6bf40f0f$export$9f27bc3417b4524d;
var $898f5e7f6bf40f0f$export$db77ccec0bb4ccac;
var $898f5e7f6bf40f0f$export$8392c0c9d3dcbd35;
var $898f5e7f6bf40f0f$export$ffb0004e005737fa;
var $898f5e7f6bf40f0f$export$b624eff549462981;
var $898f5e7f6bf40f0f$export$7897aa7841a5380c;
var $898f5e7f6bf40f0f$export$602eac185826482c;
var $898f5e7f6bf40f0f$export$e2c29f18771995cb;
var $898f5e7f6bf40f0f$export$5f8d39834fd61797;
var $898f5e7f6bf40f0f$export$74bf444e3cd11ea5;
var $898f5e7f6bf40f0f$export$92387174baf9b227;
var $898f5e7f6bf40f0f$export$ec112efeb987d9c6;
var $898f5e7f6bf40f0f$export$b706b080d889d2c9;
var $898f5e7f6bf40f0f$export$5be5a87408f70ddc;
var $898f5e7f6bf40f0f$export$45a5e7f76e0caa8d;
var $898f5e7f6bf40f0f$export$455c2e768291efa6;
var $898f5e7f6bf40f0f$export$9522e17588c12572;
var $898f5e7f6bf40f0f$export$2110ac352bb060b9;
var $898f5e7f6bf40f0f$export$56885ab8b9c456ab;
var $898f5e7f6bf40f0f$export$d927fcb6adf8f9de;
var $898f5e7f6bf40f0f$export$b82d16f27459e05a;
var $898f5e7f6bf40f0f$export$522c17b4f5e123e8;
var $898f5e7f6bf40f0f$export$1aabd8a0274ecfd6;
var $898f5e7f6bf40f0f$export$9b621391a187a31a;
var $898f5e7f6bf40f0f$export$f5bbd400c2f4426f;
"use strict";
var $898f5e7f6bf40f0f$var$b = "function" === typeof Symbol && Symbol.for, $898f5e7f6bf40f0f$var$c = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.element") : 60103, $898f5e7f6bf40f0f$var$d = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.portal") : 60106, $898f5e7f6bf40f0f$var$e = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.fragment") : 60107, $898f5e7f6bf40f0f$var$f = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.strict_mode") : 60108, $898f5e7f6bf40f0f$var$g = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.profiler") : 60114, $898f5e7f6bf40f0f$var$h = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.provider") : 60109, $898f5e7f6bf40f0f$var$k = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.context") : 60110, $898f5e7f6bf40f0f$var$l = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.async_mode") : 60111, $898f5e7f6bf40f0f$var$m = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $898f5e7f6bf40f0f$var$n = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.forward_ref") : 60112, $898f5e7f6bf40f0f$var$p = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.suspense") : 60113, $898f5e7f6bf40f0f$var$q = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.suspense_list") : 60120, $898f5e7f6bf40f0f$var$r = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.memo") : 60115, $898f5e7f6bf40f0f$var$t = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.lazy") : 60116, $898f5e7f6bf40f0f$var$v = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.block") : 60121, $898f5e7f6bf40f0f$var$w = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.fundamental") : 60117, $898f5e7f6bf40f0f$var$x = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.responder") : 60118, $898f5e7f6bf40f0f$var$y = $898f5e7f6bf40f0f$var$b ? Symbol.for("react.scope") : 60119;
function $898f5e7f6bf40f0f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $898f5e7f6bf40f0f$var$c:
                switch(a = a.type, a){
                    case $898f5e7f6bf40f0f$var$l:
                    case $898f5e7f6bf40f0f$var$m:
                    case $898f5e7f6bf40f0f$var$e:
                    case $898f5e7f6bf40f0f$var$g:
                    case $898f5e7f6bf40f0f$var$f:
                    case $898f5e7f6bf40f0f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $898f5e7f6bf40f0f$var$k:
                            case $898f5e7f6bf40f0f$var$n:
                            case $898f5e7f6bf40f0f$var$t:
                            case $898f5e7f6bf40f0f$var$r:
                            case $898f5e7f6bf40f0f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $898f5e7f6bf40f0f$var$d:
                return u;
        }
    }
}
function $898f5e7f6bf40f0f$var$A(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$m;
}
$898f5e7f6bf40f0f$export$2b8d127b894957b9 = $898f5e7f6bf40f0f$var$l;
$898f5e7f6bf40f0f$export$cea3a54a6425200c = $898f5e7f6bf40f0f$var$m;
$898f5e7f6bf40f0f$export$a7c73072b1a182ae = $898f5e7f6bf40f0f$var$k;
$898f5e7f6bf40f0f$export$9f27bc3417b4524d = $898f5e7f6bf40f0f$var$h;
$898f5e7f6bf40f0f$export$db77ccec0bb4ccac = $898f5e7f6bf40f0f$var$c;
$898f5e7f6bf40f0f$export$8392c0c9d3dcbd35 = $898f5e7f6bf40f0f$var$n;
$898f5e7f6bf40f0f$export$ffb0004e005737fa = $898f5e7f6bf40f0f$var$e;
$898f5e7f6bf40f0f$export$b624eff549462981 = $898f5e7f6bf40f0f$var$t;
$898f5e7f6bf40f0f$export$7897aa7841a5380c = $898f5e7f6bf40f0f$var$r;
$898f5e7f6bf40f0f$export$602eac185826482c = $898f5e7f6bf40f0f$var$d;
$898f5e7f6bf40f0f$export$e2c29f18771995cb = $898f5e7f6bf40f0f$var$g;
$898f5e7f6bf40f0f$export$5f8d39834fd61797 = $898f5e7f6bf40f0f$var$f;
$898f5e7f6bf40f0f$export$74bf444e3cd11ea5 = $898f5e7f6bf40f0f$var$p;
$898f5e7f6bf40f0f$export$92387174baf9b227 = function(a) {
    return $898f5e7f6bf40f0f$var$A(a) || $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$l;
};
$898f5e7f6bf40f0f$export$ec112efeb987d9c6 = $898f5e7f6bf40f0f$var$A;
$898f5e7f6bf40f0f$export$b706b080d889d2c9 = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$k;
};
$898f5e7f6bf40f0f$export$5be5a87408f70ddc = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$h;
};
$898f5e7f6bf40f0f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $898f5e7f6bf40f0f$var$c;
};
$898f5e7f6bf40f0f$export$455c2e768291efa6 = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$n;
};
$898f5e7f6bf40f0f$export$9522e17588c12572 = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$e;
};
$898f5e7f6bf40f0f$export$2110ac352bb060b9 = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$t;
};
$898f5e7f6bf40f0f$export$56885ab8b9c456ab = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$r;
};
$898f5e7f6bf40f0f$export$d927fcb6adf8f9de = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$d;
};
$898f5e7f6bf40f0f$export$b82d16f27459e05a = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$g;
};
$898f5e7f6bf40f0f$export$522c17b4f5e123e8 = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$f;
};
$898f5e7f6bf40f0f$export$1aabd8a0274ecfd6 = function(a) {
    return $898f5e7f6bf40f0f$var$z(a) === $898f5e7f6bf40f0f$var$p;
};
$898f5e7f6bf40f0f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $898f5e7f6bf40f0f$var$e || a === $898f5e7f6bf40f0f$var$m || a === $898f5e7f6bf40f0f$var$g || a === $898f5e7f6bf40f0f$var$f || a === $898f5e7f6bf40f0f$var$p || a === $898f5e7f6bf40f0f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $898f5e7f6bf40f0f$var$t || a.$$typeof === $898f5e7f6bf40f0f$var$r || a.$$typeof === $898f5e7f6bf40f0f$var$h || a.$$typeof === $898f5e7f6bf40f0f$var$k || a.$$typeof === $898f5e7f6bf40f0f$var$n || a.$$typeof === $898f5e7f6bf40f0f$var$w || a.$$typeof === $898f5e7f6bf40f0f$var$x || a.$$typeof === $898f5e7f6bf40f0f$var$y || a.$$typeof === $898f5e7f6bf40f0f$var$v);
};
$898f5e7f6bf40f0f$export$f5bbd400c2f4426f = $898f5e7f6bf40f0f$var$z;

});

parcelRegister("h5Ho9", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $c7148f559d547f69$export$a7c73072b1a182ae; }, function (v) { return $c7148f559d547f69$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c7148f559d547f69$export$9f27bc3417b4524d; }, function (v) { return $c7148f559d547f69$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c7148f559d547f69$export$db77ccec0bb4ccac; }, function (v) { return $c7148f559d547f69$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c7148f559d547f69$export$8392c0c9d3dcbd35; }, function (v) { return $c7148f559d547f69$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c7148f559d547f69$export$ffb0004e005737fa; }, function (v) { return $c7148f559d547f69$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c7148f559d547f69$export$b624eff549462981; }, function (v) { return $c7148f559d547f69$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c7148f559d547f69$export$7897aa7841a5380c; }, function (v) { return $c7148f559d547f69$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c7148f559d547f69$export$602eac185826482c; }, function (v) { return $c7148f559d547f69$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c7148f559d547f69$export$e2c29f18771995cb; }, function (v) { return $c7148f559d547f69$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c7148f559d547f69$export$5f8d39834fd61797; }, function (v) { return $c7148f559d547f69$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c7148f559d547f69$export$74bf444e3cd11ea5; }, function (v) { return $c7148f559d547f69$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c7148f559d547f69$export$92387174baf9b227; }, function (v) { return $c7148f559d547f69$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c7148f559d547f69$export$ec112efeb987d9c6; }, function (v) { return $c7148f559d547f69$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c7148f559d547f69$export$b706b080d889d2c9; }, function (v) { return $c7148f559d547f69$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c7148f559d547f69$export$5be5a87408f70ddc; }, function (v) { return $c7148f559d547f69$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c7148f559d547f69$export$45a5e7f76e0caa8d; }, function (v) { return $c7148f559d547f69$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c7148f559d547f69$export$455c2e768291efa6; }, function (v) { return $c7148f559d547f69$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c7148f559d547f69$export$9522e17588c12572; }, function (v) { return $c7148f559d547f69$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c7148f559d547f69$export$2110ac352bb060b9; }, function (v) { return $c7148f559d547f69$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c7148f559d547f69$export$56885ab8b9c456ab; }, function (v) { return $c7148f559d547f69$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c7148f559d547f69$export$d927fcb6adf8f9de; }, function (v) { return $c7148f559d547f69$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c7148f559d547f69$export$b82d16f27459e05a; }, function (v) { return $c7148f559d547f69$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c7148f559d547f69$export$522c17b4f5e123e8; }, function (v) { return $c7148f559d547f69$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c7148f559d547f69$export$1aabd8a0274ecfd6; }, function (v) { return $c7148f559d547f69$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c7148f559d547f69$export$9b621391a187a31a; }, function (v) { return $c7148f559d547f69$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c7148f559d547f69$export$f5bbd400c2f4426f; }, function (v) { return $c7148f559d547f69$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c7148f559d547f69$export$a7c73072b1a182ae;
var $c7148f559d547f69$export$9f27bc3417b4524d;
var $c7148f559d547f69$export$db77ccec0bb4ccac;
var $c7148f559d547f69$export$8392c0c9d3dcbd35;
var $c7148f559d547f69$export$ffb0004e005737fa;
var $c7148f559d547f69$export$b624eff549462981;
var $c7148f559d547f69$export$7897aa7841a5380c;
var $c7148f559d547f69$export$602eac185826482c;
var $c7148f559d547f69$export$e2c29f18771995cb;
var $c7148f559d547f69$export$5f8d39834fd61797;
var $c7148f559d547f69$export$74bf444e3cd11ea5;
var $c7148f559d547f69$export$92387174baf9b227;
var $c7148f559d547f69$export$ec112efeb987d9c6;
var $c7148f559d547f69$export$b706b080d889d2c9;
var $c7148f559d547f69$export$5be5a87408f70ddc;
var $c7148f559d547f69$export$45a5e7f76e0caa8d;
var $c7148f559d547f69$export$455c2e768291efa6;
var $c7148f559d547f69$export$9522e17588c12572;
var $c7148f559d547f69$export$2110ac352bb060b9;
var $c7148f559d547f69$export$56885ab8b9c456ab;
var $c7148f559d547f69$export$d927fcb6adf8f9de;
var $c7148f559d547f69$export$b82d16f27459e05a;
var $c7148f559d547f69$export$522c17b4f5e123e8;
var $c7148f559d547f69$export$1aabd8a0274ecfd6;
var $c7148f559d547f69$export$9b621391a187a31a;
var $c7148f559d547f69$export$f5bbd400c2f4426f;
"use strict";
var $c7148f559d547f69$var$b = 60103, $c7148f559d547f69$var$c = 60106, $c7148f559d547f69$var$d = 60107, $c7148f559d547f69$var$e = 60108, $c7148f559d547f69$var$f = 60114, $c7148f559d547f69$var$g = 60109, $c7148f559d547f69$var$h = 60110, $c7148f559d547f69$var$k = 60112, $c7148f559d547f69$var$l = 60113, $c7148f559d547f69$var$m = 60120, $c7148f559d547f69$var$n = 60115, $c7148f559d547f69$var$p = 60116, $c7148f559d547f69$var$q = 60121, $c7148f559d547f69$var$r = 60122, $c7148f559d547f69$var$u = 60117, $c7148f559d547f69$var$v = 60129, $c7148f559d547f69$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $c7148f559d547f69$var$x = Symbol.for;
    $c7148f559d547f69$var$b = $c7148f559d547f69$var$x("react.element");
    $c7148f559d547f69$var$c = $c7148f559d547f69$var$x("react.portal");
    $c7148f559d547f69$var$d = $c7148f559d547f69$var$x("react.fragment");
    $c7148f559d547f69$var$e = $c7148f559d547f69$var$x("react.strict_mode");
    $c7148f559d547f69$var$f = $c7148f559d547f69$var$x("react.profiler");
    $c7148f559d547f69$var$g = $c7148f559d547f69$var$x("react.provider");
    $c7148f559d547f69$var$h = $c7148f559d547f69$var$x("react.context");
    $c7148f559d547f69$var$k = $c7148f559d547f69$var$x("react.forward_ref");
    $c7148f559d547f69$var$l = $c7148f559d547f69$var$x("react.suspense");
    $c7148f559d547f69$var$m = $c7148f559d547f69$var$x("react.suspense_list");
    $c7148f559d547f69$var$n = $c7148f559d547f69$var$x("react.memo");
    $c7148f559d547f69$var$p = $c7148f559d547f69$var$x("react.lazy");
    $c7148f559d547f69$var$q = $c7148f559d547f69$var$x("react.block");
    $c7148f559d547f69$var$r = $c7148f559d547f69$var$x("react.server.block");
    $c7148f559d547f69$var$u = $c7148f559d547f69$var$x("react.fundamental");
    $c7148f559d547f69$var$v = $c7148f559d547f69$var$x("react.debug_trace_mode");
    $c7148f559d547f69$var$w = $c7148f559d547f69$var$x("react.legacy_hidden");
}
function $c7148f559d547f69$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $c7148f559d547f69$var$b:
                switch(a = a.type, a){
                    case $c7148f559d547f69$var$d:
                    case $c7148f559d547f69$var$f:
                    case $c7148f559d547f69$var$e:
                    case $c7148f559d547f69$var$l:
                    case $c7148f559d547f69$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c7148f559d547f69$var$h:
                            case $c7148f559d547f69$var$k:
                            case $c7148f559d547f69$var$p:
                            case $c7148f559d547f69$var$n:
                            case $c7148f559d547f69$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $c7148f559d547f69$var$c:
                return t;
        }
    }
}
var $c7148f559d547f69$var$z = $c7148f559d547f69$var$g, $c7148f559d547f69$var$A = $c7148f559d547f69$var$b, $c7148f559d547f69$var$B = $c7148f559d547f69$var$k, $c7148f559d547f69$var$C = $c7148f559d547f69$var$d, $c7148f559d547f69$var$D = $c7148f559d547f69$var$p, $c7148f559d547f69$var$E = $c7148f559d547f69$var$n, $c7148f559d547f69$var$F = $c7148f559d547f69$var$c, $c7148f559d547f69$var$G = $c7148f559d547f69$var$f, $c7148f559d547f69$var$H = $c7148f559d547f69$var$e, $c7148f559d547f69$var$I = $c7148f559d547f69$var$l;
$c7148f559d547f69$export$a7c73072b1a182ae = $c7148f559d547f69$var$h;
$c7148f559d547f69$export$9f27bc3417b4524d = $c7148f559d547f69$var$z;
$c7148f559d547f69$export$db77ccec0bb4ccac = $c7148f559d547f69$var$A;
$c7148f559d547f69$export$8392c0c9d3dcbd35 = $c7148f559d547f69$var$B;
$c7148f559d547f69$export$ffb0004e005737fa = $c7148f559d547f69$var$C;
$c7148f559d547f69$export$b624eff549462981 = $c7148f559d547f69$var$D;
$c7148f559d547f69$export$7897aa7841a5380c = $c7148f559d547f69$var$E;
$c7148f559d547f69$export$602eac185826482c = $c7148f559d547f69$var$F;
$c7148f559d547f69$export$e2c29f18771995cb = $c7148f559d547f69$var$G;
$c7148f559d547f69$export$5f8d39834fd61797 = $c7148f559d547f69$var$H;
$c7148f559d547f69$export$74bf444e3cd11ea5 = $c7148f559d547f69$var$I;
$c7148f559d547f69$export$92387174baf9b227 = function() {
    return !1;
};
$c7148f559d547f69$export$ec112efeb987d9c6 = function() {
    return !1;
};
$c7148f559d547f69$export$b706b080d889d2c9 = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$h;
};
$c7148f559d547f69$export$5be5a87408f70ddc = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$g;
};
$c7148f559d547f69$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c7148f559d547f69$var$b;
};
$c7148f559d547f69$export$455c2e768291efa6 = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$k;
};
$c7148f559d547f69$export$9522e17588c12572 = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$d;
};
$c7148f559d547f69$export$2110ac352bb060b9 = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$p;
};
$c7148f559d547f69$export$56885ab8b9c456ab = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$n;
};
$c7148f559d547f69$export$d927fcb6adf8f9de = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$c;
};
$c7148f559d547f69$export$b82d16f27459e05a = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$f;
};
$c7148f559d547f69$export$522c17b4f5e123e8 = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$e;
};
$c7148f559d547f69$export$1aabd8a0274ecfd6 = function(a) {
    return $c7148f559d547f69$var$y(a) === $c7148f559d547f69$var$l;
};
$c7148f559d547f69$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c7148f559d547f69$var$d || a === $c7148f559d547f69$var$f || a === $c7148f559d547f69$var$v || a === $c7148f559d547f69$var$e || a === $c7148f559d547f69$var$l || a === $c7148f559d547f69$var$m || a === $c7148f559d547f69$var$w || "object" === typeof a && null !== a && (a.$$typeof === $c7148f559d547f69$var$p || a.$$typeof === $c7148f559d547f69$var$n || a.$$typeof === $c7148f559d547f69$var$g || a.$$typeof === $c7148f559d547f69$var$h || a.$$typeof === $c7148f559d547f69$var$k || a.$$typeof === $c7148f559d547f69$var$u || a.$$typeof === $c7148f559d547f69$var$q || a[0] === $c7148f559d547f69$var$r) ? !0 : !1;
};
$c7148f559d547f69$export$f5bbd400c2f4426f = $c7148f559d547f69$var$y;

});

parcelRegister("fw6ZE", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("6bjSP")), (parcelRequire("8mKeA")), (parcelRequire("jQYBi")), (parcelRequire("7Yr9A")), (parcelRequire("k9XOC")), (parcelRequire("korLD")), (parcelRequire("jv8Lc")), (parcelRequire("j5TZa")), (parcelRequire("croIr")), (parcelRequire("3cHqQ")), (parcelRequire("g5oGh")), (parcelRequire("g6Iup")), (parcelRequire("huuE5")), (parcelRequire("9zl2U")), (parcelRequire("bEspG")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")), (parcelRequire("bu28Q")), (parcelRequire("1lRRd")), (parcelRequire("7bq7S")), (parcelRequire("kOUfs")), (parcelRequire("6Qi31")), (parcelRequire("bHouN")), (parcelRequire("f6Jo9")), (parcelRequire("iJO3c")), (parcelRequire("i6cRD")), (parcelRequire("qX4rw")), (parcelRequire("f2JmM")), (parcelRequire("jifIy")), (parcelRequire("jkaNt")), (parcelRequire("bKAb2")), (parcelRequire("3kikJ")), (parcelRequire("6nesm")), (parcelRequire("hSRM4")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("ezlGF", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kqcu3"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function extend(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function create() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function init() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function mixIn(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function clone() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function init(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function toString(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function concat(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function clamp() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function clone() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function random(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function stringify(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function parse(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function stringify(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function parse(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function stringify(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function parse(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function reset() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function _append(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function _process(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function clone() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function init(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function reset() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function update(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function finalize(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function _createHelper(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function _createHmacHelper(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("kqcu3", function(module, exports) {
"use strict";

});


parcelRegister("6bjSP", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function init(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function init(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function toX32() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function clone() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("8mKeA", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function subInit(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("jQYBi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function stringify(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function parse(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function stringify(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function parse(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("7Yr9A", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function stringify(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function parse(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("k9XOC", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function stringify(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function parse(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("korLD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function _doReset() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function _doFinalize() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function clone() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("jv8Lc", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function _doReset() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function _doFinalize() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function clone() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("j5TZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function _doReset() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function _doFinalize() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function clone() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("croIr", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("j5TZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function _doReset() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function _doFinalize() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("3cHqQ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("6bjSP")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function _doReset() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function _doFinalize() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function clone() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("g5oGh", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("6bjSP")), (parcelRequire("3cHqQ")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function _doReset() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function _doFinalize() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("g6Iup", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("6bjSP")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function _doReset() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function _doFinalize() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function clone() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("huuE5", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function _doReset() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function _doFinalize() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function clone() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("9zl2U", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function init(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function reset() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function update(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function finalize(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("bEspG", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("j5TZa")), (parcelRequire("9zl2U")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function init(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function compute(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("dITj9", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("jv8Lc")), (parcelRequire("9zl2U")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function init(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function compute(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("cRUO7", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("dITj9")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function createEncryptor(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function createDecryptor(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function init(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function reset() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function process(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function finalize(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function encrypt(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function decrypt(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function _doFinalize() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function createEncryptor(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function createDecryptor(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function init(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function processBlock(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function processBlock(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function pad(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function unpad(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function reset() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function _doProcessBlock(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function _doFinalize() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function init(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function toString(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function stringify(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function parse(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function encrypt(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function decrypt(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function _parse(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function execute(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function encrypt(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function decrypt(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("bu28Q", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("1lRRd", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("7bq7S", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("kOUfs", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("6Qi31", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function processBlock(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function processBlock(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("bHouN", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function pad(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function unpad(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("f6Jo9", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function pad(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function unpad(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("iJO3c", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function pad(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function unpad(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("i6cRD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function pad(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function unpad(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("qX4rw", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function pad() {},
        unpad: function unpad() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("f2JmM", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function stringify(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function parse(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("jifIy", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("7Yr9A")), (parcelRequire("korLD")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function _doReset() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function encryptBlock(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function decryptBlock(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("jkaNt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("7Yr9A")), (parcelRequire("korLD")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function _doReset() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function encryptBlock(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function decryptBlock(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function _doReset() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function encryptBlock(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function decryptBlock(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("bKAb2", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("7Yr9A")), (parcelRequire("korLD")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function _doReset() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function _doReset() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("3kikJ", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("7Yr9A")), (parcelRequire("korLD")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function _doReset() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("6nesm", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("7Yr9A")), (parcelRequire("korLD")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function _doReset() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("hSRM4", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("ezlGF")), (parcelRequire("7Yr9A")), (parcelRequire("korLD")), (parcelRequire("dITj9")), (parcelRequire("cRUO7")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        var N = 16;
        //Origin pbox and sbox, derived from PI
        var ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        var ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            var a = x >> 24 & 0xFF;
            var b = x >> 16 & 0xFF;
            var c = x >> 8 & 0xFF;
            var d = x & 0xFF;
            var y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            var Xl = left;
            var Xr = right;
            var temp;
            for(var i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            var Xl = left;
            var Xr = right;
            var temp;
            for(var i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(var Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(var Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            var keyIndex = 0;
            for(var index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            var Data1 = 0;
            var Data2 = 0;
            var res = 0;
            for(var i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(var i1 = 0; i1 < 4; i1++)for(var j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i1][j] = Data1;
                ctx.sbox[i1][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function _doReset() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function encryptBlock(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function decryptBlock(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});



var $2nwvT = parcelRequire("2nwvT");
var $d8ffb49eb4cd7afd$exports = {};
"use strict";

$d8ffb49eb4cd7afd$exports = (parcelRequire("jIgWH"));



var $dQFEZ = parcelRequire("dQFEZ");
var $8dbfa3fee6dc40a7$exports = {};

$parcel$export($8dbfa3fee6dc40a7$exports, "createRoot", function () { return $8dbfa3fee6dc40a7$export$882461b6382ed46c; }, function (v) { return $8dbfa3fee6dc40a7$export$882461b6382ed46c = v; });
$parcel$export($8dbfa3fee6dc40a7$exports, "hydrateRoot", function () { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e; }, function (v) { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e = v; });
var $8dbfa3fee6dc40a7$export$882461b6382ed46c;
var $8dbfa3fee6dc40a7$export$757ceba2d55c277e;
"use strict";
var $4288f0eb191085d1$exports = {};
"use strict";
function $4288f0eb191085d1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4288f0eb191085d1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4288f0eb191085d1$var$checkDCE();

$4288f0eb191085d1$exports = (parcelRequire("gZreO"));


var $8dbfa3fee6dc40a7$var$i;
$8dbfa3fee6dc40a7$export$882461b6382ed46c = $4288f0eb191085d1$exports.createRoot;
$8dbfa3fee6dc40a7$export$757ceba2d55c277e = $4288f0eb191085d1$exports.hydrateRoot;




var $3de45623f3aba285$exports = {};

$3de45623f3aba285$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "profile.cb628fc0.jpeg";


var $ee0def20b6b951ce$exports = {};

var $bJtXW = parcelRequire("bJtXW");
var $903353200bfa7e9a$exports = {};
// shim for using process in browser
var $903353200bfa7e9a$var$process = $903353200bfa7e9a$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $903353200bfa7e9a$var$cachedSetTimeout;
var $903353200bfa7e9a$var$cachedClearTimeout;
function $903353200bfa7e9a$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $903353200bfa7e9a$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $903353200bfa7e9a$var$cachedSetTimeout = setTimeout;
        else $903353200bfa7e9a$var$cachedSetTimeout = $903353200bfa7e9a$var$defaultSetTimout;
    } catch (e) {
        $903353200bfa7e9a$var$cachedSetTimeout = $903353200bfa7e9a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $903353200bfa7e9a$var$cachedClearTimeout = clearTimeout;
        else $903353200bfa7e9a$var$cachedClearTimeout = $903353200bfa7e9a$var$defaultClearTimeout;
    } catch (e) {
        $903353200bfa7e9a$var$cachedClearTimeout = $903353200bfa7e9a$var$defaultClearTimeout;
    }
})();
function $903353200bfa7e9a$var$runTimeout(fun) {
    if ($903353200bfa7e9a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($903353200bfa7e9a$var$cachedSetTimeout === $903353200bfa7e9a$var$defaultSetTimout || !$903353200bfa7e9a$var$cachedSetTimeout) && setTimeout) {
        $903353200bfa7e9a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $903353200bfa7e9a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $903353200bfa7e9a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $903353200bfa7e9a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $903353200bfa7e9a$var$runClearTimeout(marker) {
    if ($903353200bfa7e9a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($903353200bfa7e9a$var$cachedClearTimeout === $903353200bfa7e9a$var$defaultClearTimeout || !$903353200bfa7e9a$var$cachedClearTimeout) && clearTimeout) {
        $903353200bfa7e9a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $903353200bfa7e9a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $903353200bfa7e9a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $903353200bfa7e9a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $903353200bfa7e9a$var$queue = [];
var $903353200bfa7e9a$var$draining = false;
var $903353200bfa7e9a$var$currentQueue;
var $903353200bfa7e9a$var$queueIndex = -1;
function $903353200bfa7e9a$var$cleanUpNextTick() {
    if (!$903353200bfa7e9a$var$draining || !$903353200bfa7e9a$var$currentQueue) return;
    $903353200bfa7e9a$var$draining = false;
    if ($903353200bfa7e9a$var$currentQueue.length) $903353200bfa7e9a$var$queue = $903353200bfa7e9a$var$currentQueue.concat($903353200bfa7e9a$var$queue);
    else $903353200bfa7e9a$var$queueIndex = -1;
    if ($903353200bfa7e9a$var$queue.length) $903353200bfa7e9a$var$drainQueue();
}
function $903353200bfa7e9a$var$drainQueue() {
    if ($903353200bfa7e9a$var$draining) return;
    var timeout = $903353200bfa7e9a$var$runTimeout($903353200bfa7e9a$var$cleanUpNextTick);
    $903353200bfa7e9a$var$draining = true;
    var len = $903353200bfa7e9a$var$queue.length;
    while(len){
        $903353200bfa7e9a$var$currentQueue = $903353200bfa7e9a$var$queue;
        $903353200bfa7e9a$var$queue = [];
        while(++$903353200bfa7e9a$var$queueIndex < len)if ($903353200bfa7e9a$var$currentQueue) $903353200bfa7e9a$var$currentQueue[$903353200bfa7e9a$var$queueIndex].run();
        $903353200bfa7e9a$var$queueIndex = -1;
        len = $903353200bfa7e9a$var$queue.length;
    }
    $903353200bfa7e9a$var$currentQueue = null;
    $903353200bfa7e9a$var$draining = false;
    $903353200bfa7e9a$var$runClearTimeout(timeout);
}
$903353200bfa7e9a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $903353200bfa7e9a$var$queue.push(new $903353200bfa7e9a$var$Item(fun, args));
    if ($903353200bfa7e9a$var$queue.length === 1 && !$903353200bfa7e9a$var$draining) $903353200bfa7e9a$var$runTimeout($903353200bfa7e9a$var$drainQueue);
};
// v8 likes predictible objects
function $903353200bfa7e9a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$903353200bfa7e9a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$903353200bfa7e9a$var$process.title = "browser";
$903353200bfa7e9a$var$process.browser = true;
$903353200bfa7e9a$var$process.env = {};
$903353200bfa7e9a$var$process.argv = [];
$903353200bfa7e9a$var$process.version = ""; // empty string to avoid regexp issues
$903353200bfa7e9a$var$process.versions = {};
function $903353200bfa7e9a$var$noop() {}
$903353200bfa7e9a$var$process.on = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.addListener = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.once = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.off = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.removeListener = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.removeAllListeners = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.emit = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.prependListener = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.prependOnceListener = $903353200bfa7e9a$var$noop;
$903353200bfa7e9a$var$process.listeners = function(name) {
    return [];
};
$903353200bfa7e9a$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$903353200bfa7e9a$var$process.cwd = function() {
    return "/";
};
$903353200bfa7e9a$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$903353200bfa7e9a$var$process.umask = function() {
    return 0;
};



!function(e, t) {
    $ee0def20b6b951ce$exports = t((parcelRequire("dQFEZ")));
}("undefined" != typeof self ? self : undefined, function(e) {
    return function() {
        var t = {
            7403: function(e, t, r) {
                "use strict";
                var g = function g(e, t) {
                    var _$r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var _$n = Object.getOwnPropertySymbols(e);
                        t && (_$n = _$n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), _$r.push.apply(_$r, _$n);
                    }
                    return _$r;
                };
                var w = function w(e) {
                    for(var _$t = 1; _$t < arguments.length; _$t++){
                        var _$r = null != arguments[_$t] ? arguments[_$t] : {};
                        _$t % 2 ? g(Object(_$r), !0).forEach(function(t) {
                            O(e, t, _$r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(_$r)) : g(Object(_$r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(_$r, t));
                        });
                    }
                    return e;
                };
                var x = function x(e) {
                    return function(e) {
                        if (Array.isArray(e)) return j(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return j(e, t);
                            var _$r = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === _$r && e.constructor && (_$r = e.constructor.name), "Map" === _$r || "Set" === _$r ? Array.from(e) : "Arguments" === _$r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$r) ? j(e, t) : void 0;
                        }
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                };
                var j = function j(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var _$r = 0, _$n = new Array(t); _$r < t; _$r++)_$n[_$r] = e[_$r];
                    return _$n;
                };
                var E = function E(e, t) {
                    for(var _$r = 0; _$r < t.length; _$r++){
                        var _$n = t[_$r];
                        _$n.enumerable = _$n.enumerable || !1, _$n.configurable = !0, "value" in _$n && (_$n.writable = !0), Object.defineProperty(e, T(_$n.key), _$n);
                    }
                };
                var O = function O(e, t, r) {
                    return (t = T(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                };
                var T = function T(e) {
                    var _$t = function(e, t) {
                        if ("object" !== _(e) || null === e) return e;
                        var _$r = e[Symbol.toPrimitive];
                        if (void 0 !== _$r) {
                            var _$n = _$r.call(e, "string");
                            if ("object" !== _(_$n)) return _$n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === _(_$t) ? _$t : String(_$t);
                };
                r.d(t, {
                    default: function() {
                        return S;
                    }
                });
                var _$n = r(4087), o = r.n(_$n);
                var a = function a(e) {
                    return new RegExp(/<[a-z][\s\S]*>/i).test(e);
                }, i = function i(e, t) {
                    return Math.floor(Math.random() * (t - e + 1)) + e;
                };
                var s = "TYPE_CHARACTER", u = "REMOVE_CHARACTER", c = "REMOVE_ALL", p = "REMOVE_LAST_VISIBLE_NODE", l = "PAUSE_FOR", f = "CALL_FUNCTION", v = "ADD_HTML_TAG_ELEMENT", d = "CHANGE_DELETE_SPEED", h = "CHANGE_DELAY", y = "CHANGE_CURSOR", b = "PASTE_STRING", m = "HTML_TAG";
                function _(e) {
                    return _ = "function" == typeof Symbol && "symbol" == (0, $bJtXW._)(Symbol.iterator) ? function _(e) {
                        return typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                    }, _(e);
                }
                var S = function() {
                    function e(t, r) {
                        var _ = this;
                        if (function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), O(this, "state", {
                            cursorAnimation: null,
                            lastFrameTime: null,
                            pauseUntil: null,
                            eventQueue: [],
                            eventLoop: null,
                            eventLoopPaused: !1,
                            reverseCalledEvents: [],
                            calledEvents: [],
                            visibleNodes: [],
                            initialOptions: null,
                            elements: {
                                container: null,
                                wrapper: document.createElement("span"),
                                cursor: document.createElement("span")
                            }
                        }), O(this, "options", {
                            strings: null,
                            cursor: "|",
                            delay: "natural",
                            pauseFor: 1500,
                            deleteSpeed: "natural",
                            loop: !1,
                            autoStart: !1,
                            devMode: !1,
                            skipAddStyles: !1,
                            wrapperClassName: "Typewriter__wrapper",
                            cursorClassName: "Typewriter__cursor",
                            stringSplitter: null,
                            onCreateTextNode: null,
                            onRemoveNode: null
                        }), O(this, "setupWrapperElement", function() {
                            _.state.elements.container && (_.state.elements.wrapper.className = _.options.wrapperClassName, _.state.elements.cursor.className = _.options.cursorClassName, _.state.elements.cursor.innerHTML = _.options.cursor, _.state.elements.container.innerHTML = "", _.state.elements.container.appendChild(_.state.elements.wrapper), _.state.elements.container.appendChild(_.state.elements.cursor));
                        }), O(this, "start", function() {
                            return _.state.eventLoopPaused = !1, _.runEventLoop(), _;
                        }), O(this, "pause", function() {
                            return _.state.eventLoopPaused = !0, _;
                        }), O(this, "stop", function() {
                            return _.state.eventLoop && ((0, _$n.cancel)(_.state.eventLoop), _.state.eventLoop = null), _;
                        }), O(this, "pauseFor", function(e) {
                            return _.addEventToQueue(l, {
                                ms: e
                            }), _;
                        }), O(this, "typeOutAllStrings", function() {
                            return "string" == typeof _.options.strings ? (_.typeString(_.options.strings).pauseFor(_.options.pauseFor), _) : (_.options.strings.forEach(function(e) {
                                _.typeString(e).pauseFor(_.options.pauseFor).deleteAll(_.options.deleteSpeed);
                            }), _);
                        }), O(this, "typeString", function(e) {
                            var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            if (a(e)) return _.typeOutHTMLString(e, _$t);
                            if (e) {
                                var _$r = (_.options || {}).stringSplitter, _$n = "function" == typeof _$r ? _$r(e) : e.split("");
                                _.typeCharacters(_$n, _$t);
                            }
                            return _;
                        }), O(this, "pasteString", function(e) {
                            var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            return a(e) ? _.typeOutHTMLString(e, _$t, !0) : (e && _.addEventToQueue(b, {
                                character: e,
                                node: _$t
                            }), _);
                        }), O(this, "typeOutHTMLString", function(e) {
                            var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, _$r = arguments.length > 2 ? arguments[2] : void 0, _$n = function(e) {
                                var _$t = document.createElement("div");
                                return _$t.innerHTML = e, _$t.childNodes;
                            }(e);
                            if (_$n.length > 0) for(var o = 0; o < _$n.length; o++){
                                var a = _$n[o], i = a.innerHTML;
                                a && 3 !== a.nodeType ? (a.innerHTML = "", _.addEventToQueue(v, {
                                    node: a,
                                    parentNode: _$t
                                }), _$r ? _.pasteString(i, a) : _.typeString(i, a)) : a.textContent && (_$r ? _.pasteString(a.textContent, _$t) : _.typeString(a.textContent, _$t));
                            }
                            return _;
                        }), O(this, "deleteAll", function() {
                            var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "natural";
                            return _.addEventToQueue(c, {
                                speed: _$e
                            }), _;
                        }), O(this, "changeDeleteSpeed", function(e) {
                            if (!e) throw new Error("Must provide new delete speed");
                            return _.addEventToQueue(d, {
                                speed: e
                            }), _;
                        }), O(this, "changeDelay", function(e) {
                            if (!e) throw new Error("Must provide new delay");
                            return _.addEventToQueue(h, {
                                delay: e
                            }), _;
                        }), O(this, "changeCursor", function(e) {
                            if (!e) throw new Error("Must provide new cursor");
                            return _.addEventToQueue(y, {
                                cursor: e
                            }), _;
                        }), O(this, "deleteChars", function(e) {
                            if (!e) throw new Error("Must provide amount of characters to delete");
                            for(var _$t = 0; _$t < e; _$t++)_.addEventToQueue(u);
                            return _;
                        }), O(this, "callFunction", function(e, t) {
                            if (!e || "function" != typeof e) throw new Error("Callback must be a function");
                            return _.addEventToQueue(f, {
                                cb: e,
                                thisArg: t
                            }), _;
                        }), O(this, "typeCharacters", function(e) {
                            var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            if (!e || !Array.isArray(e)) throw new Error("Characters must be an array");
                            return e.forEach(function(e) {
                                _.addEventToQueue(s, {
                                    character: e,
                                    node: _$t
                                });
                            }), _;
                        }), O(this, "removeCharacters", function(e) {
                            if (!e || !Array.isArray(e)) throw new Error("Characters must be an array");
                            return e.forEach(function() {
                                _.addEventToQueue(u);
                            }), _;
                        }), O(this, "addEventToQueue", function(e, t) {
                            var _$r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                            return _.addEventToStateProperty(e, t, _$r, "eventQueue");
                        }), O(this, "addReverseCalledEvent", function(e, t) {
                            var _$r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                            return _.options.loop ? _.addEventToStateProperty(e, t, _$r, "reverseCalledEvents") : _;
                        }), O(this, "addEventToStateProperty", function(e, t) {
                            var _$r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], _$n = arguments.length > 3 ? arguments[3] : void 0, o = {
                                eventName: e,
                                eventArgs: t || {}
                            };
                            return _.state[_$n] = _$r ? [
                                o
                            ].concat(x(_.state[_$n])) : [].concat(x(_.state[_$n]), [
                                o
                            ]), _;
                        }), O(this, "runEventLoop", function() {
                            _.state.lastFrameTime || (_.state.lastFrameTime = Date.now());
                            var _$e = Date.now(), _$t = _$e - _.state.lastFrameTime;
                            if (!_.state.eventQueue.length) {
                                if (!_.options.loop) return;
                                _.state.eventQueue = x(_.state.calledEvents), _.state.calledEvents = [], _.options = w({}, _.state.initialOptions);
                            }
                            if (_.state.eventLoop = o()(_.runEventLoop), !_.state.eventLoopPaused) {
                                if (_.state.pauseUntil) {
                                    if (_$e < _.state.pauseUntil) return;
                                    _.state.pauseUntil = null;
                                }
                                var _$r, _$n = x(_.state.eventQueue), a = _$n.shift();
                                if (!(_$t <= (_$r = a.eventName === p || a.eventName === u ? "natural" === _.options.deleteSpeed ? i(40, 80) : _.options.deleteSpeed : "natural" === _.options.delay ? i(120, 160) : _.options.delay))) {
                                    var g = a.eventName, j = a.eventArgs;
                                    switch(_.logInDevMode({
                                        currentEvent: a,
                                        state: _.state,
                                        delay: _$r
                                    }), g){
                                        case b:
                                        case s:
                                            var E = j.character, O = j.node, T = document.createTextNode(E), S = T;
                                            _.options.onCreateTextNode && "function" == typeof _.options.onCreateTextNode && (S = _.options.onCreateTextNode(E, T)), S && (O ? O.appendChild(S) : _.state.elements.wrapper.appendChild(S)), _.state.visibleNodes = [].concat(x(_.state.visibleNodes), [
                                                {
                                                    type: "TEXT_NODE",
                                                    character: E,
                                                    node: S
                                                }
                                            ]);
                                            break;
                                        case u:
                                            _$n.unshift({
                                                eventName: p,
                                                eventArgs: {
                                                    removingCharacterNode: !0
                                                }
                                            });
                                            break;
                                        case l:
                                            var A = a.eventArgs.ms;
                                            _.state.pauseUntil = Date.now() + parseInt(A);
                                            break;
                                        case f:
                                            var P = a.eventArgs, N = P.cb, C = P.thisArg;
                                            N.call(C, {
                                                elements: _.state.elements
                                            });
                                            break;
                                        case v:
                                            var L = a.eventArgs, k = L.node, D = L.parentNode;
                                            D ? D.appendChild(k) : _.state.elements.wrapper.appendChild(k), _.state.visibleNodes = [].concat(x(_.state.visibleNodes), [
                                                {
                                                    type: m,
                                                    node: k,
                                                    parentNode: D || _.state.elements.wrapper
                                                }
                                            ]);
                                            break;
                                        case c:
                                            var M = _.state.visibleNodes, R = j.speed, F = [];
                                            R && F.push({
                                                eventName: d,
                                                eventArgs: {
                                                    speed: R,
                                                    temp: !0
                                                }
                                            });
                                            for(var z = 0, Q = M.length; z < Q; z++)F.push({
                                                eventName: p,
                                                eventArgs: {
                                                    removingCharacterNode: !1
                                                }
                                            });
                                            R && F.push({
                                                eventName: d,
                                                eventArgs: {
                                                    speed: _.options.deleteSpeed,
                                                    temp: !0
                                                }
                                            }), _$n.unshift.apply(_$n, F);
                                            break;
                                        case p:
                                            var I = a.eventArgs.removingCharacterNode;
                                            if (_.state.visibleNodes.length) {
                                                var U = _.state.visibleNodes.pop(), H = U.type, q = U.node, B = U.character;
                                                _.options.onRemoveNode && "function" == typeof _.options.onRemoveNode && _.options.onRemoveNode({
                                                    node: q,
                                                    character: B
                                                }), q && q.parentNode.removeChild(q), H === m && I && _$n.unshift({
                                                    eventName: p,
                                                    eventArgs: {}
                                                });
                                            }
                                            break;
                                        case d:
                                            _.options.deleteSpeed = a.eventArgs.speed;
                                            break;
                                        case h:
                                            _.options.delay = a.eventArgs.delay;
                                            break;
                                        case y:
                                            _.options.cursor = a.eventArgs.cursor, _.state.elements.cursor.innerHTML = a.eventArgs.cursor;
                                    }
                                    _.options.loop && (a.eventName === p || a.eventArgs && a.eventArgs.temp || (_.state.calledEvents = [].concat(x(_.state.calledEvents), [
                                        a
                                    ]))), _.state.eventQueue = _$n, _.state.lastFrameTime = _$e;
                                }
                            }
                        }), t) {
                            if ("string" == typeof t) {
                                var g = document.querySelector(t);
                                if (!g) throw new Error("Could not find container element");
                                this.state.elements.container = g;
                            } else this.state.elements.container = t;
                        }
                        r && (this.options = w(w({}, this.options), r)), this.state.initialOptions = w({}, this.options), this.init();
                    }
                    var _$t, _$r;
                    return _$t = e, _$r = [
                        {
                            key: "init",
                            value: function value() {
                                var _$e, _$t;
                                this.setupWrapperElement(), this.addEventToQueue(y, {
                                    cursor: this.options.cursor
                                }, !0), this.addEventToQueue(c, null, !0), !window || window.___TYPEWRITER_JS_STYLES_ADDED___ || this.options.skipAddStyles || (_$e = ".Typewriter__cursor{-webkit-animation:Typewriter-cursor 1s infinite;animation:Typewriter-cursor 1s infinite;margin-left:1px}@-webkit-keyframes Typewriter-cursor{0%{opacity:0}50%{opacity:1}100%{opacity:0}}@keyframes Typewriter-cursor{0%{opacity:0}50%{opacity:1}100%{opacity:0}}", (_$t = document.createElement("style")).appendChild(document.createTextNode(_$e)), document.head.appendChild(_$t), window.___TYPEWRITER_JS_STYLES_ADDED___ = !0), !0 === this.options.autoStart && this.options.strings && this.typeOutAllStrings().start();
                            }
                        },
                        {
                            key: "logInDevMode",
                            value: function value(e) {
                                this.options.devMode && console.log(e);
                            }
                        }
                    ], E(_$t.prototype, _$r), Object.defineProperty(_$t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            8552: function(e, t, r) {
                var _$n = r(852)(r(5639), "DataView");
                e.exports = _$n;
            },
            1989: function(e, t, r) {
                var u = function u(e) {
                    var t = -1, _$r = null == e ? 0 : e.length;
                    for(this.clear(); ++t < _$r;){
                        var _$n = e[t];
                        this.set(_$n[0], _$n[1]);
                    }
                };
                var _$n = r(1789), o = r(401), a = r(7667), i = r(1327), s = r(1866);
                u.prototype.clear = _$n, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = s, e.exports = u;
            },
            8407: function(e, t, r) {
                var u = function u(e) {
                    var t = -1, _$r = null == e ? 0 : e.length;
                    for(this.clear(); ++t < _$r;){
                        var _$n = e[t];
                        this.set(_$n[0], _$n[1]);
                    }
                };
                var _$n = r(7040), o = r(4125), a = r(2117), i = r(7518), s = r(4705);
                u.prototype.clear = _$n, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = s, e.exports = u;
            },
            7071: function(e, t, r) {
                var _$n = r(852)(r(5639), "Map");
                e.exports = _$n;
            },
            3369: function(e, t, r) {
                var u = function u(e) {
                    var t = -1, _$r = null == e ? 0 : e.length;
                    for(this.clear(); ++t < _$r;){
                        var _$n = e[t];
                        this.set(_$n[0], _$n[1]);
                    }
                };
                var _$n = r(4785), o = r(1285), a = r(6e3), i = r(9916), s = r(5265);
                u.prototype.clear = _$n, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = i, u.prototype.set = s, e.exports = u;
            },
            3818: function(e, t, r) {
                var _$n = r(852)(r(5639), "Promise");
                e.exports = _$n;
            },
            8525: function(e, t, r) {
                var _$n = r(852)(r(5639), "Set");
                e.exports = _$n;
            },
            8668: function(e, t, r) {
                var i = function i(e) {
                    var t = -1, _$r = null == e ? 0 : e.length;
                    for(this.__data__ = new _$n; ++t < _$r;)this.add(e[t]);
                };
                var _$n = r(3369), o = r(619), a = r(2385);
                i.prototype.add = i.prototype.push = o, i.prototype.has = a, e.exports = i;
            },
            6384: function(e, t, r) {
                var c = function c(e) {
                    var t = this.__data__ = new _$n(e);
                    this.size = t.size;
                };
                var _$n = r(8407), o = r(7465), a = r(3779), i = r(7599), s = r(4758), u = r(4309);
                c.prototype.clear = o, c.prototype.delete = a, c.prototype.get = i, c.prototype.has = s, c.prototype.set = u, e.exports = c;
            },
            2705: function(e, t, r) {
                var _$n = r(5639).Symbol;
                e.exports = _$n;
            },
            1149: function(e, t, r) {
                var _$n = r(5639).Uint8Array;
                e.exports = _$n;
            },
            577: function(e, t, r) {
                var _$n = r(852)(r(5639), "WeakMap");
                e.exports = _$n;
            },
            4963: function(e) {
                e.exports = function(e, t) {
                    for(var r = -1, _$n = null == e ? 0 : e.length, o = 0, a = []; ++r < _$n;){
                        var i = e[r];
                        t(i, r, e) && (a[o++] = i);
                    }
                    return a;
                };
            },
            4636: function(e, t, r) {
                var _$n = r(2545), o = r(5694), a = r(1469), i = r(4144), s = r(5776), u = r(6719), c = Object.prototype.hasOwnProperty;
                e.exports = function(e, t) {
                    var _$r = a(e), p = !_$r && o(e), l = !_$r && !p && i(e), f = !_$r && !p && !l && u(e), v = _$r || p || l || f, d = v ? _$n(e.length, String) : [], h = d.length;
                    for(var y in e)!t && !c.call(e, y) || v && ("length" == y || l && ("offset" == y || "parent" == y) || f && ("buffer" == y || "byteLength" == y || "byteOffset" == y) || s(y, h)) || d.push(y);
                    return d;
                };
            },
            2488: function(e) {
                e.exports = function(e, t) {
                    for(var r = -1, _$n = t.length, o = e.length; ++r < _$n;)e[o + r] = t[r];
                    return e;
                };
            },
            2908: function(e) {
                e.exports = function(e, t) {
                    for(var r = -1, _$n = null == e ? 0 : e.length; ++r < _$n;)if (t(e[r], r, e)) return !0;
                    return !1;
                };
            },
            8470: function(e, t, r) {
                var _$n = r(7813);
                e.exports = function(e, t) {
                    for(var _$r = e.length; _$r--;)if (_$n(e[_$r][0], t)) return _$r;
                    return -1;
                };
            },
            8866: function(e, t, r) {
                var _$n = r(2488), o = r(1469);
                e.exports = function(e, t, r) {
                    var a = t(e);
                    return o(e) ? a : _$n(a, r(e));
                };
            },
            4239: function(e, t, r) {
                var _$n = r(2705), o = r(9607), a = r(2333), i = _$n ? _$n.toStringTag : void 0;
                e.exports = function(e) {
                    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : i && i in Object(e) ? o(e) : a(e);
                };
            },
            9454: function(e, t, r) {
                var _$n = r(4239), o = r(7005);
                e.exports = function(e) {
                    return o(e) && "[object Arguments]" == _$n(e);
                };
            },
            939: function(e, t, r) {
                var _$n = r(2492), o = r(7005);
                e.exports = function e(t, r, a, i, s) {
                    return t === r || (null == t || null == r || !o(t) && !o(r) ? t != t && r != r : _$n(t, r, a, i, e, s));
                };
            },
            2492: function(e, t, r) {
                var _$n = r(6384), o = r(7114), a = r(8351), i = r(6096), s = r(4160), u = r(1469), c = r(4144), p = r(6719), l = "[object Arguments]", f = "[object Array]", v = "[object Object]", d = Object.prototype.hasOwnProperty;
                e.exports = function(e, t, r, h, y, b) {
                    var m = u(e), _ = u(t), g = m ? f : s(e), w = _ ? f : s(t), x = (g = g == l ? v : g) == v, j = (w = w == l ? v : w) == v, E = g == w;
                    if (E && c(e)) {
                        if (!c(t)) return !1;
                        m = !0, x = !1;
                    }
                    if (E && !x) return b || (b = new _$n), m || p(e) ? o(e, t, r, h, y, b) : a(e, t, g, r, h, y, b);
                    if (!(1 & r)) {
                        var O = x && d.call(e, "__wrapped__"), T = j && d.call(t, "__wrapped__");
                        if (O || T) {
                            var S = O ? e.value() : e, A = T ? t.value() : t;
                            return b || (b = new _$n), y(S, A, r, h, b);
                        }
                    }
                    return !!E && (b || (b = new _$n), i(e, t, r, h, y, b));
                };
            },
            8458: function(e, t, r) {
                var _$n = r(3560), o = r(5346), a = r(3218), i = r(346), s = /^\[object .+?Constructor\]$/, u = Function.prototype, c = Object.prototype, p = u.toString, l = c.hasOwnProperty, f = RegExp("^" + p.call(l).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
                e.exports = function(e) {
                    return !(!a(e) || o(e)) && (_$n(e) ? f : s).test(i(e));
                };
            },
            8749: function(e, t, r) {
                var _$n = r(4239), o = r(1780), a = r(7005), i = {};
                i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, e.exports = function(e) {
                    return a(e) && o(e.length) && !!i[_$n(e)];
                };
            },
            280: function(e, t, r) {
                var _$n = r(5726), o = r(6916), a = Object.prototype.hasOwnProperty;
                e.exports = function(e) {
                    if (!_$n(e)) return o(e);
                    var t = [];
                    for(var _$r in Object(e))a.call(e, _$r) && "constructor" != _$r && t.push(_$r);
                    return t;
                };
            },
            2545: function(e) {
                e.exports = function(e, t) {
                    for(var r = -1, _$n = Array(e); ++r < e;)_$n[r] = t(r);
                    return _$n;
                };
            },
            1717: function(e) {
                e.exports = function(e) {
                    return function(t) {
                        return e(t);
                    };
                };
            },
            4757: function(e) {
                e.exports = function(e, t) {
                    return e.has(t);
                };
            },
            4429: function(e, t, r) {
                var _$n = r(5639)["__core-js_shared__"];
                e.exports = _$n;
            },
            7114: function(e, t, r) {
                var _$n = r(8668), o = r(2908), a = r(4757);
                e.exports = function(e, t, r, i, s, u) {
                    var c = 1 & r, p = e.length, l = t.length;
                    if (p != l && !(c && l > p)) return !1;
                    var f = u.get(e), v = u.get(t);
                    if (f && v) return f == t && v == e;
                    var d = -1, h = !0, y = 2 & r ? new _$n : void 0;
                    for(u.set(e, t), u.set(t, e); ++d < p;){
                        var b = e[d], m = t[d];
                        if (i) var _ = c ? i(m, b, d, t, e, u) : i(b, m, d, e, t, u);
                        if (void 0 !== _) {
                            if (_) continue;
                            h = !1;
                            break;
                        }
                        if (y) {
                            if (!o(t, function(e, t) {
                                if (!a(y, t) && (b === e || s(b, e, r, i, u))) return y.push(t);
                            })) {
                                h = !1;
                                break;
                            }
                        } else if (b !== m && !s(b, m, r, i, u)) {
                            h = !1;
                            break;
                        }
                    }
                    return u.delete(e), u.delete(t), h;
                };
            },
            8351: function(e, t, r) {
                var _$n = r(2705), o = r(1149), a = r(7813), i = r(7114), s = r(8776), u = r(1814), c = _$n ? _$n.prototype : void 0, p = c ? c.valueOf : void 0;
                e.exports = function(e, t, r, n, c, l, f) {
                    switch(r){
                        case "[object DataView]":
                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                            e = e.buffer, t = t.buffer;
                        case "[object ArrayBuffer]":
                            return !(e.byteLength != t.byteLength || !l(new o(e), new o(t)));
                        case "[object Boolean]":
                        case "[object Date]":
                        case "[object Number]":
                            return a(+e, +t);
                        case "[object Error]":
                            return e.name == t.name && e.message == t.message;
                        case "[object RegExp]":
                        case "[object String]":
                            return e == t + "";
                        case "[object Map]":
                            var v = s;
                        case "[object Set]":
                            var d = 1 & n;
                            if (v || (v = u), e.size != t.size && !d) return !1;
                            var h = f.get(e);
                            if (h) return h == t;
                            n |= 2, f.set(e, t);
                            var y = i(v(e), v(t), n, c, l, f);
                            return f.delete(e), y;
                        case "[object Symbol]":
                            if (p) return p.call(e) == p.call(t);
                    }
                    return !1;
                };
            },
            6096: function(e, t, r) {
                var _$n = r(8234), o = Object.prototype.hasOwnProperty;
                e.exports = function(e, t, r, a, i, s) {
                    var u = 1 & r, c = _$n(e), p = c.length;
                    if (p != _$n(t).length && !u) return !1;
                    for(var l = p; l--;){
                        var f = c[l];
                        if (!(u ? f in t : o.call(t, f))) return !1;
                    }
                    var v = s.get(e), d = s.get(t);
                    if (v && d) return v == t && d == e;
                    var h = !0;
                    s.set(e, t), s.set(t, e);
                    for(var y = u; ++l < p;){
                        var b = e[f = c[l]], m = t[f];
                        if (a) var _ = u ? a(m, b, f, t, e, s) : a(b, m, f, e, t, s);
                        if (!(void 0 === _ ? b === m || i(b, m, r, a, s) : _)) {
                            h = !1;
                            break;
                        }
                        y || (y = "constructor" == f);
                    }
                    if (h && !y) {
                        var g = e.constructor, w = t.constructor;
                        g == w || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof w && w instanceof w || (h = !1);
                    }
                    return s.delete(e), s.delete(t), h;
                };
            },
            1957: function(e, t, r) {
                var _$n = "object" == typeof r.g && r.g && r.g.Object === Object && r.g;
                e.exports = _$n;
            },
            8234: function(e, t, r) {
                var _$n = r(8866), o = r(9551), a = r(3674);
                e.exports = function(e) {
                    return _$n(e, a, o);
                };
            },
            5050: function(e, t, r) {
                var _$n = r(7019);
                e.exports = function(e, t) {
                    var _$r = e.__data__;
                    return _$n(t) ? _$r["string" == typeof t ? "string" : "hash"] : _$r.map;
                };
            },
            852: function(e, t, r) {
                var _$n = r(8458), o = r(7801);
                e.exports = function(e, t) {
                    var _$r = o(e, t);
                    return _$n(_$r) ? _$r : void 0;
                };
            },
            9607: function(e, t, r) {
                var _$n = r(2705), o = Object.prototype, a = o.hasOwnProperty, i = o.toString, s = _$n ? _$n.toStringTag : void 0;
                e.exports = function(e) {
                    var t = a.call(e, s), _$r = e[s];
                    try {
                        e[s] = void 0;
                        var _$n = !0;
                    } catch (e) {}
                    var o = i.call(e);
                    return _$n && (t ? e[s] = _$r : delete e[s]), o;
                };
            },
            9551: function(e, t, r) {
                var _$n = r(4963), o = r(479), a = Object.prototype.propertyIsEnumerable, i = Object.getOwnPropertySymbols, s = i ? function s(e) {
                    return null == e ? [] : (e = Object(e), _$n(i(e), function(t) {
                        return a.call(e, t);
                    }));
                } : o;
                e.exports = s;
            },
            4160: function(e, t, r) {
                var _$n = r(8552), o = r(7071), a = r(3818), i = r(8525), s = r(577), u = r(4239), c = r(346), p = "[object Map]", l = "[object Promise]", f = "[object Set]", v = "[object WeakMap]", d = "[object DataView]", h = c(_$n), y = c(o), b = c(a), m = c(i), _ = c(s), g = u;
                (_$n && g(new _$n(new ArrayBuffer(1))) != d || o && g(new o) != p || a && g(a.resolve()) != l || i && g(new i) != f || s && g(new s) != v) && (g = function g(e) {
                    var t = u(e), _$r = "[object Object]" == t ? e.constructor : void 0, _$n = _$r ? c(_$r) : "";
                    if (_$n) switch(_$n){
                        case h:
                            return d;
                        case y:
                            return p;
                        case b:
                            return l;
                        case m:
                            return f;
                        case _:
                            return v;
                    }
                    return t;
                }), e.exports = g;
            },
            7801: function(e) {
                e.exports = function(e, t) {
                    return null == e ? void 0 : e[t];
                };
            },
            1789: function(e, t, r) {
                var _$n = r(4536);
                e.exports = function() {
                    this.__data__ = _$n ? _$n(null) : {}, this.size = 0;
                };
            },
            401: function(e) {
                e.exports = function(e) {
                    var t = this.has(e) && delete this.__data__[e];
                    return this.size -= t ? 1 : 0, t;
                };
            },
            7667: function(e, t, r) {
                var _$n = r(4536), o = Object.prototype.hasOwnProperty;
                e.exports = function(e) {
                    var t = this.__data__;
                    if (_$n) {
                        var _$r = t[e];
                        return "__lodash_hash_undefined__" === _$r ? void 0 : _$r;
                    }
                    return o.call(t, e) ? t[e] : void 0;
                };
            },
            1327: function(e, t, r) {
                var _$n = r(4536), o = Object.prototype.hasOwnProperty;
                e.exports = function(e) {
                    var t = this.__data__;
                    return _$n ? void 0 !== t[e] : o.call(t, e);
                };
            },
            1866: function(e, t, r) {
                var _$n = r(4536);
                e.exports = function(e, t) {
                    var _$r = this.__data__;
                    return this.size += this.has(e) ? 0 : 1, _$r[e] = _$n && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                };
            },
            5776: function(e) {
                var t = /^(?:0|[1-9]\d*)$/;
                e.exports = function(e, r) {
                    var _$n = typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                    return !!(r = null == r ? 9007199254740991 : r) && ("number" == _$n || "symbol" != _$n && t.test(e)) && e > -1 && e % 1 == 0 && e < r;
                };
            },
            7019: function(e) {
                e.exports = function(e) {
                    var t = typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
                };
            },
            5346: function(e, t, r) {
                var _$n, o = r(4429), a = (_$n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + _$n : "";
                e.exports = function(e) {
                    return !!a && a in e;
                };
            },
            5726: function(e) {
                var t = Object.prototype;
                e.exports = function(e) {
                    var r = e && e.constructor;
                    return e === ("function" == typeof r && r.prototype || t);
                };
            },
            7040: function(e) {
                e.exports = function() {
                    this.__data__ = [], this.size = 0;
                };
            },
            4125: function(e, t, r) {
                var _$n = r(8470), o = Array.prototype.splice;
                e.exports = function(e) {
                    var t = this.__data__, _$r = _$n(t, e);
                    return !(_$r < 0 || (_$r == t.length - 1 ? t.pop() : o.call(t, _$r, 1), --this.size, 0));
                };
            },
            2117: function(e, t, r) {
                var _$n = r(8470);
                e.exports = function(e) {
                    var t = this.__data__, _$r = _$n(t, e);
                    return _$r < 0 ? void 0 : t[_$r][1];
                };
            },
            7518: function(e, t, r) {
                var _$n = r(8470);
                e.exports = function(e) {
                    return _$n(this.__data__, e) > -1;
                };
            },
            4705: function(e, t, r) {
                var _$n = r(8470);
                e.exports = function(e, t) {
                    var _$r = this.__data__, o = _$n(_$r, e);
                    return o < 0 ? (++this.size, _$r.push([
                        e,
                        t
                    ])) : _$r[o][1] = t, this;
                };
            },
            4785: function(e, t, r) {
                var _$n = r(1989), o = r(8407), a = r(7071);
                e.exports = function() {
                    this.size = 0, this.__data__ = {
                        hash: new _$n,
                        map: new (a || o),
                        string: new _$n
                    };
                };
            },
            1285: function(e, t, r) {
                var _$n = r(5050);
                e.exports = function(e) {
                    var t = _$n(this, e).delete(e);
                    return this.size -= t ? 1 : 0, t;
                };
            },
            6e3: function(e, t, r) {
                var _$n = r(5050);
                e.exports = function(e) {
                    return _$n(this, e).get(e);
                };
            },
            9916: function(e, t, r) {
                var _$n = r(5050);
                e.exports = function(e) {
                    return _$n(this, e).has(e);
                };
            },
            5265: function(e, t, r) {
                var _$n = r(5050);
                e.exports = function(e, t) {
                    var _$r = _$n(this, e), o = _$r.size;
                    return _$r.set(e, t), this.size += _$r.size == o ? 0 : 1, this;
                };
            },
            8776: function(e) {
                e.exports = function(e) {
                    var t = -1, r = Array(e.size);
                    return e.forEach(function(e, n) {
                        r[++t] = [
                            n,
                            e
                        ];
                    }), r;
                };
            },
            4536: function(e, t, r) {
                var _$n = r(852)(Object, "create");
                e.exports = _$n;
            },
            6916: function(e, t, r) {
                var _$n = r(5569)(Object.keys, Object);
                e.exports = _$n;
            },
            1167: function(e, t, r) {
                e = r.nmd(e);
                var _$n = r(1957), o = t && !t.nodeType && t, a = o && e && !e.nodeType && e, i = a && a.exports === o && _$n.process, s = function() {
                    try {
                        return a && a.require && a.require("util").types || i && i.binding && i.binding("util");
                    } catch (e) {}
                }();
                e.exports = s;
            },
            2333: function(e) {
                var t = Object.prototype.toString;
                e.exports = function(e) {
                    return t.call(e);
                };
            },
            5569: function(e) {
                e.exports = function(e, t) {
                    return function(r) {
                        return e(t(r));
                    };
                };
            },
            5639: function(e, t, r) {
                var _$n = r(1957), o = "object" == typeof self && self && self.Object === Object && self, a = _$n || o || Function("return this")();
                e.exports = a;
            },
            619: function(e) {
                e.exports = function(e) {
                    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                };
            },
            2385: function(e) {
                e.exports = function(e) {
                    return this.__data__.has(e);
                };
            },
            1814: function(e) {
                e.exports = function(e) {
                    var t = -1, r = Array(e.size);
                    return e.forEach(function(e) {
                        r[++t] = e;
                    }), r;
                };
            },
            7465: function(e, t, r) {
                var _$n = r(8407);
                e.exports = function() {
                    this.__data__ = new _$n, this.size = 0;
                };
            },
            3779: function(e) {
                e.exports = function(e) {
                    var t = this.__data__, r = t.delete(e);
                    return this.size = t.size, r;
                };
            },
            7599: function(e) {
                e.exports = function(e) {
                    return this.__data__.get(e);
                };
            },
            4758: function(e) {
                e.exports = function(e) {
                    return this.__data__.has(e);
                };
            },
            4309: function(e, t, r) {
                var _$n = r(8407), o = r(7071), a = r(3369);
                e.exports = function(e, t) {
                    var _$r = this.__data__;
                    if (_$r instanceof _$n) {
                        var i = _$r.__data__;
                        if (!o || i.length < 199) return i.push([
                            e,
                            t
                        ]), this.size = ++_$r.size, this;
                        _$r = this.__data__ = new a(i);
                    }
                    return _$r.set(e, t), this.size = _$r.size, this;
                };
            },
            346: function(e) {
                var t = Function.prototype.toString;
                e.exports = function(e) {
                    if (null != e) {
                        try {
                            return t.call(e);
                        } catch (e) {}
                        try {
                            return e + "";
                        } catch (e) {}
                    }
                    return "";
                };
            },
            7813: function(e) {
                e.exports = function(e, t) {
                    return e === t || e != e && t != t;
                };
            },
            5694: function(e, t, r) {
                var _$n = r(9454), o = r(7005), a = Object.prototype, i = a.hasOwnProperty, s = a.propertyIsEnumerable, u = _$n(function() {
                    return arguments;
                }()) ? _$n : function u(e) {
                    return o(e) && i.call(e, "callee") && !s.call(e, "callee");
                };
                e.exports = u;
            },
            1469: function(e) {
                var t = Array.isArray;
                e.exports = t;
            },
            8612: function(e, t, r) {
                var _$n = r(3560), o = r(1780);
                e.exports = function(e) {
                    return null != e && o(e.length) && !_$n(e);
                };
            },
            4144: function(e, t, r) {
                e = r.nmd(e);
                var _$n = r(5639), o = r(5062), a = t && !t.nodeType && t, i = a && e && !e.nodeType && e, s = i && i.exports === a ? _$n.Buffer : void 0, u = (s ? s.isBuffer : void 0) || o;
                e.exports = u;
            },
            8446: function(e, t, r) {
                var _$n = r(939);
                e.exports = function(e, t) {
                    return _$n(e, t);
                };
            },
            3560: function(e, t, r) {
                var _$n = r(4239), o = r(3218);
                e.exports = function(e) {
                    if (!o(e)) return !1;
                    var t = _$n(e);
                    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                };
            },
            1780: function(e) {
                e.exports = function(e) {
                    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                };
            },
            3218: function(e) {
                e.exports = function(e) {
                    var t = typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                    return null != e && ("object" == t || "function" == t);
                };
            },
            7005: function(e) {
                e.exports = function(e) {
                    return null != e && "object" == typeof e;
                };
            },
            6719: function(e, t, r) {
                var _$n = r(8749), o = r(1717), a = r(1167), i = a && a.isTypedArray, s = i ? o(i) : _$n;
                e.exports = s;
            },
            3674: function(e, t, r) {
                var _$n = r(4636), o = r(280), a = r(8612);
                e.exports = function(e) {
                    return a(e) ? _$n(e) : o(e);
                };
            },
            479: function(e) {
                e.exports = function() {
                    return [];
                };
            },
            5062: function(e) {
                e.exports = function() {
                    return !1;
                };
            },
            75: function(e) {
                (function() {
                    var t, r, _$n, o, a, i;
                    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function() {
                        return performance.now();
                    } : "undefined" != typeof $903353200bfa7e9a$exports && null !== $903353200bfa7e9a$exports && $903353200bfa7e9a$exports.hrtime ? (e.exports = function() {
                        return (t() - a) / 1e6;
                    }, r = $903353200bfa7e9a$exports.hrtime, o = (t = function t() {
                        var _$e;
                        return 1e9 * (_$e = r())[0] + _$e[1];
                    })(), i = 1e9 * $903353200bfa7e9a$exports.uptime(), a = o - i) : Date.now ? (e.exports = function() {
                        return Date.now() - _$n;
                    }, _$n = Date.now()) : (e.exports = function() {
                        return (new Date).getTime() - _$n;
                    }, _$n = (new Date).getTime());
                }).call(this);
            },
            4087: function(e, t, r) {
                for(var _$n = r(75), o = "undefined" == typeof window ? r.g : window, a = [
                    "moz",
                    "webkit"
                ], i = "AnimationFrame", s = o["request" + i], u = o["cancel" + i] || o["cancelRequest" + i], c = 0; !s && c < a.length; c++)s = o[a[c] + "Request" + i], u = o[a[c] + "Cancel" + i] || o[a[c] + "CancelRequest" + i];
                if (!s || !u) {
                    var p = 0, l = 0, f = [];
                    s = function s(e) {
                        if (0 === f.length) {
                            var t = _$n(), _$r = Math.max(0, 16.666666666666668 - (t - p));
                            p = _$r + t, setTimeout(function() {
                                var _$e = f.slice(0);
                                f.length = 0;
                                for(var t = 0; t < _$e.length; t++)if (!_$e[t].cancelled) try {
                                    _$e[t].callback(p);
                                } catch (e) {
                                    setTimeout(function() {
                                        throw e;
                                    }, 0);
                                }
                            }, Math.round(_$r));
                        }
                        return f.push({
                            handle: ++l,
                            callback: e,
                            cancelled: !1
                        }), l;
                    }, u = function u(e) {
                        for(var t = 0; t < f.length; t++)f[t].handle === e && (f[t].cancelled = !0);
                    };
                }
                e.exports = function(e) {
                    return s.call(o, e);
                }, e.exports.cancel = function() {
                    u.apply(o, arguments);
                }, e.exports.polyfill = function(e) {
                    e || (e = o), e.requestAnimationFrame = s, e.cancelAnimationFrame = u;
                };
            },
            8156: function(t) {
                "use strict";
                t.exports = e;
            }
        }, r = {};
        function n(e) {
            var o = r[e];
            if (void 0 !== o) return o.exports;
            var a = r[e] = {
                id: e,
                loaded: !1,
                exports: {}
            };
            return t[e].call(a.exports, a, a.exports, n), a.loaded = !0, a.exports;
        }
        n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e, t) {
            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.nmd = function(e) {
            return e.paths = [], e.children || (e.children = []), e;
        };
        var o = {};
        return function() {
            "use strict";
            var u = function u(e, t) {
                for(var r = 0; r < t.length; r++){
                    var _$n = t[r];
                    _$n.enumerable = _$n.enumerable || !1, _$n.configurable = !0, "value" in _$n && (_$n.writable = !0), Object.defineProperty(e, f(_$n.key), _$n);
                }
            };
            var p = function p(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            };
            var f = function f(e) {
                var t = function(e, t) {
                    if ("object" !== s(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var _$n = r.call(e, "string");
                        if ("object" !== s(_$n)) return _$n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" === s(t) ? t : String(t);
            };
            n.d(o, {
                default: function() {
                    return d;
                }
            });
            var e = n(8156), t = n.n(e), r = n(7403), a = n(8446), i = n.n(a);
            function s(e) {
                return s = "function" == typeof Symbol && "symbol" == (0, $bJtXW._)(Symbol.iterator) ? function s(e) {
                    return typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e);
                }, s(e);
            }
            function c(e, t) {
                return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function c(e, t) {
                    return e.__proto__ = t, e;
                }, c(e, t);
            }
            function l(e) {
                return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function l(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, l(e);
            }
            var v = function(e) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && c(e, t);
                }(h, e);
                var _$n, o, a, v, d = (a = h, v = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function d() {
                    var _$e, t = l(a);
                    if (v) {
                        var r = l(this).constructor;
                        _$e = Reflect.construct(t, arguments, r);
                    } else _$e = t.apply(this, arguments);
                    return function(e, t) {
                        if (t && ("object" === s(t) || "function" == typeof t)) return t;
                        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                        return p(e);
                    }(this, _$e);
                });
                function h() {
                    var _$e, t, r, _$n;
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, h);
                    for(var o = arguments.length, a = new Array(o), i = 0; i < o; i++)a[i] = arguments[i];
                    return t = p(_$e = d.call.apply(d, [
                        this
                    ].concat(a))), _$n = {
                        instance: null
                    }, (r = f(r = "state")) in t ? Object.defineProperty(t, r, {
                        value: _$n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[r] = _$n, _$e;
                }
                return _$n = h, o = [
                    {
                        key: "componentDidMount",
                        value: function value() {
                            var _$e = this, t = new r.default(this.typewriter, this.props.options);
                            this.setState({
                                instance: t
                            }, function() {
                                var r = _$e.props.onInit;
                                r && r(t);
                            });
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function value(e) {
                            i()(this.props.options, e.options) || this.setState({
                                instance: new r.default(this.typewriter, this.props.options)
                            });
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function value() {
                            this.state.instance && this.state.instance.stop();
                        }
                    },
                    {
                        key: "render",
                        value: function value() {
                            var _$e = this, r = this.props.component;
                            return t().createElement(r, {
                                ref: function ref(t) {
                                    return _$e.typewriter = t;
                                },
                                className: "Typewriter",
                                "data-testid": "typewriter-wrapper"
                            });
                        }
                    }
                ], u(_$n.prototype, o), Object.defineProperty(_$n, "prototype", {
                    writable: !1
                }), h;
            }(e.Component);
            v.defaultProps = {
                component: "div"
            };
            var d = v;
        }(), o.default;
    }();
});


var $ddde20b8c5d3de5c$var$Intro = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        className: "h-screen md:h-[calc(100vh-80px)] mt-5 flex justify-center items-center",
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
            className: "flex flex-col lg:flex-row xl:mx-12 lg:gap-4 ",
            children: [
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                    className: "lg:px-10 w-full lg:w-8/12 flex flex-col items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            className: "font-poppins align-middle text-center lg:pb-8 pb-4 text-4xl md:text-6xl font-bold text-[#333333] dark:text-[#e0e0e0] leading-tight lg:leading-normal",
                            children: "Damyant Jain"
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            className: "lg:pb-8 pb-4 tracking-wider font-poppins text-2xl md:text-4xl font-bold text-[#e53939]",
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ee0def20b6b951ce$exports))), {
                                options: {
                                    strings: [
                                        "Programmer",
                                        "Developer",
                                        "Student",
                                        "Innovator",
                                        "Curious"
                                    ],
                                    autoStart: true,
                                    loop: true,
                                    deleteSpeed: 50
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            className: "align-middle text-center font-poppins dark:text-[#e0e0e0] text-[#333333]",
                            children: "I'm all about turning cool ideas into awesome products and exploring the ever-evolving tech world. With over 3 years of experience, I'm passionate about solving real-world problems. When I'm not coding, you can find me enjoying sports."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                    className: "p-5 w-full pt-20 lg:pt-0 lg:w-4/12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                        className: "rounded-full shadow-2xl object-cover dark:shadow-[#e53939] h-56 w-56  lg:h-72 lg:w-72",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3de45623f3aba285$exports))),
                        alt: "Damyant Jain"
                    })
                })
            ]
        })
    });
};
var $ddde20b8c5d3de5c$export$2e2bcd8739ae039 = $ddde20b8c5d3de5c$var$Intro;




var $dcJGd = parcelRequire("dcJGd");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $72osQ = parcelRequire("72osQ");
function $e1f0c9b9d3f0410c$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $72osQ._)(target, key, source[key]);
        });
    }
    return target;
}


function $c856efe13547de99$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $85cafde4a2dd4f41$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $c856efe13547de99$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $2nwvT = parcelRequire("2nwvT");

var $bJtXW = parcelRequire("bJtXW");

var $lngen = parcelRequire("lngen");

var $dQFEZ = parcelRequire("dQFEZ");
"use client";
var $6ee4651e93391e62$var$__defProp = Object.defineProperty;
var $6ee4651e93391e62$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $6ee4651e93391e62$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6ee4651e93391e62$var$__publicField = function(obj, key, value) {
    return $6ee4651e93391e62$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
};
// src/observe.ts
var $6ee4651e93391e62$var$observerMap = /* @__PURE__ */ new Map();
var $6ee4651e93391e62$var$RootIds = /* @__PURE__ */ new WeakMap();
var $6ee4651e93391e62$var$rootId = 0;
var $6ee4651e93391e62$var$unsupportedValue = void 0;
function $6ee4651e93391e62$export$2ef3a60ee1f37bec(inView) {
    $6ee4651e93391e62$var$unsupportedValue = inView;
}
function $6ee4651e93391e62$var$getRootId(root) {
    if (!root) return "0";
    if ($6ee4651e93391e62$var$RootIds.has(root)) return $6ee4651e93391e62$var$RootIds.get(root);
    $6ee4651e93391e62$var$rootId += 1;
    $6ee4651e93391e62$var$RootIds.set(root, $6ee4651e93391e62$var$rootId.toString());
    return $6ee4651e93391e62$var$RootIds.get(root);
}
function $6ee4651e93391e62$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== void 0;
    }).map(function(key) {
        return "".concat(key, "_").concat(key === "root" ? $6ee4651e93391e62$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $6ee4651e93391e62$var$createObserver(options) {
    var id = $6ee4651e93391e62$var$optionsToId(options);
    var instance = $6ee4651e93391e62$var$observerMap.get(id);
    if (!instance) {
        var elements = /* @__PURE__ */ new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _a;
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                });
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $6ee4651e93391e62$var$observerMap.set(id, instance);
    }
    return instance;
}
function $6ee4651e93391e62$export$d1203567a167490e(element, callback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, fallbackInView = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $6ee4651e93391e62$var$unsupportedValue;
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    }
    var _createObserver = $6ee4651e93391e62$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements;
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $6ee4651e93391e62$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $6ee4651e93391e62$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $6ee4651e93391e62$export$a62107ca74432f44 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(InView, _React_Component);
    var _super = (0, $lngen._)(InView);
    function InView(props) {
        (0, $grujF._)(this, InView);
        var _this;
        _this = _super.call(this, props);
        $6ee4651e93391e62$var$__publicField((0, $dcJGd._)(_this), "node", null);
        $6ee4651e93391e62$var$__publicField((0, $dcJGd._)(_this), "_unobserveCb", null);
        $6ee4651e93391e62$var$__publicField((0, $dcJGd._)(_this), "handleNode", function(node) {
            if (_this.node) {
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: void 0
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        });
        $6ee4651e93391e62$var$__publicField((0, $dcJGd._)(_this), "handleChange", function(inView, entry) {
            if (inView && _this.props.triggerOnce) _this.unobserve();
            if (!$6ee4651e93391e62$var$isPlainChildren(_this.props)) _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) _this.props.onChange(inView, entry);
        });
        _this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
        return _this;
    }
    (0, $dhMkv._)(InView, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.unobserve();
                this.observeNode();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
                    this.unobserve();
                    this.observeNode();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unobserve();
            }
        },
        {
            key: "observeNode",
            value: function observeNode() {
                if (!this.node || this.props.skip) return;
                var _this_props = this.props, threshold = _this_props.threshold, root = _this_props.root, rootMargin = _this_props.rootMargin, trackVisibility = _this_props.trackVisibility, delay = _this_props.delay, fallbackInView = _this_props.fallbackInView;
                this._unobserveCb = $6ee4651e93391e62$export$d1203567a167490e(this.node, this.handleChange, {
                    threshold: threshold,
                    root: root,
                    rootMargin: rootMargin,
                    // @ts-ignore
                    trackVisibility: trackVisibility,
                    // @ts-ignore
                    delay: delay
                }, fallbackInView);
            }
        },
        {
            key: "unobserve",
            value: function unobserve() {
                if (this._unobserveCb) {
                    this._unobserveCb();
                    this._unobserveCb = null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                if (typeof children === "function") {
                    var _this_state = this.state, inView = _this_state.inView, entry = _this_state.entry;
                    return children({
                        inView: inView,
                        entry: entry,
                        ref: this.handleNode
                    });
                }
                var _this_props = this.props, as = _this_props.as, triggerOnce = _this_props.triggerOnce, threshold = _this_props.threshold, root = _this_props.root, rootMargin = _this_props.rootMargin, onChange = _this_props.onChange, skip = _this_props.skip, trackVisibility = _this_props.trackVisibility, delay = _this_props.delay, initialInView = _this_props.initialInView, fallbackInView = _this_props.fallbackInView, props = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_this_props, [
                    "as",
                    "triggerOnce",
                    "threshold",
                    "root",
                    "rootMargin",
                    "onChange",
                    "skip",
                    "trackVisibility",
                    "delay",
                    "initialInView",
                    "fallbackInView"
                ]);
                return $dQFEZ.createElement(as || "div", (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                    ref: this.handleNode
                }, props), children);
            }
        }
    ]);
    return InView;
}($dQFEZ.Component);
function $6ee4651e93391e62$export$2f62ee6831462844() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView, onChange = _ref.onChange;
    var _a;
    var _React2_useState = (0, $2nwvT._)($dQFEZ.useState(null), 2), ref = _React2_useState[0], setRef = _React2_useState[1];
    var callback = $dQFEZ.useRef();
    var _React2_useState1 = (0, $2nwvT._)($dQFEZ.useState({
        inView: !!initialInView,
        entry: void 0
    }), 2), state = _React2_useState1[0], setState = _React2_useState1[1];
    callback.current = onChange;
    $dQFEZ.useEffect(function() {
        if (skip || !ref) return;
        var unobserve;
        unobserve = $6ee4651e93391e62$export$d1203567a167490e(ref, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
        return function() {
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    var entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    var previousEntryTarget = $dQFEZ.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    var result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map




function $68f469483b2832ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $68f469483b2832ee$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $68f469483b2832ee$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $dQFEZ = parcelRequire("dQFEZ");

var $dQFEZ = parcelRequire("dQFEZ");
/**
 * @public
 */ var $0acdd268e97afa5a$export$22a697fb29aac98d = (0, $dQFEZ.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});



var $dQFEZ = parcelRequire("dQFEZ");
var $ae8dea0de7d1e112$export$2285bbca2c666415 = (0, $dQFEZ.createContext)({});



var $dQFEZ = parcelRequire("dQFEZ");

var $dQFEZ = parcelRequire("dQFEZ");
/**
 * @public
 */ var $4fa6635067f6f474$export$f224e4635b6f8ce2 = (0, $dQFEZ.createContext)(null);




var $dQFEZ = parcelRequire("dQFEZ");
var $d40be6a98a50f608$export$4e09c449d6c407f7 = typeof document !== "undefined";


var $4887edf070f19529$export$700979bc83e7db82 = (0, $d40be6a98a50f608$export$4e09c449d6c407f7) ? (0, $dQFEZ.useLayoutEffect) : (0, $dQFEZ.useEffect);



var $dQFEZ = parcelRequire("dQFEZ");
var $f87d791d047a722d$export$40f10139ecf1f171 = (0, $dQFEZ.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ var $954f6dcdfd539927$export$9fd24a634729c672 = function(str) {
    return str.replace(RegExp("([a-z])([A-Z])", "gu"), "$1-$2").toLowerCase();
};


var $de72616665b27730$export$ed7b8fa9dbf0105d = "framerAppearId";
var $de72616665b27730$export$8592e1c077c890a6 = "data-" + (0, $954f6dcdfd539927$export$9fd24a634729c672)($de72616665b27730$export$ed7b8fa9dbf0105d);


var $edee933072dcb548$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


function $adc20fe6c02db18a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ var thisFrame = new Set();
    var nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ var isProcessing = false;
    var flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ var toKeepAlive = new WeakSet();
    var latestFrameData = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    var step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: function(callback) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var addToCurrentFrame = immediate && isProcessing;
            var queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: function(callback) {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: function(frameData) {
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            var ref;
            ref = [
                nextFrame,
                thisFrame
            ], thisFrame = ref[0], nextFrame = ref[1], ref;
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


var $f8b0daac2b5158dc$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
var $f8b0daac2b5158dc$var$maxElapsed = 40;
function $f8b0daac2b5158dc$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    var runNextFrame = false;
    var useDefaultElapsed = true;
    var state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    var flagRunNextFrame = function() {
        return runNextFrame = true;
    };
    var steps = $f8b0daac2b5158dc$export$71ecace0a033b35a.reduce(function(acc, key) {
        acc[key] = (0, $adc20fe6c02db18a$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    var read = steps.read, resolveKeyframes = steps.resolveKeyframes, update = steps.update, preRender = steps.preRender, render = steps.render, postRender = steps.postRender;
    var processBatch = function() {
        var timestamp = (0, $edee933072dcb548$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $f8b0daac2b5158dc$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    var wake = function() {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    var schedule = $f8b0daac2b5158dc$export$71ecace0a033b35a.reduce(function(acc, key) {
        var step = steps[key];
        acc[key] = function(process) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    var cancel = function(process) {
        for(var i = 0; i < $f8b0daac2b5158dc$export$71ecace0a033b35a.length; i++)steps[$f8b0daac2b5158dc$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


var $346b530bc5e6ade4$var$_createRenderBatcher = (0, $f8b0daac2b5158dc$export$510b0596a933801a)(queueMicrotask, false), $346b530bc5e6ade4$export$bb76eed83315504c = $346b530bc5e6ade4$var$_createRenderBatcher.schedule, $346b530bc5e6ade4$export$3252729004b8456e = $346b530bc5e6ade4$var$_createRenderBatcher.cancel;


function $e9c25423de102281$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $dQFEZ = parcelRequire("dQFEZ");
/**
 * Internal, exported only for usage in Framer
 */ var $fff1757b250efb2b$export$da5f7b802957459a = (0, $dQFEZ.createContext)({});


var $1056e15c612ff777$var$scheduleHandoffComplete = false;
function $1056e15c612ff777$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _useContext = (0, $dQFEZ.useContext)((0, $ae8dea0de7d1e112$export$2285bbca2c666415)), parent = _useContext.visualElement;
    var lazyContext = (0, $dQFEZ.useContext)((0, $f87d791d047a722d$export$40f10139ecf1f171));
    var presenceContext = (0, $dQFEZ.useContext)((0, $4fa6635067f6f474$export$f224e4635b6f8ce2));
    var reducedMotionConfig = (0, $dQFEZ.useContext)((0, $0acdd268e97afa5a$export$22a697fb29aac98d)).reducedMotion;
    var visualElementRef = (0, $dQFEZ.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    var visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ var initialLayoutGroupConfig = (0, $dQFEZ.useContext)((0, $fff1757b250efb2b$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $1056e15c612ff777$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $dQFEZ.useInsertionEffect)(function() {
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ var wantsHandoff = (0, $dQFEZ.useRef)(Boolean(props[0, $de72616665b27730$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $4887edf070f19529$export$700979bc83e7db82)(function() {
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $346b530bc5e6ade4$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $dQFEZ.useEffect)(function() {
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            if (!$1056e15c612ff777$var$scheduleHandoffComplete) {
                $1056e15c612ff777$var$scheduleHandoffComplete = true;
                queueMicrotask($1056e15c612ff777$var$completeHandoff);
            }
        }
    });
    return visualElement;
}
function $1056e15c612ff777$var$completeHandoff() {
    window.HandoffComplete = true;
}
function $1056e15c612ff777$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    var layoutId = props.layoutId, layout = props.layout, drag = props.drag, dragConstraints = props.dragConstraints, layoutScroll = props.layoutScroll, layoutRoot = props.layoutRoot;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $1056e15c612ff777$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $e9c25423de102281$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $1056e15c612ff777$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $1056e15c612ff777$var$getClosestProjectingNode(visualElement.parent);
}



var $dQFEZ = parcelRequire("dQFEZ");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $0bef4a991924a127$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $dQFEZ.useCallback)(function(instance) {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $e9c25423de102281$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $dQFEZ = parcelRequire("dQFEZ");

/**
 * Decides if the supplied variable is variant label
 */ function $e0f40a620bc45744$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $4ee7515c1ffdc148$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}




var $2us1u = parcelRequire("2us1u");
var $1500c6a0728839ac$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
var $1500c6a0728839ac$export$1405a65085f40b9 = [
    "initial"
].concat((0, $2us1u._)($1500c6a0728839ac$export$16e45afcc206d3a8));


function $0b7e066ec777c86a$export$4b3c3bd8d910d78d(props) {
    return (0, $4ee7515c1ffdc148$export$aa71198ceeaf53ce)(props.animate) || (0, $1500c6a0728839ac$export$1405a65085f40b9).some(function(name) {
        return (0, $e0f40a620bc45744$export$720b90e312cea233)(props[name]);
    });
}
function $0b7e066ec777c86a$export$ce46fa4165cdec40(props) {
    return Boolean($0b7e066ec777c86a$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $d614193aeee51e7f$export$12fc32fc096a04a3(props, context) {
    if ((0, $0b7e066ec777c86a$export$4b3c3bd8d910d78d)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $e0f40a620bc45744$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $e0f40a620bc45744$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $b75fcb8f43a04c75$export$c5638d843b37a176(props) {
    var _getCurrentTreeVariants = (0, $d614193aeee51e7f$export$12fc32fc096a04a3)(props, (0, $dQFEZ.useContext)((0, $ae8dea0de7d1e112$export$2285bbca2c666415))), initial = _getCurrentTreeVariants.initial, animate = _getCurrentTreeVariants.animate;
    return (0, $dQFEZ.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $b75fcb8f43a04c75$var$variantLabelsAsDependency(initial),
        $b75fcb8f43a04c75$var$variantLabelsAsDependency(animate)
    ]);
}
function $b75fcb8f43a04c75$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



var $62bab7f5fc850b6e$var$_loop = function(key) {
    $62bab7f5fc850b6e$export$65570e08d843624d[key] = {
        isEnabled: function(props) {
            return $62bab7f5fc850b6e$var$featureProps[key].some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $62bab7f5fc850b6e$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
var $62bab7f5fc850b6e$export$65570e08d843624d = {};
for(var $62bab7f5fc850b6e$var$key in $62bab7f5fc850b6e$var$featureProps)$62bab7f5fc850b6e$var$_loop($62bab7f5fc850b6e$var$key);


function $44185beb94054e7b$export$449561ec5703cdc8(features) {
    for(var key in features)(0, $62bab7f5fc850b6e$export$65570e08d843624d)[key] = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $62bab7f5fc850b6e$export$65570e08d843624d)[key], features[key]);
}




var $dQFEZ = parcelRequire("dQFEZ");
var $c9258bc28bb8df33$export$a3579ca508007a95 = (0, $dQFEZ.createContext)({});



var $d94b3b1d6ffd8254$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b8cf0c54888a2417$export$46b7e4b9dc6110c3(param) {
    var preloadedFeatures = param.preloadedFeatures, createVisualElement = param.createVisualElement, useRender = param.useRender, useVisualState = param.useVisualState, Component = param.Component;
    preloadedFeatures && (0, $44185beb94054e7b$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ var MeasureLayout;
        var configAndProps = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $dQFEZ.useContext)((0, $0acdd268e97afa5a$export$22a697fb29aac98d)), props), {
            layoutId: $b8cf0c54888a2417$var$useLayoutId(props)
        });
        var isStatic = configAndProps.isStatic;
        var context = (0, $b75fcb8f43a04c75$export$c5638d843b37a176)(props);
        var visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $d40be6a98a50f608$export$4e09c449d6c407f7)) {
            $b8cf0c54888a2417$var$useStrictMode(configAndProps, preloadedFeatures);
            var layoutProjection = $b8cf0c54888a2417$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $1056e15c612ff777$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $d8ffb49eb4cd7afd$exports.jsxs)((0, $ae8dea0de7d1e112$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $d8ffb49eb4cd7afd$exports.jsx)(MeasureLayout, (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                useRender(Component, props, (0, $0bef4a991924a127$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    var ForwardRefComponent = (0, $dQFEZ.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $d94b3b1d6ffd8254$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b8cf0c54888a2417$var$useLayoutId(param) {
    var layoutId = param.layoutId;
    var layoutGroupId = (0, $dQFEZ.useContext)((0, $c9258bc28bb8df33$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $b8cf0c54888a2417$var$useStrictMode(configAndProps, preloadedFeatures) {
    var isStrict = (0, $dQFEZ.useContext)((0, $f87d791d047a722d$export$40f10139ecf1f171)).strict;
}
function $b8cf0c54888a2417$var$getProjectionFunctionality(props) {
    var drag = (0, $62bab7f5fc850b6e$export$65570e08d843624d).drag, layout = (0, $62bab7f5fc850b6e$export$65570e08d843624d).layout;
    if (!drag && !layout) return {};
    var combined = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $8bb37fa158ef1e8c$export$a28d6df673050e18(createConfig) {
    function custom(Component) {
        var customMotionComponentConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (0, $b8cf0c54888a2417$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}




/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $78477f61f0d85119$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $d3214709b7c7176a$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $78477f61f0d85119$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}





var $dQFEZ = parcelRequire("dQFEZ");

var $dQFEZ = parcelRequire("dQFEZ");
var $ae2875b24a733eed$export$91ddd985b97788d1 = {};
function $ae2875b24a733eed$export$de9e7791c71225fd(correctors) {
    Object.assign($ae2875b24a733eed$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ var $458c1d3a49d65b1f$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ var $458c1d3a49d65b1f$export$7b42a0094fb00b6e = new Set($458c1d3a49d65b1f$export$280dc01950909d86);


function $3f8ee39b82ceb57a$export$6d27ce8e3de1c3cf(key, param) {
    var layout = param.layout, layoutId = param.layoutId;
    return (0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $ae2875b24a733eed$export$91ddd985b97788d1)[key] || key === "opacity");
}


var $719c6b4fb69ff79d$export$605d60a2578142d3 = function(value) {
    return Boolean(value && value.getVelocity);
};



var $81f9be88174867c9$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
var $81f9be88174867c9$var$numTransforms = (0, $458c1d3a49d65b1f$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $81f9be88174867c9$export$bdc96e0d5c8f914(transform, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    var transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(var i = 0; i < $81f9be88174867c9$var$numTransforms; i++){
        var key = (0, $458c1d3a49d65b1f$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            var transformName = $81f9be88174867c9$var$translateAlias[key] || key;
            transformString += "".concat(transformName, "(").concat(transform[key], ") ");
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


var $fa15c42eacb6654d$var$checkStringStartsWith = function(token) {
    return function(key) {
        return typeof key === "string" && key.startsWith(token);
    };
};
var $fa15c42eacb6654d$export$9de1236619d9e756 = $fa15c42eacb6654d$var$checkStringStartsWith("--");
var $fa15c42eacb6654d$var$startsAsVariableToken = $fa15c42eacb6654d$var$checkStringStartsWith("var(--");
var $fa15c42eacb6654d$export$31f9caa2600b5723 = function(value) {
    var startsWithToken = $fa15c42eacb6654d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $fa15c42eacb6654d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var $fa15c42eacb6654d$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $6b31467deb1ecbf4$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};




var $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


var $933d4c7094aff38e$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $933d4c7094aff38e$export$58f0f39f63f3cf42 = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $933d4c7094aff38e$export$98e628dec113755e), {
    transform: function(v) {
        return (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)(0, 1, v);
    }
});
var $933d4c7094aff38e$export$dcdf75081b88279d = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $933d4c7094aff38e$export$98e628dec113755e), {
    default: 1
});




/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
var $02ca8b8e76a91153$export$83d2e9e3e4ee39ed = function(v) {
    return Math.round(v * 100000) / 100000;
};
var $02ca8b8e76a91153$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");
var $02ca8b8e76a91153$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");
var $02ca8b8e76a91153$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");
function $02ca8b8e76a91153$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $02ca8b8e76a91153$export$b931b78cbb3caf86(v) {
    return v == null;
}


var $0881ed62dbc2428c$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return (0, $02ca8b8e76a91153$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "".concat(v).concat(unit);
        }
    };
};
var $0881ed62dbc2428c$export$41fc368e1a942b97 = $0881ed62dbc2428c$var$createUnitType("deg");
var $0881ed62dbc2428c$export$626336c2cd4b14de = $0881ed62dbc2428c$var$createUnitType("%");
var $0881ed62dbc2428c$export$91c0eda1d06bf008 = $0881ed62dbc2428c$var$createUnitType("px");
var $0881ed62dbc2428c$export$f91e8c45a95a32f2 = $0881ed62dbc2428c$var$createUnitType("vh");
var $0881ed62dbc2428c$export$aed3d7b7d206c196 = $0881ed62dbc2428c$var$createUnitType("vw");
var $0881ed62dbc2428c$export$44e2e1705876d7ed = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $0881ed62dbc2428c$export$626336c2cd4b14de), {
    parse: function(v) {
        return $0881ed62dbc2428c$export$626336c2cd4b14de.parse(v) / 100;
    },
    transform: function(v) {
        return $0881ed62dbc2428c$export$626336c2cd4b14de.transform(v * 100);
    }
});





var $c44b736bc485715c$export$7d260a2a5f8bc19e = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $933d4c7094aff38e$export$98e628dec113755e)), {
    transform: Math.round
});


var $cb64cb658ad60100$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderTopWidth: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderRightWidth: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderRadius: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    radius: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    maxWidth: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    height: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    maxHeight: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    size: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    top: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    right: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    bottom: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    left: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    paddingTop: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    paddingRight: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    paddingBottom: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    paddingLeft: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    margin: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    marginTop: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    marginRight: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    marginBottom: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    marginLeft: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    rotateX: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    rotateY: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    rotateZ: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    scale: (0, $933d4c7094aff38e$export$dcdf75081b88279d),
    scaleX: (0, $933d4c7094aff38e$export$dcdf75081b88279d),
    scaleY: (0, $933d4c7094aff38e$export$dcdf75081b88279d),
    scaleZ: (0, $933d4c7094aff38e$export$dcdf75081b88279d),
    skew: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    skewX: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    skewY: (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    distance: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    translateX: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    translateY: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    translateZ: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    x: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    y: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    z: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    perspective: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    transformPerspective: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    opacity: (0, $933d4c7094aff38e$export$58f0f39f63f3cf42),
    originX: (0, $0881ed62dbc2428c$export$44e2e1705876d7ed),
    originY: (0, $0881ed62dbc2428c$export$44e2e1705876d7ed),
    originZ: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $c44b736bc485715c$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $933d4c7094aff38e$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $933d4c7094aff38e$export$58f0f39f63f3cf42),
    numOctaves: (0, $c44b736bc485715c$export$7d260a2a5f8bc19e)
};


function $13cbff5e14cbcd80$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    var style = state.style, vars = state.vars, transform = state.transform, transformOrigin = state.transformOrigin;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $fa15c42eacb6654d$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $cb64cb658ad60100$export$eec14432cd1cb67b)[key];
        var valueAsType = (0, $6b31467deb1ecbf4$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $81f9be88174867c9$export$bdc96e0d5c8f914)(state.transform, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        var _transformOrigin_originX = transformOrigin.originX, originX = _transformOrigin_originX === void 0 ? "50%" : _transformOrigin_originX, _transformOrigin_originY = transformOrigin.originY, originY = _transformOrigin_originY === void 0 ? "50%" : _transformOrigin_originY, _transformOrigin_originZ = transformOrigin.originZ, originZ = _transformOrigin_originZ === void 0 ? 0 : _transformOrigin_originZ;
        style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
    }
}


var $4d93f86e3a69bef4$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    };
};


function $5e1c873133858513$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $719c6b4fb69ff79d$export$605d60a2578142d3)(source[key]) && !(0, $3f8ee39b82ceb57a$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $5e1c873133858513$var$useInitialMotionValues(param, visualState) {
    var transformTemplate = param.transformTemplate;
    return (0, $dQFEZ.useMemo)(function() {
        var state = (0, $4d93f86e3a69bef4$export$8940b483cf52eeda)();
        (0, $13cbff5e14cbcd80$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $5e1c873133858513$var$useStyle(props, visualState) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $5e1c873133858513$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $5e1c873133858513$var$useInitialMotionValues(props, visualState));
    return style;
}
function $5e1c873133858513$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $5e1c873133858513$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $e2747a960589a80f$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $e2747a960589a80f$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $e2747a960589a80f$var$validMotionProps.has(key);
}


var $530313d1f042095d$var$shouldForward = function(key) {
    return !(0, $e2747a960589a80f$export$2f9c46555243bf04)(key);
};
function $530313d1f042095d$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $530313d1f042095d$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $e2747a960589a80f$export$2f9c46555243bf04)(key) : isValidProp(key);
    };
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $530313d1f042095d$export$59d6962c470509a5($530313d1f042095d$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $530313d1f042095d$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($530313d1f042095d$var$shouldForward(key) || forwardMotionProps === true && (0, $e2747a960589a80f$export$2f9c46555243bf04)(key) || !isDom && !(0, $e2747a960589a80f$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}






var $dQFEZ = parcelRequire("dQFEZ");




function $c51cc98fb08b6217$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $0881ed62dbc2428c$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $c51cc98fb08b6217$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $c51cc98fb08b6217$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $c51cc98fb08b6217$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}



var $2b9fe70632b6840d$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $2b9fe70632b6840d$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $2b9fe70632b6840d$export$311b43f666da1d82(attrs, length) {
    var spacing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, useDashCase = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $2b9fe70632b6840d$var$dashKeys : $2b9fe70632b6840d$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $0881ed62dbc2428c$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    var pathLength = (0, $0881ed62dbc2428c$export$91c0eda1d06bf008).transform(length);
    var pathSpacing = (0, $0881ed62dbc2428c$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $91df2c47b15ea8f0$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate) {
    var attrX = _param.attrX, attrY = _param.attrY, attrScale = _param.attrScale, originX = _param.originX, originY = _param.originY, pathLength = _param.pathLength, _param_pathSpacing = _param.pathSpacing, pathSpacing = _param_pathSpacing === void 0 ? 1 : _param_pathSpacing, _param_pathOffset = _param.pathOffset, pathOffset = _param_pathOffset === void 0 ? 0 : _param_pathOffset, latest = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $13cbff5e14cbcd80$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $c51cc98fb08b6217$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $2b9fe70632b6840d$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}





var $5f955f31c57591ad$export$41be8b43e1c4d4f9 = function() {
    return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $4d93f86e3a69bef4$export$8940b483cf52eeda)()), {
        attrs: {}
    });
};


var $baea5e7697904cc6$export$6328ce7565ea1049 = function(tag) {
    return typeof tag === "string" && tag.toLowerCase() === "svg";
};


function $024aac31e5e6c43d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    var visualProps = (0, $dQFEZ.useMemo)(function() {
        var state = (0, $5f955f31c57591ad$export$41be8b43e1c4d4f9)();
        (0, $91df2c47b15ea8f0$export$5475d24f125d7053)(state, visualState, (0, $baea5e7697904cc6$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, state.attrs), {
            style: (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $5e1c873133858513$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}



function $ee48b3870114cda2$export$5d29104eefd89cc8() {
    var forwardMotionProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var useRender = function(Component, props, ref, param, isStatic) {
        var latestValues = param.latestValues;
        var useVisualProps = (0, $d3214709b7c7176a$export$88f3fc2fd3766989)(Component) ? (0, $024aac31e5e6c43d$export$84309c4f53cb1bd5) : (0, $5e1c873133858513$export$57be0a314572d87d);
        var visualProps = useVisualProps(props, latestValues, isStatic, Component);
        var filteredProps = (0, $530313d1f042095d$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = Component !== (0, $dQFEZ.Fragment) ? (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, filteredProps, visualProps), {
            ref: ref
        }) : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ var children = props.children;
        var renderedChildren = (0, $dQFEZ.useMemo)(function() {
            return (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(children) ? children.get() : children;
        }, [
            children
        ]);
        return (0, $dQFEZ.createElement)(Component, (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, elementProps), {
            children: renderedChildren
        }));
    };
    return useRender;
}



function $0ec3e01a84905c76$export$1a32bf6229c258c0(element, param, styleProp, projection) {
    var style = param.style, vars = param.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ var $944d9d7404e87d24$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $b00285c0951e7b7f$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $0ec3e01a84905c76$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $944d9d7404e87d24$export$28931db5d57958e5).has(key) ? (0, $954f6dcdfd539927$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $4ba2c6b29cfaba58$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $719c6b4fb69ff79d$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3f8ee39b82ceb57a$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}



function $a6468c62becd11cf$export$16da615486abaa45(props, prevProps, visualElement) {
    var newValues = (0, $4ba2c6b29cfaba58$export$16da615486abaa45)(props, prevProps, visualElement);
    for(var key in props)if ((0, $719c6b4fb69ff79d$export$605d60a2578142d3)(props[key]) || (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(prevProps[key])) {
        var targetKey = (0, $458c1d3a49d65b1f$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




var $dQFEZ = parcelRequire("dQFEZ");



var $2nwvT = parcelRequire("2nwvT");
function $f00bc84c0df1779b$var$getValueState(visualElement) {
    var state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach(function(value, key) {
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $f00bc84c0df1779b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        var _getValueState = (0, $2nwvT._)($f00bc84c0df1779b$var$getValueState(visualElement), 2), current = _getValueState[0], velocity = _getValueState[1];
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        var _getValueState1 = (0, $2nwvT._)($f00bc84c0df1779b$var$getValueState(visualElement), 2), current1 = _getValueState1[0], velocity1 = _getValueState1[1];
        definition = definition(custom !== undefined ? custom : props.custom, current1, velocity1);
    }
    return definition;
}



var $dQFEZ = parcelRequire("dQFEZ");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $aa070268e56bbe37$export$fe4300aa8eebea86(init) {
    var ref = (0, $dQFEZ.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


var $0fad434c33d9e872$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};


var $dbfd1ed8c0784204$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $dbfd1ed8c0784204$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $0fad434c33d9e872$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $ed000a70011c0ae0$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $dbfd1ed8c0784204$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




/**
 * A list of values that can be hardware-accelerated.
 */ var $acd27adf2695813d$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




function $574a8a1d2e0b35cc$export$b3f9dd865b560c6(name) {
    if ((0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $acd27adf2695813d$export$a27eefbd8fb5e404).has(name)) return (0, $954f6dcdfd539927$export$9fd24a634729c672)(name);
}



var $2nwvT = parcelRequire("2nwvT");

var $1g4fM = parcelRequire("1g4fM");

var $eaxdf = parcelRequire("eaxdf");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $f625ca9f0dc92caa$export$71511d61b312f219(arr) {
    return (0, $1g4fM._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $9kJqn._)();
}


function $240b8108c1be092c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $240b8108c1be092c$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $240b8108c1be092c$export$ec937e64de6c1257(param, fromIndex, toIndex) {
    var _param = (0, $f625ca9f0dc92caa$export$71511d61b312f219)(param), arr = _param.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _arr_splice = (0, $2nwvT._)(arr.splice(fromIndex, 1), 1), item = _arr_splice[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


function $8a348e04716008a3$var$makeState(param, props, context, presenceContext, isStatic) {
    var _param_applyWillChange = param.applyWillChange, applyWillChange = _param_applyWillChange === void 0 ? false : _param_applyWillChange, scrapeMotionValuesFromProps = param.scrapeMotionValuesFromProps, createRenderState = param.createRenderState, onMount = param.onMount;
    var state = {
        latestValues: $8a348e04716008a3$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $8a348e04716008a3$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $dQFEZ.useContext)((0, $ae8dea0de7d1e112$export$2285bbca2c666415));
        var presenceContext = (0, $dQFEZ.useContext)((0, $4fa6635067f6f474$export$f224e4635b6f8ce2));
        var make = function() {
            return $8a348e04716008a3$var$makeState(config, props, context, presenceContext, isStatic);
        };
        return isStatic ? make() : (0, $aa070268e56bbe37$export$fe4300aa8eebea86)(make);
    };
};
function $8a348e04716008a3$var$addWillChange(willChange, name) {
    var memberName = (0, $574a8a1d2e0b35cc$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $240b8108c1be092c$export$20e507e47fae79fd)(willChange, memberName);
}
function $8a348e04716008a3$var$forEachDefinition(props, definition, callback) {
    var list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(var i = 0; i < list.length; i++){
        var resolved = (0, $f00bc84c0df1779b$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            var transitionEnd = resolved.transitionEnd, transition = resolved.transition, target = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            callback(target, transitionEnd);
        }
    }
}
function $8a348e04716008a3$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    var values = {};
    var willChange = [];
    var applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    var motionValues = scrapeMotionValues(props, {});
    for(var key in motionValues)values[key] = (0, $ed000a70011c0ae0$export$fcc2206ecb6d74b)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants$1 = (0, $0b7e066ec777c86a$export$4b3c3bd8d910d78d)(props);
    var isVariantNode$1 = (0, $0b7e066ec777c86a$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    var variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $4ee7515c1ffdc148$export$aa71198ceeaf53ce)(variantToSet)) $8a348e04716008a3$var$forEachDefinition(props, variantToSet, function(target, transitionEnd) {
        for(var key in target){
            var valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(var key1 in transitionEnd)values[key1] = transitionEnd[key1];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $4ee7515c1ffdc148$export$aa71198ceeaf53ce)(animate)) $8a348e04716008a3$var$forEachDefinition(props, animate, function(target) {
            for(var key in target)$8a348e04716008a3$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}





var $fb816313cb795261$export$8793edee2d425525 = function(any) {
    return any;
};



var $1134021eb916ca42$var$_createRenderBatcher = (0, $f8b0daac2b5158dc$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $fb816313cb795261$export$8793edee2d425525), true), $1134021eb916ca42$export$2cef06c20297c17d = $1134021eb916ca42$var$_createRenderBatcher.schedule, $1134021eb916ca42$export$ec99c0ef4978dccb = $1134021eb916ca42$var$_createRenderBatcher.cancel, $1134021eb916ca42$export$fff89137e9e818ce = $1134021eb916ca42$var$_createRenderBatcher.state, $1134021eb916ca42$export$be3f796aed065412 = $1134021eb916ca42$var$_createRenderBatcher.steps;


var $2dcef6c4fe9b76d0$export$44dabd3fae512e85 = {
    useVisualState: (0, $8a348e04716008a3$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $a6468c62becd11cf$export$16da615486abaa45),
        createRenderState: (0, $5f955f31c57591ad$export$41be8b43e1c4d4f9),
        onMount: function(props, instance, param) {
            var renderState = param.renderState, latestValues = param.latestValues;
            (0, $1134021eb916ca42$export$2cef06c20297c17d).read(function() {
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $1134021eb916ca42$export$2cef06c20297c17d).render(function() {
                (0, $91df2c47b15ea8f0$export$5475d24f125d7053)(renderState, latestValues, (0, $baea5e7697904cc6$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $b00285c0951e7b7f$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





var $e94cfb6bf27e820d$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $8a348e04716008a3$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: (0, $4ba2c6b29cfaba58$export$16da615486abaa45),
        createRenderState: (0, $4d93f86e3a69bef4$export$8940b483cf52eeda)
    })
};


function $251dae90958b34e1$export$732916c0e88175fb(Component, param, preloadedFeatures, createVisualElement) {
    var _param_forwardMotionProps = param.forwardMotionProps, forwardMotionProps = _param_forwardMotionProps === void 0 ? false : _param_forwardMotionProps;
    var baseConfig = (0, $d3214709b7c7176a$export$88f3fc2fd3766989)(Component) ? (0, $2dcef6c4fe9b76d0$export$44dabd3fae512e85) : (0, $e94cfb6bf27e820d$export$e13ea21d87ea57c8);
    return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $ee48b3870114cda2$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");
function $63bd599df9fc420d$export$b1d829ddf82884aa(target, eventName, handler) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}


var $07b957812985c680$export$a4cf9c8a4b063a6e = function(event) {
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $3bcd6d32796288e9$export$12f84bb882d06e1a(event) {
    var pointType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "page";
    return {
        point: {
            x: event["".concat(pointType, "X")],
            y: event["".concat(pointType, "Y")]
        }
    };
}
var $3bcd6d32796288e9$export$c404e80f92c98d29 = function(handler) {
    return function(event) {
        return (0, $07b957812985c680$export$a4cf9c8a4b063a6e)(event) && handler(event, $3bcd6d32796288e9$export$12f84bb882d06e1a(event));
    };
};


function $db69ad6144494a98$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(target, eventName, (0, $3bcd6d32796288e9$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var $34ca4cb779ef64d7$var$combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var $34ca4cb779ef64d7$export$a4627e546088548d = function() {
    for(var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++){
        transformers[_key] = arguments[_key];
    }
    return transformers.reduce($34ca4cb779ef64d7$var$combineFunctions);
};


function $73b68d6bef4a7404$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $73b68d6bef4a7404$var$globalHorizontalLock = $73b68d6bef4a7404$export$518c5fc2dcb7974b("dragHorizontal");
var $73b68d6bef4a7404$var$globalVerticalLock = $73b68d6bef4a7404$export$518c5fc2dcb7974b("dragVertical");
function $73b68d6bef4a7404$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $73b68d6bef4a7404$var$globalVerticalLock();
    else if (drag === "x") lock = $73b68d6bef4a7404$var$globalHorizontalLock();
    else {
        var openHorizontal = $73b68d6bef4a7404$var$globalHorizontalLock();
        var openVertical = $73b68d6bef4a7404$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = function() {
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $73b68d6bef4a7404$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $73b68d6bef4a7404$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");
var $d9394131c38c23bf$export$6e91cf7616333d5 = /*#__PURE__*/ function() {
    "use strict";
    function Feature(node) {
        (0, $grujF._)(this, Feature);
        this.isMounted = false;
        this.node = node;
    }
    (0, $dhMkv._)(Feature, [
        {
            key: "update",
            value: function update() {}
        }
    ]);
    return Feature;
}();



function $173eaa6b522a528e$var$addHoverEvent(node, isActive) {
    var eventName = isActive ? "pointerenter" : "pointerleave";
    var callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    var handleEvent = function(event, info) {
        if (event.pointerType === "touch" || (0, $73b68d6bef4a7404$export$1b3dd616664938e4)()) return;
        var props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        var callback = props[callbackName];
        if (callback) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
            return callback(event, info);
        });
    };
    return (0, $db69ad6144494a98$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
var $173eaa6b522a528e$export$93a81ea037eac456 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(HoverGesture, Feature);
    var _super = (0, $lngen._)(HoverGesture);
    function HoverGesture() {
        (0, $grujF._)(this, HoverGesture);
        return _super.apply(this, arguments);
    }
    (0, $dhMkv._)(HoverGesture, [
        {
            key: "mount",
            value: function mount() {
                this.unmount = (0, $34ca4cb779ef64d7$export$a4627e546088548d)($173eaa6b522a528e$var$addHoverEvent(this.node, true), $173eaa6b522a528e$var$addHoverEvent(this.node, false));
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return HoverGesture;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");



var $52139f42dca6e904$export$d4826db40d47595b = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(FocusGesture, Feature);
    var _super = (0, $lngen._)(FocusGesture);
    function FocusGesture() {
        (0, $grujF._)(this, FocusGesture);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.isActive = false;
        return _this;
    }
    (0, $dhMkv._)(FocusGesture, [
        {
            key: "onFocus",
            value: function onFocus() {
                var isFocusVisible = false;
                /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
                    isFocusVisible = this.node.current.matches(":focus-visible");
                } catch (e) {
                    isFocusVisible = true;
                }
                if (!isFocusVisible || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", true);
                this.isActive = true;
            }
        },
        {
            key: "onBlur",
            value: function onBlur() {
                if (!this.isActive || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", false);
                this.isActive = false;
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.unmount = (0, $34ca4cb779ef64d7$export$a4627e546088548d)((0, $63bd599df9fc420d$export$b1d829ddf82884aa)(this.node.current, "focus", function() {
                    return _this.onFocus();
                }), (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(this.node.current, "blur", function() {
                    return _this.onBlur();
                }));
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return FocusGesture;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");






/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $123c207d5e4e6320$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $123c207d5e4e6320$export$e841ada32ff745b(parent, child.parentElement);
};




function $a4eb5b67bff52a9c$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    var syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $3bcd6d32796288e9$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
var $a4eb5b67bff52a9c$export$f026abdbba7f0c9e = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(PressGesture, Feature);
    var _super = (0, $lngen._)(PressGesture);
    function PressGesture() {
        (0, $grujF._)(this, PressGesture);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.removeStartListeners = (0, $fb816313cb795261$export$8793edee2d425525);
        _this.removeEndListeners = (0, $fb816313cb795261$export$8793edee2d425525);
        _this.removeAccessibleListeners = (0, $fb816313cb795261$export$8793edee2d425525);
        _this.startPointerPress = function(startEvent, startInfo) {
            if (_this.isPressing) return;
            _this.removeEndListeners();
            var props = _this.node.getProps();
            var endPointerPress = function(endEvent, endInfo) {
                if (!_this.checkPressEnd()) return;
                var _this_node_getProps = _this.node.getProps(), onTap = _this_node_getProps.onTap, onTapCancel = _this_node_getProps.onTapCancel, globalTapTarget = _this_node_getProps.globalTapTarget;
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ var handler = !globalTapTarget && !(0, $123c207d5e4e6320$export$e841ada32ff745b)(_this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $1134021eb916ca42$export$2cef06c20297c17d).update(function() {
                    return handler(endEvent, endInfo);
                });
            };
            var removePointerUpListener = (0, $db69ad6144494a98$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            var removePointerCancelListener = (0, $db69ad6144494a98$export$fcff2e64e6676b81)(window, "pointercancel", function(cancelEvent, cancelInfo) {
                return _this.cancelPress(cancelEvent, cancelInfo);
            }, {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            _this.removeEndListeners = (0, $34ca4cb779ef64d7$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            _this.startPress(startEvent, startInfo);
        };
        _this.startAccessiblePress = function() {
            var handleKeydown = function(keydownEvent) {
                if (keydownEvent.key !== "Enter" || _this.isPressing) return;
                var handleKeyup = function(keyupEvent) {
                    if (keyupEvent.key !== "Enter" || !_this.checkPressEnd()) return;
                    $a4eb5b67bff52a9c$var$fireSyntheticPointerEvent("up", function(event, info) {
                        var onTap = _this.node.getProps().onTap;
                        if (onTap) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                            return onTap(event, info);
                        });
                    });
                };
                _this.removeEndListeners();
                _this.removeEndListeners = (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(_this.node.current, "keyup", handleKeyup);
                $a4eb5b67bff52a9c$var$fireSyntheticPointerEvent("down", function(event, info) {
                    _this.startPress(event, info);
                });
            };
            var removeKeydownListener = (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(_this.node.current, "keydown", handleKeydown);
            var handleBlur = function() {
                if (!_this.isPressing) return;
                $a4eb5b67bff52a9c$var$fireSyntheticPointerEvent("cancel", function(cancelEvent, cancelInfo) {
                    return _this.cancelPress(cancelEvent, cancelInfo);
                });
            };
            var removeBlurListener = (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(_this.node.current, "blur", handleBlur);
            _this.removeAccessibleListeners = (0, $34ca4cb779ef64d7$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
        return _this;
    }
    (0, $dhMkv._)(PressGesture, [
        {
            key: "startPress",
            value: function startPress(event, info) {
                this.isPressing = true;
                var _this_node_getProps = this.node.getProps(), onTapStart = _this_node_getProps.onTapStart, whileTap = _this_node_getProps.whileTap;
                /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
                if (onTapStart) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                    return onTapStart(event, info);
                });
            }
        },
        {
            key: "checkPressEnd",
            value: function checkPressEnd() {
                this.removeEndListeners();
                this.isPressing = false;
                var props = this.node.getProps();
                if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
                return !(0, $73b68d6bef4a7404$export$1b3dd616664938e4)();
            }
        },
        {
            key: "cancelPress",
            value: function cancelPress(event, info) {
                if (!this.checkPressEnd()) return;
                var onTapCancel = this.node.getProps().onTapCancel;
                if (onTapCancel) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                    return onTapCancel(event, info);
                });
            }
        },
        {
            key: "mount",
            value: function mount() {
                var props = this.node.getProps();
                var removePointerListener = (0, $db69ad6144494a98$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
                    passive: !(props.onTapStart || props["onPointerStart"])
                });
                var removeFocusListener = (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
                this.removeStartListeners = (0, $34ca4cb779ef64d7$export$a4627e546088548d)(removePointerListener, removeFocusListener);
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removeStartListeners();
                this.removeEndListeners();
                this.removeAccessibleListeners();
            }
        }
    ]);
    return PressGesture;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 

var $e3edcdbf610c9c12$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $e3edcdbf610c9c12$var$observers = new WeakMap();
var $e3edcdbf610c9c12$var$fireObserverCallback = function(entry) {
    var callback = $e3edcdbf610c9c12$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
var $e3edcdbf610c9c12$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($e3edcdbf610c9c12$var$fireObserverCallback);
};
function $e3edcdbf610c9c12$var$initIntersectionObserver(_param) {
    var root = _param.root, options = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$e3edcdbf610c9c12$var$observers.has(lookupRoot)) $e3edcdbf610c9c12$var$observers.set(lookupRoot, {});
    var rootObservers = $e3edcdbf610c9c12$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($e3edcdbf610c9c12$var$fireAllObserverCallbacks, (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
        root: root
    }, options));
    return rootObservers[key];
}
function $e3edcdbf610c9c12$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $e3edcdbf610c9c12$var$initIntersectionObserver(options);
    $e3edcdbf610c9c12$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $e3edcdbf610c9c12$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


var $fa7b6f1b1c96e2d9$var$thresholdNames = {
    some: 0,
    all: 1
};
var $fa7b6f1b1c96e2d9$export$150851c8cc2f0c72 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(InViewFeature, Feature);
    var _super = (0, $lngen._)(InViewFeature);
    function InViewFeature() {
        (0, $grujF._)(this, InViewFeature);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.hasEnteredView = false;
        _this.isInView = false;
        return _this;
    }
    (0, $dhMkv._)(InViewFeature, [
        {
            key: "startObserver",
            value: function startObserver() {
                var _this = this;
                this.unmount();
                var _this_node_getProps = this.node.getProps(), _this_node_getProps_viewport = _this_node_getProps.viewport, viewport = _this_node_getProps_viewport === void 0 ? {} : _this_node_getProps_viewport;
                var root = viewport.root, rootMargin = viewport.margin, _viewport_amount = viewport.amount, amount = _viewport_amount === void 0 ? "some" : _viewport_amount, once = viewport.once;
                var options = {
                    root: root ? root.current : undefined,
                    rootMargin: rootMargin,
                    threshold: typeof amount === "number" ? amount : $fa7b6f1b1c96e2d9$var$thresholdNames[amount]
                };
                var onIntersectionUpdate = function(entry) {
                    var isIntersecting = entry.isIntersecting;
                    /**
             * If there's been no change in the viewport state, early return.
             */ if (_this.isInView === isIntersecting) return;
                    _this.isInView = isIntersecting;
                    /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && _this.hasEnteredView) return;
                    else if (isIntersecting) _this.hasEnteredView = true;
                    if (_this.node.animationState) _this.node.animationState.setActive("whileInView", isIntersecting);
                    /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var _this_node_getProps = _this.node.getProps(), onViewportEnter = _this_node_getProps.onViewportEnter, onViewportLeave = _this_node_getProps.onViewportLeave;
                    var callback = isIntersecting ? onViewportEnter : onViewportLeave;
                    callback && callback(entry);
                };
                return (0, $e3edcdbf610c9c12$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
            }
        },
        {
            key: "mount",
            value: function mount() {
                this.startObserver();
            }
        },
        {
            key: "update",
            value: function update() {
                if (typeof IntersectionObserver === "undefined") return;
                var _this_node = this.node, props = _this_node.props, prevProps = _this_node.prevProps;
                var hasOptionsChanged = [
                    "amount",
                    "margin",
                    "root"
                ].some($fa7b6f1b1c96e2d9$var$hasViewportOptionChanged(props, prevProps));
                if (hasOptionsChanged) this.startObserver();
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return InViewFeature;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));
function $fa7b6f1b1c96e2d9$var$hasViewportOptionChanged(param) {
    var _param_viewport = param.viewport, viewport = _param_viewport === void 0 ? {} : _param_viewport, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.viewport, prevViewport = tmp === void 0 ? {} : tmp;
    return function(name) {
        return viewport[name] !== prevViewport[name];
    };
}


var $0051659ccbbb73a2$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $fa7b6f1b1c96e2d9$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $a4eb5b67bff52a9c$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $52139f42dca6e904$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $173eaa6b522a528e$export$93a81ea037eac456)
    }
};



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");




var $2us1u = parcelRequire("2us1u");


function $7471e449acc6dd77$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




function $73f2f95224ec0d43$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return (0, $f00bc84c0df1779b$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}









/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $961b5de3ad585623$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};
var $961b5de3ad585623$export$f64c3bfbc58eec0f = function(milliseconds) {
    return milliseconds / 1000;
};



var $30dad1ee1f8213dc$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
var $30dad1ee1f8213dc$var$criticallyDampedSpring = function(target) {
    return {
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $30dad1ee1f8213dc$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ var $30dad1ee1f8213dc$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
var $30dad1ee1f8213dc$export$262124b154b9f1c0 = function(valueKey, param) {
    var keyframes = param.keyframes;
    if (keyframes.length > 2) return $30dad1ee1f8213dc$var$keyframesTransition;
    else if ((0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $30dad1ee1f8213dc$var$criticallyDampedSpring(keyframes[1]) : $30dad1ee1f8213dc$var$underDampedSpring;
    return $30dad1ee1f8213dc$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ 
function $a113484cc917d77a$export$ca8e47dc8ed5a9d7(_param) {
    var when = _param.when, _delay = _param.delay, delayChildren = _param.delayChildren, staggerChildren = _param.staggerChildren, staggerDirection = _param.staggerDirection, repeat = _param.repeat, repeatType = _param.repeatType, repeatDelay = _param.repeatDelay, from = _param.from, elapsed = _param.elapsed, transition = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from",
        "elapsed"
    ]);
    return !!Object.keys(transition).length;
}
function $a113484cc917d77a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



var $f780fab6a2a70141$export$888a3d84909f9e3d = {
    current: false
};


var $0a3f2bb43fc99f38$var$isNotNull = function(value) {
    return value !== null;
};
function $0a3f2bb43fc99f38$export$14de59408fad90b(keyframes, param, finalKeyframe) {
    var repeat = param.repeat, _param_repeatType = param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType;
    var resolvedKeyframes = keyframes.filter($0a3f2bb43fc99f38$var$isNotNull);
    var index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}




var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");




var $lngen = parcelRequire("lngen");


var $61a3cf971ef168a3$var$now;
function $61a3cf971ef168a3$var$clearTime() {
    $61a3cf971ef168a3$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ var $61a3cf971ef168a3$export$2da9be4cfdb689b1 = {
    now: function() {
        if ($61a3cf971ef168a3$var$now === undefined) $61a3cf971ef168a3$export$2da9be4cfdb689b1.set((0, $1134021eb916ca42$export$fff89137e9e818ce).isProcessing || (0, $edee933072dcb548$export$dd826089e3c5e502).useManualTiming ? (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp : performance.now());
        return $61a3cf971ef168a3$var$now;
    },
    set: function(newTime) {
        $61a3cf971ef168a3$var$now = newTime;
        queueMicrotask($61a3cf971ef168a3$var$clearTime);
    }
};



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $gyGuQ = parcelRequire("gyGuQ");
function $d079121360b168c5$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $gyGuQ._)(object);
        if (object === null) break;
    }
    return object;
}


function $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $8665ac34acf389ad$export$71511d61b312f219 = Reflect.get;
    else $8665ac34acf389ad$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $d079121360b168c5$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver || target);
}



var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $lngen = parcelRequire("lngen");
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $86b034b188fdb549$export$ade84c85e44a6cb1 = function(v) {
    return RegExp("^0[^.\\s]+$", "u").test(v);
};


function $4f93276109beed5a$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $86b034b188fdb549$export$ade84c85e44a6cb1)(value);
    else return true;
}



var $2nwvT = parcelRequire("2nwvT");

var $aaa7e0662adcfa6d$export$491112666e282270 = (0, $fb816313cb795261$export$8793edee2d425525);
var $aaa7e0662adcfa6d$export$f5708dca728d7177 = (0, $fb816313cb795261$export$8793edee2d425525);
var $aaa7e0662adcfa6d$var$check, $aaa7e0662adcfa6d$var$message, $aaa7e0662adcfa6d$var$check1, $aaa7e0662adcfa6d$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $b224a6dcf0077c0f$export$65583ed5a868f2d9 = function(v) {
    return RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);
};



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $d02e1fc8eaad8c96$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $d02e1fc8eaad8c96$export$b9f0c1f373aee2b0(current) {
    var match = $d02e1fc8eaad8c96$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, $2nwvT._)(match, 4), token1 = _match[1], token2 = _match[2], fallback = _match[3];
    return [
        "--".concat(token1 !== null && token1 !== void 0 ? token1 : token2),
        fallback
    ];
}
var $d02e1fc8eaad8c96$var$maxDepth = 4;
function $d02e1fc8eaad8c96$export$289398774300c991(current, element) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (0, $aaa7e0662adcfa6d$export$f5708dca728d7177)(depth <= $d02e1fc8eaad8c96$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'));
    var _parseCSSVariable = (0, $2nwvT._)($d02e1fc8eaad8c96$export$b9f0c1f373aee2b0(current), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        var trimmed = resolved.trim();
        return (0, $b224a6dcf0077c0f$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $fa15c42eacb6654d$export$31f9caa2600b5723)(fallback) ? $d02e1fc8eaad8c96$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






var $16e50cdfc46415a6$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
var $16e50cdfc46415a6$export$8e5250d1aa9bf370 = function(v) {
    return v === (0, $933d4c7094aff38e$export$98e628dec113755e) || v === (0, $0881ed62dbc2428c$export$91c0eda1d06bf008);
};
var $16e50cdfc46415a6$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $16e50cdfc46415a6$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, param) {
        var transform = param.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(RegExp("^matrix3d\\((.+)\\)$", "u"));
        if (matrix3d) return $16e50cdfc46415a6$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(RegExp("^matrix\\((.+)\\)$", "u"));
            if (matrix) return $16e50cdfc46415a6$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $16e50cdfc46415a6$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $16e50cdfc46415a6$var$nonTranslationalTransformKeys = (0, $458c1d3a49d65b1f$export$280dc01950909d86).filter(function(key) {
    return !$16e50cdfc46415a6$var$transformKeys.has(key);
});
function $16e50cdfc46415a6$export$39d4bc9655f3f632(visualElement) {
    var removedTransforms = [];
    $16e50cdfc46415a6$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
var $16e50cdfc46415a6$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(param, param1) {
        var x = param.x, _param_paddingLeft = param1.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? "0" : _param_paddingLeft, _param_paddingRight = param1.paddingRight, paddingRight = _param_paddingRight === void 0 ? "0" : _param_paddingRight;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(param, param1) {
        var y = param.y, _param_paddingTop = param1.paddingTop, paddingTop = _param_paddingTop === void 0 ? "0" : _param_paddingTop, _param_paddingBottom = param1.paddingBottom, paddingBottom = _param_paddingBottom === void 0 ? "0" : _param_paddingBottom;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, param) {
        var top = param.top;
        return parseFloat(top);
    },
    left: function(_bbox, param) {
        var left = param.left;
        return parseFloat(left);
    },
    bottom: function(param, param1) {
        var y = param.y, top = param1.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(param, param1) {
        var x = param.x, left = param1.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $16e50cdfc46415a6$var$getTranslateFromMatrix(4, 13),
    y: $16e50cdfc46415a6$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$16e50cdfc46415a6$export$781d46a8aa670d52.translateX = $16e50cdfc46415a6$export$781d46a8aa670d52.x;
$16e50cdfc46415a6$export$781d46a8aa670d52.translateY = $16e50cdfc46415a6$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ var $f994341bffd015be$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};


/**
 * ValueType for "auto"
 */ var $f1e7a04bdfdd0dba$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};


/**
 * A list of value types commonly used for dimensions
 */ var $d62090a0ae012143$export$d176691c1998a1f5 = [
    (0, $933d4c7094aff38e$export$98e628dec113755e),
    (0, $0881ed62dbc2428c$export$91c0eda1d06bf008),
    (0, $0881ed62dbc2428c$export$626336c2cd4b14de),
    (0, $0881ed62dbc2428c$export$41fc368e1a942b97),
    (0, $0881ed62dbc2428c$export$aed3d7b7d206c196),
    (0, $0881ed62dbc2428c$export$f91e8c45a95a32f2),
    (0, $f1e7a04bdfdd0dba$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $d62090a0ae012143$export$eefdd52e3ccae428 = function(v) {
    return $d62090a0ae012143$export$d176691c1998a1f5.find((0, $f994341bffd015be$export$6eae4d0a6a7ca7cd)(v));
};



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");


var $13b26bd7daa0ff86$var$toResolve = new Set();
var $13b26bd7daa0ff86$var$isScheduled = false;
var $13b26bd7daa0ff86$var$anyNeedsMeasurement = false;
function $13b26bd7daa0ff86$var$measureAllKeyframes() {
    if ($13b26bd7daa0ff86$var$anyNeedsMeasurement) {
        var resolversToMeasure = Array.from($13b26bd7daa0ff86$var$toResolve).filter(function(resolver) {
            return resolver.needsMeasurement;
        });
        var elementsToMeasure = new Set(resolversToMeasure.map(function(resolver) {
            return resolver.element;
        }));
        var transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach(function(element) {
            var removedTransforms = (0, $16e50cdfc46415a6$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureInitialState();
        });
        // Write
        elementsToMeasure.forEach(function(element) {
            element.render();
            var restore = transformsToRestore.get(element);
            if (restore) restore.forEach(function(param) {
                var _param = (0, $2nwvT._)(param, 2), key = _param[0], value = _param[1];
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureEndState();
        });
        // Write
        resolversToMeasure.forEach(function(resolver) {
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $13b26bd7daa0ff86$var$anyNeedsMeasurement = false;
    $13b26bd7daa0ff86$var$isScheduled = false;
    $13b26bd7daa0ff86$var$toResolve.forEach(function(resolver) {
        return resolver.complete();
    });
    $13b26bd7daa0ff86$var$toResolve.clear();
}
function $13b26bd7daa0ff86$var$readAllKeyframes() {
    $13b26bd7daa0ff86$var$toResolve.forEach(function(resolver) {
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $13b26bd7daa0ff86$var$anyNeedsMeasurement = true;
    });
}
function $13b26bd7daa0ff86$export$78b96d2a12593b05() {
    $13b26bd7daa0ff86$var$readAllKeyframes();
    $13b26bd7daa0ff86$var$measureAllKeyframes();
}
var $13b26bd7daa0ff86$export$74d34ca3182f1750 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        var isAsync = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, $grujF._)(this, KeyframeResolver);
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = (0, $2us1u._)(unresolvedKeyframes);
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    (0, $dhMkv._)(KeyframeResolver, [
        {
            key: "scheduleResolve",
            value: function scheduleResolve() {
                this.isScheduled = true;
                if (this.isAsync) {
                    $13b26bd7daa0ff86$var$toResolve.add(this);
                    if (!$13b26bd7daa0ff86$var$isScheduled) {
                        $13b26bd7daa0ff86$var$isScheduled = true;
                        (0, $1134021eb916ca42$export$2cef06c20297c17d).read($13b26bd7daa0ff86$var$readAllKeyframes);
                        (0, $1134021eb916ca42$export$2cef06c20297c17d).resolveKeyframes($13b26bd7daa0ff86$var$measureAllKeyframes);
                    }
                } else {
                    this.readKeyframes();
                    this.complete();
                }
            }
        },
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name, element = _this.element, motionValue = _this.motionValue;
                /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(var i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
                    /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                        var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                        var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                        if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                        else if (element && name) {
                            var valueAsRead = element.readValue(name, finalKeyframe);
                            if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                        }
                        if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                        if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
                    } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
                }
            }
        },
        {
            key: "setFinalKeyframe",
            value: function setFinalKeyframe() {}
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {}
        },
        {
            key: "renderEndStyles",
            value: function renderEndStyles() {}
        },
        {
            key: "measureEndState",
            value: function measureEndState() {}
        },
        {
            key: "complete",
            value: function complete() {
                this.isComplete = true;
                this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
                $13b26bd7daa0ff86$var$toResolve.delete(this);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (!this.isComplete) {
                    this.isScheduled = false;
                    $13b26bd7daa0ff86$var$toResolve.delete(this);
                }
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (!this.isComplete) this.scheduleResolve();
            }
        }
    ]);
    return KeyframeResolver;
}();









var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ var $41ff2448b674898c$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean((0, $02ca8b8e76a91153$export$844ec244b1367d54)(v) && (0, $02ca8b8e76a91153$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $02ca8b8e76a91153$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $41ff2448b674898c$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        if (!(0, $02ca8b8e76a91153$export$844ec244b1367d54)(v)) return v;
        var _v_match = (0, $2nwvT._)(v.match((0, $02ca8b8e76a91153$export$2444ca58c08448e4)), 4), a = _v_match[0], b = _v_match[1], c = _v_match[2], alpha = _v_match[3];
        var _obj;
        return _obj = {}, (0, $72osQ._)(_obj, aName, parseFloat(a)), (0, $72osQ._)(_obj, bName, parseFloat(b)), (0, $72osQ._)(_obj, cName, parseFloat(c)), (0, $72osQ._)(_obj, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _obj;
    };
};


var $a6f4b0070f9e1e22$var$clampRgbUnit = function(v) {
    return (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)(0, 255, v);
};
var $a6f4b0070f9e1e22$export$7a99c86b5b1f4c9e = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $933d4c7094aff38e$export$98e628dec113755e)), {
    transform: function(v) {
        return Math.round($a6f4b0070f9e1e22$var$clampRgbUnit(v));
    }
});
var $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b = {
    test: (0, $41ff2448b674898c$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $41ff2448b674898c$export$73d6f35be992df24)("red", "green", "blue"),
    transform: function(param) {
        var red = param.red, green = param.green, blue = param.blue, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "rgba(" + $a6f4b0070f9e1e22$export$7a99c86b5b1f4c9e.transform(red) + ", " + $a6f4b0070f9e1e22$export$7a99c86b5b1f4c9e.transform(green) + ", " + $a6f4b0070f9e1e22$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $02ca8b8e76a91153$export$83d2e9e3e4ee39ed)((0, $933d4c7094aff38e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



function $a1e8b4b0a8169406$var$parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $a1e8b4b0a8169406$export$834dfc94dde4b3d8 = {
    test: (0, $41ff2448b674898c$export$2c8400d58aca05e)("#"),
    parse: $a1e8b4b0a8169406$var$parseHex,
    transform: (0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b).transform
};






var $a02cbc38928a2c12$export$810b04175080204c = {
    test: (0, $41ff2448b674898c$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $41ff2448b674898c$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: function(param) {
        var hue = param.hue, saturation = param.saturation, lightness = param.lightness, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "hsla(" + Math.round(hue) + ", " + (0, $0881ed62dbc2428c$export$626336c2cd4b14de).transform((0, $02ca8b8e76a91153$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $0881ed62dbc2428c$export$626336c2cd4b14de).transform((0, $02ca8b8e76a91153$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $02ca8b8e76a91153$export$83d2e9e3e4ee39ed)((0, $933d4c7094aff38e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



var $d95c076f89c05413$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b).test(v) || (0, $a1e8b4b0a8169406$export$834dfc94dde4b3d8).test(v) || (0, $a02cbc38928a2c12$export$810b04175080204c).test(v);
    },
    parse: function(v) {
        if ((0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b).test(v)) return (0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $a02cbc38928a2c12$export$810b04175080204c).test(v)) return (0, $a02cbc38928a2c12$export$810b04175080204c).parse(v);
        else return (0, $a1e8b4b0a8169406$export$834dfc94dde4b3d8).parse(v);
    },
    transform: function(v) {
        return (0, $02ca8b8e76a91153$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b).transform(v) : (0, $a02cbc38928a2c12$export$810b04175080204c).transform(v);
    }
};



function $69b61e406d097f9e$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $02ca8b8e76a91153$export$844ec244b1367d54)(v) && (((_a = v.match((0, $02ca8b8e76a91153$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $02ca8b8e76a91153$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
var $69b61e406d097f9e$var$NUMBER_TOKEN = "number";
var $69b61e406d097f9e$var$COLOR_TOKEN = "color";
var $69b61e406d097f9e$var$VAR_TOKEN = "var";
var $69b61e406d097f9e$var$VAR_FUNCTION_TOKEN = "var(";
var $69b61e406d097f9e$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
var $69b61e406d097f9e$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $69b61e406d097f9e$export$b61fc7c44bf646d5(value) {
    var originalValue = value.toString();
    var values = [];
    var indexes = {
        color: [],
        number: [],
        var: []
    };
    var types = [];
    var i = 0;
    var tokenised = originalValue.replace($69b61e406d097f9e$var$complexRegex, function(parsedValue) {
        if ((0, $d95c076f89c05413$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($69b61e406d097f9e$var$COLOR_TOKEN);
            values.push((0, $d95c076f89c05413$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($69b61e406d097f9e$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($69b61e406d097f9e$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($69b61e406d097f9e$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $69b61e406d097f9e$var$SPLIT_TOKEN;
    });
    var split = tokenised.split($69b61e406d097f9e$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $69b61e406d097f9e$var$parseComplexValue(v) {
    return $69b61e406d097f9e$export$b61fc7c44bf646d5(v).values;
}
function $69b61e406d097f9e$var$createTransformer(source) {
    var _analyseComplexValue = $69b61e406d097f9e$export$b61fc7c44bf646d5(source), split = _analyseComplexValue.split, types = _analyseComplexValue.types;
    var numSections = split.length;
    return function(v) {
        var output = "";
        for(var i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                var type = types[i];
                if (type === $69b61e406d097f9e$var$NUMBER_TOKEN) output += (0, $02ca8b8e76a91153$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $69b61e406d097f9e$var$COLOR_TOKEN) output += (0, $d95c076f89c05413$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
var $69b61e406d097f9e$var$convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : v;
};
function $69b61e406d097f9e$var$getAnimatableNone(v) {
    var parsed = $69b61e406d097f9e$var$parseComplexValue(v);
    var transformer = $69b61e406d097f9e$var$createTransformer(v);
    return transformer(parsed.map($69b61e406d097f9e$var$convertNumbersToZero));
}
var $69b61e406d097f9e$export$83a0e34f1302825b = {
    test: $69b61e406d097f9e$var$test,
    parse: $69b61e406d097f9e$var$parseComplexValue,
    createTransformer: $69b61e406d097f9e$var$createTransformer,
    getAnimatableNone: $69b61e406d097f9e$var$getAnimatableNone
};






var $2nwvT = parcelRequire("2nwvT");


/**
 * Properties that should default to 1 or 100%
 */ var $d4f251153a6b13e5$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $d4f251153a6b13e5$var$applyDefaultFilter(v) {
    var _v_slice_split = (0, $2nwvT._)(v.slice(0, -1).split("("), 2), name = _v_slice_split[0], value = _v_slice_split[1];
    if (name === "drop-shadow") return v;
    var _ref = (0, $2nwvT._)(value.match((0, $02ca8b8e76a91153$export$2444ca58c08448e4)) || [], 1), number = _ref[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = $d4f251153a6b13e5$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var $d4f251153a6b13e5$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
var $d4f251153a6b13e5$export$3dea766d36a8935f = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $69b61e406d097f9e$export$83a0e34f1302825b)), {
    getAnimatableNone: function(v) {
        var functions = v.match($d4f251153a6b13e5$var$functionRegex);
        return functions ? functions.map($d4f251153a6b13e5$var$applyDefaultFilter).join(" ") : v;
    }
});







/**
 * A map of default value types for common values
 */ var $ded79850b04b204e$export$98cd7c72c5a731fb = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $cb64cb658ad60100$export$eec14432cd1cb67b)), {
    // Color props
    color: (0, $d95c076f89c05413$export$35e9368ef982300f),
    backgroundColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    outlineColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    fill: (0, $d95c076f89c05413$export$35e9368ef982300f),
    stroke: (0, $d95c076f89c05413$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    borderTopColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    borderRightColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    borderBottomColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    borderLeftColor: (0, $d95c076f89c05413$export$35e9368ef982300f),
    filter: (0, $d4f251153a6b13e5$export$3dea766d36a8935f),
    WebkitFilter: (0, $d4f251153a6b13e5$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $ded79850b04b204e$export$67d1babe0338d23b = function(key) {
    return $ded79850b04b204e$export$98cd7c72c5a731fb[key];
};


function $d0ba51653f20745d$export$cea0cedcb94873b5(key, value) {
    var defaultValueType = (0, $ded79850b04b204e$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $d4f251153a6b13e5$export$3dea766d36a8935f)) defaultValueType = (0, $69b61e406d097f9e$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ var $a82d077312261700$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $a82d077312261700$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    var i = 0;
    var animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        var keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$a82d077312261700$var$invalidTemplates.has(keyframe) && (0, $69b61e406d097f9e$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (animatableTemplate && name) try {
        for(var _iterator = noneKeyframeIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var noneIndex = _step.value;
            unresolvedKeyframes[noneIndex] = (0, $d0ba51653f20745d$export$cea0cedcb94873b5)(name, animatableTemplate);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}


var $7bfe4cc0123b898c$export$4983792d11b61017 = /*#__PURE__*/ function(KeyframeResolver) {
    "use strict";
    (0, $j6Mzi._)(DOMKeyframesResolver, KeyframeResolver);
    var _super = (0, $lngen._)(DOMKeyframesResolver);
    function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue) {
        (0, $grujF._)(this, DOMKeyframesResolver);
        return _super.call(this, unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    (0, $dhMkv._)(DOMKeyframesResolver, [
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, element = _this.element, name = _this.name;
                if (!element.current) return;
                (0, $8665ac34acf389ad$export$71511d61b312f219)((0, $gyGuQ._)(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
                /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(var i = 0; i < unresolvedKeyframes.length; i++){
                    var keyframe = unresolvedKeyframes[i];
                    if (typeof keyframe === "string") {
                        keyframe = keyframe.trim();
                        if ((0, $fa15c42eacb6654d$export$31f9caa2600b5723)(keyframe)) {
                            var resolved = (0, $d02e1fc8eaad8c96$export$289398774300c991)(keyframe, element.current);
                            if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                            if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                        }
                    }
                }
                /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
                /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $16e50cdfc46415a6$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
                var _unresolvedKeyframes = (0, $2nwvT._)(unresolvedKeyframes, 2), origin = _unresolvedKeyframes[0], target = _unresolvedKeyframes[1];
                var originType = (0, $d62090a0ae012143$export$eefdd52e3ccae428)(origin);
                var targetType = (0, $d62090a0ae012143$export$eefdd52e3ccae428)(target);
                /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
                /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $16e50cdfc46415a6$export$8e5250d1aa9bf370)(originType) && (0, $16e50cdfc46415a6$export$8e5250d1aa9bf370)(targetType)) for(var i1 = 0; i1 < unresolvedKeyframes.length; i1++){
                    var value = unresolvedKeyframes[i1];
                    if (typeof value === "string") unresolvedKeyframes[i1] = parseFloat(value);
                }
                else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
            }
        },
        {
            key: "resolveNoneKeyframes",
            value: function resolveNoneKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                var noneKeyframeIndexes = [];
                for(var i = 0; i < unresolvedKeyframes.length; i++)if ((0, $4f93276109beed5a$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
                if (noneKeyframeIndexes.length) (0, $a82d077312261700$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
            }
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {
                var _this = this, element = _this.element, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                if (!element.current) return;
                if (name === "height") this.suspendedScrollY = window.pageYOffset;
                this.measuredOrigin = (0, $16e50cdfc46415a6$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                unresolvedKeyframes[0] = this.measuredOrigin;
                // Set final key frame to measure after next render
                var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
            }
        },
        {
            key: "measureEndState",
            value: function measureEndState() {
                var _a;
                var _this = this, element = _this.element, name = _this.name, unresolvedKeyframes = _this.unresolvedKeyframes;
                if (!element.current) return;
                var value = element.getValue(name);
                value && value.jump(this.measuredOrigin, false);
                var finalKeyframeIndex = unresolvedKeyframes.length - 1;
                var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
                unresolvedKeyframes[finalKeyframeIndex] = (0, $16e50cdfc46415a6$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
                // If we removed transform values, reapply them before the next render
                if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(function(param) {
                    var _param = (0, $2nwvT._)(param, 2), unsetTransformName = _param[0], unsetTransformValue = _param[1];
                    element.getValue(unsetTransformName).set(unsetTransformValue);
                });
                this.resolveNoneKeyframes();
            }
        }
    ]);
    return DOMKeyframesResolver;
}((0, $13b26bd7daa0ff86$export$74d34ca3182f1750));


function $46569f4cbd18a4ef$export$7c73462e0d25e514(callback) {
    var result;
    return function() {
        if (result === undefined) result = callback();
        return result;
    };
}





var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");






/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $5916cf819d716f31$export$65676b58b122bc38 = function(value, name) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $69b61e406d097f9e$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $4a206e32d6db238b$var$hasKeyframesChanged(keyframes) {
    var current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(var i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $4a206e32d6db238b$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ var originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = (0, $5916cf819d716f31$export$65676b58b122bc38)(originKeyframe, name);
    var isTargetAnimatable = (0, $5916cf819d716f31$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $aaa7e0662adcfa6d$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, ' from "').concat(originKeyframe, '" to "').concat(targetKeyframe, '". ').concat(originKeyframe, " is not an animatable value - to enable this animation set ").concat(originKeyframe, " to a value animatable to ").concat(targetKeyframe, " via the `style` property."));
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $4a206e32d6db238b$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



var $94681169bc6ff608$export$d1e4f34b9c2550c1 = /*#__PURE__*/ function() {
    "use strict";
    function BaseAnimation(_param) {
        (0, $grujF._)(this, BaseAnimation);
        var _param_autoplay = _param.autoplay, autoplay = _param_autoplay === void 0 ? true : _param_autoplay, _param_delay = _param.delay, delay = _param_delay === void 0 ? 0 : _param_delay, _param_type = _param.type, type = _param_type === void 0 ? "keyframes" : _param_type, _param_repeat = _param.repeat, repeat = _param_repeat === void 0 ? 0 : _param_repeat, _param_repeatDelay = _param.repeatDelay, repeatDelay = _param_repeatDelay === void 0 ? 0 : _param_repeatDelay, _param_repeatType = _param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, options = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType"
        ]);
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType
        }, options);
        this.updateFinishedPromise();
    }
    (0, $dhMkv._)(BaseAnimation, [
        {
            key: "resolved",
            get: /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ function get() {
                if (!this._resolved && !this.hasAttemptedResolve) (0, $13b26bd7daa0ff86$export$78b96d2a12593b05)();
                return this._resolved;
            }
        },
        {
            /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ key: "onKeyframesResolved",
            value: function onKeyframesResolved(keyframes, finalKeyframe) {
                this.hasAttemptedResolve = true;
                var _this_options = this.options, name = _this_options.name, type = _this_options.type, velocity = _this_options.velocity, delay = _this_options.delay, onComplete = _this_options.onComplete, onUpdate = _this_options.onUpdate, isGenerator = _this_options.isGenerator;
                /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $4a206e32d6db238b$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
                    // Finish immediately
                    if ((0, $f780fab6a2a70141$export$888a3d84909f9e3d).current || !delay) {
                        onUpdate === null || onUpdate === void 0 || onUpdate((0, $0a3f2bb43fc99f38$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                        onComplete === null || onComplete === void 0 || onComplete();
                        this.resolveFinishedPromise();
                        return;
                    } else this.options.duration = 0;
                }
                var resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
                if (resolvedAnimation === false) return;
                this._resolved = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                    keyframes: keyframes,
                    finalKeyframe: finalKeyframe
                }, resolvedAnimation);
                this.onPostResolved();
            }
        },
        {
            key: "onPostResolved",
            value: function onPostResolved() {}
        },
        {
            /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ key: "then",
            value: function then(resolve, reject) {
                return this.currentFinishedPromise.then(resolve, reject);
            }
        },
        {
            key: "updateFinishedPromise",
            value: function updateFinishedPromise() {
                var _this = this;
                this.currentFinishedPromise = new Promise(function(resolve) {
                    _this.resolveFinishedPromise = resolve;
                });
            }
        }
    ]);
    return BaseAnimation;
}();



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");




var $2us1u = parcelRequire("2us1u");

var $lngen = parcelRequire("lngen");





/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $076f367f29e64da6$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


var $3cbd20255fafcc81$var$velocitySampleDuration = 5; // ms
function $3cbd20255fafcc81$export$854187271d233eb5(resolveValue, t, current) {
    var prevT = Math.max(t - $3cbd20255fafcc81$var$velocitySampleDuration, 0);
    return (0, $076f367f29e64da6$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





var $03a11f30c08d5619$var$safeMin = 0.001;
var $03a11f30c08d5619$export$a3cdb76e84ee608e = 0.01;
var $03a11f30c08d5619$export$1824b851fad8862b = 10.0;
var $03a11f30c08d5619$export$ff08f2d53484465 = 0.05;
var $03a11f30c08d5619$export$201ca48e54038115 = 1;
function $03a11f30c08d5619$export$b15f158dc6d6f458(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? 800 : _param_duration, _param_bounce = param.bounce, bounce = _param_bounce === void 0 ? 0.25 : _param_bounce, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? 0 : _param_velocity, _param_mass = param.mass, mass = _param_mass === void 0 ? 1 : _param_mass;
    var envelope;
    var derivative;
    (0, $aaa7e0662adcfa6d$export$491112666e282270)(duration <= (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)($03a11f30c08d5619$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)($03a11f30c08d5619$export$ff08f2d53484465, $03a11f30c08d5619$export$201ca48e54038115, dampingRatio);
    duration = (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)($03a11f30c08d5619$export$a3cdb76e84ee608e, $03a11f30c08d5619$export$1824b851fad8862b, (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $03a11f30c08d5619$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $03a11f30c08d5619$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $03a11f30c08d5619$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $03a11f30c08d5619$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$03a11f30c08d5619$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $03a11f30c08d5619$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $03a11f30c08d5619$var$rootIterations = 12;
function $03a11f30c08d5619$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $03a11f30c08d5619$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $03a11f30c08d5619$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


var $5b5837d983fbf340$var$durationKeys = [
    "duration",
    "bounce"
];
var $5b5837d983fbf340$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $5b5837d983fbf340$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $5b5837d983fbf340$var$getSpringOptions(options) {
    var springOptions = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$5b5837d983fbf340$var$isSpringType(options, $5b5837d983fbf340$var$physicsKeys) && $5b5837d983fbf340$var$isSpringType(options, $5b5837d983fbf340$var$durationKeys)) {
        var derived = (0, $03a11f30c08d5619$export$b15f158dc6d6f458)(options);
        springOptions = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, springOptions, derived), {
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $5b5837d983fbf340$export$b36281d89752ae66(_param) {
    var keyframes = _param.keyframes, restDelta = _param.restDelta, restSpeed = _param.restSpeed, options = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
        "keyframes",
        "restDelta",
        "restSpeed"
    ]);
    var origin = keyframes[0];
    var target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: origin
    };
    var _getSpringOptions = $5b5837d983fbf340$var$getSpringOptions((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options), {
        velocity: -(0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(options.velocity || 0)
    })), stiffness = _getSpringOptions.stiffness, damping = _getSpringOptions.damping, mass = _getSpringOptions.mass, duration = _getSpringOptions.duration, velocity = _getSpringOptions.velocity, isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
    var initialVelocity = velocity || 0.0;
    var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    var initialDelta = target - origin;
    var undampedAngularFreq = (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ var isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    var resolveSpring;
    if (dampingRatio < 1) {
        var angularFreq = (0, $03a11f30c08d5619$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = function(t) {
        return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    };
    else {
        // Overdamped spring
        var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: function(t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $3cbd20255fafcc81$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $1c8a7e32d7d2cabc$export$ee3ff3a17106998(param) {
    var keyframes = param.keyframes, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? 0.0 : _param_velocity, _param_power = param.power, power = _param_power === void 0 ? 0.8 : _param_power, _param_timeConstant = param.timeConstant, timeConstant = _param_timeConstant === void 0 ? 325 : _param_timeConstant, _param_bounceDamping = param.bounceDamping, bounceDamping = _param_bounceDamping === void 0 ? 10 : _param_bounceDamping, _param_bounceStiffness = param.bounceStiffness, bounceStiffness = _param_bounceStiffness === void 0 ? 500 : _param_bounceStiffness, modifyTarget = param.modifyTarget, min = param.min, max = param.max, _param_restDelta = param.restDelta, restDelta = _param_restDelta === void 0 ? 0.5 : _param_restDelta, restSpeed = param.restSpeed;
    var origin = keyframes[0];
    var state = {
        done: false,
        value: origin
    };
    var isOutOfBounds = function(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    };
    var nearestBoundary = function(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    var amplitude = power * velocity;
    var ideal = origin + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    var calcDelta = function(t) {
        return -amplitude * Math.exp(-t / timeConstant);
    };
    var calcLatest = function(t) {
        return target + calcDelta(t);
    };
    var applyFriction = function(t) {
        var delta = calcDelta(t);
        var latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ var timeReachedBoundary;
    var spring$1;
    var checkCatchBoundary = function(t) {
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $5b5837d983fbf340$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $3cbd20255fafcc81$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: function(t) {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ var hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var $9b3f98bc4a1f3617$var$calcBezier = function(t, a1, a2) {
    return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var $9b3f98bc4a1f3617$var$subdivisionPrecision = 0.0000001;
var $9b3f98bc4a1f3617$var$subdivisionMaxIterations = 12;
function $9b3f98bc4a1f3617$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $9b3f98bc4a1f3617$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $9b3f98bc4a1f3617$var$subdivisionPrecision && ++i < $9b3f98bc4a1f3617$var$subdivisionMaxIterations);
    return currentT;
}
function $9b3f98bc4a1f3617$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $fb816313cb795261$export$8793edee2d425525;
    var getTForX = function(aX) {
        return $9b3f98bc4a1f3617$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    };
    // If animation is at start/end, return t without easing
    return function(t) {
        return t === 0 || t === 1 ? t : $9b3f98bc4a1f3617$var$calcBezier(getTForX(t), mY1, mY2);
    };
}


var $9721ff6219cfd84c$export$929e5a82286172a6 = (0, $9b3f98bc4a1f3617$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
var $9721ff6219cfd84c$export$57636bb43b1ccbb0 = (0, $9b3f98bc4a1f3617$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
var $9721ff6219cfd84c$export$c07234257a03d5e9 = (0, $9b3f98bc4a1f3617$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


var $7aa9428b11c9958c$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



var $2nwvT = parcelRequire("2nwvT");




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var $140a789a7ccee932$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var $edd31ceddda477b7$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};


var $26c2ab1a9090836c$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $26c2ab1a9090836c$export$c8d67a19199d1a50 = (0, $edd31ceddda477b7$export$2c07eeff45156d4d)($26c2ab1a9090836c$export$e444123e42d03385);
var $26c2ab1a9090836c$export$30d3455eee55bed5 = (0, $140a789a7ccee932$export$f946554fb8aeaf0d)($26c2ab1a9090836c$export$e444123e42d03385);





var $7e9f4781c652c445$export$77edfce482316a60 = (0, $9b3f98bc4a1f3617$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
var $7e9f4781c652c445$export$b01116c84cdfe1a2 = (0, $edd31ceddda477b7$export$2c07eeff45156d4d)($7e9f4781c652c445$export$77edfce482316a60);
var $7e9f4781c652c445$export$ddc5fd596f6c71b2 = (0, $140a789a7ccee932$export$f946554fb8aeaf0d)($7e9f4781c652c445$export$b01116c84cdfe1a2);



var $f227acaaf629f3d4$export$6b0af63b873d419e = function(p) {
    return (p *= 2) < 1 ? 0.5 * (0, $7e9f4781c652c445$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};


var $d8962e660cd45e90$var$easingLookup = {
    linear: (0, $fb816313cb795261$export$8793edee2d425525),
    easeIn: (0, $9721ff6219cfd84c$export$929e5a82286172a6),
    easeInOut: (0, $9721ff6219cfd84c$export$c07234257a03d5e9),
    easeOut: (0, $9721ff6219cfd84c$export$57636bb43b1ccbb0),
    circIn: (0, $26c2ab1a9090836c$export$e444123e42d03385),
    circInOut: (0, $26c2ab1a9090836c$export$30d3455eee55bed5),
    circOut: (0, $26c2ab1a9090836c$export$c8d67a19199d1a50),
    backIn: (0, $7e9f4781c652c445$export$b01116c84cdfe1a2),
    backInOut: (0, $7e9f4781c652c445$export$ddc5fd596f6c71b2),
    backOut: (0, $7e9f4781c652c445$export$77edfce482316a60),
    anticipate: (0, $f227acaaf629f3d4$export$6b0af63b873d419e)
};
var $d8962e660cd45e90$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $aaa7e0662adcfa6d$export$f5708dca728d7177)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _definition = (0, $2nwvT._)(definition, 4), x1 = _definition[0], y1 = _definition[1], x2 = _definition[2], y2 = _definition[3];
        return (0, $9b3f98bc4a1f3617$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $aaa7e0662adcfa6d$export$f5708dca728d7177)($d8962e660cd45e90$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return $d8962e660cd45e90$var$easingLookup[definition];
    }
    return definition;
};



var $2us1u = parcelRequire("2us1u");



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ var $3369424d70926287$export$504d7abb21fa8c9 = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};





var $2us1u = parcelRequire("2us1u");
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var $364e42417e478d28$export$3bb0b4ff1037b8dd = function(from, to, progress) {
    return from + (to - from) * progress;
};





// Adapted from https://gist.github.com/mjackson/5311256
function $66f4a387c230a9d2$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $66f4a387c230a9d2$export$6ae64dbcd6bfc33e(param) {
    var hue = param.hue, saturation = param.saturation, lightness = param.lightness, alpha = param.alpha;
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    var red = 0;
    var green = 0;
    var blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        var p = 2 * lightness - q;
        red = $66f4a387c230a9d2$var$hueToRgb(p, q, hue + 1 / 3);
        green = $66f4a387c230a9d2$var$hueToRgb(p, q, hue);
        blue = $66f4a387c230a9d2$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $1ef66bf338cbe431$export$a6f92d4bae65c0f1(a, b) {
    return function(p) {
        return p > 0 ? b : a;
    };
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var $e29c97e76683f304$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
var $e29c97e76683f304$var$colorTypes = [
    (0, $a1e8b4b0a8169406$export$834dfc94dde4b3d8),
    (0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b),
    (0, $a02cbc38928a2c12$export$810b04175080204c)
];
var $e29c97e76683f304$var$getColorType = function(v) {
    return $e29c97e76683f304$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
function $e29c97e76683f304$var$asRGBA(color) {
    var type = $e29c97e76683f304$var$getColorType(color);
    (0, $aaa7e0662adcfa6d$export$491112666e282270)(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."));
    if (!Boolean(type)) return false;
    var model = type.parse(color);
    if (type === (0, $a02cbc38928a2c12$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $66f4a387c230a9d2$export$6ae64dbcd6bfc33e)(model);
    return model;
}
var $e29c97e76683f304$export$51e568cf5c039bac = function(from, to) {
    var fromRGBA = $e29c97e76683f304$var$asRGBA(from);
    var toRGBA = $e29c97e76683f304$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $1ef66bf338cbe431$export$a6f92d4bae65c0f1)(from, to);
    var blended = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, fromRGBA);
    return function(v) {
        blended.red = $e29c97e76683f304$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $e29c97e76683f304$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $e29c97e76683f304$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $a6f4b0070f9e1e22$export$4e46ac54fc82cf3b).transform(blended);
    };
};







var $36e08eed3a616a42$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $36e08eed3a616a42$export$fed62ccc3fb1a568(origin, target) {
    if ($36e08eed3a616a42$export$e5a55ae567dd4ac7.has(origin)) return function(p) {
        return p <= 0 ? origin : target;
    };
    else return function(p) {
        return p >= 1 ? target : origin;
    };
}



function $cd46d4cabe2c2fb8$var$mixNumber(a, b) {
    return function(p) {
        return (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(a, b, p);
    };
}
function $cd46d4cabe2c2fb8$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $cd46d4cabe2c2fb8$var$mixNumber;
    else if (typeof a === "string") return (0, $fa15c42eacb6654d$export$31f9caa2600b5723)(a) ? (0, $1ef66bf338cbe431$export$a6f92d4bae65c0f1) : (0, $d95c076f89c05413$export$35e9368ef982300f).test(a) ? (0, $e29c97e76683f304$export$51e568cf5c039bac) : $cd46d4cabe2c2fb8$export$65516310a87d8205;
    else if (Array.isArray(a)) return $cd46d4cabe2c2fb8$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $d95c076f89c05413$export$35e9368ef982300f).test(a) ? (0, $e29c97e76683f304$export$51e568cf5c039bac) : $cd46d4cabe2c2fb8$export$ebc23b6840c51ba1;
    return 0, $1ef66bf338cbe431$export$a6f92d4bae65c0f1;
}
function $cd46d4cabe2c2fb8$export$3bbefa2f402845c4(a, b) {
    var output = (0, $2us1u._)(a);
    var numValues = output.length;
    var blendValue = a.map(function(v, i) {
        return $cd46d4cabe2c2fb8$export$36ec24672cd098e0(v)(v, b[i]);
    });
    return function(p) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $cd46d4cabe2c2fb8$export$ebc23b6840c51ba1(a, b) {
    var output = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, a, b);
    var blendValue = {};
    for(var key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $cd46d4cabe2c2fb8$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $cd46d4cabe2c2fb8$var$matchOrder(origin, target) {
    var _a;
    var orderedOrigin = [];
    var pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(var i = 0; i < target.values.length; i++){
        var type = target.types[i];
        var originIndex = origin.indexes[type][pointers[type]];
        var originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
var $cd46d4cabe2c2fb8$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $69b61e406d097f9e$export$83a0e34f1302825b).createTransformer(target);
    var originStats = (0, $69b61e406d097f9e$export$b61fc7c44bf646d5)(origin);
    var targetStats = (0, $69b61e406d097f9e$export$b61fc7c44bf646d5)(target);
    var canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $36e08eed3a616a42$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $36e08eed3a616a42$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $36e08eed3a616a42$export$fed62ccc3fb1a568)(origin, target);
        return (0, $34ca4cb779ef64d7$export$a4627e546088548d)($cd46d4cabe2c2fb8$export$3bbefa2f402845c4($cd46d4cabe2c2fb8$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $aaa7e0662adcfa6d$export$491112666e282270)(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."));
        return (0, $1ef66bf338cbe431$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $60ee8ad822e4a9c1$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(from, to, p);
    var mixer = (0, $cd46d4cabe2c2fb8$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $e3acc545efd07b24$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || (0, $60ee8ad822e4a9c1$export$2c9e8a9632a706b2);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] || (0, $fb816313cb795261$export$8793edee2d425525) : ease;
            mixer = (0, $34ca4cb779ef64d7$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $e3acc545efd07b24$export$89e29e4ab65e70a9(input, output) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.clamp, isClamp = tmp === void 0 ? true : tmp, ease = _ref.ease, mixer = _ref.mixer;
    var inputLength = input.length;
    (0, $aaa7e0662adcfa6d$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return function() {
        return output[0];
    };
    if (inputLength === 2 && input[0] === input[1]) return function() {
        return output[1];
    };
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = (0, $2us1u._)(input).reverse();
        output = (0, $2us1u._)(output).reverse();
    }
    var mixers = $e3acc545efd07b24$var$createMixers(output, ease, mixer);
    var numMixers = mixers.length;
    var interpolator = function(v) {
        var i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        var progressInRange = (0, $3369424d70926287$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? function(v) {
        return interpolator((0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v));
    } : interpolator;
}




function $5c97568715680353$export$dafee61230cf05c6(offset, remaining) {
    var min = offset[offset.length - 1];
    for(var i = 1; i <= remaining; i++){
        var offsetProgress = (0, $3369424d70926287$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $05122e86e8495fdb$export$24dbcec0b26e6d9d(arr) {
    var offset = [
        0
    ];
    (0, $5c97568715680353$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $876401b304685bdf$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}


function $b1744b07cfb558f4$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $9721ff6219cfd84c$export$c07234257a03d5e9);
    }).splice(0, values.length - 1);
}
function $b1744b07cfb558f4$export$d25ddfdf17c3ad3e(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? 300 : _param_duration, keyframeValues = param.keyframes, times = param.times, _param_ease = param.ease, ease = _param_ease === void 0 ? "easeInOut" : _param_ease;
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ var easingFunctions = (0, $7aa9428b11c9958c$export$216948827bbdc797)(ease) ? ease.map((0, $d8962e660cd45e90$export$ef97fe084f156ca4)) : (0, $d8962e660cd45e90$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ var absoluteTimes = (0, $876401b304685bdf$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $05122e86e8495fdb$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    var mapTimeToKeyframe = (0, $e3acc545efd07b24$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $b1744b07cfb558f4$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: function(t) {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var $1dd11c685b1e2ba3$export$f4ff70a5b4808fd8 = 20000;
function $1dd11c685b1e2ba3$export$cbdd6b3d40ea54e2(generator) {
    var duration = 0;
    var timeStep = 50;
    var state = generator.next(duration);
    while(!state.done && duration < $1dd11c685b1e2ba3$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $1dd11c685b1e2ba3$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







var $2426491c23a1c522$export$c1033964b5ad7fef = function(update) {
    var passTimestamp = function(param) {
        var timestamp = param.timestamp;
        return update(timestamp);
    };
    return {
        start: function() {
            return (0, $1134021eb916ca42$export$2cef06c20297c17d).update(passTimestamp, true);
        },
        stop: function() {
            return (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(passTimestamp);
        },
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: function() {
            return (0, $1134021eb916ca42$export$fff89137e9e818ce).isProcessing ? (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp : (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
        }
    };
};



var $3abd21d0c4d9d183$var$generators = {
    decay: (0, $1c8a7e32d7d2cabc$export$ee3ff3a17106998),
    inertia: (0, $1c8a7e32d7d2cabc$export$ee3ff3a17106998),
    tween: (0, $b1744b07cfb558f4$export$d25ddfdf17c3ad3e),
    keyframes: (0, $b1744b07cfb558f4$export$d25ddfdf17c3ad3e),
    spring: (0, $5b5837d983fbf340$export$b36281d89752ae66)
};
var $3abd21d0c4d9d183$var$percentToProgress = function(percent) {
    return percent / 100;
};
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ var $3abd21d0c4d9d183$export$fd98d9cca67a58bc = /*#__PURE__*/ function(BaseAnimation) {
    "use strict";
    (0, $j6Mzi._)(MainThreadAnimation, BaseAnimation);
    var _super = (0, $lngen._)(MainThreadAnimation);
    function MainThreadAnimation(_param) {
        (0, $grujF._)(this, MainThreadAnimation);
        var _this;
        var tmp = _param.KeyframeResolver, KeyframeResolver$1 = tmp === void 0 ? (0, $13b26bd7daa0ff86$export$74d34ca3182f1750) : tmp, options = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
            "KeyframeResolver"
        ]);
        _this = _super.call(this, options);
        /**
         * The time at which the animation was paused.
         */ _this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ _this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ _this.cancelTime = null;
        /**
         * The current time of the animation.
         */ _this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ _this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ _this.pendingPlayState = "running";
        _this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ _this.stop = function() {
            _this.resolver.cancel();
            _this.isStopped = true;
            if (_this.state === "idle") return;
            _this.teardown();
            var onStop = _this.options.onStop;
            onStop && onStop();
        };
        var _this_options = _this.options, name = _this_options.name, motionValue = _this_options.motionValue, _$keyframes = _this_options.keyframes;
        var onResolved = function(resolvedKeyframes, finalKeyframe) {
            return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        };
        if (name && motionValue && motionValue.owner) _this.resolver = motionValue.owner.resolveKeyframes(_$keyframes, onResolved, name, motionValue);
        else _this.resolver = new KeyframeResolver$1(_$keyframes, onResolved, name, motionValue);
        _this.resolver.scheduleResolve();
        return _this;
    }
    (0, $dhMkv._)(MainThreadAnimation, [
        {
            key: "initPlayback",
            value: function initPlayback(keyframes$1) {
                var _this_options = this.options, _this_options_type = _this_options.type, type = _this_options_type === void 0 ? "keyframes" : _this_options_type, _this_options_repeat = _this_options.repeat, repeat = _this_options_repeat === void 0 ? 0 : _this_options_repeat, _this_options_repeatDelay = _this_options.repeatDelay, repeatDelay = _this_options_repeatDelay === void 0 ? 0 : _this_options_repeatDelay, repeatType = _this_options.repeatType, _this_options_velocity = _this_options.velocity, velocity = _this_options_velocity === void 0 ? 0 : _this_options_velocity;
                var generatorFactory = $3abd21d0c4d9d183$var$generators[type] || (0, $b1744b07cfb558f4$export$d25ddfdf17c3ad3e);
                /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ var mapPercentToKeyframes;
                var mirroredGenerator;
                if (generatorFactory !== (0, $b1744b07cfb558f4$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
                    mapPercentToKeyframes = (0, $34ca4cb779ef64d7$export$a4627e546088548d)($3abd21d0c4d9d183$var$percentToProgress, (0, $60ee8ad822e4a9c1$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
                    keyframes$1 = [
                        0,
                        100
                    ];
                }
                var generator = generatorFactory((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, this.options), {
                    keyframes: keyframes$1
                }));
                /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, this.options), {
                    keyframes: (0, $2us1u._)(keyframes$1).reverse(),
                    velocity: -velocity
                }));
                /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $1dd11c685b1e2ba3$export$cbdd6b3d40ea54e2)(generator);
                var calculatedDuration = generator.calculatedDuration;
                var resolvedDuration = calculatedDuration + repeatDelay;
                var totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
                return {
                    generator: generator,
                    mirroredGenerator: mirroredGenerator,
                    mapPercentToKeyframes: mapPercentToKeyframes,
                    calculatedDuration: calculatedDuration,
                    resolvedDuration: resolvedDuration,
                    totalDuration: totalDuration
                };
            }
        },
        {
            key: "onPostResolved",
            value: function onPostResolved() {
                var _this_options = this.options, _this_options_autoplay = _this_options.autoplay, autoplay = _this_options_autoplay === void 0 ? true : _this_options_autoplay;
                this.play();
                if (this.pendingPlayState === "paused" || !autoplay) this.pause();
                else this.state = this.pendingPlayState;
            }
        },
        {
            key: "tick",
            value: function tick(timestamp) {
                var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var resolved = this.resolved;
                // If the animations has failed to resolve, return the final keyframe.
                if (!resolved) {
                    var _$keyframes = this.options.keyframes;
                    return {
                        done: true,
                        value: _$keyframes[_$keyframes.length - 1]
                    };
                }
                var finalKeyframe = resolved.finalKeyframe, generator = resolved.generator, mirroredGenerator = resolved.mirroredGenerator, mapPercentToKeyframes = resolved.mapPercentToKeyframes, _$keyframes1 = resolved.keyframes, calculatedDuration = resolved.calculatedDuration, totalDuration = resolved.totalDuration, resolvedDuration = resolved.resolvedDuration;
                if (this.startTime === null) return generator.next(0);
                var _this_options = this.options, delay = _this_options.delay, repeat = _this_options.repeat, repeatType = _this_options.repeatType, repeatDelay = _this_options.repeatDelay, onUpdate = _this_options.onUpdate;
                /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
                else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
                // Update currentTime
                if (sample) this.currentTime = timestamp;
                else if (this.holdTime !== null) this.currentTime = this.holdTime;
                else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
                // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
                // example.
                this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
                // Rebase on delay
                var timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
                var isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
                this.currentTime = Math.max(timeWithoutDelay, 0);
                // If this animation has finished, set the current time  to the total duration.
                if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
                var elapsed = this.currentTime;
                var frameGenerator = generator;
                if (repeat) {
                    /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
                    /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ var currentIteration = Math.floor(progress);
                    /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ var iterationProgress = progress % 1.0;
                    /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
                    iterationProgress === 1 && currentIteration--;
                    currentIteration = Math.min(currentIteration, repeat + 1);
                    /**
             * Reverse progress if we're not running in "normal" direction
             */ var isOddIteration = Boolean(currentIteration % 2);
                    if (isOddIteration) {
                        if (repeatType === "reverse") {
                            iterationProgress = 1 - iterationProgress;
                            if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                        } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
                    }
                    elapsed = (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
                }
                /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ var state = isInDelayPhase ? {
                    done: false,
                    value: _$keyframes1[0]
                } : frameGenerator.next(elapsed);
                if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
                var done = state.done;
                if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
                var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
                if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $0a3f2bb43fc99f38$export$14de59408fad90b)(_$keyframes1, this.options, finalKeyframe);
                if (onUpdate) onUpdate(state.value);
                if (isAnimationFinished) this.finish();
                return state;
            }
        },
        {
            key: "duration",
            get: function get() {
                var resolved = this.resolved;
                return resolved ? (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(this.currentTime);
            },
            set: function set(newTime) {
                newTime = (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(newTime);
                this.currentTime = newTime;
                if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
                else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.playbackSpeed;
            },
            set: function set(newSpeed) {
                var hasChanged = this.playbackSpeed !== newSpeed;
                this.playbackSpeed = newSpeed;
                if (hasChanged) this.time = (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(this.currentTime);
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                if (!this.resolver.isScheduled) this.resolver.resume();
                if (!this._resolved) {
                    this.pendingPlayState = "running";
                    return;
                }
                if (this.isStopped) return;
                var _this_options = this.options, _this_options_driver = _this_options.driver, driver = _this_options_driver === void 0 ? (0, $2426491c23a1c522$export$c1033964b5ad7fef) : _this_options_driver, onPlay = _this_options.onPlay;
                if (!this.driver) this.driver = driver(function(timestamp) {
                    return _this.tick(timestamp);
                });
                onPlay && onPlay();
                var now = this.driver.now();
                if (this.holdTime !== null) this.startTime = now - this.holdTime;
                else if (!this.startTime || this.state === "finished") this.startTime = now;
                if (this.state === "finished") this.updateFinishedPromise();
                this.cancelTime = this.startTime;
                this.holdTime = null;
                /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
                this.driver.start();
            }
        },
        {
            key: "pause",
            value: function pause() {
                var _a;
                if (!this._resolved) {
                    this.pendingPlayState = "paused";
                    return;
                }
                this.state = "paused";
                this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
            }
        },
        {
            key: "complete",
            value: function complete() {
                if (this.state !== "running") this.play();
                this.pendingPlayState = this.state = "finished";
                this.holdTime = null;
            }
        },
        {
            key: "finish",
            value: function finish() {
                this.teardown();
                this.state = "finished";
                var onComplete = this.options.onComplete;
                onComplete && onComplete();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.cancelTime !== null) this.tick(this.cancelTime);
                this.teardown();
                this.updateFinishedPromise();
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.state = "idle";
                this.stopDriver();
                this.resolveFinishedPromise();
                this.updateFinishedPromise();
                this.startTime = this.cancelTime = null;
                this.resolver.cancel();
            }
        },
        {
            key: "stopDriver",
            value: function stopDriver() {
                if (!this.driver) return;
                this.driver.stop();
                this.driver = undefined;
            }
        },
        {
            key: "sample",
            value: function sample(time) {
                this.startTime = 0;
                return this.tick(time, true);
            }
        }
    ]);
    return MainThreadAnimation;
}((0, $94681169bc6ff608$export$d1e4f34b9c2550c1));
// Legacy interface
function $3abd21d0c4d9d183$export$ee9b76de7353d815(options) {
    return new $3abd21d0c4d9d183$export$fd98d9cca67a58bc(options);
}




var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");
var $5deb2a70712574e1$export$ff43f99925d7366b = function(easing) {
    return Array.isArray(easing) && typeof easing[0] === "number";
};


function $ef2412a00a3a5e0a$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $ef2412a00a3a5e0a$export$2cf569f5e2221176 || (0, $5deb2a70712574e1$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($ef2412a00a3a5e0a$export$fcdd8f3f2160beda));
}
var $ef2412a00a3a5e0a$export$2523b8f0bd8f44cb = function(param) {
    var _param = (0, $2nwvT._)(param, 4), a = _param[0], b = _param[1], c = _param[2], d = _param[3];
    return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};
var $ef2412a00a3a5e0a$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $ef2412a00a3a5e0a$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $ef2412a00a3a5e0a$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $ef2412a00a3a5e0a$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $ef2412a00a3a5e0a$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $ef2412a00a3a5e0a$var$mapEasingToNativeEasingWithDefault(easing) {
    return $ef2412a00a3a5e0a$export$916ea73bcd3a6030(easing) || $ef2412a00a3a5e0a$export$2cf569f5e2221176.easeOut;
}
function $ef2412a00a3a5e0a$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $5deb2a70712574e1$export$ff43f99925d7366b)(easing)) return $ef2412a00a3a5e0a$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($ef2412a00a3a5e0a$var$mapEasingToNativeEasingWithDefault);
    else return $ef2412a00a3a5e0a$export$2cf569f5e2221176[easing];
}


function $34f5a979a2495aa3$export$c76cd972d26986f9(element, valueName, keyframes) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration, _ref_repeat = _ref.repeat, repeat = _ref_repeat === void 0 ? 0 : _ref_repeat, _ref_repeatType = _ref.repeatType, repeatType = _ref_repeatType === void 0 ? "loop" : _ref_repeatType, ease = _ref.ease, times = _ref.times;
    var keyframeOptions = (0, $72osQ._)({}, valueName, keyframes);
    if (times) keyframeOptions.offset = times;
    var easing = (0, $ef2412a00a3a5e0a$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




var $10ae706a3b934ab1$var$supportsWaapi = (0, $46569f4cbd18a4ef$export$7c73462e0d25e514)(function() {
    return Object.hasOwnProperty.call(Element.prototype, "animate");
});
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ var $10ae706a3b934ab1$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var $10ae706a3b934ab1$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $10ae706a3b934ab1$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $ef2412a00a3a5e0a$export$fcdd8f3f2160beda)(options.ease);
}
function $10ae706a3b934ab1$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ var sampleAnimation = new (0, $3abd21d0c4d9d183$export$fd98d9cca67a58bc)((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options), {
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    }));
    var state = {
        done: false,
        value: keyframes[0]
    };
    var pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ var t = 0;
    while(!state.done && t < $10ae706a3b934ab1$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $10ae706a3b934ab1$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $10ae706a3b934ab1$var$sampleDelta,
        ease: "linear"
    };
}
var $10ae706a3b934ab1$export$2a45abb4e6513325 = /*#__PURE__*/ function(BaseAnimation) {
    "use strict";
    (0, $j6Mzi._)(AcceleratedAnimation, BaseAnimation);
    var _super = (0, $lngen._)(AcceleratedAnimation);
    function AcceleratedAnimation(options) {
        (0, $grujF._)(this, AcceleratedAnimation);
        var _this;
        _this = _super.call(this, options);
        var _this_options = _this.options, name = _this_options.name, motionValue = _this_options.motionValue, keyframes = _this_options.keyframes;
        _this.resolver = new (0, $7bfe4cc0123b898c$export$4983792d11b61017)(keyframes, function(resolvedKeyframes, finalKeyframe) {
            return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        }, name, motionValue);
        _this.resolver.scheduleResolve();
        return _this;
    }
    (0, $dhMkv._)(AcceleratedAnimation, [
        {
            key: "initPlayback",
            value: function initPlayback(keyframes, finalKeyframe) {
                var _this = this;
                var _a;
                var _this_options = this.options, _this_options_duration = _this_options.duration, duration = _this_options_duration === void 0 ? 300 : _this_options_duration, times = _this_options.times, ease = _this_options.ease, type = _this_options.type, motionValue = _this_options.motionValue, name = _this_options.name;
                /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
                /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($10ae706a3b934ab1$var$requiresPregeneratedKeyframes(this.options)) {
                    var _this_options1 = this.options, onComplete = _this_options1.onComplete, onUpdate = _this_options1.onUpdate, motionValue1 = _this_options1.motionValue, options = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_this_options1, [
                        "onComplete",
                        "onUpdate",
                        "motionValue"
                    ]);
                    var pregeneratedAnimation = $10ae706a3b934ab1$var$pregenerateKeyframes(keyframes, options);
                    keyframes = pregeneratedAnimation.keyframes;
                    // If this is a very short animation, ensure we have
                    // at least two keyframes to animate between as older browsers
                    // can't animate between a single keyframe.
                    if (keyframes.length === 1) keyframes[1] = keyframes[0];
                    duration = pregeneratedAnimation.duration;
                    times = pregeneratedAnimation.times;
                    ease = pregeneratedAnimation.ease;
                    type = "keyframes";
                }
                var animation = (0, $34f5a979a2495aa3$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, this.options), {
                    duration: duration,
                    times: times,
                    ease: ease
                }));
                // Override the browser calculated startTime with one synchronised to other JS
                // and WAAPI animations starting this event loop.
                animation.startTime = (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
                if (this.pendingTimeline) {
                    animation.timeline = this.pendingTimeline;
                    this.pendingTimeline = undefined;
                } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = function() {
                    var onComplete = _this.options.onComplete;
                    motionValue.set((0, $0a3f2bb43fc99f38$export$14de59408fad90b)(keyframes, _this.options, finalKeyframe));
                    onComplete && onComplete();
                    _this.cancel();
                    _this.resolveFinishedPromise();
                };
                return {
                    animation: animation,
                    duration: duration,
                    times: times,
                    type: type,
                    ease: ease,
                    keyframes: keyframes
                };
            }
        },
        {
            key: "duration",
            get: function get() {
                var resolved = this.resolved;
                if (!resolved) return 0;
                var duration = resolved.duration;
                return (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(duration);
            }
        },
        {
            key: "time",
            get: function get() {
                var resolved = this.resolved;
                if (!resolved) return 0;
                var animation = resolved.animation;
                return (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
            },
            set: function set(newTime) {
                var resolved = this.resolved;
                if (!resolved) return;
                var animation = resolved.animation;
                animation.currentTime = (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(newTime);
            }
        },
        {
            key: "speed",
            get: function get() {
                var resolved = this.resolved;
                if (!resolved) return 1;
                var animation = resolved.animation;
                return animation.playbackRate;
            },
            set: function set(newSpeed) {
                var resolved = this.resolved;
                if (!resolved) return;
                var animation = resolved.animation;
                animation.playbackRate = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                var resolved = this.resolved;
                if (!resolved) return "idle";
                var animation = resolved.animation;
                return animation.playState;
            }
        },
        {
            /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ key: "attachTimeline",
            value: function attachTimeline(timeline) {
                if (!this._resolved) this.pendingTimeline = timeline;
                else {
                    var resolved = this.resolved;
                    if (!resolved) return 0, $fb816313cb795261$export$8793edee2d425525;
                    var animation = resolved.animation;
                    animation.timeline = timeline;
                    animation.onfinish = null;
                }
                return 0, $fb816313cb795261$export$8793edee2d425525;
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.isStopped) return;
                var resolved = this.resolved;
                if (!resolved) return;
                var animation = resolved.animation;
                if (animation.playState === "finished") this.updateFinishedPromise();
                animation.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                var resolved = this.resolved;
                if (!resolved) return;
                var animation = resolved.animation;
                animation.pause();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.resolver.cancel();
                this.isStopped = true;
                if (this.state === "idle") return;
                var resolved = this.resolved;
                if (!resolved) return;
                var animation = resolved.animation, keyframes = resolved.keyframes, duration = resolved.duration, type = resolved.type, ease = resolved.ease, times = resolved.times;
                if (animation.playState === "idle" || animation.playState === "finished") return;
                /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
                    var _this_options = this.options, motionValue = _this_options.motionValue, onUpdate = _this_options.onUpdate, onComplete = _this_options.onComplete, options = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_this_options, [
                        "motionValue",
                        "onUpdate",
                        "onComplete"
                    ]);
                    var sampleAnimation = new (0, $3abd21d0c4d9d183$export$fd98d9cca67a58bc)((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options), {
                        keyframes: keyframes,
                        duration: duration,
                        type: type,
                        ease: ease,
                        times: times,
                        isGenerator: true
                    }));
                    var sampleTime = (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(this.time);
                    motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $10ae706a3b934ab1$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $10ae706a3b934ab1$var$sampleDelta);
                }
                var onStop = this.options.onStop;
                onStop && onStop();
                this.cancel();
            }
        },
        {
            key: "complete",
            value: function complete() {
                var resolved = this.resolved;
                if (!resolved) return;
                resolved.animation.finish();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var resolved = this.resolved;
                if (!resolved) return;
                resolved.animation.cancel();
            }
        }
    ], [
        {
            key: "supports",
            value: function supports(options) {
                var motionValue = options.motionValue, name = options.name, repeatDelay = options.repeatDelay, repeatType = options.repeatType, damping = options.damping, type = options.type;
                return $10ae706a3b934ab1$var$supportsWaapi() && name && (0, $acd27adf2695813d$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
            }
        }
    ]);
    return AcceleratedAnimation;
}((0, $94681169bc6ff608$export$d1e4f34b9c2550c1));




var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

function $141405bd19b8d143$export$b4f1bbab0c442a76(update, timeline) {
    var prevProgress;
    var onFrame = function() {
        var currentTime = timeline.currentTime;
        var percentage = currentTime === null ? 0 : currentTime.value;
        var progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $1134021eb916ca42$export$2cef06c20297c17d).update(onFrame, true);
    return function() {
        return (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(onFrame);
    };
}



var $b644b7ec981a3a45$export$20d68f04f30763a5 = (0, $46569f4cbd18a4ef$export$7c73462e0d25e514)(function() {
    return window.ScrollTimeline !== undefined;
});


var $779be5f0b3e748e5$export$c1e41718f71efe41 = /*#__PURE__*/ function() {
    "use strict";
    function GroupPlaybackControls(animations) {
        var _this = this;
        (0, $grujF._)(this, GroupPlaybackControls);
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = function() {
            return _this.runAll("stop");
        };
        this.animations = animations.filter(Boolean);
    }
    (0, $dhMkv._)(GroupPlaybackControls, [
        {
            key: "then",
            value: function then(onResolve, onReject) {
                return Promise.all(this.animations).then(onResolve).catch(onReject);
            }
        },
        {
            /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ key: "getAll",
            value: function getAll(propName) {
                return this.animations[0][propName];
            }
        },
        {
            key: "setAll",
            value: function setAll(propName, newValue) {
                for(var i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                var cancelAll = this.animations.map(function(animation) {
                    if ((0, $b644b7ec981a3a45$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
                    else {
                        animation.pause();
                        return (0, $141405bd19b8d143$export$b4f1bbab0c442a76)(function(progress) {
                            animation.time = animation.duration * progress;
                        }, timeline);
                    }
                });
                return function() {
                    cancelAll.forEach(function(cancelTimeline, i) {
                        if (cancelTimeline) cancelTimeline();
                        _this.animations[i].stop();
                    });
                };
            }
        },
        {
            key: "time",
            get: function get() {
                return this.getAll("time");
            },
            set: function set(time) {
                this.setAll("time", time);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.getAll("speed");
            },
            set: function set(speed) {
                this.setAll("speed", speed);
            }
        },
        {
            key: "duration",
            get: function get() {
                var max = 0;
                for(var i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
                return max;
            }
        },
        {
            key: "runAll",
            value: function runAll(methodName) {
                this.animations.forEach(function(controls) {
                    return controls[methodName]();
                });
            }
        },
        {
            key: "play",
            value: function play() {
                this.runAll("play");
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.runAll("pause");
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.runAll("cancel");
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.runAll("complete");
            }
        }
    ]);
    return GroupPlaybackControls;
}();


var $e9a361abb303d2a2$export$90b3dfc33ff3548 = function(name, value, target) {
    var transition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, element = arguments.length > 4 ? arguments[4] : void 0, isHandoff = arguments.length > 5 ? arguments[5] : void 0, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd = arguments.length > 6 ? arguments[6] : void 0;
    return function(onComplete) {
        var valueTransition = (0, $a113484cc917d77a$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ var delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ var _transition_elapsed = transition.elapsed, elapsed = _transition_elapsed === void 0 ? 0 : _transition_elapsed;
        elapsed = elapsed - (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(delay);
        var options = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: function(v) {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: function() {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $a113484cc917d77a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options, (0, $30dad1ee1f8213dc$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        var shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $f780fab6a2a70141$export$888a3d84909f9e3d).current || (0, $edee933072dcb548$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            var finalKeyframe = (0, $0a3f2bb43fc99f38$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $1134021eb916ca42$export$2cef06c20297c17d).update(function() {
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $779be5f0b3e748e5$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $10ae706a3b934ab1$export$2a45abb4e6513325).supports(options)) return new (0, $10ae706a3b934ab1$export$2a45abb4e6513325)(options);
        else return new (0, $3abd21d0c4d9d183$export$fd98d9cca67a58bc)(options);
    };
};






var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $520c7c228cb8ad64$export$e7dff9482a5fd23c = /*#__PURE__*/ function() {
    "use strict";
    function SubscriptionManager() {
        (0, $grujF._)(this, SubscriptionManager);
        this.subscriptions = [];
    }
    (0, $dhMkv._)(SubscriptionManager, [
        {
            key: "add",
            value: function add(handler) {
                var _this = this;
                (0, $240b8108c1be092c$export$20e507e47fae79fd)(this.subscriptions, handler);
                return function() {
                    return (0, $240b8108c1be092c$export$fe2d9b4e03920b4c)(_this.subscriptions, handler);
                };
            }
        },
        {
            key: "notify",
            value: function notify(a, b, c) {
                var numSubscriptions = this.subscriptions.length;
                if (!numSubscriptions) return;
                if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
                else for(var i = 0; i < numSubscriptions; i++){
                    /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
                    handler && handler(a, b, c);
                }
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.subscriptions.length;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.subscriptions.length = 0;
            }
        }
    ]);
    return SubscriptionManager;
}();






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ var $bde97c2bbeed274b$var$MAX_VELOCITY_DELTA = 30;
var $bde97c2bbeed274b$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
var $bde97c2bbeed274b$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $bde97c2bbeed274b$export$8cea36d14ee64562 = /*#__PURE__*/ function() {
    "use strict";
    function MotionValue(init) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _this = this;
        (0, $grujF._)(this, MotionValue);
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.3.6";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = function(v) {
            var render = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var currentTime = (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (_this.updatedAt !== currentTime) _this.setPrevFrameValue();
            _this.prev = _this.current;
            _this.setCurrent(v);
            // Update update subscribers
            if (_this.current !== _this.prev && _this.events.change) _this.events.change.notify(_this.current);
            // Update render subscribers
            if (render && _this.events.renderRequest) _this.events.renderRequest.notify(_this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    (0, $dhMkv._)(MotionValue, [
        {
            key: "setCurrent",
            value: function setCurrent(current) {
                this.current = current;
                this.updatedAt = (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
                if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $bde97c2bbeed274b$var$isFloat(this.current);
            }
        },
        {
            key: "setPrevFrameValue",
            value: function setPrevFrameValue() {
                var prevFrameValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.current;
                this.prevFrameValue = prevFrameValue;
                this.prevUpdatedAt = this.updatedAt;
            }
        },
        {
            /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ key: "onChange",
            value: function onChange(subscription) {
                return this.on("change", subscription);
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                var _this = this;
                if (!this.events[eventName]) this.events[eventName] = new (0, $520c7c228cb8ad64$export$e7dff9482a5fd23c)();
                var unsubscribe = this.events[eventName].add(callback);
                if (eventName === "change") return function() {
                    unsubscribe();
                    /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $1134021eb916ca42$export$2cef06c20297c17d).read(function() {
                        if (!_this.events.change.getSize()) _this.stop();
                    });
                };
                return unsubscribe;
            }
        },
        {
            key: "clearListeners",
            value: function clearListeners() {
                for(var eventManagers in this.events)this.events[eventManagers].clear();
            }
        },
        {
            /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ key: "attach",
            value: function attach(passiveEffect, stopPassiveEffect) {
                this.passiveEffect = passiveEffect;
                this.stopPassiveEffect = stopPassiveEffect;
            }
        },
        {
            /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ key: "set",
            value: function set(v) {
                var render = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
                else this.passiveEffect(v, this.updateAndNotify);
            }
        },
        {
            key: "setWithVelocity",
            value: function setWithVelocity(prev, current, delta) {
                this.set(current);
                this.prev = undefined;
                this.prevFrameValue = prev;
                this.prevUpdatedAt = this.updatedAt - delta;
            }
        },
        {
            /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ key: "jump",
            value: function jump(v) {
                var endAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.updateAndNotify(v);
                this.prev = v;
                this.prevUpdatedAt = this.prevFrameValue = undefined;
                endAnimation && this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        },
        {
            /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ key: "get",
            value: function get() {
                if ($bde97c2bbeed274b$export$67fcd818a264039d.current) $bde97c2bbeed274b$export$67fcd818a264039d.current.push(this);
                return this.current;
            }
        },
        {
            /**
     * @public
     */ key: "getPrevious",
            value: function getPrevious() {
                return this.prev;
            }
        },
        {
            /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ key: "getVelocity",
            value: function getVelocity() {
                var currentTime = (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
                if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $bde97c2bbeed274b$var$MAX_VELOCITY_DELTA) return 0;
                var delta = Math.min(this.updatedAt - this.prevUpdatedAt, $bde97c2bbeed274b$var$MAX_VELOCITY_DELTA);
                // Casts because of parseFloat's poor typing
                return (0, $076f367f29e64da6$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
            }
        },
        {
            /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ key: "start",
            value: function start(startAnimation) {
                var _this = this;
                this.stop();
                return new Promise(function(resolve) {
                    _this.hasAnimated = true;
                    _this.animation = startAnimation(resolve);
                    if (_this.events.animationStart) _this.events.animationStart.notify();
                }).then(function() {
                    if (_this.events.animationComplete) _this.events.animationComplete.notify();
                    _this.clearAnimation();
                });
            }
        },
        {
            /**
     * Stop the currently active animation.
     *
     * @public
     */ key: "stop",
            value: function stop() {
                if (this.animation) {
                    this.animation.stop();
                    if (this.events.animationCancel) this.events.animationCancel.notify();
                }
                this.clearAnimation();
            }
        },
        {
            /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ key: "isAnimating",
            value: function isAnimating() {
                return !!this.animation;
            }
        },
        {
            key: "clearAnimation",
            value: function clearAnimation() {
                delete this.animation;
            }
        },
        {
            /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ key: "destroy",
            value: function destroy() {
                this.clearListeners();
                this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        }
    ]);
    return MotionValue;
}();
function $bde97c2bbeed274b$export$ce8bdc721e76545f(init, options) {
    return new $bde97c2bbeed274b$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $debc911be3c26118$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $bde97c2bbeed274b$export$ce8bdc721e76545f)(value));
}
function $debc911be3c26118$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $73f2f95224ec0d43$export$7b1b1c981f4f0558)(visualElement, definition);
    var _ref = resolved || {}, _ref_transitionEnd = _ref.transitionEnd, transitionEnd = _ref_transitionEnd === void 0 ? {} : _ref_transitionEnd, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? {} : _ref_transition, target = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, target, transitionEnd);
    for(var key in target){
        var value = (0, $dbfd1ed8c0784204$export$5485128c47bd48bb)(target[key]);
        $debc911be3c26118$var$setMotionValue(visualElement, key, value);
    }
}




function $6334040f84a80be4$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $de72616665b27730$export$8592e1c077c890a6];
}



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");




var $8ffb6172f4d02031$export$3fe5fa490af65f85 = /*#__PURE__*/ function(MotionValue) {
    "use strict";
    (0, $j6Mzi._)(WillChangeMotionValue, MotionValue);
    var _super = (0, $lngen._)(WillChangeMotionValue);
    function WillChangeMotionValue() {
        (0, $grujF._)(this, WillChangeMotionValue);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.output = [];
        _this.counts = new Map();
        return _this;
    }
    (0, $dhMkv._)(WillChangeMotionValue, [
        {
            key: "add",
            value: function add(name) {
                var _this = this;
                var styleName = (0, $574a8a1d2e0b35cc$export$b3f9dd865b560c6)(name);
                if (!styleName) return;
                /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ var prevCount = this.counts.get(styleName) || 0;
                this.counts.set(styleName, prevCount + 1);
                if (prevCount === 0) {
                    this.output.push(styleName);
                    this.update();
                }
                /**
         * Prevents the remove function from being called multiple times.
         */ var hasRemoved = false;
                return function() {
                    if (hasRemoved) return;
                    hasRemoved = true;
                    var newCount = _this.counts.get(styleName) - 1;
                    _this.counts.set(styleName, newCount);
                    if (newCount === 0) {
                        (0, $240b8108c1be092c$export$fe2d9b4e03920b4c)(_this.output, styleName);
                        _this.update();
                    }
                };
            }
        },
        {
            key: "update",
            value: function update() {
                this.set(this.output.length ? this.output.join(", ") : "auto");
            }
        }
    ]);
    return WillChangeMotionValue;
}((0, $bde97c2bbeed274b$export$8cea36d14ee64562));
function $8ffb6172f4d02031$export$384afe146fc0c056() {
    return (0, $aa070268e56bbe37$export$fe4300aa8eebea86)(function() {
        return new $8ffb6172f4d02031$export$3fe5fa490af65f85("auto");
    });
}



function $851bd87414310d5a$export$98397f3adbf6259f(value) {
    return Boolean((0, $719c6b4fb69ff79d$export$605d60a2578142d3)(value) && value.add);
}


function $26200d9f5f242395$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    var willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $8ffb6172f4d02031$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $851bd87414310d5a$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $e84464b742e0ec31$var$shouldBlockAnimation(param, key) {
    var protectedKeys = param.protectedKeys, needsAnimating = param.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $e84464b742e0ec31$export$68cacfeee78d98d2(visualElement, targetAndTransition) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, transitionOverride = _ref.transitionOverride, type = _ref.type;
    var _a;
    var _targetAndTransition_transition = targetAndTransition.transition, transition = _targetAndTransition_transition === void 0 ? visualElement.getDefaultTransition() : _targetAndTransition_transition, transitionEnd = targetAndTransition.transitionEnd, target = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(var key in target){
        var value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        var valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $e84464b742e0ec31$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
            delay: delay,
            elapsed: 0
        }, (0, $a113484cc917d77a$export$7c1391340308742e)(transition || {}, key));
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ var isHandoff = false;
        if (window.HandoffAppearAnimations) {
            var appearId = (0, $6334040f84a80be4$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                var elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $1134021eb916ca42$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $e9a361abb303d2a2$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $26200d9f5f242395$export$3ac5aed310be0bee)(visualElement, key)));
        var animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(function() {
        (0, $1134021eb916ca42$export$2cef06c20297c17d).update(function() {
            transitionEnd && (0, $debc911be3c26118$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}





var $2nwvT = parcelRequire("2nwvT");


function $5a8955c615d28bfc$export$4709dc300705b2af(visualElement, variant) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _a;
    var resolved = (0, $73f2f95224ec0d43$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    var _ref = resolved || {}, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? visualElement.getDefaultTransition() || {} : _ref_transition;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return Promise.all((0, $e84464b742e0ec31$export$68cacfeee78d98d2)(visualElement, resolved, options));
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function() {
        var forwardDelay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _transition_delayChildren = transition.delayChildren, delayChildren = _transition_delayChildren === void 0 ? 0 : _transition_delayChildren, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $5a8955c615d28bfc$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _ref1 = (0, $2nwvT._)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _ref1[0], last = _ref1[1];
        return first().then(function() {
            return last();
        });
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $5a8955c615d28bfc$var$animateChildren(visualElement, variant) {
    var delayChildren = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, staggerChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerDirection = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, options = arguments.length > 5 ? arguments[5] : void 0;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return i * staggerChildren;
    } : function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($5a8955c615d28bfc$export$523a0bedf33ad781).forEach(function(child, i) {
        child.notify("AnimationStart", variant);
        animations.push($5a8955c615d28bfc$export$4709dc300705b2af(child, variant, (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notify("AnimationComplete", variant);
        }));
    });
    return Promise.all(animations);
}
function $5a8955c615d28bfc$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}



function $fa895be873988539$export$ff62cf473653f109(visualElement, definition) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    visualElement.notify("AnimationStart", definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return (0, $5a8955c615d28bfc$export$4709dc300705b2af)(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $5a8955c615d28bfc$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $73f2f95224ec0d43$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $e84464b742e0ec31$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(function() {
        (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
            visualElement.notify("AnimationComplete", definition);
        });
    });
}


var $a510560c83c41c68$var$reversePriorityOrder = (0, $2us1u._)((0, $1500c6a0728839ac$export$16e45afcc206d3a8)).reverse();
var $a510560c83c41c68$var$numAnimationTypes = (0, $1500c6a0728839ac$export$16e45afcc206d3a8).length;
function $a510560c83c41c68$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(param) {
            var animation = param.animation, options = param.options;
            return (0, $fa895be873988539$export$ff62cf473653f109)(visualElement, animation, options);
        }));
    };
}
function $a510560c83c41c68$export$bb53502b7a672aa8(visualElement) {
    var animate = $a510560c83c41c68$var$animateList(visualElement);
    var state = $a510560c83c41c68$var$createState();
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(type) {
        return function(acc, definition) {
            var _a;
            var resolved = (0, $73f2f95224ec0d43$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                var transition = resolved.transition, transitionEnd = resolved.transitionEnd, target = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        var _loop = function(i) {
            var _animations;
            var type = $a510560c83c41c68$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = props[type] !== undefined ? props[type] : context[type];
            var propIsVariant = (0, $e0f40a620bc45744$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $4ee7515c1ffdc148$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $a510560c83c41c68$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            var handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _typeState_prevResolvedValues = typeState.prevResolvedValues, prevResolvedValues = _typeState_prevResolvedValues === void 0 ? {} : _typeState_prevResolvedValues;
            var allKeys = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, prevResolvedValues, resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ var valueHasChanged = false;
                if ((0, $0fad434c33d9e872$export$9153ad4c4999f4a0)(next) && (0, $0fad434c33d9e872$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $7471e449acc6dd77$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, encounteredKeys, resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) (_animations = animations).push.apply(_animations, (0, $2us1u._)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: {
                        type: type
                    }
                };
            })));
        };
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $a510560c83c41c68$var$numAnimationTypes; i++)_loop(i);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        },
        reset: function() {
            state = $a510560c83c41c68$var$createState();
            isInitialRender = true;
        }
    };
}
function $a510560c83c41c68$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $7471e449acc6dd77$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $a510560c83c41c68$var$createTypeState() {
    var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $a510560c83c41c68$var$createState() {
    return {
        animate: $a510560c83c41c68$var$createTypeState(true),
        whileInView: $a510560c83c41c68$var$createTypeState(),
        whileHover: $a510560c83c41c68$var$createTypeState(),
        whileTap: $a510560c83c41c68$var$createTypeState(),
        whileDrag: $a510560c83c41c68$var$createTypeState(),
        whileFocus: $a510560c83c41c68$var$createTypeState(),
        exit: $a510560c83c41c68$var$createTypeState()
    };
}



var $c3d76a5dbb926afc$export$b45b3fe5caabdca = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(AnimationFeature, Feature);
    var _super = (0, $lngen._)(AnimationFeature);
    function AnimationFeature(node) {
        (0, $grujF._)(this, AnimationFeature);
        var _this = _super.call(this, node);
        node.animationState || (node.animationState = (0, $a510560c83c41c68$export$bb53502b7a672aa8)(node));
        return _this;
    }
    (0, $dhMkv._)(AnimationFeature, [
        {
            key: "updateAnimationControlsSubscription",
            value: function updateAnimationControlsSubscription() {
                var animate = this.node.getProps().animate;
                if ((0, $4ee7515c1ffdc148$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
            }
        },
        {
            /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ key: "mount",
            value: function mount() {
                this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "update",
            value: function update() {
                var animate = this.node.getProps().animate;
                var _ref = this.node.prevProps || {}, prevAnimate = _ref.animate;
                if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _a;
                this.node.animationState.reset();
                (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
            }
        }
    ]);
    return AnimationFeature;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");

var $cb76ef4145f3ff30$var$id = 0;
var $cb76ef4145f3ff30$export$4989d1eb6104cc6c = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(ExitAnimationFeature, Feature);
    var _super = (0, $lngen._)(ExitAnimationFeature);
    function ExitAnimationFeature() {
        (0, $grujF._)(this, ExitAnimationFeature);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = $cb76ef4145f3ff30$var$id++;
        return _this;
    }
    (0, $dhMkv._)(ExitAnimationFeature, [
        {
            key: "update",
            value: function update() {
                var _this = this;
                if (!this.node.presenceContext) return;
                var _this_node_presenceContext = this.node.presenceContext, isPresent = _this_node_presenceContext.isPresent, onExitComplete = _this_node_presenceContext.onExitComplete;
                var _ref = this.node.prevPresenceContext || {}, prevIsPresent = _ref.isPresent;
                if (!this.node.animationState || isPresent === prevIsPresent) return;
                var exitAnimation = this.node.animationState.setActive("exit", !isPresent);
                if (onExitComplete && !isPresent) exitAnimation.then(function() {
                    return onExitComplete(_this.id);
                });
            }
        },
        {
            key: "mount",
            value: function mount() {
                var register = (this.node.presenceContext || {}).register;
                if (register) this.unmount = register(this.id);
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return ExitAnimationFeature;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));


var $be27ed77b2e5a032$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $c3d76a5dbb926afc$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $cb76ef4145f3ff30$export$4989d1eb6104cc6c)
    }
};



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");




var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");






var $6a348c772548332b$export$9f17032d917177de = function(a, b) {
    return Math.abs(a - b);
};
function $6a348c772548332b$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    var xDelta = $6a348c772548332b$export$9f17032d917177de(a.x, b.x);
    var yDelta = $6a348c772548332b$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}




/**
 * @internal
 */ var $9b6dc319aac82545$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    "use strict";
    function PanSession(event, handlers) {
        var _this = this;
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, transformPagePoint = _ref.transformPagePoint, contextWindow = _ref.contextWindow, _ref_dragSnapToOrigin = _ref.dragSnapToOrigin, dragSnapToOrigin = _ref_dragSnapToOrigin === void 0 ? false : _ref_dragSnapToOrigin;
        (0, $grujF._)(this, PanSession);
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $9b6dc319aac82545$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $6a348c772548332b$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp;
            _this.history.push((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            }));
            var _this_handlers = _this.handlers, onStart = _this_handlers.onStart, onMove = _this_handlers.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $9b6dc319aac82545$var$transformPoint(info, _this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $1134021eb916ca42$export$2cef06c20297c17d).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _this_handlers = _this.handlers, onEnd = _this_handlers.onEnd, onSessionEnd = _this_handlers.onSessionEnd, resumeAnimation = _this_handlers.resumeAnimation;
            if (_this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var panInfo = $9b6dc319aac82545$var$getPanInfo(event.type === "pointercancel" ? _this.lastMoveEventInfo : $9b6dc319aac82545$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $07b957812985c680$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        var info = (0, $3bcd6d32796288e9$export$12f84bb882d06e1a)(event);
        var initialInfo = $9b6dc319aac82545$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp;
        this.history = [
            (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $9b6dc319aac82545$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $34ca4cb779ef64d7$export$a4627e546088548d)((0, $db69ad6144494a98$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $db69ad6144494a98$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $db69ad6144494a98$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    (0, $dhMkv._)(PanSession, [
        {
            key: "updateHandlers",
            value: function updateHandlers(handlers) {
                this.handlers = handlers;
            }
        },
        {
            key: "end",
            value: function end() {
                this.removeListeners && this.removeListeners();
                (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(this.updatePoint);
            }
        }
    ]);
    return PanSession;
}();
function $9b6dc319aac82545$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $9b6dc319aac82545$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $9b6dc319aac82545$var$getPanInfo(param, history) {
    var point = param.point;
    return {
        point: point,
        delta: $9b6dc319aac82545$var$subtractPoint(point, $9b6dc319aac82545$var$lastDevicePoint(history)),
        offset: $9b6dc319aac82545$var$subtractPoint(point, $9b6dc319aac82545$var$startDevicePoint(history)),
        velocity: $9b6dc319aac82545$var$getVelocity(history, 0.1)
    };
}
function $9b6dc319aac82545$var$startDevicePoint(history) {
    return history[0];
}
function $9b6dc319aac82545$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $9b6dc319aac82545$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $9b6dc319aac82545$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $961b5de3ad585623$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (0, $961b5de3ad585623$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







var $3fdd03eb18d7c56c$var$SCALE_PRECISION = 0.0001;
var $3fdd03eb18d7c56c$var$SCALE_MIN = 1 - $3fdd03eb18d7c56c$var$SCALE_PRECISION;
var $3fdd03eb18d7c56c$var$SCALE_MAX = 1 + $3fdd03eb18d7c56c$var$SCALE_PRECISION;
var $3fdd03eb18d7c56c$var$TRANSLATE_PRECISION = 0.01;
var $3fdd03eb18d7c56c$var$TRANSLATE_MIN = 0 - $3fdd03eb18d7c56c$var$TRANSLATE_PRECISION;
var $3fdd03eb18d7c56c$var$TRANSLATE_MAX = 0 + $3fdd03eb18d7c56c$var$TRANSLATE_PRECISION;
function $3fdd03eb18d7c56c$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $3fdd03eb18d7c56c$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $3fdd03eb18d7c56c$export$e90fc1ae5e3e48ed(delta, source, target) {
    var origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $3fdd03eb18d7c56c$export$c1c127004b72a37(target) / $3fdd03eb18d7c56c$export$c1c127004b72a37(source);
    delta.translate = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $3fdd03eb18d7c56c$var$SCALE_MIN && delta.scale <= $3fdd03eb18d7c56c$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1;
    if (delta.translate >= $3fdd03eb18d7c56c$var$TRANSLATE_MIN && delta.translate <= $3fdd03eb18d7c56c$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0;
}
function $3fdd03eb18d7c56c$export$c0d25e96fc67d310(delta, source, target, origin) {
    $3fdd03eb18d7c56c$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $3fdd03eb18d7c56c$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $3fdd03eb18d7c56c$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $3fdd03eb18d7c56c$export$c1c127004b72a37(relative);
}
function $3fdd03eb18d7c56c$export$426154f9d100f99(target, relative, parent) {
    $3fdd03eb18d7c56c$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $3fdd03eb18d7c56c$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $3fdd03eb18d7c56c$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $3fdd03eb18d7c56c$export$c1c127004b72a37(layout);
}
function $3fdd03eb18d7c56c$export$2785bfcc929c5650(target, layout, parent) {
    $3fdd03eb18d7c56c$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $3fdd03eb18d7c56c$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $85e4cd4bd9da141a$export$b3c764d3fca3ffe3(point, param, elastic) {
    var min = param.min, max = param.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $85e4cd4bd9da141a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $85e4cd4bd9da141a$export$4e9195bf7793bc78(layoutBox, param) {
    var top = param.top, left = param.left, bottom = param.bottom, right = param.right;
    return {
        x: $85e4cd4bd9da141a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $85e4cd4bd9da141a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $85e4cd4bd9da141a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    var ref;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) ref = [
        max,
        min
    ], min = ref[0], max = ref[1], ref;
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $85e4cd4bd9da141a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $85e4cd4bd9da141a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $85e4cd4bd9da141a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $85e4cd4bd9da141a$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(source);
    var targetLength = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3369424d70926287$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3369424d70926287$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $85e4cd4bd9da141a$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $85e4cd4bd9da141a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $85e4cd4bd9da141a$export$7c5eaef8f4723d22() {
    var dragElastic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $85e4cd4bd9da141a$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $85e4cd4bd9da141a$export$a3366d3bac43a742;
    return {
        x: $85e4cd4bd9da141a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $85e4cd4bd9da141a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $85e4cd4bd9da141a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $85e4cd4bd9da141a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $85e4cd4bd9da141a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $85e4cd4bd9da141a$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


var $663055bf986a28b3$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $663055bf986a28b3$export$3d227df54007d73a = function() {
    return {
        x: $663055bf986a28b3$export$ff25708b37f72782(),
        y: $663055bf986a28b3$export$ff25708b37f72782()
    };
};
var $663055bf986a28b3$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $663055bf986a28b3$export$6459fc9e86be362e = function() {
    return {
        x: $663055bf986a28b3$export$6db76765312617ac(),
        y: $663055bf986a28b3$export$6db76765312617ac()
    };
};


function $61436e0004160986$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $1c15c7a4cd4e1645$export$d3955c6a8f65a36b(param) {
    var top = param.top, left = param.left, right = param.right, bottom = param.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $1c15c7a4cd4e1645$export$b6b9cd4198191a47(param) {
    var x = param.x, y = param.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $1c15c7a4cd4e1645$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $9b4f6a65c1609be2$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $9b4f6a65c1609be2$export$bdf30dca883ea463(param) {
    var scale = param.scale, scaleX = param.scaleX, scaleY = param.scaleY;
    return !$9b4f6a65c1609be2$var$isIdentityScale(scale) || !$9b4f6a65c1609be2$var$isIdentityScale(scaleX) || !$9b4f6a65c1609be2$var$isIdentityScale(scaleY);
}
function $9b4f6a65c1609be2$export$a545127cf1fbb600(values) {
    return $9b4f6a65c1609be2$export$bdf30dca883ea463(values) || $9b4f6a65c1609be2$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $9b4f6a65c1609be2$export$bf80f5f8f4dc327f(values) {
    return $9b4f6a65c1609be2$var$is2DTranslate(values.x) || $9b4f6a65c1609be2$var$is2DTranslate(values.y);
}
function $9b4f6a65c1609be2$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $a3660d4bbd841766$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $a3660d4bbd841766$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $a3660d4bbd841766$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $a3660d4bbd841766$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $a3660d4bbd841766$export$e8e3a712e9ebf422(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, originPoint = arguments.length > 3 ? arguments[3] : void 0, boxScale = arguments.length > 4 ? arguments[4] : void 0;
    axis.min = $a3660d4bbd841766$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a3660d4bbd841766$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $a3660d4bbd841766$export$d80074982803af5c(box, param) {
    var x = param.x, y = param.y;
    $a3660d4bbd841766$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $a3660d4bbd841766$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $a3660d4bbd841766$export$e2a980535c55eabb(box, treeScale, treePath) {
    var isSharedTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ var visualElement = node.options.visualElement;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $a3660d4bbd841766$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $a3660d4bbd841766$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(node.latestValues)) $a3660d4bbd841766$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $a3660d4bbd841766$var$snapToDefault(treeScale.x);
    treeScale.y = $a3660d4bbd841766$var$snapToDefault(treeScale.y);
}
function $a3660d4bbd841766$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $a3660d4bbd841766$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $a3660d4bbd841766$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale) {
    var axisOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    var originPoint = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $a3660d4bbd841766$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $a3660d4bbd841766$export$58b16271041fbfb(box, transform) {
    $a3660d4bbd841766$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $a3660d4bbd841766$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $f497d115c831d12d$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $1c15c7a4cd4e1645$export$d3955c6a8f65a36b)((0, $1c15c7a4cd4e1645$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $f497d115c831d12d$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $f497d115c831d12d$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
var $c58f370c5e3b42e6$export$d533d84f9871c879 = function(param) {
    var current = param.current;
    return current ? current.ownerDocument.defaultView : null;
};




var $8317a11ef33664a9$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
var $8317a11ef33664a9$export$86bff71f18910307 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElementDragControls(visualElement) {
        (0, $grujF._)(this, VisualElementDragControls);
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    (0, $dhMkv._)(VisualElementDragControls, [
        {
            key: "start",
            value: function start(originEvent) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_snapToCursor = _ref.snapToCursor, snapToCursor = _ref_snapToCursor === void 0 ? false : _ref_snapToCursor;
                /**
         * Don't start dragging if this component is exiting
         */ var presenceContext = this.visualElement.presenceContext;
                if (presenceContext && presenceContext.isPresent === false) return;
                var onSessionStart = function(event) {
                    var dragSnapToOrigin = _this.getProps().dragSnapToOrigin;
                    // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
                    // the component.
                    dragSnapToOrigin ? _this.pauseAnimation() : _this.stopAnimation();
                    if (snapToCursor) _this.snapToCursor((0, $3bcd6d32796288e9$export$12f84bb882d06e1a)(event, "page").point);
                };
                var onStart = function(event, info) {
                    var _a;
                    // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, dragPropagation = _this_getProps.dragPropagation, onDragStart = _this_getProps.onDragStart;
                    if (drag && !dragPropagation) {
                        if (_this.openGlobalLock) _this.openGlobalLock();
                        _this.openGlobalLock = (0, $73b68d6bef4a7404$export$2b7959ed03c1a3fe)(drag);
                        // If we don 't have the lock, don't start dragging
                        if (!_this.openGlobalLock) return;
                    }
                    _this.isDragging = true;
                    _this.currentDirection = null;
                    _this.resolveConstraints();
                    if (_this.visualElement.projection) {
                        _this.visualElement.projection.isAnimationBlocked = true;
                        _this.visualElement.projection.target = undefined;
                    }
                    /**
             * Record gesture origin
             */ (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                        var current = _this.getAxisMotionValue(axis).get() || 0;
                        /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $0881ed62dbc2428c$export$626336c2cd4b14de).test(current)) {
                            var projection = _this.visualElement.projection;
                            if (projection && projection.layout) {
                                var measuredAxis = projection.layout.layoutBox[axis];
                                if (measuredAxis) {
                                    var length = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(measuredAxis);
                                    current = length * (parseFloat(current) / 100);
                                }
                            }
                        }
                        _this.originPoint[axis] = current;
                    });
                    // Fire onDragStart event
                    if (onDragStart) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                        return onDragStart(event, info);
                    });
                    (_a = _this.removeWillChange) === null || _a === void 0 || _a.call(_this);
                    _this.removeWillChange = (0, $26200d9f5f242395$export$3ac5aed310be0bee)(_this.visualElement, "transform");
                    var animationState = _this.visualElement.animationState;
                    animationState && animationState.setActive("whileDrag", true);
                };
                var onMove = function(event, info) {
                    // latestPointerEvent = event
                    var _this_getProps = _this.getProps(), dragPropagation = _this_getProps.dragPropagation, dragDirectionLock = _this_getProps.dragDirectionLock, onDirectionLock = _this_getProps.onDirectionLock, onDrag = _this_getProps.onDrag;
                    // If we didn't successfully receive the gesture lock, early return.
                    if (!dragPropagation && !_this.openGlobalLock) return;
                    var offset = info.offset;
                    // Attempt to detect drag direction if directionLock is true
                    if (dragDirectionLock && _this.currentDirection === null) {
                        _this.currentDirection = $8317a11ef33664a9$var$getCurrentDirection(offset);
                        // If we've successfully set a direction, notify listener
                        if (_this.currentDirection !== null) onDirectionLock && onDirectionLock(_this.currentDirection);
                        return;
                    }
                    // Update each point with the latest position
                    _this.updateAxis("x", info.point, offset);
                    _this.updateAxis("y", info.point, offset);
                    /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.render();
                    /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
                };
                var onSessionEnd = function(event, info) {
                    return _this.stop(event, info);
                };
                var resumeAnimation = function() {
                    return (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                        var _a;
                        return _this.getAnimationState(axis) === "paused" && ((_a = _this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
                    });
                };
                var dragSnapToOrigin = this.getProps().dragSnapToOrigin;
                this.panSession = new (0, $9b6dc319aac82545$export$d9c66232c9c4689c)(originEvent, {
                    onSessionStart: onSessionStart,
                    onStart: onStart,
                    onMove: onMove,
                    onSessionEnd: onSessionEnd,
                    resumeAnimation: resumeAnimation
                }, {
                    transformPagePoint: this.visualElement.getTransformPagePoint(),
                    dragSnapToOrigin: dragSnapToOrigin,
                    contextWindow: (0, $c58f370c5e3b42e6$export$d533d84f9871c879)(this.visualElement)
                });
            }
        },
        {
            key: "stop",
            value: function stop(event, info) {
                var _a;
                (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
                var isDragging = this.isDragging;
                this.cancel();
                if (!isDragging) return;
                var velocity = info.velocity;
                this.startAnimation(velocity);
                var onDragEnd = this.getProps().onDragEnd;
                if (onDragEnd) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                    return onDragEnd(event, info);
                });
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.isDragging = false;
                var _this_visualElement = this.visualElement, projection = _this_visualElement.projection, animationState = _this_visualElement.animationState;
                if (projection) projection.isAnimationBlocked = false;
                this.panSession && this.panSession.end();
                this.panSession = undefined;
                var dragPropagation = this.getProps().dragPropagation;
                if (!dragPropagation && this.openGlobalLock) {
                    this.openGlobalLock();
                    this.openGlobalLock = null;
                }
                animationState && animationState.setActive("whileDrag", false);
            }
        },
        {
            key: "updateAxis",
            value: function updateAxis(axis, _point, offset) {
                var drag = this.getProps().drag;
                // If we're not dragging this axis, do an early return.
                if (!offset || !$8317a11ef33664a9$var$shouldDrag(axis, drag, this.currentDirection)) return;
                var axisValue = this.getAxisMotionValue(axis);
                var next = this.originPoint[axis] + offset[axis];
                // Apply constraints
                if (this.constraints && this.constraints[axis]) next = (0, $85e4cd4bd9da141a$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
                axisValue.set(next);
            }
        },
        {
            key: "resolveConstraints",
            value: function resolveConstraints() {
                var _this = this;
                var _a;
                var _this_getProps = this.getProps(), dragConstraints = _this_getProps.dragConstraints, dragElastic = _this_getProps.dragElastic;
                var layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
                var prevConstraints = this.constraints;
                if (dragConstraints && (0, $e9c25423de102281$export$dedd81df7bc1307)(dragConstraints)) {
                    if (!this.constraints) this.constraints = this.resolveRefConstraints();
                } else if (dragConstraints && layout) this.constraints = (0, $85e4cd4bd9da141a$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
                else this.constraints = false;
                this.elastic = (0, $85e4cd4bd9da141a$export$7c5eaef8f4723d22)(dragElastic);
                /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    if (_this.constraints !== false && _this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $85e4cd4bd9da141a$export$e9672cc4c36a8b87)(layout.layoutBox[axis], _this.constraints[axis]);
                });
            }
        },
        {
            key: "resolveRefConstraints",
            value: function resolveRefConstraints() {
                var _this_getProps = this.getProps(), constraints = _this_getProps.dragConstraints, onMeasureDragConstraints = _this_getProps.onMeasureDragConstraints;
                if (!constraints || !(0, $e9c25423de102281$export$dedd81df7bc1307)(constraints)) return false;
                var constraintsElement = constraints.current;
                (0, $aaa7e0662adcfa6d$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
                var projection = this.visualElement.projection;
                // TODO
                if (!projection || !projection.layout) return false;
                var constraintsBox = (0, $f497d115c831d12d$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
                var measuredConstraints = (0, $85e4cd4bd9da141a$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
                /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
                    var userConstraints = onMeasureDragConstraints((0, $1c15c7a4cd4e1645$export$b6b9cd4198191a47)(measuredConstraints));
                    this.hasMutatedConstraints = !!userConstraints;
                    if (userConstraints) measuredConstraints = (0, $1c15c7a4cd4e1645$export$d3955c6a8f65a36b)(userConstraints);
                }
                return measuredConstraints;
            }
        },
        {
            key: "startAnimation",
            value: function startAnimation(velocity) {
                var _this = this;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragMomentum = _this_getProps.dragMomentum, dragElastic = _this_getProps.dragElastic, dragTransition = _this_getProps.dragTransition, dragSnapToOrigin = _this_getProps.dragSnapToOrigin, onDragTransitionEnd = _this_getProps.onDragTransitionEnd;
                var constraints = this.constraints || {};
                var momentumAnimations = (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    if (!$8317a11ef33664a9$var$shouldDrag(axis, drag, _this.currentDirection)) return;
                    var transition = constraints && constraints[axis] || {};
                    if (dragSnapToOrigin) transition = {
                        min: 0,
                        max: 0
                    };
                    /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
                    var bounceDamping = dragElastic ? 40 : 10000000;
                    var inertia = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                        type: "inertia",
                        velocity: dragMomentum ? velocity[axis] : 0,
                        bounceStiffness: bounceStiffness,
                        bounceDamping: bounceDamping,
                        timeConstant: 750,
                        restDelta: 1,
                        restSpeed: 10
                    }, dragTransition, transition);
                    // If we're not animating on an externally-provided `MotionValue` we can use the
                    // component's animation controls which will handle interactions with whileHover (etc),
                    // otherwise we just have to animate the `MotionValue` itself.
                    return _this.startAxisValueAnimation(axis, inertia);
                });
                // Run all animations and then resolve the new drag constraints.
                return Promise.all(momentumAnimations).then(onDragTransitionEnd);
            }
        },
        {
            key: "startAxisValueAnimation",
            value: function startAxisValueAnimation(axis, transition) {
                var axisValue = this.getAxisMotionValue(axis);
                return axisValue.start((0, $e9a361abb303d2a2$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false, (0, $26200d9f5f242395$export$3ac5aed310be0bee)(this.visualElement, axis)));
            }
        },
        {
            key: "stopAnimation",
            value: function stopAnimation() {
                var _this = this;
                (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    return _this.getAxisMotionValue(axis).stop();
                });
            }
        },
        {
            key: "pauseAnimation",
            value: function pauseAnimation() {
                var _this = this;
                (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    var _a;
                    return (_a = _this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
                });
            }
        },
        {
            key: "getAnimationState",
            value: function getAnimationState(axis) {
                var _a;
                return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
            }
        },
        {
            /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ key: "getAxisMotionValue",
            value: function getAxisMotionValue(axis) {
                var dragKey = "_drag".concat(axis.toUpperCase());
                var props = this.visualElement.getProps();
                var externalMotionValue = props[dragKey];
                return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
            }
        },
        {
            key: "snapToCursor",
            value: function snapToCursor(point) {
                var _this = this;
                (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    var drag = _this.getProps().drag;
                    // If we're not dragging this axis, do an early return.
                    if (!$8317a11ef33664a9$var$shouldDrag(axis, drag, _this.currentDirection)) return;
                    var projection = _this.visualElement.projection;
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (projection && projection.layout) {
                        var _projection_layout_layoutBox_axis = projection.layout.layoutBox[axis], min = _projection_layout_layoutBox_axis.min, max = _projection_layout_layoutBox_axis.max;
                        axisValue.set(point[axis] - (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(min, max, 0.5));
                    }
                });
            }
        },
        {
            /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ key: "scalePositionWithinConstraints",
            value: function scalePositionWithinConstraints() {
                var _this = this;
                if (!this.visualElement.current) return;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragConstraints = _this_getProps.dragConstraints;
                var projection = this.visualElement.projection;
                if (!(0, $e9c25423de102281$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
                /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
                /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
                    x: 0,
                    y: 0
                };
                (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (axisValue && _this.constraints !== false) {
                        var latest = axisValue.get();
                        boxProgress[axis] = (0, $85e4cd4bd9da141a$export$13abbfca044ca46d)({
                            min: latest,
                            max: latest
                        }, _this.constraints[axis]);
                    }
                });
                /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
                this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
                projection.root && projection.root.updateScroll();
                projection.updateLayout();
                this.resolveConstraints();
                /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                    if (!$8317a11ef33664a9$var$shouldDrag(axis, drag, null)) return;
                    /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
                    var _this_constraints_axis = _this.constraints[axis], min = _this_constraints_axis.min, max = _this_constraints_axis.max;
                    axisValue.set((0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
                });
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                var _this = this;
                if (!this.visualElement.current) return;
                $8317a11ef33664a9$export$f0a15892c27dc07c.set(this.visualElement, this);
                var element = this.visualElement.current;
                /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $db69ad6144494a98$export$fcff2e64e6676b81)(element, "pointerdown", function(event) {
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, _this_getProps_dragListener = _this_getProps.dragListener, dragListener = _this_getProps_dragListener === void 0 ? true : _this_getProps_dragListener;
                    drag && dragListener && _this.start(event);
                });
                var measureDragConstraints = function() {
                    var dragConstraints = _this.getProps().dragConstraints;
                    if ((0, $e9c25423de102281$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) _this.constraints = _this.resolveRefConstraints();
                };
                var projection = this.visualElement.projection;
                var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
                if (projection && !projection.layout) {
                    projection.root && projection.root.updateScroll();
                    projection.updateLayout();
                }
                (0, $1134021eb916ca42$export$2cef06c20297c17d).read(measureDragConstraints);
                /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(window, "resize", function() {
                    return _this.scalePositionWithinConstraints();
                });
                /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function(param) {
                    var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged;
                    if (_this.isDragging && hasLayoutChanged) {
                        (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
                            var motionValue = _this.getAxisMotionValue(axis);
                            if (!motionValue) return;
                            _this.originPoint[axis] += delta[axis].translate;
                            motionValue.set(motionValue.get() + delta[axis].translate);
                        });
                        _this.visualElement.render();
                    }
                });
                return function() {
                    stopResizeListener();
                    stopPointerListener();
                    stopMeasureLayoutListener();
                    stopLayoutUpdateListener && stopLayoutUpdateListener();
                };
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                var props = this.visualElement.getProps();
                var _props_drag = props.drag, drag = _props_drag === void 0 ? false : _props_drag, _props_dragDirectionLock = props.dragDirectionLock, dragDirectionLock = _props_dragDirectionLock === void 0 ? false : _props_dragDirectionLock, _props_dragPropagation = props.dragPropagation, dragPropagation = _props_dragPropagation === void 0 ? false : _props_dragPropagation, _props_dragConstraints = props.dragConstraints, dragConstraints = _props_dragConstraints === void 0 ? false : _props_dragConstraints, _props_dragElastic = props.dragElastic, dragElastic = _props_dragElastic === void 0 ? (0, $85e4cd4bd9da141a$export$a3366d3bac43a742) : _props_dragElastic, _props_dragMomentum = props.dragMomentum, dragMomentum = _props_dragMomentum === void 0 ? true : _props_dragMomentum;
                return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, props), {
                    drag: drag,
                    dragDirectionLock: dragDirectionLock,
                    dragPropagation: dragPropagation,
                    dragConstraints: dragConstraints,
                    dragElastic: dragElastic,
                    dragMomentum: dragMomentum
                });
            }
        }
    ]);
    return VisualElementDragControls;
}();
function $8317a11ef33664a9$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8317a11ef33664a9$var$getCurrentDirection(offset) {
    var lockThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


var $154ee79a98f34d03$export$5d97dc2872682820 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(DragGesture, Feature);
    var _super = (0, $lngen._)(DragGesture);
    function DragGesture(node) {
        (0, $grujF._)(this, DragGesture);
        var _this;
        _this = _super.call(this, node);
        _this.removeGroupControls = (0, $fb816313cb795261$export$8793edee2d425525);
        _this.removeListeners = (0, $fb816313cb795261$export$8793edee2d425525);
        _this.controls = new (0, $8317a11ef33664a9$export$86bff71f18910307)(node);
        return _this;
    }
    (0, $dhMkv._)(DragGesture, [
        {
            key: "mount",
            value: function mount() {
                // If we've been provided a DragControls for manual control over the drag gesture,
                // subscribe this component to it on mount.
                var dragControls = this.node.getProps().dragControls;
                if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
                this.removeListeners = this.controls.addListeners() || (0, $fb816313cb795261$export$8793edee2d425525);
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removeGroupControls();
                this.removeListeners();
            }
        }
    ]);
    return DragGesture;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");






var $1556b743982d1d5a$var$asyncHandler = function(handler) {
    return function(event, info) {
        if (handler) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
            return handler(event, info);
        });
    };
};
var $1556b743982d1d5a$export$b4f8f1ee75ce5859 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $j6Mzi._)(PanGesture, Feature);
    var _super = (0, $lngen._)(PanGesture);
    function PanGesture() {
        (0, $grujF._)(this, PanGesture);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.removePointerDownListener = (0, $fb816313cb795261$export$8793edee2d425525);
        return _this;
    }
    (0, $dhMkv._)(PanGesture, [
        {
            key: "onPointerDown",
            value: function onPointerDown(pointerDownEvent) {
                this.session = new (0, $9b6dc319aac82545$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
                    transformPagePoint: this.node.getTransformPagePoint(),
                    contextWindow: (0, $c58f370c5e3b42e6$export$d533d84f9871c879)(this.node)
                });
            }
        },
        {
            key: "createPanHandlers",
            value: function createPanHandlers() {
                var _this = this;
                var _this_node_getProps = this.node.getProps(), onPanSessionStart = _this_node_getProps.onPanSessionStart, onPanStart = _this_node_getProps.onPanStart, onPan = _this_node_getProps.onPan, onPanEnd = _this_node_getProps.onPanEnd;
                return {
                    onSessionStart: $1556b743982d1d5a$var$asyncHandler(onPanSessionStart),
                    onStart: $1556b743982d1d5a$var$asyncHandler(onPanStart),
                    onMove: onPan,
                    onEnd: function(event, info) {
                        delete _this.session;
                        if (onPanEnd) (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                            return onPanEnd(event, info);
                        });
                    }
                };
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.removePointerDownListener = (0, $db69ad6144494a98$export$fcff2e64e6676b81)(this.node.current, "pointerdown", function(event) {
                    return _this.onPointerDown(event);
                });
            }
        },
        {
            key: "update",
            value: function update() {
                this.session && this.session.updateHandlers(this.createPanHandlers());
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removePointerDownListener();
                this.session && this.session.end();
            }
        }
    ]);
    return PanGesture;
}((0, $d9394131c38c23bf$export$6e91cf7616333d5));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");



var $2nwvT = parcelRequire("2nwvT");

var $lngen = parcelRequire("lngen");


var $dQFEZ = parcelRequire("dQFEZ");

var $dQFEZ = parcelRequire("dQFEZ");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $f8101c460941971a$export$2a8c16d82a0a0e26() {
    var context = (0, $dQFEZ.useContext)((0, $4fa6635067f6f474$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    var id = (0, $dQFEZ.useId)();
    (0, $dQFEZ.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete && onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $f8101c460941971a$export$8249053f690ea39a() {
    return $f8101c460941971a$export$ee27c052bca048fb((0, $dQFEZ.useContext)((0, $4fa6635067f6f474$export$f224e4635b6f8ce2)));
}
function $f8101c460941971a$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $13965e5337addde9$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $a976d9639d6fe080$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $a976d9639d6fe080$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $0881ed62dbc2428c$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $a976d9639d6fe080$export$fafff692be55225d(latest, node.target.x);
        var y = $a976d9639d6fe080$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};




var $84c3c53ff0b05577$export$eb0bc629e74dcf8 = {
    correct: function(latest, param) {
        var treeScale = param.treeScale, projectionDelta = param.projectionDelta;
        var original = latest;
        var shadow = (0, $69b61e406d097f9e$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $69b61e406d097f9e$export$83a0e34f1302825b).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





var $31d7336c9fb9e92d$var$MeasureLayoutWithContext = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $j6Mzi._)(MeasureLayoutWithContext, Component);
    var _super = (0, $lngen._)(MeasureLayoutWithContext);
    function MeasureLayoutWithContext() {
        (0, $grujF._)(this, MeasureLayoutWithContext);
        return _super.apply(this, arguments);
    }
    (0, $dhMkv._)(MeasureLayoutWithContext, [
        {
            /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, switchLayoutGroup = _this_props.switchLayoutGroup, layoutId = _this_props.layoutId;
                var projection = visualElement.projection;
                (0, $ae2875b24a733eed$export$de9e7791c71225fd)($31d7336c9fb9e92d$var$defaultScaleCorrectors);
                if (projection) {
                    if (layoutGroup.group) layoutGroup.group.add(projection);
                    if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
                    projection.root.didUpdate();
                    projection.addEventListener("animationComplete", function() {
                        _this.safeToRemove();
                    });
                    projection.setOptions((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, projection.options), {
                        onExitComplete: function() {
                            return _this.safeToRemove();
                        }
                    }));
                }
                (0, $13965e5337addde9$export$97db156a3ed1593b).hasEverUpdated = true;
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var _this = this;
                var _this_props = this.props, layoutDependency = _this_props.layoutDependency, visualElement = _this_props.visualElement, drag = _this_props.drag, isPresent = _this_props.isPresent;
                var projection = visualElement.projection;
                if (!projection) return null;
                /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
                if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
                else this.safeToRemove();
                if (prevProps.isPresent !== isPresent) {
                    if (isPresent) projection.promote();
                    else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                        var stack = projection.getStack();
                        if (!stack || !stack.members.length) _this.safeToRemove();
                    });
                }
                return null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this = this;
                var projection = this.props.visualElement.projection;
                if (projection) {
                    projection.root.didUpdate();
                    (0, $346b530bc5e6ade4$export$bb76eed83315504c).postRender(function() {
                        if (!projection.currentAnimation && projection.isLead()) _this.safeToRemove();
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, promoteContext = _this_props.switchLayoutGroup;
                var projection = visualElement.projection;
                if (projection) {
                    projection.scheduleCheckAfterUnmount();
                    if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
                    if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
                }
            }
        },
        {
            key: "safeToRemove",
            value: function safeToRemove() {
                var safeToRemove = this.props.safeToRemove;
                safeToRemove && safeToRemove();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return MeasureLayoutWithContext;
}((0, $dQFEZ.Component));
function $31d7336c9fb9e92d$export$779f5fb01ad751cd(props) {
    var _usePresence = (0, $2nwvT._)((0, $f8101c460941971a$export$2a8c16d82a0a0e26)(), 2), isPresent = _usePresence[0], safeToRemove = _usePresence[1];
    var layoutGroup = (0, $dQFEZ.useContext)((0, $c9258bc28bb8df33$export$a3579ca508007a95));
    return (0, $d8ffb49eb4cd7afd$exports.jsx)($31d7336c9fb9e92d$var$MeasureLayoutWithContext, (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $dQFEZ.useContext)((0, $fff1757b250efb2b$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var $31d7336c9fb9e92d$var$defaultScaleCorrectors = {
    borderRadius: (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $a976d9639d6fe080$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $a976d9639d6fe080$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $a976d9639d6fe080$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $a976d9639d6fe080$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $a976d9639d6fe080$export$5eafb6257a5844c),
    boxShadow: (0, $84c3c53ff0b05577$export$eb0bc629e74dcf8)
};



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");



var $2us1u = parcelRequire("2us1u");






var $f9e781f51bc03c71$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $f9e781f51bc03c71$var$numBorders = $f9e781f51bc03c71$var$borders.length;
var $f9e781f51bc03c71$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $f9e781f51bc03c71$var$isPx = function(value) {
    return typeof value === "number" || (0, $0881ed62dbc2428c$export$91c0eda1d06bf008).test(value);
};
function $f9e781f51bc03c71$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $f9e781f51bc03c71$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $f9e781f51bc03c71$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $f9e781f51bc03c71$var$numBorders; i++){
        var borderLabel = "border".concat($f9e781f51bc03c71$var$borders[i], "Radius");
        var followRadius = $f9e781f51bc03c71$var$getRadius(follow, borderLabel);
        var leadRadius = $f9e781f51bc03c71$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $f9e781f51bc03c71$var$isPx(followRadius) === $f9e781f51bc03c71$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $364e42417e478d28$export$3bb0b4ff1037b8dd)($f9e781f51bc03c71$var$asNumber(followRadius), $f9e781f51bc03c71$var$asNumber(leadRadius), progress), 0);
            if ((0, $0881ed62dbc2428c$export$626336c2cd4b14de).test(leadRadius) || (0, $0881ed62dbc2428c$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $f9e781f51bc03c71$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $f9e781f51bc03c71$var$easeCrossfadeIn = $f9e781f51bc03c71$var$compress(0, 0.5, (0, $26c2ab1a9090836c$export$c8d67a19199d1a50));
var $f9e781f51bc03c71$var$easeCrossfadeOut = $f9e781f51bc03c71$var$compress(0.5, 0.95, (0, $fb816313cb795261$export$8793edee2d425525));
function $f9e781f51bc03c71$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3369424d70926287$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a723b2b360843335$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a723b2b360843335$export$c53fd88f45d77e4b(box, originBox) {
    $a723b2b360843335$export$a0230ae482601ae8(box.x, originBox.x);
    $a723b2b360843335$export$a0230ae482601ae8(box.y, originBox.y);
}





var $2nwvT = parcelRequire("2nwvT");



/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $5cdc90a77563ad73$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $a3660d4bbd841766$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $a3660d4bbd841766$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $5cdc90a77563ad73$export$cc12a0672fae5b4a(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5, boxScale = arguments.length > 4 ? arguments[4] : void 0, originAxis = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : axis, sourceAxis = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : axis;
    if ((0, $0881ed62dbc2428c$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $5cdc90a77563ad73$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $5cdc90a77563ad73$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $5cdc90a77563ad73$export$42b76f1d0d16d5b(axis, transforms, param, origin, sourceAxis) {
    var _param = (0, $2nwvT._)(param, 3), key = _param[0], scaleKey = _param[1], originKey = _param[2];
    $5cdc90a77563ad73$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $5cdc90a77563ad73$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $5cdc90a77563ad73$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $5cdc90a77563ad73$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $5cdc90a77563ad73$export$42b76f1d0d16d5b(box.x, transforms, $5cdc90a77563ad73$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $5cdc90a77563ad73$export$42b76f1d0d16d5b(box.y, transforms, $5cdc90a77563ad73$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $4690f6bd1285a864$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $4690f6bd1285a864$export$a7ec7642fe550fb6(delta) {
    return $4690f6bd1285a864$var$isAxisDeltaZero(delta.x) && $4690f6bd1285a864$var$isAxisDeltaZero(delta.y);
}
function $4690f6bd1285a864$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $4690f6bd1285a864$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $4690f6bd1285a864$export$c5706146bc63213(box) {
    return (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(box.x) / (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(box.y);
}



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $f12c4077ced3b8ac$export$39be5b2d82fc9dc7 = /*#__PURE__*/ function() {
    "use strict";
    function NodeStack() {
        (0, $grujF._)(this, NodeStack);
        this.members = [];
    }
    (0, $dhMkv._)(NodeStack, [
        {
            key: "add",
            value: function add(node) {
                (0, $240b8108c1be092c$export$20e507e47fae79fd)(this.members, node);
                node.scheduleRender();
            }
        },
        {
            key: "remove",
            value: function remove(node) {
                (0, $240b8108c1be092c$export$fe2d9b4e03920b4c)(this.members, node);
                if (node === this.prevLead) this.prevLead = undefined;
                if (node === this.lead) {
                    var prevLead = this.members[this.members.length - 1];
                    if (prevLead) this.promote(prevLead);
                }
            }
        },
        {
            key: "relegate",
            value: function relegate(node) {
                var indexOfNode = this.members.findIndex(function(member) {
                    return node === member;
                });
                if (indexOfNode === 0) return false;
                /**
         * Find the next projection node that is present
         */ var prevLead;
                for(var i = indexOfNode; i >= 0; i--){
                    var member = this.members[i];
                    if (member.isPresent !== false) {
                        prevLead = member;
                        break;
                    }
                }
                if (prevLead) {
                    this.promote(prevLead);
                    return true;
                } else return false;
            }
        },
        {
            key: "promote",
            value: function promote(node, preserveFollowOpacity) {
                var prevLead = this.lead;
                if (node === prevLead) return;
                this.prevLead = prevLead;
                this.lead = node;
                node.show();
                if (prevLead) {
                    prevLead.instance && prevLead.scheduleRender();
                    node.scheduleRender();
                    node.resumeFrom = prevLead;
                    if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
                    if (prevLead.snapshot) {
                        node.snapshot = prevLead.snapshot;
                        node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                    }
                    if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
                    var crossfade = node.options.crossfade;
                    if (crossfade === false) prevLead.hide();
                /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
            }
        },
        {
            key: "exitAnimationComplete",
            value: function exitAnimationComplete() {
                this.members.forEach(function(node) {
                    var options = node.options, resumingFrom = node.resumingFrom;
                    options.onExitComplete && options.onExitComplete();
                    if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
                });
            }
        },
        {
            key: "scheduleRender",
            value: function scheduleRender() {
                this.members.forEach(function(node) {
                    node.instance && node.scheduleRender(false);
                });
            }
        },
        {
            /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ key: "removeLeadSnapshot",
            value: function removeLeadSnapshot() {
                if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
            }
        }
    ]);
    return NodeStack;
}();



function $1d516ac34e3f30b2$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    var transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, ").concat(zTranslate, "px) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var transformPerspective = latestTransform.transformPerspective, rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY, skewX = latestTransform.skewX, skewY = latestTransform.skewY;
        if (transformPerspective) transform = "perspective(".concat(transformPerspective, "px) ").concat(transform);
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
        if (skewX) transform += "skewX(".concat(skewX, "deg) ");
        if (skewY) transform += "skewY(".concat(skewY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform || "none";
}





var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $9fa2818e80e920fe$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};


var $37d0c662741611c9$export$1465d17e3de78a96 = /*#__PURE__*/ function() {
    "use strict";
    function FlatTree() {
        (0, $grujF._)(this, FlatTree);
        this.children = [];
        this.isDirty = false;
    }
    (0, $dhMkv._)(FlatTree, [
        {
            key: "add",
            value: function add(child) {
                (0, $240b8108c1be092c$export$20e507e47fae79fd)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "remove",
            value: function remove(child) {
                (0, $240b8108c1be092c$export$fe2d9b4e03920b4c)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                this.isDirty && this.children.sort((0, $9fa2818e80e920fe$export$d689d9dec5ad338));
                this.isDirty = false;
                this.children.forEach(callback);
            }
        }
    ]);
    return FlatTree;
}();






/**
 * Timeout defined in ms
 */ function $4d94f3593b4e7494$export$1391212d75b2ee65(callback, timeout) {
    var start = (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
    var checkElapsed = function(param) {
        var timestamp = param.timestamp;
        var elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $1134021eb916ca42$export$2cef06c20297c17d).read(checkElapsed, true);
    return function() {
        return (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(checkElapsed);
    };
}



function $0c1973270b763104$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $b9fa1b429bc97155$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $ea6034c54dd87d32$export$335a17c977067b99(value, keyframes, options) {
    var motionValue$1 = (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(value) ? value : (0, $bde97c2bbeed274b$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $e9a361abb303d2a2$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}








var $a4fa0da8ce0f2603$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
var $a4fa0da8ce0f2603$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $a4fa0da8ce0f2603$var$animationTarget = 1000;
var $a4fa0da8ce0f2603$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ var $a4fa0da8ce0f2603$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $a4fa0da8ce0f2603$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    var latestValues = visualElement.latestValues;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $a4fa0da8ce0f2603$var$isOptimisedAppearTree(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return false;
    var visualElement = projectionNode.options.visualElement;
    if (!visualElement) return false;
    else if ((0, $6334040f84a80be4$export$5f8d21e84d1d84fc)(visualElement)) return true;
    else if (projectionNode.parent && !projectionNode.parent.hasCheckedOptimisedAppear) return $a4fa0da8ce0f2603$var$isOptimisedAppearTree(projectionNode.parent);
    else return false;
}
function $a4fa0da8ce0f2603$export$a84b61f69daa9da0(param) {
    var attachResizeListener = param.attachResizeListener, defaultParent = param.defaultParent, measureScroll = param.measureScroll, checkIsScrollRoot = param.checkIsScrollRoot, resetTransform = param.resetTransform;
    return /*#__PURE__*/ function() {
        "use strict";
        function ProjectionNode() {
            var _this = this;
            var latestValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            (0, $grujF._)(this, ProjectionNode);
            /**
             * A unique ID generated for every projection node.
             */ this.id = $a4fa0da8ce0f2603$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = function() {
                return _this.update();
            };
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = function() {
                _this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $a4fa0da8ce0f2603$var$projectionFrameData.totalNodes = $a4fa0da8ce0f2603$var$projectionFrameData.resolvedTargetDeltas = $a4fa0da8ce0f2603$var$projectionFrameData.recalculatedProjection = 0;
                _this.nodes.forEach($a4fa0da8ce0f2603$export$131f2f0cc5fe9609);
                _this.nodes.forEach($a4fa0da8ce0f2603$var$resolveTargetDelta);
                _this.nodes.forEach($a4fa0da8ce0f2603$var$calcProjection);
                _this.nodes.forEach($a4fa0da8ce0f2603$export$c2664f37bc951031);
                (0, $0c1973270b763104$export$e5185e241753e543)($a4fa0da8ce0f2603$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $2us1u._)(parent.path).concat([
                parent
            ]) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $37d0c662741611c9$export$1465d17e3de78a96)();
        }
        (0, $dhMkv._)(ProjectionNode, [
            {
                key: "addEventListener",
                value: function addEventListener(name, handler) {
                    if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $520c7c228cb8ad64$export$e7dff9482a5fd23c)());
                    return this.eventHandlers.get(name).add(handler);
                }
            },
            {
                key: "notifyListeners",
                value: function notifyListeners(name) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _subscriptionManager;
                    var subscriptionManager = this.eventHandlers.get(name);
                    subscriptionManager && (_subscriptionManager = subscriptionManager).notify.apply(_subscriptionManager, (0, $2us1u._)(args));
                }
            },
            {
                key: "hasListeners",
                value: function hasListeners(name) {
                    return this.eventHandlers.has(name);
                }
            },
            {
                /**
         * Lifecycles
         */ key: "mount",
                value: function mount(instance) {
                    var _this = this;
                    var isLayoutDirty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.root.hasTreeAnimated;
                    if (this.instance) return;
                    this.isSVG = (0, $b9fa1b429bc97155$export$17eda790a720ec57)(instance);
                    this.instance = instance;
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout, visualElement = _this_options.visualElement;
                    if (visualElement && !visualElement.current) visualElement.mount(instance);
                    this.root.nodes.add(this);
                    this.parent && this.parent.children.add(this);
                    if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
                    if (attachResizeListener) {
                        var cancelDelay;
                        var resizeUnblockUpdate = function() {
                            return _this.root.updateBlockedByResize = false;
                        };
                        attachResizeListener(instance, function() {
                            _this.root.updateBlockedByResize = true;
                            cancelDelay && cancelDelay();
                            cancelDelay = (0, $4d94f3593b4e7494$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                            if ((0, $13965e5337addde9$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                                (0, $13965e5337addde9$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                                _this.nodes.forEach($a4fa0da8ce0f2603$var$finishAnimation);
                            }
                        });
                    }
                    if (layoutId) this.root.registerSharedNode(layoutId, this);
                    // Only register the handler if it requires layout animation
                    if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(param) {
                        var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged, hasRelativeTargetChanged = param.hasRelativeTargetChanged, newLayout = param.layout;
                        if (_this.isTreeAnimationBlocked()) {
                            _this.target = undefined;
                            _this.relativeTarget = undefined;
                            return;
                        }
                        // TODO: Check here if an animation exists
                        var layoutTransition = _this.options.transition || visualElement.getDefaultTransition() || $a4fa0da8ce0f2603$var$defaultLayoutTransition;
                        var _visualElement_getProps = visualElement.getProps(), onLayoutAnimationStart = _visualElement_getProps.onLayoutAnimationStart, onLayoutAnimationComplete = _visualElement_getProps.onLayoutAnimationComplete;
                        /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !(0, $4690f6bd1285a864$export$ef641b782d85522)(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                        /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                        if (_this.options.layoutRoot || _this.resumeFrom && _this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                            if (_this.resumeFrom) {
                                _this.resumingFrom = _this.resumeFrom;
                                _this.resumingFrom.resumingFrom = undefined;
                            }
                            _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                            var animationOptions = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $a113484cc917d77a$export$7c1391340308742e)(layoutTransition, "layout")), {
                                onPlay: onLayoutAnimationStart,
                                onComplete: onLayoutAnimationComplete
                            });
                            if (visualElement.shouldReduceMotion || _this.options.layoutRoot) {
                                animationOptions.delay = 0;
                                animationOptions.type = false;
                            }
                            _this.startAnimation(animationOptions);
                        } else {
                            /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $a4fa0da8ce0f2603$var$finishAnimation(_this);
                            if (_this.isLead() && _this.options.onExitComplete) _this.options.onExitComplete();
                        }
                        _this.targetLayout = newLayout;
                    });
                }
            },
            {
                key: "unmount",
                value: function unmount() {
                    this.options.layoutId && this.willUpdate();
                    this.root.nodes.remove(this);
                    var stack = this.getStack();
                    stack && stack.remove(this);
                    this.parent && this.parent.children.delete(this);
                    this.instance = undefined;
                    (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(this.updateProjection);
                }
            },
            {
                // only on the root
                key: "blockUpdate",
                value: function blockUpdate() {
                    this.updateManuallyBlocked = true;
                }
            },
            {
                key: "unblockUpdate",
                value: function unblockUpdate() {
                    this.updateManuallyBlocked = false;
                }
            },
            {
                key: "isUpdateBlocked",
                value: function isUpdateBlocked() {
                    return this.updateManuallyBlocked || this.updateBlockedByResize;
                }
            },
            {
                key: "isTreeAnimationBlocked",
                value: function isTreeAnimationBlocked() {
                    return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
                }
            },
            {
                // Note: currently only running on root node
                key: "startUpdate",
                value: function startUpdate() {
                    if (this.isUpdateBlocked()) return;
                    this.isUpdating = true;
                    this.nodes && this.nodes.forEach($a4fa0da8ce0f2603$var$resetSkewAndRotation);
                    this.animationId++;
                }
            },
            {
                key: "getTransformTemplate",
                value: function getTransformTemplate() {
                    var visualElement = this.options.visualElement;
                    return visualElement && visualElement.getProps().transformTemplate;
                }
            },
            {
                key: "willUpdate",
                value: function willUpdate() {
                    var shouldNotifyListeners = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.root.hasTreeAnimated = true;
                    if (this.root.isUpdateBlocked()) {
                        this.options.onExitComplete && this.options.onExitComplete();
                        return;
                    }
                    /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.HandoffCancelAllAnimations && $a4fa0da8ce0f2603$var$isOptimisedAppearTree(this)) window.HandoffCancelAllAnimations();
                    !this.root.isUpdating && this.root.startUpdate();
                    if (this.isLayoutDirty) return;
                    this.isLayoutDirty = true;
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.shouldResetTransform = true;
                        node.updateScroll("snapshot");
                        if (node.options.layoutRoot) node.willUpdate(false);
                    }
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout;
                    if (layoutId === undefined && !layout) return;
                    var transformTemplate = this.getTransformTemplate();
                    this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    this.updateSnapshot();
                    shouldNotifyListeners && this.notifyListeners("willUpdate");
                }
            },
            {
                key: "update",
                value: function update() {
                    this.updateScheduled = false;
                    var updateWasBlocked = this.isUpdateBlocked();
                    // When doing an instant transition, we skip the layout update,
                    // but should still clean up the measurements so that the next
                    // snapshot could be taken correctly.
                    if (updateWasBlocked) {
                        this.unblockUpdate();
                        this.clearAllSnapshots();
                        this.nodes.forEach($a4fa0da8ce0f2603$var$clearMeasurements);
                        return;
                    }
                    if (!this.isUpdating) this.nodes.forEach($a4fa0da8ce0f2603$var$clearIsLayoutDirty);
                    this.isUpdating = false;
                    /**
             * Write
             */ this.nodes.forEach($a4fa0da8ce0f2603$var$resetTransformStyle);
                    /**
             * Read ==================
             */ // Update layout measurements of updated children
                    this.nodes.forEach($a4fa0da8ce0f2603$var$updateLayout);
                    /**
             * Write
             */ // Notify listeners that the layout is updated
                    this.nodes.forEach($a4fa0da8ce0f2603$var$notifyLayoutUpdate);
                    this.clearAllSnapshots();
                    /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ var now = (0, $61a3cf971ef168a3$export$2da9be4cfdb689b1).now();
                    (0, $1134021eb916ca42$export$fff89137e9e818ce).delta = (0, $0ff5fb4b2d8667c1$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp);
                    (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp = now;
                    (0, $1134021eb916ca42$export$fff89137e9e818ce).isProcessing = true;
                    (0, $1134021eb916ca42$export$be3f796aed065412).update.process((0, $1134021eb916ca42$export$fff89137e9e818ce));
                    (0, $1134021eb916ca42$export$be3f796aed065412).preRender.process((0, $1134021eb916ca42$export$fff89137e9e818ce));
                    (0, $1134021eb916ca42$export$be3f796aed065412).render.process((0, $1134021eb916ca42$export$fff89137e9e818ce));
                    (0, $1134021eb916ca42$export$fff89137e9e818ce).isProcessing = false;
                }
            },
            {
                key: "didUpdate",
                value: function didUpdate() {
                    if (!this.updateScheduled) {
                        this.updateScheduled = true;
                        (0, $346b530bc5e6ade4$export$bb76eed83315504c).read(this.scheduleUpdate);
                    }
                }
            },
            {
                key: "clearAllSnapshots",
                value: function clearAllSnapshots() {
                    this.nodes.forEach($a4fa0da8ce0f2603$var$clearSnapshot);
                    this.sharedNodes.forEach($a4fa0da8ce0f2603$var$removeLeadSnapshots);
                }
            },
            {
                key: "scheduleUpdateProjection",
                value: function scheduleUpdateProjection() {
                    if (!this.projectionUpdateScheduled) {
                        this.projectionUpdateScheduled = true;
                        (0, $1134021eb916ca42$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
                    }
                }
            },
            {
                key: "scheduleCheckAfterUnmount",
                value: function scheduleCheckAfterUnmount() {
                    var _this = this;
                    /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $1134021eb916ca42$export$2cef06c20297c17d).postRender(function() {
                        if (_this.isLayoutDirty) _this.root.didUpdate();
                        else _this.root.checkUpdateFailed();
                    });
                }
            },
            {
                /**
         * Update measurements
         */ key: "updateSnapshot",
                value: function updateSnapshot() {
                    if (this.snapshot || !this.instance) return;
                    this.snapshot = this.measure();
                }
            },
            {
                key: "updateLayout",
                value: function updateLayout() {
                    if (!this.instance) return;
                    // TODO: Incorporate into a forwarded scroll offset
                    this.updateScroll();
                    if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
                    /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.updateScroll();
                    }
                    var prevLayout = this.layout;
                    this.layout = this.measure(false);
                    this.layoutCorrected = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    this.isLayoutDirty = false;
                    this.projectionDelta = undefined;
                    this.notifyListeners("measure", this.layout.layoutBox);
                    var visualElement = this.options.visualElement;
                    visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
                }
            },
            {
                key: "updateScroll",
                value: function updateScroll() {
                    var phase = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "measure";
                    var needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
                    if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
                    if (needsMeasurement) this.scroll = {
                        animationId: this.root.animationId,
                        phase: phase,
                        isRoot: checkIsScrollRoot(this.instance),
                        offset: measureScroll(this.instance)
                    };
                }
            },
            {
                key: "resetTransform",
                value: function resetTransform1() {
                    if (!resetTransform) return;
                    var isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
                    var hasProjection = this.projectionDelta && !(0, $4690f6bd1285a864$export$a7ec7642fe550fb6)(this.projectionDelta);
                    var transformTemplate = this.getTransformTemplate();
                    var transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
                    if (isResetRequested && (hasProjection || (0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                        resetTransform(this.instance, transformTemplateValue);
                        this.shouldResetTransform = false;
                        this.scheduleRender();
                    }
                }
            },
            {
                key: "measure",
                value: function measure() {
                    var removeTransform = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var pageBox = this.measurePageBox();
                    var layoutBox = this.removeElementScroll(pageBox);
                    /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
                    $a4fa0da8ce0f2603$var$roundBox(layoutBox);
                    return {
                        animationId: this.root.animationId,
                        measuredBox: pageBox,
                        layoutBox: layoutBox,
                        latestValues: {},
                        source: this.id
                    };
                }
            },
            {
                key: "measurePageBox",
                value: function measurePageBox() {
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    var box = visualElement.measureViewportBox();
                    // Remove viewport scroll to give page-relative coordinates
                    var scroll = this.root.scroll;
                    if (scroll) {
                        (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                        (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                    }
                    return box;
                }
            },
            {
                key: "removeElementScroll",
                value: function removeElementScroll(box) {
                    var boxWithoutScroll = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    (0, $a723b2b360843335$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        var scroll = node.scroll, options = node.options;
                        if (node !== this.root && scroll && options.layoutScroll) {
                            /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                                (0, $a723b2b360843335$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                                var _this_root = this.root, rootScroll = _this_root.scroll;
                                /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                                    (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                                    (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                                }
                            }
                            (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                            (0, $a3660d4bbd841766$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                        }
                    }
                    return boxWithoutScroll;
                }
            },
            {
                key: "applyTransform",
                value: function applyTransform(box) {
                    var transformOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var withTransforms = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    (0, $a723b2b360843335$export$c53fd88f45d77e4b)(withTransforms, box);
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $a3660d4bbd841766$export$58b16271041fbfb)(withTransforms, {
                            x: -node.scroll.offset.x,
                            y: -node.scroll.offset.y
                        });
                        if (!(0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(node.latestValues)) continue;
                        (0, $a3660d4bbd841766$export$58b16271041fbfb)(withTransforms, node.latestValues);
                    }
                    if ((0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(this.latestValues)) (0, $a3660d4bbd841766$export$58b16271041fbfb)(withTransforms, this.latestValues);
                    return withTransforms;
                }
            },
            {
                key: "removeTransform",
                value: function removeTransform(box) {
                    var boxWithoutTransform = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    (0, $a723b2b360843335$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        if (!node.instance) continue;
                        if (!(0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(node.latestValues)) continue;
                        (0, $9b4f6a65c1609be2$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                        var sourceBox = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                        var nodeBox = node.measurePageBox();
                        (0, $a723b2b360843335$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                        (0, $5cdc90a77563ad73$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
                    }
                    if ((0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(this.latestValues)) (0, $5cdc90a77563ad73$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
                    return boxWithoutTransform;
                }
            },
            {
                key: "setTargetDelta",
                value: function setTargetDelta(delta) {
                    this.targetDelta = delta;
                    this.root.scheduleUpdateProjection();
                    this.isProjectionDirty = true;
                }
            },
            {
                key: "setOptions",
                value: function setOptions(options) {
                    this.options = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, this.options, options), {
                        crossfade: options.crossfade !== undefined ? options.crossfade : true
                    });
                }
            },
            {
                key: "clearMeasurements",
                value: function clearMeasurements() {
                    this.scroll = undefined;
                    this.layout = undefined;
                    this.snapshot = undefined;
                    this.prevTransformTemplateValue = undefined;
                    this.targetDelta = undefined;
                    this.target = undefined;
                    this.isLayoutDirty = false;
                }
            },
            {
                key: "forceRelativeParentToResolveTarget",
                value: function forceRelativeParentToResolveTarget() {
                    if (!this.relativeParent) return;
                    /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
                }
            },
            {
                key: "resolveTargetDelta",
                value: function resolveTargetDelta() {
                    var forceRecalculation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _a;
                    /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ var lead = this.getLead();
                    this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
                    this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
                    this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ var canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
                    this.resolvedRelativeTargetAt = (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp;
                    /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                        var relativeParent = this.getClosestProjectingParent();
                        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                            this.relativeParent = relativeParent;
                            this.forceRelativeParentToResolveTarget();
                            this.relativeTarget = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                            this.relativeTargetOrigin = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                            (0, $3fdd03eb18d7c56c$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                            (0, $a723b2b360843335$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                        } else this.relativeParent = this.relativeTarget = undefined;
                    }
                    /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
                    /**
             * Lazy-init target data structure
             */ if (!this.target) {
                        this.target = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                        this.targetWithTransforms = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    }
                    /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                        this.forceRelativeParentToResolveTarget();
                        (0, $3fdd03eb18d7c56c$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
                    /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                        if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                        this.target = this.applyTransform(this.layout.layoutBox);
                        else (0, $a723b2b360843335$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                        (0, $a3660d4bbd841766$export$d80074982803af5c)(this.target, this.targetDelta);
                    } else /**
                 * If no target, use own layout as target
                 */ (0, $a723b2b360843335$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                    /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                        this.attemptToResolveRelativeTarget = false;
                        var relativeParent1 = this.getClosestProjectingParent();
                        if (relativeParent1 && Boolean(relativeParent1.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent1.options.layoutScroll && relativeParent1.target && this.animationProgress !== 1) {
                            this.relativeParent = relativeParent1;
                            this.forceRelativeParentToResolveTarget();
                            this.relativeTarget = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                            this.relativeTargetOrigin = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                            (0, $3fdd03eb18d7c56c$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent1.target);
                            (0, $a723b2b360843335$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                        } else this.relativeParent = this.relativeTarget = undefined;
                    }
                    /**
             * Increase debug counter for resolved target deltas
             */ $a4fa0da8ce0f2603$var$projectionFrameData.resolvedTargetDeltas++;
                }
            },
            {
                key: "getClosestProjectingParent",
                value: function getClosestProjectingParent() {
                    if (!this.parent || (0, $9b4f6a65c1609be2$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $9b4f6a65c1609be2$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
                    if (this.parent.isProjecting()) return this.parent;
                    else return this.parent.getClosestProjectingParent();
                }
            },
            {
                key: "isProjecting",
                value: function isProjecting() {
                    return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
                }
            },
            {
                key: "calcProjection",
                value: function calcProjection() {
                    var _a;
                    var lead = this.getLead();
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    var canSkip = true;
                    /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
                    /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
                    /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $1134021eb916ca42$export$fff89137e9e818ce).timestamp) canSkip = false;
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
                    if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
                    if (!this.layout || !(layout || layoutId)) return;
                    /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $a723b2b360843335$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
                    /**
             * Record previous tree scales before updating.
             */ var prevTreeScaleX = this.treeScale.x;
                    var prevTreeScaleY = this.treeScale.y;
                    /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $a3660d4bbd841766$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
                    /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                        lead.target = lead.layout.layoutBox;
                        lead.targetWithTransforms = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    }
                    var target = lead.target;
                    if (!target) {
                        /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                            this.projectionDelta = (0, $663055bf986a28b3$export$3d227df54007d73a)();
                            this.projectionTransform = "none";
                            this.scheduleRender();
                        }
                        return;
                    }
                    if (!this.projectionDelta) {
                        this.projectionDelta = (0, $663055bf986a28b3$export$3d227df54007d73a)();
                        this.projectionDeltaWithTransform = (0, $663055bf986a28b3$export$3d227df54007d73a)();
                    }
                    var prevProjectionTransform = this.projectionTransform;
                    /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $3fdd03eb18d7c56c$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
                    this.projectionTransform = (0, $1d516ac34e3f30b2$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
                    if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                        this.hasProjected = true;
                        this.scheduleRender();
                        this.notifyListeners("projectionUpdate", target);
                    }
                    /**
             * Increase debug counter for recalculated projections
             */ $a4fa0da8ce0f2603$var$projectionFrameData.recalculatedProjection++;
                }
            },
            {
                key: "hide",
                value: function hide() {
                    this.isVisible = false;
                // TODO: Schedule render
                }
            },
            {
                key: "show",
                value: function show() {
                    this.isVisible = true;
                // TODO: Schedule render
                }
            },
            {
                key: "scheduleRender",
                value: function scheduleRender() {
                    var notifyAll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.options.scheduleRender && this.options.scheduleRender();
                    if (notifyAll) {
                        var stack = this.getStack();
                        stack && stack.scheduleRender();
                    }
                    if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
                }
            },
            {
                key: "setAnimationOrigin",
                value: function setAnimationOrigin(delta) {
                    var _this = this;
                    var hasOnlyRelativeTargetChanged = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var snapshot = this.snapshot;
                    var snapshotLatestValues = snapshot ? snapshot.latestValues : {};
                    var mixedValues = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, this.latestValues);
                    var targetDelta = (0, $663055bf986a28b3$export$3d227df54007d73a)();
                    if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
                    this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
                    var relativeLayout = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    var snapshotSource = snapshot ? snapshot.source : undefined;
                    var layoutSource = this.layout ? this.layout.source : undefined;
                    var isSharedLayoutAnimation = snapshotSource !== layoutSource;
                    var stack = this.getStack();
                    var isOnlyMember = !stack || stack.members.length <= 1;
                    var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($a4fa0da8ce0f2603$var$hasOpacityCrossfade));
                    this.animationProgress = 0;
                    var prevRelativeTarget;
                    this.mixTargetDelta = function(latest) {
                        var progress = latest / 1000;
                        $a4fa0da8ce0f2603$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                        $a4fa0da8ce0f2603$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                        _this.setTargetDelta(targetDelta);
                        if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && _this.relativeParent && _this.relativeParent.layout) {
                            (0, $3fdd03eb18d7c56c$export$2785bfcc929c5650)(relativeLayout, _this.layout.layoutBox, _this.relativeParent.layout.layoutBox);
                            $a4fa0da8ce0f2603$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                            /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $4690f6bd1285a864$export$8d5cf76bb7daff09)(_this.relativeTarget, prevRelativeTarget)) _this.isProjectionDirty = false;
                            if (!prevRelativeTarget) prevRelativeTarget = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                            (0, $a723b2b360843335$export$c53fd88f45d77e4b)(prevRelativeTarget, _this.relativeTarget);
                        }
                        if (isSharedLayoutAnimation) {
                            _this.animationValues = mixedValues;
                            (0, $f9e781f51bc03c71$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                        }
                        _this.root.scheduleUpdateProjection();
                        _this.scheduleRender();
                        _this.animationProgress = progress;
                    };
                    this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
                }
            },
            {
                key: "startAnimation",
                value: function startAnimation(options) {
                    var _this = this;
                    this.notifyListeners("animationStart");
                    this.currentAnimation && this.currentAnimation.stop();
                    if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
                    if (this.pendingAnimation) {
                        (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(this.pendingAnimation);
                        this.pendingAnimation = undefined;
                    }
                    /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $1134021eb916ca42$export$2cef06c20297c17d).update(function() {
                        (0, $13965e5337addde9$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                        _this.currentAnimation = (0, $ea6034c54dd87d32$export$335a17c977067b99)(0, $a4fa0da8ce0f2603$var$animationTarget, (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options), {
                            onUpdate: function(latest) {
                                _this.mixTargetDelta(latest);
                                options.onUpdate && options.onUpdate(latest);
                            },
                            onComplete: function() {
                                options.onComplete && options.onComplete();
                                _this.completeAnimation();
                            }
                        }));
                        if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                        _this.pendingAnimation = undefined;
                    });
                }
            },
            {
                key: "completeAnimation",
                value: function completeAnimation() {
                    if (this.resumingFrom) {
                        this.resumingFrom.currentAnimation = undefined;
                        this.resumingFrom.preserveOpacity = undefined;
                    }
                    var stack = this.getStack();
                    stack && stack.exitAnimationComplete();
                    this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
                    this.notifyListeners("animationComplete");
                }
            },
            {
                key: "finishAnimation",
                value: function finishAnimation() {
                    if (this.currentAnimation) {
                        this.mixTargetDelta && this.mixTargetDelta($a4fa0da8ce0f2603$var$animationTarget);
                        this.currentAnimation.stop();
                    }
                    this.completeAnimation();
                }
            },
            {
                key: "applyTransformsToTarget",
                value: function applyTransformsToTarget() {
                    var lead = this.getLead();
                    var targetWithTransforms = lead.targetWithTransforms, target = lead.target, layout = lead.layout, latestValues = lead.latestValues;
                    if (!targetWithTransforms || !target || !layout) return;
                    /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $a4fa0da8ce0f2603$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                        target = this.target || (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                        var xLength = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(this.layout.layoutBox.x);
                        target.x.min = lead.target.x.min;
                        target.x.max = target.x.min + xLength;
                        var yLength = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(this.layout.layoutBox.y);
                        target.y.min = lead.target.y.min;
                        target.y.max = target.y.min + yLength;
                    }
                    (0, $a723b2b360843335$export$c53fd88f45d77e4b)(targetWithTransforms, target);
                    /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $a3660d4bbd841766$export$58b16271041fbfb)(targetWithTransforms, latestValues);
                    /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $3fdd03eb18d7c56c$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
                }
            },
            {
                key: "registerSharedNode",
                value: function registerSharedNode(layoutId, node) {
                    if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $f12c4077ced3b8ac$export$39be5b2d82fc9dc7)());
                    var stack = this.sharedNodes.get(layoutId);
                    stack.add(node);
                    var config = node.options.initialPromotionConfig;
                    node.promote({
                        transition: config ? config.transition : undefined,
                        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
                    });
                }
            },
            {
                key: "isLead",
                value: function isLead() {
                    var stack = this.getStack();
                    return stack ? stack.lead === this : true;
                }
            },
            {
                key: "getLead",
                value: function getLead() {
                    var _a;
                    var layoutId = this.options.layoutId;
                    return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
                }
            },
            {
                key: "getPrevLead",
                value: function getPrevLead() {
                    var _a;
                    var layoutId = this.options.layoutId;
                    return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
                }
            },
            {
                key: "getStack",
                value: function getStack() {
                    var layoutId = this.options.layoutId;
                    if (layoutId) return this.root.sharedNodes.get(layoutId);
                }
            },
            {
                key: "promote",
                value: function promote() {
                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, needsReset = _ref.needsReset, transition = _ref.transition, preserveFollowOpacity = _ref.preserveFollowOpacity;
                    var stack = this.getStack();
                    if (stack) stack.promote(this, preserveFollowOpacity);
                    if (needsReset) {
                        this.projectionDelta = undefined;
                        this.needsReset = true;
                    }
                    if (transition) this.setOptions({
                        transition: transition
                    });
                }
            },
            {
                key: "relegate",
                value: function relegate() {
                    var stack = this.getStack();
                    if (stack) return stack.relegate(this);
                    else return false;
                }
            },
            {
                key: "resetSkewAndRotation",
                value: function resetSkewAndRotation() {
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return;
                    // If there's no detected skew or rotation values, we can early return without a forced render.
                    var hasDistortingTransform = false;
                    /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ var latestValues = visualElement.latestValues;
                    if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
                    // If there's no distorting values, we don't need to do any more.
                    if (!hasDistortingTransform) return;
                    var resetValues = {};
                    if (latestValues.z) $a4fa0da8ce0f2603$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
                    // Check the skew and rotate value of all axes and reset to 0
                    for(var i = 0; i < $a4fa0da8ce0f2603$var$transformAxes.length; i++){
                        $a4fa0da8ce0f2603$var$resetDistortingTransform("rotate".concat($a4fa0da8ce0f2603$var$transformAxes[i]), visualElement, resetValues, this.animationValues);
                        $a4fa0da8ce0f2603$var$resetDistortingTransform("skew".concat($a4fa0da8ce0f2603$var$transformAxes[i]), visualElement, resetValues, this.animationValues);
                    }
                    // Force a render of this element to apply the transform with all skews and rotations
                    // set to 0.
                    visualElement.render();
                    // Put back all the values we reset
                    for(var key in resetValues){
                        visualElement.setStaticValue(key, resetValues[key]);
                        if (this.animationValues) this.animationValues[key] = resetValues[key];
                    }
                    // Schedule a render for the next frame. This ensures we won't visually
                    // see the element with the reset rotate value applied.
                    visualElement.scheduleRender();
                }
            },
            {
                key: "getProjectionStyles",
                value: function getProjectionStyles(styleProp) {
                    var _a, _b;
                    if (!this.instance || this.isSVG) return undefined;
                    if (!this.isVisible) return $a4fa0da8ce0f2603$var$hiddenVisibility;
                    var styles = {
                        visibility: ""
                    };
                    var transformTemplate = this.getTransformTemplate();
                    if (this.needsReset) {
                        this.needsReset = false;
                        styles.opacity = "";
                        styles.pointerEvents = (0, $ed000a70011c0ae0$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                        return styles;
                    }
                    var lead = this.getLead();
                    if (!this.projectionDelta || !this.layout || !lead.target) {
                        var emptyStyles = {};
                        if (this.options.layoutId) {
                            emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                            emptyStyles.pointerEvents = (0, $ed000a70011c0ae0$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        }
                        if (this.hasProjected && !(0, $9b4f6a65c1609be2$export$a545127cf1fbb600)(this.latestValues)) {
                            emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                            this.hasProjected = false;
                        }
                        return emptyStyles;
                    }
                    var valuesToRender = lead.animationValues || lead.latestValues;
                    this.applyTransformsToTarget();
                    styles.transform = (0, $1d516ac34e3f30b2$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
                    if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
                    var _this_projectionDelta = this.projectionDelta, x = _this_projectionDelta.x, y = _this_projectionDelta.y;
                    styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
                    if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
                    else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
                    /**
             * Apply scale correction
             */ for(var key in 0, $ae2875b24a733eed$export$91ddd985b97788d1){
                        if (valuesToRender[key] === undefined) continue;
                        var _scaleCorrectors_key = (0, $ae2875b24a733eed$export$91ddd985b97788d1)[key], correct = _scaleCorrectors_key.correct, applyTo = _scaleCorrectors_key.applyTo;
                        /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ var corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                        if (applyTo) {
                            var num = applyTo.length;
                            for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                        } else styles[key] = corrected;
                    }
                    /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $ed000a70011c0ae0$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
                    return styles;
                }
            },
            {
                key: "clearSnapshot",
                value: function clearSnapshot() {
                    this.resumeFrom = this.snapshot = undefined;
                }
            },
            {
                // Only run on root
                key: "resetTree",
                value: function resetTree() {
                    this.root.nodes.forEach(function(node) {
                        var _a;
                        return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
                    });
                    this.root.nodes.forEach($a4fa0da8ce0f2603$var$clearMeasurements);
                    this.root.sharedNodes.clear();
                }
            }
        ]);
        return ProjectionNode;
    }();
}
function $a4fa0da8ce0f2603$var$updateLayout(node) {
    node.updateLayout();
}
function $a4fa0da8ce0f2603$var$notifyLayoutUpdate(node) {
    var _a;
    var snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _node_layout = node.layout, layout = _node_layout.layoutBox, measuredLayout = _node_layout.measuredBox;
        var animationType = node.options.animationType;
        var isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($a4fa0da8ce0f2603$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $61436e0004160986$export$b789de563eb43b1)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, $3fdd03eb18d7c56c$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        var layoutDelta = (0, $663055bf986a28b3$export$3d227df54007d73a)();
        (0, $3fdd03eb18d7c56c$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        var visualDelta = (0, $663055bf986a28b3$export$3d227df54007d73a)();
        if (isShared) (0, $3fdd03eb18d7c56c$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $3fdd03eb18d7c56c$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        var hasLayoutChanged = !(0, $4690f6bd1285a864$export$a7ec7642fe550fb6)(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            var relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                var parentSnapshot = relativeParent.snapshot, parentLayout = relativeParent.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    (0, $3fdd03eb18d7c56c$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    var relativeLayout = (0, $663055bf986a28b3$export$6459fc9e86be362e)();
                    (0, $3fdd03eb18d7c56c$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $4690f6bd1285a864$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        var onExitComplete = node.options.onExitComplete;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $a4fa0da8ce0f2603$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $a4fa0da8ce0f2603$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $a4fa0da8ce0f2603$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $a4fa0da8ce0f2603$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $a4fa0da8ce0f2603$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $a4fa0da8ce0f2603$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $a4fa0da8ce0f2603$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $a4fa0da8ce0f2603$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $a4fa0da8ce0f2603$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $a4fa0da8ce0f2603$var$calcProjection(node) {
    node.calcProjection();
}
function $a4fa0da8ce0f2603$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $a4fa0da8ce0f2603$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $a4fa0da8ce0f2603$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $a4fa0da8ce0f2603$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $364e42417e478d28$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $a4fa0da8ce0f2603$export$6ffd3e6ae339a132(output, from, to, p) {
    $a4fa0da8ce0f2603$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $a4fa0da8ce0f2603$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $a4fa0da8ce0f2603$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $a4fa0da8ce0f2603$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
var $a4fa0da8ce0f2603$var$userAgentContains = function(string) {
    return typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
};
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ var $a4fa0da8ce0f2603$var$roundPoint = $a4fa0da8ce0f2603$var$userAgentContains("applewebkit/") && !$a4fa0da8ce0f2603$var$userAgentContains("chrome/") ? Math.round : (0, $fb816313cb795261$export$8793edee2d425525);
function $a4fa0da8ce0f2603$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $a4fa0da8ce0f2603$var$roundPoint(axis.min);
    axis.max = $a4fa0da8ce0f2603$var$roundPoint(axis.max);
}
function $a4fa0da8ce0f2603$var$roundBox(box) {
    $a4fa0da8ce0f2603$var$roundAxis(box.x);
    $a4fa0da8ce0f2603$var$roundAxis(box.y);
}
function $a4fa0da8ce0f2603$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $3fdd03eb18d7c56c$export$28d0384c4b79bde2)((0, $4690f6bd1285a864$export$c5706146bc63213)(snapshot), (0, $4690f6bd1285a864$export$c5706146bc63213)(layout), 0.2);
}




var $4d4656ea29856bc8$export$2d029a49a09b6177 = (0, $a4fa0da8ce0f2603$export$a84b61f69daa9da0)({
    attachResizeListener: function(ref, notify) {
        return (0, $63bd599df9fc420d$export$b1d829ddf82884aa)(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});


var $6d52979c0e32fd4d$export$b91509fcf893b648 = {
    current: undefined
};
var $6d52979c0e32fd4d$export$b61a9eb3dbde8858 = (0, $a4fa0da8ce0f2603$export$a84b61f69daa9da0)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$6d52979c0e32fd4d$export$b91509fcf893b648.current) {
            var documentNode = new (0, $4d4656ea29856bc8$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $6d52979c0e32fd4d$export$b91509fcf893b648.current = documentNode;
        }
        return $6d52979c0e32fd4d$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});


var $50f17eda5c58cf90$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $1556b743982d1d5a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $154ee79a98f34d03$export$5d97dc2872682820),
        ProjectionNode: (0, $6d52979c0e32fd4d$export$b61a9eb3dbde8858),
        MeasureLayout: (0, $31d7336c9fb9e92d$export$779f5fb01ad751cd)
    }
};



var $dQFEZ = parcelRequire("dQFEZ");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");








var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");



var $2us1u = parcelRequire("2us1u");


// Does this device prefer reduced motion? Returns `null` server-side.
var $2e86db59cd05f2ca$export$ff7706047246b98b = {
    current: null
};
var $2e86db59cd05f2ca$export$6476d16e2fd2d0db = {
    current: false
};


function $3a596c09e0fdcb12$export$ca9f41fb23dded3d() {
    (0, $2e86db59cd05f2ca$export$6476d16e2fd2d0db).current = true;
    if (!(0, $d40be6a98a50f608$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return (0, $2e86db59cd05f2ca$export$ff7706047246b98b).current = motionMediaQuery.matches;
        };
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $2e86db59cd05f2ca$export$ff7706047246b98b).current = false;
}












function $d0b6ac0904d794c4$export$9a552858d5197f6e(element, next, prev) {
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $719c6b4fb69ff79d$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $719c6b4fb69ff79d$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $bde97c2bbeed274b$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                var latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $bde97c2bbeed274b$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(var key1 in prev)if (next[key1] === undefined) element.removeValue(key1);
    return next;
}






var $4f7e1a63f43516e5$export$bc2a978a17abfdde = new WeakMap();






var $2us1u = parcelRequire("2us1u");




/**
 * A list of all ValueTypes
 */ var $c8acc314005bb26d$var$valueTypes = (0, $2us1u._)((0, $d62090a0ae012143$export$d176691c1998a1f5)).concat([
    (0, $d95c076f89c05413$export$35e9368ef982300f),
    (0, $69b61e406d097f9e$export$83a0e34f1302825b)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $c8acc314005bb26d$export$950e7e59ea1ffed7 = function(v) {
    return $c8acc314005bb26d$var$valueTypes.find((0, $f994341bffd015be$export$6eae4d0a6a7ca7cd)(v));
};





var $fdabed03578d55f2$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
var $fdabed03578d55f2$var$numVariantProps = (0, $1500c6a0728839ac$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ var $fdabed03578d55f2$export$fa8b653c0f3714e5 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElement(param) {
        var _this = this;
        var parent = param.parent, props = param.props, presenceContext = param.presenceContext, reducedMotionConfig = param.reducedMotionConfig, blockInitialAnimation = param.blockInitialAnimation, visualState = param.visualState, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $grujF._)(this, VisualElement);
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        this.resolveKeyframes = function(keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value) {
            return new _this.KeyframeResolver(keyframes, onComplete, name, value, _this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $13b26bd7daa0ff86$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = function() {
            return _this.notify("Update", _this.latestValues);
        };
        this.render = function() {
            if (!_this.current) return;
            _this.triggerBuild();
            _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
        };
        this.scheduleRender = function() {
            return (0, $1134021eb916ca42$export$2cef06c20297c17d).render(_this.render, false, true);
        };
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, latestValues);
        this.initialValues = props.initial ? (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $0b7e066ec777c86a$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $0b7e066ec777c86a$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), willChange = _this_scrapeMotionValuesFromProps.willChange, initialMotionValues = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    (0, $dhMkv._)(VisualElement, [
        {
            /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
                return {};
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                var _this = this;
                this.current = instance;
                (0, $4f7e1a63f43516e5$export$bc2a978a17abfdde).set(instance, this);
                if (this.projection && !this.projection.instance) this.projection.mount(instance);
                if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
                this.values.forEach(function(value, key) {
                    return _this.bindToMotionValue(key, value);
                });
                if (!(0, $2e86db59cd05f2ca$export$6476d16e2fd2d0db).current) (0, $3a596c09e0fdcb12$export$ca9f41fb23dded3d)();
                this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $2e86db59cd05f2ca$export$ff7706047246b98b).current;
                if (this.parent) this.parent.children.add(this);
                this.update(this.props, this.presenceContext);
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                (0, $4f7e1a63f43516e5$export$bc2a978a17abfdde).delete(this.current);
                this.projection && this.projection.unmount();
                (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(this.notifyUpdate);
                (0, $1134021eb916ca42$export$ec99c0ef4978dccb)(this.render);
                this.valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                this.removeFromVariantTree && this.removeFromVariantTree();
                this.parent && this.parent.children.delete(this);
                for(var key in this.events)this.events[key].clear();
                for(var key1 in this.features){
                    var feature = this.features[key1];
                    if (feature) {
                        feature.unmount();
                        feature.isMounted = false;
                    }
                }
                this.current = null;
            }
        },
        {
            key: "bindToMotionValue",
            value: function bindToMotionValue(key, value) {
                var _this = this;
                var valueIsTransform = (0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(key);
                var removeOnChange = value.on("change", function(latestValue) {
                    _this.latestValues[key] = latestValue;
                    _this.props.onUpdate && (0, $1134021eb916ca42$export$2cef06c20297c17d).preRender(_this.notifyUpdate);
                    if (valueIsTransform && _this.projection) _this.projection.isTransformDirty = true;
                });
                var removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
                this.valueSubscriptions.set(key, function() {
                    removeOnChange();
                    removeOnRenderRequest();
                    if (value.owner) value.stop();
                });
            }
        },
        {
            key: "sortNodePosition",
            value: function sortNodePosition(other) {
                /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
                return this.sortInstanceNodePosition(this.current, other.current);
            }
        },
        {
            key: "updateFeatures",
            value: function updateFeatures() {
                var key = "animation";
                for(key in 0, $62bab7f5fc850b6e$export$65570e08d843624d){
                    var featureDefinition = (0, $62bab7f5fc850b6e$export$65570e08d843624d)[key];
                    if (!featureDefinition) continue;
                    var isEnabled = featureDefinition.isEnabled, FeatureConstructor = featureDefinition.Feature;
                    /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
                    /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                        var feature = this.features[key];
                        if (feature.isMounted) feature.update();
                        else {
                            feature.mount();
                            feature.isMounted = true;
                        }
                    }
                }
            }
        },
        {
            key: "triggerBuild",
            value: function triggerBuild() {
                this.build(this.renderState, this.latestValues, this.props);
            }
        },
        {
            /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ key: "measureViewportBox",
            value: function measureViewportBox() {
                return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $663055bf986a28b3$export$6459fc9e86be362e)();
            }
        },
        {
            key: "getStaticValue",
            value: function getStaticValue(key) {
                return this.latestValues[key];
            }
        },
        {
            key: "setStaticValue",
            value: function setStaticValue(key, value) {
                this.latestValues[key] = value;
            }
        },
        {
            /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ key: "update",
            value: function update(props, presenceContext) {
                if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
                this.prevProps = this.props;
                this.props = props;
                this.prevPresenceContext = this.presenceContext;
                this.presenceContext = presenceContext;
                /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(var i = 0; i < $fdabed03578d55f2$var$propEventHandlers.length; i++){
                    var key = $fdabed03578d55f2$var$propEventHandlers[i];
                    if (this.propEventSubscriptions[key]) {
                        this.propEventSubscriptions[key]();
                        delete this.propEventSubscriptions[key];
                    }
                    var listenerName = "on" + key;
                    var listener = props[listenerName];
                    if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
                }
                this.prevMotionValues = (0, $d0b6ac0904d794c4$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
                if (this.handleChildMotionValue) this.handleChildMotionValue();
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                return this.props;
            }
        },
        {
            /**
     * Returns the variant definition with a given name.
     */ key: "getVariant",
            value: function getVariant(name) {
                return this.props.variants ? this.props.variants[name] : undefined;
            }
        },
        {
            /**
     * Returns the defined default transition on this component.
     */ key: "getDefaultTransition",
            value: function getDefaultTransition() {
                return this.props.transition;
            }
        },
        {
            key: "getTransformPagePoint",
            value: function getTransformPagePoint() {
                return this.props.transformPagePoint;
            }
        },
        {
            key: "getClosestVariantNode",
            value: function getClosestVariantNode() {
                return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
            }
        },
        {
            key: "getVariantContext",
            value: function getVariantContext() {
                var startAtParent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
                if (!this.isControllingVariants) {
                    var context = this.parent ? this.parent.getVariantContext() || {} : {};
                    if (this.props.initial !== undefined) context.initial = this.props.initial;
                    return context;
                }
                var context1 = {};
                for(var i = 0; i < $fdabed03578d55f2$var$numVariantProps; i++){
                    var name = (0, $1500c6a0728839ac$export$1405a65085f40b9)[i];
                    var prop = this.props[name];
                    if ((0, $e0f40a620bc45744$export$720b90e312cea233)(prop) || prop === false) context1[name] = prop;
                }
                return context1;
            }
        },
        {
            /**
     * Add a child visual element to our set of children.
     */ key: "addVariantChild",
            value: function addVariantChild(child) {
                var closestVariantNode = this.getClosestVariantNode();
                if (closestVariantNode) {
                    closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }
        },
        {
            /**
     * Add a motion value and bind it to this visual element.
     */ key: "addValue",
            value: function addValue(key, value) {
                // Remove existing value if it exists
                var existingValue = this.values.get(key);
                if (value !== existingValue) {
                    if (existingValue) this.removeValue(key);
                    this.bindToMotionValue(key, value);
                    this.values.set(key, value);
                    this.latestValues[key] = value.get();
                }
            }
        },
        {
            /**
     * Remove a motion value and unbind any active subscriptions.
     */ key: "removeValue",
            value: function removeValue(key) {
                this.values.delete(key);
                var unsubscribe = this.valueSubscriptions.get(key);
                if (unsubscribe) {
                    unsubscribe();
                    this.valueSubscriptions.delete(key);
                }
                delete this.latestValues[key];
                this.removeValueFromRenderState(key, this.renderState);
            }
        },
        {
            /**
     * Check whether we have a motion value for this key
     */ key: "hasValue",
            value: function hasValue(key) {
                return this.values.has(key);
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (this.props.values && this.props.values[key]) return this.props.values[key];
                var value = this.values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $bde97c2bbeed274b$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                        owner: this
                    });
                    this.addValue(key, value);
                }
                return value;
            }
        },
        {
            /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ key: "readValue",
            value: function readValue(key, target) {
                var _a;
                var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
                if (value !== undefined && value !== null) {
                    if (typeof value === "string" && ((0, $b224a6dcf0077c0f$export$65583ed5a868f2d9)(value) || (0, $86b034b188fdb549$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
                    value = parseFloat(value);
                    else if (!(0, $c8acc314005bb26d$export$950e7e59ea1ffed7)(value) && (0, $69b61e406d097f9e$export$83a0e34f1302825b).test(target)) value = (0, $d0ba51653f20745d$export$cea0cedcb94873b5)(key, target);
                    this.setBaseTarget(key, (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(value) ? value.get() : value);
                }
                return (0, $719c6b4fb69ff79d$export$605d60a2578142d3)(value) ? value.get() : value;
            }
        },
        {
            /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ key: "setBaseTarget",
            value: function setBaseTarget(key, value) {
                this.baseTarget[key] = value;
            }
        },
        {
            /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ key: "getBaseTarget",
            value: function getBaseTarget(key) {
                var _a;
                var initial = this.props.initial;
                var valueFromInitial;
                if (typeof initial === "string" || typeof initial === "object") {
                    var variant = (0, $f00bc84c0df1779b$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
                    if (variant) valueFromInitial = variant[key];
                }
                /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
                /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ var target = this.getBaseTargetFromProps(this.props, key);
                if (target !== undefined && !(0, $719c6b4fb69ff79d$export$605d60a2578142d3)(target)) return target;
                /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!this.events[eventName]) this.events[eventName] = new (0, $520c7c228cb8ad64$export$e7dff9482a5fd23c)();
                return this.events[eventName].add(callback);
            }
        },
        {
            key: "notify",
            value: function notify(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_events_eventName;
                if (this.events[eventName]) (_this_events_eventName = this.events[eventName]).notify.apply(_this_events_eventName, (0, $2us1u._)(args));
            }
        }
    ]);
    return VisualElement;
}();



var $65587fadb6626131$export$e49735c2a366bdc7 = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, $j6Mzi._)(DOMVisualElement, VisualElement);
    var _super = (0, $lngen._)(DOMVisualElement);
    function DOMVisualElement() {
        (0, $grujF._)(this, DOMVisualElement);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.KeyframeResolver = (0, $7bfe4cc0123b898c$export$4983792d11b61017);
        return _this;
    }
    (0, $dhMkv._)(DOMVisualElement, [
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition(a, b) {
                /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props.style ? props.style[key] : undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, param) {
                var vars = param.vars, style = param.style;
                delete vars[key];
                delete style[key];
            }
        }
    ]);
    return DOMVisualElement;
}((0, $fdabed03578d55f2$export$fa8b653c0f3714e5));



function $db240cc0f9efa76a$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $db240cc0f9efa76a$export$23fea75b03ac16b3 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $j6Mzi._)(HTMLVisualElement, DOMVisualElement);
    var _super = (0, $lngen._)(HTMLVisualElement);
    function HTMLVisualElement() {
        (0, $grujF._)(this, HTMLVisualElement);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = "html";
        _this.applyWillChange = true;
        return _this;
    }
    (0, $dhMkv._)(HTMLVisualElement, [
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ((0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(key)) {
                    var defaultType = (0, $ded79850b04b204e$export$67d1babe0338d23b)(key);
                    return defaultType ? defaultType.default || 0 : 0;
                } else {
                    var computedStyle = $db240cc0f9efa76a$export$3735103072e4a80(instance);
                    var value = ((0, $fa15c42eacb6654d$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
                    return typeof value === "string" ? value.trim() : value;
                }
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox(instance, param) {
                var transformPagePoint = param.transformPagePoint;
                return (0, $f497d115c831d12d$export$d8718b6a7e5c624e)(instance, transformPagePoint);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $13cbff5e14cbcd80$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $4ba2c6b29cfaba58$export$16da615486abaa45)(props, prevProps, visualElement);
            }
        },
        {
            key: "handleChildMotionValue",
            value: function handleChildMotionValue() {
                var _this = this;
                if (this.childSubscription) {
                    this.childSubscription();
                    delete this.childSubscription;
                }
                var children = this.props.children;
                if ((0, $719c6b4fb69ff79d$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", function(latest) {
                    if (_this.current) _this.current.textContent = "".concat(latest);
                });
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, renderState, styleProp, projection) {
                (0, $0ec3e01a84905c76$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
            }
        }
    ]);
    return HTMLVisualElement;
}((0, $65587fadb6626131$export$e49735c2a366bdc7));



var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");


var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $lngen = parcelRequire("lngen");










var $538966105ebede37$export$86bcdffbaf733d84 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $j6Mzi._)(SVGVisualElement, DOMVisualElement);
    var _super = (0, $lngen._)(SVGVisualElement);
    function SVGVisualElement() {
        (0, $grujF._)(this, SVGVisualElement);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = "svg";
        _this.isSVGTag = false;
        return _this;
    }
    (0, $dhMkv._)(SVGVisualElement, [
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props[key];
            }
        },
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ((0, $458c1d3a49d65b1f$export$7b42a0094fb00b6e).has(key)) {
                    var defaultType = (0, $ded79850b04b204e$export$67d1babe0338d23b)(key);
                    return defaultType ? defaultType.default || 0 : 0;
                }
                key = !(0, $944d9d7404e87d24$export$28931db5d57958e5).has(key) ? (0, $954f6dcdfd539927$export$9fd24a634729c672)(key) : key;
                return instance.getAttribute(key);
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox() {
                return (0, $663055bf986a28b3$export$6459fc9e86be362e)();
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $a6468c62becd11cf$export$16da615486abaa45)(props, prevProps, visualElement);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $91df2c47b15ea8f0$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, renderState, styleProp, projection) {
                (0, $b00285c0951e7b7f$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                this.isSVGTag = (0, $baea5e7697904cc6$export$6328ce7565ea1049)(instance.tagName);
                (0, $8665ac34acf389ad$export$71511d61b312f219)((0, $gyGuQ._)(SVGVisualElement.prototype), "mount", this).call(this, instance);
            }
        }
    ]);
    return SVGVisualElement;
}((0, $65587fadb6626131$export$e49735c2a366bdc7));



var $48d7af1c7071e507$export$56ba0183203348f5 = function(Component, options) {
    return (0, $d3214709b7c7176a$export$88f3fc2fd3766989)(Component) ? new (0, $538966105ebede37$export$86bcdffbaf733d84)(options) : new (0, $db240cc0f9efa76a$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $dQFEZ.Fragment)
    });
};




var $b80faf2c7d6ef320$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $6d52979c0e32fd4d$export$b61a9eb3dbde8858),
        MeasureLayout: (0, $31d7336c9fb9e92d$export$779f5fb01ad751cd)
    }
};


var $08cdba583e3e8032$var$preloadedFeatures = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, (0, $be27ed77b2e5a032$export$7f9953c70dacfd7f), (0, $0051659ccbbb73a2$export$e5b72898e5a201f1), (0, $50f17eda5c58cf90$export$d7d5d435647ed5a0), (0, $b80faf2c7d6ef320$export$b3219800bda33a1f));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $08cdba583e3e8032$export$e25e478948902b8b = /*@__PURE__*/ (0, $8bb37fa158ef1e8c$export$a28d6df673050e18)(function(Component, config) {
    return (0, $251dae90958b34e1$export$732916c0e88175fb)(Component, config, $08cdba583e3e8032$var$preloadedFeatures, (0, $48d7af1c7071e507$export$56ba0183203348f5));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $08cdba583e3e8032$export$546614c4a05701f9(key) {
    return (0, $b8cf0c54888a2417$export$46b7e4b9dc6110c3)((0, $251dae90958b34e1$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $08cdba583e3e8032$var$preloadedFeatures, (0, $48d7af1c7071e507$export$56ba0183203348f5)));
}


var $c5c6a7c34754f7b0$var$projects = [
    {
        title: "Kanbas",
        description: "A robust Learning Management System (LMS) inspired by Canvas, designed to streamline the management of courses, assignments, grades, and modules in an educational setting. ",
        image: "kanbas",
        link: "https://github.com/damyantjain/kanbas-react-web-app"
    },
    {
        title: "Jiffy",
        description: "A comprehensive food delivery application built with React.js, Redux, and TailwindCSS . Integrates live APIs from Swiggy offering real-time ordering experience.",
        image: "jiffy",
        link: "https://github.com/damyantjain/jiffy"
    },
    {
        title: "Admitly",
        description: "A unified admission portal for rapid admission process for both students and universities. Powered by Spring Boot and deployed on Azure Web Apps",
        image: "admitly",
        link: "https://github.com/gauravtejwani24/UniversityApplicationPortal"
    },
    {
        title: "Customer Manager",
        description: "A powerful WPF-based client for managing customer data, leveraging gRPC services for high performance and scalability utilizing streaming and asynchronous communication.",
        image: "customerManagement",
        link: "https://github.com/damyantjain/WPF-Customer-App"
    },
    {
        title: "useFormAutoSave",
        description: "A lightweight, customizable React hook that automatically saves form data to prevent loss during user sessions. Provides configurable save intervals, state persistence, and seamless integration with form libraries.",
        image: "useFormAutoSave",
        link: "https://github.com/damyantjain/use-form-auto-save"
    },
    {
        title: "Portfolio Website",
        description: "A responsive personal portfolio built with React, Tailwind CSS, and Framer Motion. Features interactive animations, dark mode support, and a clean, modern design to showcase my projects and skills.",
        image: "portfolio",
        link: "https://github.com/damyantjain/portfolio-website"
    },
    {
        title: "CoralCake",
        description: "A benchmarking platform for Large Language Models (LLMs). Run a single prompt across multiple LLMs (OpenAI, Mistral, etc.) and compare latency, token usage, and cost in real time. Export results as CSV/JSON and review historical runs side-by-side to pick the best model for your use case.",
        image: "coralcake",
        link: "https://github.com/damyantjain/CoralCake",
        demo: "https://coralcake.vercel.app"
    },
    {
        title: "NeatMeet",
        description: "A community event discovery app that allows users to explore events happening around them, filter events by location, search for events, and interact with the event community through voting and creating events.",
        image: "neatmeet",
        link: "https://github.com/damyantjain/NeatMeet"
    }
];
var $c5c6a7c34754f7b0$export$2e2bcd8739ae039 = $c5c6a7c34754f7b0$var$projects;




var $696ade2992fe63ba$exports = {};

$696ade2992fe63ba$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "kanbas.06923b96.png";


var $a22e3aadc49d902f$exports = {};

$a22e3aadc49d902f$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "customerManagement.8dd4aebf.png";


var $34da2f95572efc7d$exports = {};

$34da2f95572efc7d$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "jiffy.0f68bce1.png";


var $0d934b36de6515ce$exports = {};

$0d934b36de6515ce$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "admitly.ac94ca29.png";


var $858d78ab93fac6ac$exports = {};

$858d78ab93fac6ac$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "useFormAutoSave.a2222892.png";


var $d0e17801779e1ebc$exports = {};

$d0e17801779e1ebc$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "portfolio.468ea1f8.png";


var $705494969241933f$exports = {};

$705494969241933f$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "coralcake.d91a0f37.png";


var $71eb9a6e190443bc$exports = {};

$71eb9a6e190443bc$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "neatmeet.6262e700.png";



var $dQFEZ = parcelRequire("dQFEZ");

var $dQFEZ = parcelRequire("dQFEZ");
var $8c2bad7b63af33e9$var$ThemeContext = /*#__PURE__*/ (0, $dQFEZ.createContext)({
    darkMode: false
});
var $8c2bad7b63af33e9$export$2e2bcd8739ae039 = $8c2bad7b63af33e9$var$ThemeContext;


var $532e890b02ce793c$var$ProjectCard = function(param) {
    var project = param.project;
    var darkMode = (0, $dQFEZ.useContext)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039)).darkMode;
    var imageMap = {
        kanbas: (0, (/*@__PURE__*/$parcel$interopDefault($696ade2992fe63ba$exports))),
        customerManagement: (0, (/*@__PURE__*/$parcel$interopDefault($a22e3aadc49d902f$exports))),
        jiffy: (0, (/*@__PURE__*/$parcel$interopDefault($34da2f95572efc7d$exports))),
        admitly: (0, (/*@__PURE__*/$parcel$interopDefault($0d934b36de6515ce$exports))),
        useFormAutoSave: (0, (/*@__PURE__*/$parcel$interopDefault($858d78ab93fac6ac$exports))),
        portfolio: (0, (/*@__PURE__*/$parcel$interopDefault($d0e17801779e1ebc$exports))),
        coralcake: (0, (/*@__PURE__*/$parcel$interopDefault($705494969241933f$exports))),
        neatmeet: (0, (/*@__PURE__*/$parcel$interopDefault($71eb9a6e190443bc$exports)))
    };
    var itemVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 1.5,
                ease: "easeOut"
            }
        }
    };
    var handleProjectClick = function(link) {
        window.open(link, "_blank");
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $08cdba583e3e8032$export$e25e478948902b8b).div, {
        variants: itemVariants,
        className: "flex flex-col h-full",
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
            className: "hover:cursor-pointer hover:scale-95 transition-transform duration-500 ease-in-out transform h-full",
            onClick: function() {
                return handleProjectClick(project.link);
            },
            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex flex-col h-full rounded-xl shadow-lg shadow-[#b3b3b3] dark:shadow-[#1a1919] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "relative w-full h-48 md:h-52 lg:h-48 xl:h-56",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                className: "w-full h-full object-cover",
                                src: imageMap[project.image],
                                alt: project.name
                            }),
                            darkMode && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                className: "absolute inset-0 bg-black opacity-20"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "p-4 flex-grow",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h3", {
                                className: "font-bold text-xl mb-2",
                                children: project.title
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                className: "text-sm font-poppins dark:text-gray-400 text-gray-500",
                                children: project.description
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $532e890b02ce793c$export$2e2bcd8739ae039 = $532e890b02ce793c$var$ProjectCard;


var $b4f6e7ba3c6a9b08$var$Projects = function() {
    var _useInView = (0, $6ee4651e93391e62$export$2f62ee6831462844)({
        threshold: 0.3,
        triggerOnce: true
    }), ref = _useInView.ref, inView = _useInView.inView;
    var containerVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.3,
                duration: 1,
                ease: "easeOut"
            }
        }
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        ref: ref,
        className: "align-middle text-4xl text-[#333333] dark:text-[#e0e0e0]",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "text-center font-poppins",
                children: "My Projects"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $08cdba583e3e8032$export$e25e478948902b8b).div, {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 md:mt-20",
                initial: "hidden",
                animate: inView ? "visible" : "hidden",
                variants: containerVariants,
                children: (0, $c5c6a7c34754f7b0$export$2e2bcd8739ae039).map(function(project, index) {
                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $532e890b02ce793c$export$2e2bcd8739ae039), {
                        project: project
                    }, index);
                })
            })
        ]
    });
};
var $b4f6e7ba3c6a9b08$export$2e2bcd8739ae039 = $b4f6e7ba3c6a9b08$var$Projects;



parcelRequire("dQFEZ");
// src/db/skills.js
var $52b3f559cbbf28cf$var$skillList = [
    {
        title: "Languages",
        skills: [
            {
                name: "C#",
                imageUrlName: "csharp"
            },
            {
                name: "JavaScript",
                imageUrlName: "javascript"
            },
            {
                name: "Java",
                imageUrlName: "java"
            },
            {
                name: "Python",
                imageUrlName: "python"
            }
        ]
    },
    {
        title: "Web Development",
        skills: [
            {
                name: "React.js",
                imageUrlName: "react"
            },
            {
                name: "Node.js",
                imageUrlName: "nodejs"
            },
            {
                name: "HTML",
                imageUrlName: "html5"
            },
            {
                name: "CSS",
                imageUrlName: "css3"
            },
            {
                name: "Bootstrap",
                imageUrlName: "bootstrap"
            },
            {
                name: "Redux",
                imageUrlName: "redux"
            },
            {
                name: "Tailwind",
                imageUrlName: "tailwind"
            },
            {
                name: "JavaScript",
                imageUrlName: "javascript"
            },
            {
                name: "TypeScript",
                imageUrlName: "typescript"
            }
        ]
    },
    {
        title: "Cloud and Database",
        skills: [
            {
                name: "AWS",
                imageUrlName: "aws"
            },
            {
                name: "Azure",
                imageUrlName: "azure"
            },
            {
                name: "Azure DevOps",
                imageUrlName: "azuredevops"
            },
            {
                name: "MySQL",
                imageUrlName: "mysql"
            },
            {
                name: "MongoDB",
                imageUrlName: "mongodb"
            },
            {
                name: "SQLite",
                imageUrlName: "sqlite"
            }
        ]
    },
    {
        title: "Frameworks",
        skills: [
            {
                name: "Xamarin.Forms",
                imageUrlName: "xamarin"
            },
            {
                name: "Spring",
                imageUrlName: "spring"
            },
            {
                name: "Junit",
                imageUrlName: "junit5"
            },
            {
                name: "Dotnet",
                imageUrlName: "dotnet"
            }
        ]
    }
];
var $52b3f559cbbf28cf$export$2e2bcd8739ae039 = $52b3f559cbbf28cf$var$skillList;



var $d19b1d8c96a6172c$exports = {};

$d19b1d8c96a6172c$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "dotnet.02029abf.svg";


var $5b9a4a6d39640f0e$exports = {};

$5b9a4a6d39640f0e$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "java.e0175a7d.svg";


var $dd5873ba88734f8c$exports = {};

$dd5873ba88734f8c$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "react.9e5ba8ab.svg";


var $ef3718f8ce63c821$exports = {};

$ef3718f8ce63c821$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "python.45b561f4.svg";


var $31617f5ec4df74dd$exports = {};

$31617f5ec4df74dd$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "javascript.79e4a46d.svg";


var $202d44cfb87645d2$exports = {};

$202d44cfb87645d2$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "typescript.2089fcca.svg";


var $a2cbe9d8a6fbaa1a$exports = {};

$a2cbe9d8a6fbaa1a$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "html5.432a41f1.svg";


var $a6b478e54a57065f$exports = {};

$a6b478e54a57065f$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "css3.a135f09d.svg";


var $132850b854b9c409$exports = {};

$132850b854b9c409$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "aws.1e2d6103.svg";


var $23105412ba1da654$exports = {};

$23105412ba1da654$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "azure.61731310.svg";


var $3018bfe184f63448$exports = {};

$3018bfe184f63448$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "azuredevops.df3ceb76.svg";


var $52ce04a57c472ce3$exports = {};

$52ce04a57c472ce3$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "bootstrap.d7fa268d.svg";


var $d1ac972df95a8e98$exports = {};

$d1ac972df95a8e98$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "csharp.e8446547.svg";


var $077db1ada2b34ac3$exports = {};

$077db1ada2b34ac3$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "junit5.d1e23702.svg";


var $c93cd24e993e67e9$exports = {};

$c93cd24e993e67e9$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "mysql.65a80f62.svg";


var $38c11b418c845c9b$exports = {};

$38c11b418c845c9b$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "mongodb.01769c4f.svg";


var $5cfd98ccb08ac39c$exports = {};

$5cfd98ccb08ac39c$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "nodejs.19f2f559.svg";


var $7700d2d168662e08$exports = {};

$7700d2d168662e08$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "redux.703d4e86.svg";


var $772016eeba9ed459$exports = {};

$772016eeba9ed459$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "spring.2a2fc67a.svg";


var $912d00390b4e4738$exports = {};

$912d00390b4e4738$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "sqlite.3fdd19c3.svg";


var $d5e2d3a8661cd621$exports = {};

$d5e2d3a8661cd621$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "tailwind.f90b662a.svg";


var $a2bfc86d588bf4bd$exports = {};

$a2bfc86d588bf4bd$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "xamarin.ec1d6634.svg";


var $d743ac597d2763eb$var$svgIcons = {
    dotnet: (0, (/*@__PURE__*/$parcel$interopDefault($d19b1d8c96a6172c$exports))),
    java: (0, (/*@__PURE__*/$parcel$interopDefault($5b9a4a6d39640f0e$exports))),
    react: (0, (/*@__PURE__*/$parcel$interopDefault($dd5873ba88734f8c$exports))),
    python: (0, (/*@__PURE__*/$parcel$interopDefault($ef3718f8ce63c821$exports))),
    javascript: (0, (/*@__PURE__*/$parcel$interopDefault($31617f5ec4df74dd$exports))),
    typescript: (0, (/*@__PURE__*/$parcel$interopDefault($202d44cfb87645d2$exports))),
    html5: (0, (/*@__PURE__*/$parcel$interopDefault($a2cbe9d8a6fbaa1a$exports))),
    css3: (0, (/*@__PURE__*/$parcel$interopDefault($a6b478e54a57065f$exports))),
    aws: (0, (/*@__PURE__*/$parcel$interopDefault($132850b854b9c409$exports))),
    azure: (0, (/*@__PURE__*/$parcel$interopDefault($23105412ba1da654$exports))),
    azuredevops: (0, (/*@__PURE__*/$parcel$interopDefault($3018bfe184f63448$exports))),
    bootstrap: (0, (/*@__PURE__*/$parcel$interopDefault($52ce04a57c472ce3$exports))),
    csharp: (0, (/*@__PURE__*/$parcel$interopDefault($d1ac972df95a8e98$exports))),
    junit5: (0, (/*@__PURE__*/$parcel$interopDefault($077db1ada2b34ac3$exports))),
    mysql: (0, (/*@__PURE__*/$parcel$interopDefault($c93cd24e993e67e9$exports))),
    mongodb: (0, (/*@__PURE__*/$parcel$interopDefault($38c11b418c845c9b$exports))),
    nodejs: (0, (/*@__PURE__*/$parcel$interopDefault($5cfd98ccb08ac39c$exports))),
    redux: (0, (/*@__PURE__*/$parcel$interopDefault($7700d2d168662e08$exports))),
    spring: (0, (/*@__PURE__*/$parcel$interopDefault($772016eeba9ed459$exports))),
    sqlite: (0, (/*@__PURE__*/$parcel$interopDefault($912d00390b4e4738$exports))),
    tailwind: (0, (/*@__PURE__*/$parcel$interopDefault($d5e2d3a8661cd621$exports))),
    xamarin: (0, (/*@__PURE__*/$parcel$interopDefault($a2bfc86d588bf4bd$exports)))
};
var $d743ac597d2763eb$var$TechIcons = function(param) {
    var imageUrlName = param.imageUrlName, name = param.name;
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
        src: $d743ac597d2763eb$var$svgIcons[imageUrlName],
        alt: name,
        title: name,
        className: "h-8 w-8 mb-4 md:h-10 md:w10 lg:h-12 lg:w-12 mr-2 lg:mr-5"
    });
};
var $d743ac597d2763eb$export$2e2bcd8739ae039 = $d743ac597d2763eb$var$TechIcons;




var $4e662a4d1e085f92$var$Skills = function() {
    var _useInView = (0, $6ee4651e93391e62$export$2f62ee6831462844)({
        threshold: 0.1,
        triggerOnce: true
    }), ref = _useInView.ref, inView = _useInView.inView;
    var containerVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.06,
                duration: 0.1,
                ease: "easeInOut"
            }
        }
    };
    var itemVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "py-12",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "align-middle text-center font-poppins text-4xl text-[#333333] dark:text-[#e0e0e0]",
                children: "Skills & Technologies"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $08cdba583e3e8032$export$e25e478948902b8b).div, {
                ref: ref,
                initial: "hidden",
                animate: inView ? "visible" : "hidden",
                variants: containerVariants,
                className: "mt-10 container mx-auto px-4 bg-gradient-to-br from-gray-100 to-white w-full dark:from-[#1e1e1e] dark:to-[#2222222d] shadow-lg rounded-xl p-6 pt-16 border border-gray-200 dark:border-0 mb-6",
                children: (0, $52b3f559cbbf28cf$export$2e2bcd8739ae039).map(function(skillCategory, index) {
                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "mb-10",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row gap-4",
                            children: [
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                    className: "md:w-4/12 lg:w-3/12 flex items-center",
                                    children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                        className: "font-poppins md:ml-3 dark:text-[#e0e0e0] text-[#333333] text-xl whitespace-nowrap",
                                        children: skillCategory.title
                                    })
                                }),
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                    className: "md:w-8/12 lg:w-9/12 flex flex-wrap gap-4",
                                    children: skillCategory.skills.map(function(skill, skillIndex) {
                                        return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $08cdba583e3e8032$export$e25e478948902b8b).div, {
                                            className: "flex items-center",
                                            variants: itemVariants,
                                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $d743ac597d2763eb$export$2e2bcd8739ae039), {
                                                imageUrlName: skill.imageUrlName,
                                                name: skill.name
                                            })
                                        }, skillIndex);
                                    })
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
var $4e662a4d1e085f92$export$2e2bcd8739ae039 = $4e662a4d1e085f92$var$Skills;




var $c6b6d2f16e5ddc0b$var$experience = [
    {
        company: "Philips",
        position: "Software Engineer Co-op",
        location: "Cambridge, MA",
        duration: "Jan 2025 \u2013 Present",
        description: [
            "Architected and engineered a side-by-side installation for PIC-iX (WinForms/.NET) enabling concurrent patch deployment, reducing production downtime by 65%.",
            "Developed a Python-based automation tool to generate Release Requirement Documents by programmatically ingesting, transforming, and validating Azure DevOps work item data, ensuring accuracy and consistency across releases.",
            "Reduced document processing time from days to minutes (99% reduction) by automating revision history, delta generation, and structured upload to DevOps",
            "Streamlined CI pipelines by enhancing GitHub workflows to run automated smoke tests and linting on pull requests.",
            "Created workflows to enhance developer experience, like flagging unused NuGet package references of .NET projects."
        ]
    },
    {
        company: "West Pharmaceutical Services",
        position: "Software Engineer",
        location: "Bengaluru, India",
        duration: "Oct 2022 \u2013 July 2023",
        description: [
            "Developed C# backend services for a manufacturing platform, containerized them with Docker, and deployed to Kubernetes.",
            "Implemented GraphQL endpoints over existing manufacturing data services, enabling operators to fetch complex nested datasets (production orders, machine states, quality logs) in a single query \u2014 reducing API round trips by 40%.",
            "Re-engineered manufacturing data storage by migrating time-series production logs from MongoDB to PostgreSQL with partitioned tables, improving analytical query speed by 35% for reporting dashboards.",
            "Created a Jenkins + Azure DevOps hybrid CI/CD pipeline to run automated integration tests, build Docker images, and roll out updates to Kubernetes \u2014 reducing release lead time from 1 week to under 2 days."
        ]
    },
    {
        company: "West Pharmaceutical Services",
        position: "Associate Software Engineer",
        location: "Bengaluru, India",
        duration: "July 2020 \u2013 Sep 2022",
        description: [
            "Designed and implemented a Digital Manufacturing application using .NET framework, Xamarin.Forms and MAUI",
            "Followed MVVM architecture and Object-Oriented Programming (OOP) for creating robust application.",
            "Implemented design patterns such as Command, Decorator, and Builder to enhance the software architecture.",
            "Integrated MQTT brokers with backend services to stream live sensor data into PostgreSQL-backed queues, achieving sub-second processing for shop-floor dashboards.",
            "Implemented a SignalR-based connection to efficiently route orders across the manufacturing plant."
        ]
    },
    {
        company: "West Pharmaceutical Services",
        position: "Graduate Software Engineer",
        location: "Bengaluru, India",
        duration: "Jan 2020 \u2013 July 2020",
        description: [
            "Team lead for an Asset management application to digitize the handling of all organization's assets.",
            "Developed both frontend (MAUI) and backend (SQL) of the application, based on .NET framework.",
            "Leveraged Azure to create web apps to host APIs, blob storage for file management, and SQL database for the application."
        ]
    },
    {
        company: "Chatbotsa",
        position: "Software Developer Intern",
        location: "Cairo, Egypt",
        duration: "June 2018 - July 2018",
        description: [
            "Developed and deployed chatbots using Node.js into Facebook Messenger.",
            "Utilized Dialogflow NLP for efficient user query handling."
        ]
    }
];
var $c6b6d2f16e5ddc0b$export$2e2bcd8739ae039 = $c6b6d2f16e5ddc0b$var$experience;


var $a4749dcfcfbd2848$exports = {};

$a4749dcfcfbd2848$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "external_black.8a4a545a.svg";


var $794995cde2b4a5c1$exports = {};

$794995cde2b4a5c1$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "external_white.533a6ff9.svg";



var $dQFEZ = parcelRequire("dQFEZ");

var $4e2bfa9222ee6620$var$Experience = function() {
    var _useContext = (0, $dQFEZ.useContext)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039)), darkMode = _useContext.darkMode, setDarkMode = _useContext.setDarkMode;
    var viewResume = function() {
        window.open("https://drive.google.com/file/d/1r-rFWGjE1SSHM-x6_2ZXL-BrtP2hwVGs/view?usp=drive_link", "_blank");
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "font-poppins flex justify-between mb-10 text-2xl text-[#333333] dark:text-[#e0e0e0]",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        children: "Experience"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                            title: "View Resume",
                            onClick: function() {
                                return viewResume();
                            },
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                className: "h-8 w-8",
                                src: darkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($794995cde2b4a5c1$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a4749dcfcfbd2848$exports)))
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                children: (0, $c6b6d2f16e5ddc0b$export$2e2bcd8739ae039).map(function(exp, index) {
                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "bg-gradient-to-br from-gray-100 to-white dark:from-[#1e1e1e] dark:to-[#2222222d] shadow-lg rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                className: "md:flex md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                        className: "md:w-9/12",
                                        children: [
                                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                                className: "font-bold md:text-lg text-[#333333] dark:text-[#e0e0e0]",
                                                children: exp.company
                                            }),
                                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                                className: "text-sm text-gray-500 dark:text-gray-400",
                                                children: exp.position
                                            }),
                                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                                className: "text-sm text-gray-500 dark:text-gray-400",
                                                children: exp.location
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                        className: "md:w-3/12 text-sm md:text-end text-gray-500 dark:text-gray-400",
                                        children: exp.duration
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("ul", {
                                className: "mt-2 text-gray-500 dark:text-gray-400 list-disc list-inside",
                                children: exp.description.map(function(item, i) {
                                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                                        children: item
                                    }, i);
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var $4e2bfa9222ee6620$export$2e2bcd8739ae039 = $4e2bfa9222ee6620$var$Experience;



var $18afff5d500430cf$var$education = [
    {
        university: "Northeastern University",
        school: "Khoury College of Computer Sciences",
        location: "Boston, Massachusetts",
        degree: "MS Computer Science",
        duration: "2023 - Dec 2025",
        major: "Computer Science"
    },
    {
        university: "Vellore Institute of Technology",
        school: "School of Computer Science and Engineering (SCOPE)",
        location: "Vellore, Tamil Nadu",
        degree: "B.Tech Computer Science",
        duration: "2016 - 2020",
        major: "Computer Science"
    }
];
var $18afff5d500430cf$export$2e2bcd8739ae039 = $18afff5d500430cf$var$education;


var $148fc4b450582f62$var$Education = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "font-poppins mb-10 text-2xl text-[#333333] dark:text-[#e0e0e0]",
                children: "Education"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "md:flex md:flex-row gap-8",
                children: (0, $18afff5d500430cf$export$2e2bcd8739ae039).map(function(edu, index) {
                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "bg-gradient-to-br from-gray-100 to-white w-full dark:from-[#1e1e1e] dark:to-[#2222222d] shadow-lg rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                            className: "xl:flex xl:flex-row",
                            children: [
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                                    className: "xl:w-8/12",
                                    children: [
                                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                            className: "font-bold text-[#333333] dark:text-[#e0e0e0] md:text-lg",
                                            children: edu.university
                                        }),
                                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                            className: "text-sm dark:text-gray-400 text-gray-500",
                                            children: edu.school
                                        }),
                                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                            className: "text-sm dark:text-gray-400 text-gray-500",
                                            children: edu.degree
                                        }),
                                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                            className: "text-sm dark:text-gray-400 text-gray-500",
                                            children: edu.location
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                    className: "xl:w-4/12 text-sm text-gray-500 dark:text-gray-400 xl:text-end",
                                    children: edu.duration
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
var $148fc4b450582f62$export$2e2bcd8739ae039 = $148fc4b450582f62$var$Education;


var $da15a0edaf2d3d98$var$Resume = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $4e2bfa9222ee6620$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $148fc4b450582f62$export$2e2bcd8739ae039), {})
        ]
    });
};
var $da15a0edaf2d3d98$export$2e2bcd8739ae039 = $da15a0edaf2d3d98$var$Resume;




var $dQFEZ = parcelRequire("dQFEZ");

var $7dbfc2620234cc5c$var$Contact = function() {
    var darkMode = (0, $dQFEZ.useContext)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039)).darkMode;
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "flex flex-wrap justify-end items-center gap-10 px-4 ",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "text-right text-[#333333] dark:text-[#e0e0e0]",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "font-poppins text-lg",
                        children: "E-mail"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "text-sm",
                        children: "jain.dam@northeastern.edu"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "text-right text-[#333333] dark:text-[#e0e0e0]",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "font-poppins text-lg",
                        children: "City"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "text-sm",
                        children: "Boston, MA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex gap-10",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("a", {
                            href: "https://github.com/damyantjain",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("i", {
                                className: "fa-brands fa-github fa-3x",
                                style: {
                                    color: darkMode ? "white" : "black"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("a", {
                            href: "https://linkedin.com/in/damyant",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("i", {
                                className: "fa-brands fa-linkedin fa-3x",
                                style: {
                                    color: darkMode ? "white" : "#0077B5"
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $7dbfc2620234cc5c$export$2e2bcd8739ae039 = $7dbfc2620234cc5c$var$Contact;



var $2nwvT = parcelRequire("2nwvT");

var $35ea8ec0273a7191$exports = {};
"use strict";
Object.defineProperty($35ea8ec0273a7191$exports, "__esModule", {
    value: true
});
$35ea8ec0273a7191$exports.Helpers = $35ea8ec0273a7191$exports.ScrollElement = $35ea8ec0273a7191$exports.ScrollLink = $35ea8ec0273a7191$exports.animateScroll = $35ea8ec0273a7191$exports.scrollSpy = $35ea8ec0273a7191$exports.Events = $35ea8ec0273a7191$exports.scroller = $35ea8ec0273a7191$exports.Element = $35ea8ec0273a7191$exports.Button = $35ea8ec0273a7191$exports.Link = undefined;
var $3e71142f587f39d9$exports = {};

var $bJtXW = parcelRequire("bJtXW");
"use strict";
Object.defineProperty($3e71142f587f39d9$exports, "__esModule", {
    value: true
});

var $dQFEZ = parcelRequire("dQFEZ");
var $3e71142f587f39d9$var$_react2 = $3e71142f587f39d9$var$_interopRequireDefault($dQFEZ);
var $ca7090764f1f3151$exports = {};

var $bJtXW = parcelRequire("bJtXW");
"use strict";
Object.defineProperty($ca7090764f1f3151$exports, "__esModule", {
    value: true
});
var $ca7090764f1f3151$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ca7090764f1f3151$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQFEZ = parcelRequire("dQFEZ");
var $ca7090764f1f3151$var$_react2 = $ca7090764f1f3151$var$_interopRequireDefault($dQFEZ);
var $35567781468e4e4b$exports = {};
"use strict";
Object.defineProperty($35567781468e4e4b$exports, "__esModule", {
    value: true
});
var $499e7cc858bdc12e$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $bJtXW = parcelRequire("bJtXW");
var $499e7cc858bdc12e$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $499e7cc858bdc12e$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $499e7cc858bdc12e$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $499e7cc858bdc12e$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $499e7cc858bdc12e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $499e7cc858bdc12e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $499e7cc858bdc12e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $499e7cc858bdc12e$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $499e7cc858bdc12e$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $499e7cc858bdc12e$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $499e7cc858bdc12e$var$root = $499e7cc858bdc12e$var$freeGlobal || $499e7cc858bdc12e$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $499e7cc858bdc12e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $499e7cc858bdc12e$var$objectToString = $499e7cc858bdc12e$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $499e7cc858bdc12e$var$nativeMax = Math.max, $499e7cc858bdc12e$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $499e7cc858bdc12e$var$now = function now() {
    return $499e7cc858bdc12e$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $499e7cc858bdc12e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($499e7cc858bdc12e$var$FUNC_ERROR_TEXT);
    wait = $499e7cc858bdc12e$var$toNumber(wait) || 0;
    if ($499e7cc858bdc12e$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $499e7cc858bdc12e$var$nativeMax($499e7cc858bdc12e$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $499e7cc858bdc12e$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $499e7cc858bdc12e$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($499e7cc858bdc12e$var$now());
    }
    function debounced() {
        var time = $499e7cc858bdc12e$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $499e7cc858bdc12e$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($499e7cc858bdc12e$var$FUNC_ERROR_TEXT);
    if ($499e7cc858bdc12e$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $499e7cc858bdc12e$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $499e7cc858bdc12e$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $499e7cc858bdc12e$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $499e7cc858bdc12e$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) == "symbol" || $499e7cc858bdc12e$var$isObjectLike(value) && $499e7cc858bdc12e$var$objectToString.call(value) == $499e7cc858bdc12e$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $499e7cc858bdc12e$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($499e7cc858bdc12e$var$isSymbol(value)) return $499e7cc858bdc12e$var$NAN;
    if ($499e7cc858bdc12e$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $499e7cc858bdc12e$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($499e7cc858bdc12e$var$reTrim, "");
    var isBinary = $499e7cc858bdc12e$var$reIsBinary.test(value);
    return isBinary || $499e7cc858bdc12e$var$reIsOctal.test(value) ? $499e7cc858bdc12e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $499e7cc858bdc12e$var$reIsBadHex.test(value) ? $499e7cc858bdc12e$var$NAN : +value;
}
$499e7cc858bdc12e$exports = $499e7cc858bdc12e$var$throttle;


var $35567781468e4e4b$var$_lodash2 = $35567781468e4e4b$var$_interopRequireDefault($499e7cc858bdc12e$exports);
var $7ebd618c0c8bc134$exports = {};
"use strict";
Object.defineProperty($7ebd618c0c8bc134$exports, "__esModule", {
    value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */ var $7ebd618c0c8bc134$var$addPassiveEventListener = $7ebd618c0c8bc134$exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
    var listenerName = listener.name;
    if (!listenerName) {
        listenerName = eventName;
        console.warn("Listener must be a named function.");
    }
    if (!$7ebd618c0c8bc134$var$attachedListeners.has(eventName)) $7ebd618c0c8bc134$var$attachedListeners.set(eventName, new Set());
    var listeners = $7ebd618c0c8bc134$var$attachedListeners.get(eventName);
    if (listeners.has(listenerName)) return;
    var supportsPassiveOption = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function get() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("test", null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    }();
    target.addEventListener(eventName, listener, supportsPassiveOption ? {
        passive: true
    } : false);
    listeners.add(listenerName);
};
var $7ebd618c0c8bc134$var$removePassiveEventListener = $7ebd618c0c8bc134$exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
    target.removeEventListener(eventName, listener);
    $7ebd618c0c8bc134$var$attachedListeners.get(eventName).delete(listener.name || eventName);
};
var $7ebd618c0c8bc134$var$attachedListeners = new Map();


function $35567781468e4e4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// The eventHandler will execute at a rate of 15fps by default
var $35567781468e4e4b$var$eventThrottler = function eventThrottler(eventHandler) {
    var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
    return (0, $35567781468e4e4b$var$_lodash2.default)(eventHandler, throttleAmount);
};
var $35567781468e4e4b$var$scrollSpy = {
    spyCallbacks: [],
    spySetState: [],
    scrollSpyContainers: [],
    mount: function mount(scrollSpyContainer, throttle) {
        if (scrollSpyContainer) {
            var eventHandler = $35567781468e4e4b$var$eventThrottler(function(event) {
                $35567781468e4e4b$var$scrollSpy.scrollHandler(scrollSpyContainer);
            }, throttle);
            $35567781468e4e4b$var$scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
            (0, $7ebd618c0c8bc134$exports.addPassiveEventListener)(scrollSpyContainer, "scroll", eventHandler);
        }
    },
    isMounted: function isMounted(scrollSpyContainer) {
        return $35567781468e4e4b$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
    },
    currentPositionX: function currentPositionX(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageYOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        } else return scrollSpyContainer.scrollLeft;
    },
    currentPositionY: function currentPositionY(scrollSpyContainer) {
        if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        } else return scrollSpyContainer.scrollTop;
    },
    scrollHandler: function scrollHandler(scrollSpyContainer) {
        var callbacks = $35567781468e4e4b$var$scrollSpy.scrollSpyContainers[$35567781468e4e4b$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
        callbacks.forEach(function(c) {
            return c($35567781468e4e4b$var$scrollSpy.currentPositionX(scrollSpyContainer), $35567781468e4e4b$var$scrollSpy.currentPositionY(scrollSpyContainer));
        });
    },
    addStateHandler: function addStateHandler(handler) {
        $35567781468e4e4b$var$scrollSpy.spySetState.push(handler);
    },
    addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
        var container = $35567781468e4e4b$var$scrollSpy.scrollSpyContainers[$35567781468e4e4b$var$scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];
        if (!container.spyCallbacks) container.spyCallbacks = [];
        container.spyCallbacks.push(handler);
        handler($35567781468e4e4b$var$scrollSpy.currentPositionX(scrollSpyContainer), $35567781468e4e4b$var$scrollSpy.currentPositionY(scrollSpyContainer));
    },
    updateStates: function updateStates() {
        $35567781468e4e4b$var$scrollSpy.spySetState.forEach(function(s) {
            return s();
        });
    },
    unmount: function unmount(stateHandler, spyHandler) {
        $35567781468e4e4b$var$scrollSpy.scrollSpyContainers.forEach(function(c) {
            return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
        });
        if ($35567781468e4e4b$var$scrollSpy.spySetState && $35567781468e4e4b$var$scrollSpy.spySetState.length && $35567781468e4e4b$var$scrollSpy.spySetState.indexOf(stateHandler) > -1) $35567781468e4e4b$var$scrollSpy.spySetState.splice($35567781468e4e4b$var$scrollSpy.spySetState.indexOf(stateHandler), 1);
        document.removeEventListener("scroll", $35567781468e4e4b$var$scrollSpy.scrollHandler);
    },
    update: function update() {
        return $35567781468e4e4b$var$scrollSpy.scrollSpyContainers.forEach(function(c) {
            return $35567781468e4e4b$var$scrollSpy.scrollHandler(c);
        });
    }
};
$35567781468e4e4b$exports.default = $35567781468e4e4b$var$scrollSpy;


var $ca7090764f1f3151$var$_scrollSpy2 = $ca7090764f1f3151$var$_interopRequireDefault($35567781468e4e4b$exports);
var $e422d51e669d12fe$exports = {};
"use strict";
Object.defineProperty($e422d51e669d12fe$exports, "__esModule", {
    value: true
});
var $e422d51e669d12fe$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a16ef5e81f401c3a$exports = {};
"use strict";
Object.defineProperty($a16ef5e81f401c3a$exports, "__esModule", {
    value: true
});
var $a16ef5e81f401c3a$var$updateHash = function updateHash(hash, historyUpdate) {
    var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
    var hashToUpdate = hashVal ? "#" + hashVal : "";
    var curLoc = window && window.location;
    var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
    historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};
var $a16ef5e81f401c3a$var$getHash = function getHash() {
    return window.location.hash.replace(/^#/, "");
};
var $a16ef5e81f401c3a$var$filterElementInContainer = function filterElementInContainer(container) {
    return function(element) {
        return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
    };
};
var $a16ef5e81f401c3a$var$isPositioned = function isPositioned(element) {
    return getComputedStyle(element).position !== "static";
};
var $a16ef5e81f401c3a$var$getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
    var offsetTop = element.offsetTop;
    var currentOffsetParent = element.offsetParent;
    while(currentOffsetParent && !predicate(currentOffsetParent)){
        offsetTop += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    return {
        offsetTop: offsetTop,
        offsetParent: currentOffsetParent
    };
};
var $a16ef5e81f401c3a$var$scrollOffset = function scrollOffset(c, t, horizontal) {
    if (horizontal) return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
    else {
        if (c === document) return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
        // The offsetParent of an element, according to MDN, is its nearest positioned
        // (an element whose position is anything other than static) ancestor. The offsetTop
        // of an element is taken with respect to its offsetParent which may not neccessarily
        // be its parentElement except the parent itself is positioned.
        // So if containerElement is positioned, then it must be an offsetParent somewhere
        // If it happens that targetElement is a descendant of the containerElement, and there
        // is not intermediate positioned element between the two of them, i.e.
        // targetElement"s offsetParent is the same as the containerElement, then the
        // distance between the two will be the offsetTop of the targetElement.
        // If, on the other hand, there are intermediate positioned elements between the
        // two entities, the distance between the targetElement and the containerElement
        // will be the accumulation of the offsetTop of the element and that of its
        // subsequent offsetParent until the containerElement is reached, since it
        // will also be an offsetParent at some point due to the fact that it is positioned.
        // If the containerElement is not positioned, then it can"t be an offsetParent,
        // which means that the offsetTop of the targetElement would not be with respect to it.
        // However, if the two of them happen to have the same offsetParent, then
        // the distance between them will be the difference between their offsetTop
        // since they are both taken with respect to the same entity.
        // The last resort would be to accumulate their offsetTop until a common
        // offsetParent is reached (usually the document) and taking the difference
        // between the accumulated offsetTops
        if ($a16ef5e81f401c3a$var$isPositioned(c)) {
            if (t.offsetParent !== c) {
                var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
                    return e === c || e === document;
                };
                var _getElementOffsetInfo = $a16ef5e81f401c3a$var$getElementOffsetInfoUntil(t, isContainerElementOrDocument), offsetTop = _getElementOffsetInfo.offsetTop, offsetParent = _getElementOffsetInfo.offsetParent;
                if (offsetParent !== c) throw new Error("Seems containerElement is not an ancestor of the Element");
                return offsetTop;
            }
            return t.offsetTop;
        }
        if (t.offsetParent === c.offsetParent) return t.offsetTop - c.offsetTop;
        var isDocument = function isDocument(e) {
            return e === document;
        };
        return $a16ef5e81f401c3a$var$getElementOffsetInfoUntil(t, isDocument).offsetTop - $a16ef5e81f401c3a$var$getElementOffsetInfoUntil(c, isDocument).offsetTop;
    }
};
$a16ef5e81f401c3a$exports.default = {
    updateHash: $a16ef5e81f401c3a$var$updateHash,
    getHash: $a16ef5e81f401c3a$var$getHash,
    filterElementInContainer: $a16ef5e81f401c3a$var$filterElementInContainer,
    scrollOffset: $a16ef5e81f401c3a$var$scrollOffset
};


var $e422d51e669d12fe$var$_utils2 = $e422d51e669d12fe$var$_interopRequireDefault($a16ef5e81f401c3a$exports);
var $05d177e2d8db84bb$exports = {};
"use strict";
Object.defineProperty($05d177e2d8db84bb$exports, "__esModule", {
    value: true
});
var $05d177e2d8db84bb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $05d177e2d8db84bb$var$_utils2 = $05d177e2d8db84bb$var$_interopRequireDefault($a16ef5e81f401c3a$exports);
var $9c0cbb0ef655a84b$exports = {};
"use strict";
Object.defineProperty($9c0cbb0ef655a84b$exports, "__esModule", {
    value: true
});
$9c0cbb0ef655a84b$exports.default = {
    /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */ defaultEasing: function defaultEasing(x) {
        if (x < 0.5) return Math.pow(x * 2, 2) / 2;
        return 1 - Math.pow((1 - x) * 2, 2) / 2;
    },
    /*
   * https://gist.github.com/gre/1650294
   */ // no easing, no acceleration
    linear: function linear(x) {
        return x;
    },
    // accelerating from zero velocity
    easeInQuad: function easeInQuad(x) {
        return x * x;
    },
    // decelerating to zero velocity
    easeOutQuad: function easeOutQuad(x) {
        return x * (2 - x);
    },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function easeInOutQuad(x) {
        return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
    },
    // accelerating from zero velocity 
    easeInCubic: function easeInCubic(x) {
        return x * x * x;
    },
    // decelerating to zero velocity π
    easeOutCubic: function easeOutCubic(x) {
        return --x * x * x + 1;
    },
    // acceleration until halfway, then deceleration 
    easeInOutCubic: function easeInOutCubic(x) {
        return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
    },
    // accelerating from zero velocity 
    easeInQuart: function easeInQuart(x) {
        return x * x * x * x;
    },
    // decelerating to zero velocity 
    easeOutQuart: function easeOutQuart(x) {
        return 1 - --x * x * x * x;
    },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function easeInOutQuart(x) {
        return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
    },
    // accelerating from zero velocity
    easeInQuint: function easeInQuint(x) {
        return x * x * x * x * x;
    },
    // decelerating to zero velocity
    easeOutQuint: function easeOutQuint(x) {
        return 1 + --x * x * x * x * x;
    },
    // acceleration until halfway, then deceleration 
    easeInOutQuint: function easeInOutQuint(x) {
        return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
    }
};


var $05d177e2d8db84bb$var$_smooth2 = $05d177e2d8db84bb$var$_interopRequireDefault($9c0cbb0ef655a84b$exports);
var $2f85b62c1a6ee65c$exports = {};
"use strict";
Object.defineProperty($2f85b62c1a6ee65c$exports, "__esModule", {
    value: true
});

var $2f85b62c1a6ee65c$var$events = [
    "mousedown",
    "mousewheel",
    "touchmove",
    "keydown"
];
$2f85b62c1a6ee65c$exports.default = {
    subscribe: function subscribe(cancelEvent) {
        return typeof document !== "undefined" && $2f85b62c1a6ee65c$var$events.forEach(function(event) {
            return (0, $7ebd618c0c8bc134$exports.addPassiveEventListener)(document, event, cancelEvent);
        });
    }
};


var $05d177e2d8db84bb$var$_cancelEvents2 = $05d177e2d8db84bb$var$_interopRequireDefault($2f85b62c1a6ee65c$exports);
var $6a0c7642e8f655f6$exports = {};
"use strict";
Object.defineProperty($6a0c7642e8f655f6$exports, "__esModule", {
    value: true
});
var $6a0c7642e8f655f6$var$Events = {
    registered: {},
    scrollEvent: {
        register: function register(evtName, callback) {
            $6a0c7642e8f655f6$var$Events.registered[evtName] = callback;
        },
        remove: function remove(evtName) {
            $6a0c7642e8f655f6$var$Events.registered[evtName] = null;
        }
    }
};
$6a0c7642e8f655f6$exports.default = $6a0c7642e8f655f6$var$Events;


var $05d177e2d8db84bb$var$_scrollEvents2 = $05d177e2d8db84bb$var$_interopRequireDefault($6a0c7642e8f655f6$exports);
function $05d177e2d8db84bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * Gets the easing type from the smooth prop within options.
 */ var $05d177e2d8db84bb$var$getAnimationType = function getAnimationType(options) {
    return $05d177e2d8db84bb$var$_smooth2.default[options.smooth] || $05d177e2d8db84bb$var$_smooth2.default.defaultEasing;
};
/*
 * Function helper
 */ var $05d177e2d8db84bb$var$functionWrapper = function functionWrapper(value) {
    return typeof value === "function" ? value : function() {
        return value;
    };
};
/*
 * Wraps window properties to allow server side rendering
 */ var $05d177e2d8db84bb$var$currentWindowProperties = function currentWindowProperties() {
    if (typeof window !== "undefined") return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
};
/*
 * Helper function to never extend 60fps on the webpage.
 */ var $05d177e2d8db84bb$var$requestAnimationFrameHelper = function() {
    return $05d177e2d8db84bb$var$currentWindowProperties() || function(callback, element, delay) {
        window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
    };
}();
var $05d177e2d8db84bb$var$makeData = function makeData() {
    return {
        currentPosition: 0,
        startPosition: 0,
        targetPosition: 0,
        progress: 0,
        duration: 0,
        cancel: false,
        target: null,
        containerElement: null,
        to: null,
        start: null,
        delta: null,
        percent: null,
        delayTimeout: null
    };
};
var $05d177e2d8db84bb$var$currentPositionX = function currentPositionX(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollLeft;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    }
};
var $05d177e2d8db84bb$var$currentPositionY = function currentPositionY(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollTop;
    else {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    }
};
var $05d177e2d8db84bb$var$scrollContainerWidth = function scrollContainerWidth(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollWidth - containerElement.offsetWidth;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
    }
};
var $05d177e2d8db84bb$var$scrollContainerHeight = function scrollContainerHeight(options) {
    var containerElement = options.data.containerElement;
    if (containerElement && containerElement !== document && containerElement !== document.body) return containerElement.scrollHeight - containerElement.offsetHeight;
    else {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    }
};
var $05d177e2d8db84bb$var$animateScroll = function animateScroll(easing, options, timestamp) {
    var data = options.data;
    // Cancel on specific events
    if (!options.ignoreCancelEvents && data.cancel) {
        if ($05d177e2d8db84bb$var$_scrollEvents2.default.registered["end"]) $05d177e2d8db84bb$var$_scrollEvents2.default.registered["end"](data.to, data.target, data.currentPositionY);
        return;
    }
    data.delta = Math.round(data.targetPosition - data.startPosition);
    if (data.start === null) data.start = timestamp;
    data.progress = timestamp - data.start;
    data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);
    data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);
    if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
        if (options.horizontal) data.containerElement.scrollLeft = data.currentPosition;
        else data.containerElement.scrollTop = data.currentPosition;
    } else if (options.horizontal) window.scrollTo(data.currentPosition, 0);
    else window.scrollTo(0, data.currentPosition);
    if (data.percent < 1) {
        var easedAnimate = animateScroll.bind(null, easing, options);
        $05d177e2d8db84bb$var$requestAnimationFrameHelper.call(window, easedAnimate);
        return;
    }
    if ($05d177e2d8db84bb$var$_scrollEvents2.default.registered["end"]) $05d177e2d8db84bb$var$_scrollEvents2.default.registered["end"](data.to, data.target, data.currentPosition);
};
var $05d177e2d8db84bb$var$setContainer = function setContainer(options) {
    options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};
var $05d177e2d8db84bb$var$animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
    options.data = options.data || $05d177e2d8db84bb$var$makeData();
    window.clearTimeout(options.data.delayTimeout);
    var setCancel = function setCancel() {
        options.data.cancel = true;
    };
    $05d177e2d8db84bb$var$_cancelEvents2.default.subscribe(setCancel);
    $05d177e2d8db84bb$var$setContainer(options);
    options.data.start = null;
    options.data.cancel = false;
    options.data.startPosition = options.horizontal ? $05d177e2d8db84bb$var$currentPositionX(options) : $05d177e2d8db84bb$var$currentPositionY(options);
    options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;
    if (options.data.startPosition === options.data.targetPosition) {
        if ($05d177e2d8db84bb$var$_scrollEvents2.default.registered["end"]) $05d177e2d8db84bb$var$_scrollEvents2.default.registered["end"](options.data.to, options.data.target, options.data.currentPosition);
        return;
    }
    options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);
    options.data.duration = $05d177e2d8db84bb$var$functionWrapper(options.duration)(options.data.delta);
    options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
    options.data.to = to;
    options.data.target = target;
    var easing = $05d177e2d8db84bb$var$getAnimationType(options);
    var easedAnimate = $05d177e2d8db84bb$var$animateScroll.bind(null, easing, options);
    if (options && options.delay > 0) {
        options.data.delayTimeout = window.setTimeout(function() {
            if ($05d177e2d8db84bb$var$_scrollEvents2.default.registered["begin"]) $05d177e2d8db84bb$var$_scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
            $05d177e2d8db84bb$var$requestAnimationFrameHelper.call(window, easedAnimate);
        }, options.delay);
        return;
    }
    if ($05d177e2d8db84bb$var$_scrollEvents2.default.registered["begin"]) $05d177e2d8db84bb$var$_scrollEvents2.default.registered["begin"](options.data.to, options.data.target);
    $05d177e2d8db84bb$var$requestAnimationFrameHelper.call(window, easedAnimate);
};
var $05d177e2d8db84bb$var$proceedOptions = function proceedOptions(options) {
    options = $05d177e2d8db84bb$var$_extends({}, options);
    options.data = options.data || $05d177e2d8db84bb$var$makeData();
    options.absolute = true;
    return options;
};
var $05d177e2d8db84bb$var$scrollToTop = function scrollToTop(options) {
    $05d177e2d8db84bb$var$animateTopScroll(0, $05d177e2d8db84bb$var$proceedOptions(options));
};
var $05d177e2d8db84bb$var$scrollTo = function scrollTo(toPosition, options) {
    $05d177e2d8db84bb$var$animateTopScroll(toPosition, $05d177e2d8db84bb$var$proceedOptions(options));
};
var $05d177e2d8db84bb$var$scrollToBottom = function scrollToBottom(options) {
    options = $05d177e2d8db84bb$var$proceedOptions(options);
    $05d177e2d8db84bb$var$setContainer(options);
    $05d177e2d8db84bb$var$animateTopScroll(options.horizontal ? $05d177e2d8db84bb$var$scrollContainerWidth(options) : $05d177e2d8db84bb$var$scrollContainerHeight(options), options);
};
var $05d177e2d8db84bb$var$scrollMore = function scrollMore(toPosition, options) {
    options = $05d177e2d8db84bb$var$proceedOptions(options);
    $05d177e2d8db84bb$var$setContainer(options);
    var currentPosition = options.horizontal ? $05d177e2d8db84bb$var$currentPositionX(options) : $05d177e2d8db84bb$var$currentPositionY(options);
    $05d177e2d8db84bb$var$animateTopScroll(toPosition + currentPosition, options);
};
$05d177e2d8db84bb$exports.default = {
    animateTopScroll: $05d177e2d8db84bb$var$animateTopScroll,
    getAnimationType: $05d177e2d8db84bb$var$getAnimationType,
    scrollToTop: $05d177e2d8db84bb$var$scrollToTop,
    scrollToBottom: $05d177e2d8db84bb$var$scrollToBottom,
    scrollTo: $05d177e2d8db84bb$var$scrollTo,
    scrollMore: $05d177e2d8db84bb$var$scrollMore
};


var $e422d51e669d12fe$var$_animateScroll2 = $e422d51e669d12fe$var$_interopRequireDefault($05d177e2d8db84bb$exports);

var $e422d51e669d12fe$var$_scrollEvents2 = $e422d51e669d12fe$var$_interopRequireDefault($6a0c7642e8f655f6$exports);
function $e422d51e669d12fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e422d51e669d12fe$var$__mapped = {};
var $e422d51e669d12fe$var$__activeLink = void 0;
$e422d51e669d12fe$exports.default = {
    unmount: function unmount() {
        $e422d51e669d12fe$var$__mapped = {};
    },
    register: function register(name, element) {
        $e422d51e669d12fe$var$__mapped[name] = element;
    },
    unregister: function unregister(name) {
        delete $e422d51e669d12fe$var$__mapped[name];
    },
    get: function get(name) {
        return $e422d51e669d12fe$var$__mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
    },
    setActiveLink: function setActiveLink(link) {
        return $e422d51e669d12fe$var$__activeLink = link;
    },
    getActiveLink: function getActiveLink() {
        return $e422d51e669d12fe$var$__activeLink;
    },
    scrollTo: function scrollTo(to, props) {
        var target = this.get(to);
        if (!target) {
            console.warn("target Element not found");
            return;
        }
        props = $e422d51e669d12fe$var$_extends({}, props, {
            absolute: false
        });
        var containerId = props.containerId;
        var container = props.container;
        var containerElement = void 0;
        if (containerId) containerElement = document.getElementById(containerId);
        else if (container && container.nodeType) containerElement = container;
        else containerElement = document;
        props.absolute = true;
        var horizontal = props.horizontal;
        var scrollOffset = $e422d51e669d12fe$var$_utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);
        /*
     * if animate is not provided just scroll into the view
     */ if (!props.smooth) {
            if ($e422d51e669d12fe$var$_scrollEvents2.default.registered["begin"]) $e422d51e669d12fe$var$_scrollEvents2.default.registered["begin"](to, target);
            if (containerElement === document) {
                if (props.horizontal) window.scrollTo(scrollOffset, 0);
                else window.scrollTo(0, scrollOffset);
            } else containerElement.scrollTop = scrollOffset;
            if ($e422d51e669d12fe$var$_scrollEvents2.default.registered["end"]) $e422d51e669d12fe$var$_scrollEvents2.default.registered["end"](to, target);
            return;
        }
        /*
     * Animate scrolling
     */ $e422d51e669d12fe$var$_animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
    }
};


var $ca7090764f1f3151$var$_scroller2 = $ca7090764f1f3151$var$_interopRequireDefault($e422d51e669d12fe$exports);
var $6e2a5ed7e145fa83$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6e2a5ed7e145fa83$var$ReactIs, $6e2a5ed7e145fa83$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$6e2a5ed7e145fa83$exports = (parcelRequire("9YznM"))();


var $ca7090764f1f3151$var$_propTypes2 = $ca7090764f1f3151$var$_interopRequireDefault($6e2a5ed7e145fa83$exports);
var $8d06384719699c29$exports = {};
"use strict";
Object.defineProperty($8d06384719699c29$exports, "__esModule", {
    value: true
});


var $8d06384719699c29$var$_utils2 = $8d06384719699c29$var$_interopRequireDefault($a16ef5e81f401c3a$exports);
function $8d06384719699c29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8d06384719699c29$var$scrollHash = {
    mountFlag: false,
    initialized: false,
    scroller: null,
    containers: {},
    mount: function mount(scroller) {
        this.scroller = scroller;
        this.handleHashChange = this.handleHashChange.bind(this);
        window.addEventListener("hashchange", this.handleHashChange);
        this.initStateFromHash();
        this.mountFlag = true;
    },
    mapContainer: function mapContainer(to, container) {
        this.containers[to] = container;
    },
    isMounted: function isMounted() {
        return this.mountFlag;
    },
    isInitialized: function isInitialized() {
        return this.initialized;
    },
    initStateFromHash: function initStateFromHash() {
        var _this = this;
        var hash = this.getHash();
        if (hash) window.setTimeout(function() {
            _this.scrollTo(hash, true);
            _this.initialized = true;
        }, 10);
        else this.initialized = true;
    },
    scrollTo: function scrollTo(to, isInit) {
        var scroller = this.scroller;
        var element = scroller.get(to);
        if (element && (isInit || to !== scroller.getActiveLink())) {
            var container = this.containers[to] || document;
            scroller.scrollTo(to, {
                container: container
            });
        }
    },
    getHash: function getHash() {
        return $8d06384719699c29$var$_utils2.default.getHash();
    },
    changeHash: function changeHash(to, saveHashHistory) {
        if (this.isInitialized() && $8d06384719699c29$var$_utils2.default.getHash() !== to) $8d06384719699c29$var$_utils2.default.updateHash(to, saveHashHistory);
    },
    handleHashChange: function handleHashChange() {
        this.scrollTo(this.getHash());
    },
    unmount: function unmount() {
        this.scroller = null;
        this.containers = null;
        window.removeEventListener("hashchange", this.handleHashChange);
    }
};
$8d06384719699c29$exports.default = $8d06384719699c29$var$scrollHash;


var $ca7090764f1f3151$var$_scrollHash2 = $ca7090764f1f3151$var$_interopRequireDefault($8d06384719699c29$exports);
function $ca7090764f1f3151$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca7090764f1f3151$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ca7090764f1f3151$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ca7090764f1f3151$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ca7090764f1f3151$var$protoTypes = {
    to: $ca7090764f1f3151$var$_propTypes2.default.string.isRequired,
    containerId: $ca7090764f1f3151$var$_propTypes2.default.string,
    container: $ca7090764f1f3151$var$_propTypes2.default.object,
    activeClass: $ca7090764f1f3151$var$_propTypes2.default.string,
    activeStyle: $ca7090764f1f3151$var$_propTypes2.default.object,
    spy: $ca7090764f1f3151$var$_propTypes2.default.bool,
    horizontal: $ca7090764f1f3151$var$_propTypes2.default.bool,
    smooth: $ca7090764f1f3151$var$_propTypes2.default.oneOfType([
        $ca7090764f1f3151$var$_propTypes2.default.bool,
        $ca7090764f1f3151$var$_propTypes2.default.string
    ]),
    offset: $ca7090764f1f3151$var$_propTypes2.default.number,
    delay: $ca7090764f1f3151$var$_propTypes2.default.number,
    isDynamic: $ca7090764f1f3151$var$_propTypes2.default.bool,
    onClick: $ca7090764f1f3151$var$_propTypes2.default.func,
    duration: $ca7090764f1f3151$var$_propTypes2.default.oneOfType([
        $ca7090764f1f3151$var$_propTypes2.default.number,
        $ca7090764f1f3151$var$_propTypes2.default.func
    ]),
    absolute: $ca7090764f1f3151$var$_propTypes2.default.bool,
    onSetActive: $ca7090764f1f3151$var$_propTypes2.default.func,
    onSetInactive: $ca7090764f1f3151$var$_propTypes2.default.func,
    ignoreCancelEvents: $ca7090764f1f3151$var$_propTypes2.default.bool,
    hashSpy: $ca7090764f1f3151$var$_propTypes2.default.bool,
    saveHashHistory: $ca7090764f1f3151$var$_propTypes2.default.bool,
    spyThrottle: $ca7090764f1f3151$var$_propTypes2.default.number
};
$ca7090764f1f3151$exports.default = function(Component, customScroller) {
    var scroller = customScroller || $ca7090764f1f3151$var$_scroller2.default;
    var Link = function(_React$PureComponent) {
        $ca7090764f1f3151$var$_inherits(Link, _React$PureComponent);
        function Link(props) {
            $ca7090764f1f3151$var$_classCallCheck(this, Link);
            var _this = $ca7090764f1f3151$var$_possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
            _initialiseProps.call(_this);
            _this.state = {
                active: false
            };
            return _this;
        }
        $ca7090764f1f3151$var$_createClass(Link, [
            {
                key: "getScrollSpyContainer",
                value: function getScrollSpyContainer() {
                    var containerId = this.props.containerId;
                    var container = this.props.container;
                    if (containerId && !container) return document.getElementById(containerId);
                    if (container && container.nodeType) return container;
                    return document;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.spy || this.props.hashSpy) {
                        var scrollSpyContainer = this.getScrollSpyContainer();
                        if (!$ca7090764f1f3151$var$_scrollSpy2.default.isMounted(scrollSpyContainer)) $ca7090764f1f3151$var$_scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
                        if (this.props.hashSpy) {
                            if (!$ca7090764f1f3151$var$_scrollHash2.default.isMounted()) $ca7090764f1f3151$var$_scrollHash2.default.mount(scroller);
                            $ca7090764f1f3151$var$_scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
                        }
                        $ca7090764f1f3151$var$_scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);
                        this.setState({
                            container: scrollSpyContainer
                        });
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    $ca7090764f1f3151$var$_scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
                }
            },
            {
                key: "render",
                value: function render() {
                    var className = "";
                    if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                    else className = this.props.className;
                    var style = {};
                    if (this.state && this.state.active) style = $ca7090764f1f3151$var$_extends({}, this.props.style, this.props.activeStyle);
                    else style = $ca7090764f1f3151$var$_extends({}, this.props.style);
                    var props = $ca7090764f1f3151$var$_extends({}, this.props);
                    for(var prop in $ca7090764f1f3151$var$protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                    props.className = className;
                    props.style = style;
                    props.onClick = this.handleClick;
                    return $ca7090764f1f3151$var$_react2.default.createElement(Component, props);
                }
            }
        ]);
        return Link;
    }($ca7090764f1f3151$var$_react2.default.PureComponent);
    var _initialiseProps = function _initialiseProps() {
        var _this2 = this;
        this.scrollTo = function(to, props) {
            scroller.scrollTo(to, $ca7090764f1f3151$var$_extends({}, _this2.state, props));
        };
        this.handleClick = function(event) {
            /*
       * give the posibility to override onClick
       */ if (_this2.props.onClick) _this2.props.onClick(event);
            /*
       * dont bubble the navigation
       */ if (event.stopPropagation) event.stopPropagation();
            if (event.preventDefault) event.preventDefault();
            /*
       * do the magic!
       */ _this2.scrollTo(_this2.props.to, _this2.props);
        };
        this.spyHandler = function(x, y) {
            var scrollSpyContainer = _this2.getScrollSpyContainer();
            if ($ca7090764f1f3151$var$_scrollHash2.default.isMounted() && !$ca7090764f1f3151$var$_scrollHash2.default.isInitialized()) return;
            var horizontal = _this2.props.horizontal;
            var to = _this2.props.to;
            var element = null;
            var isInside = void 0;
            var isOutside = void 0;
            if (horizontal) {
                var elemLeftBound = 0;
                var elemRightBound = 0;
                var containerLeft = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerLeft = containerCords.left;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemLeftBound = cords.left - containerLeft + x;
                    elemRightBound = elemLeftBound + cords.width;
                }
                var offsetX = x - _this2.props.offset;
                isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
                isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
            } else {
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var _containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = _containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var _cords = element.getBoundingClientRect();
                    elemTopBound = _cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + _cords.height;
                }
                var offsetY = y - _this2.props.offset;
                isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
            }
            var activeLink = scroller.getActiveLink();
            if (isOutside) {
                if (to === activeLink) scroller.setActiveLink(void 0);
                if (_this2.props.hashSpy && $ca7090764f1f3151$var$_scrollHash2.default.getHash() === to) {
                    var _props$saveHashHistor = _this2.props.saveHashHistory, saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;
                    $ca7090764f1f3151$var$_scrollHash2.default.changeHash("", saveHashHistory);
                }
                if (_this2.props.spy && _this2.state.active) {
                    _this2.setState({
                        active: false
                    });
                    _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
                }
            }
            if (isInside && (activeLink !== to || _this2.state.active === false)) {
                scroller.setActiveLink(to);
                var _props$saveHashHistor2 = _this2.props.saveHashHistory, _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;
                _this2.props.hashSpy && $ca7090764f1f3151$var$_scrollHash2.default.changeHash(to, _saveHashHistory);
                if (_this2.props.spy) {
                    _this2.setState({
                        active: true
                    });
                    _this2.props.onSetActive && _this2.props.onSetActive(to, element);
                }
            }
        };
    };
    Link.propTypes = $ca7090764f1f3151$var$protoTypes;
    Link.defaultProps = {
        offset: 0
    };
    return Link;
};


var $3e71142f587f39d9$var$_scrollLink2 = $3e71142f587f39d9$var$_interopRequireDefault($ca7090764f1f3151$exports);
function $3e71142f587f39d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e71142f587f39d9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e71142f587f39d9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3e71142f587f39d9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3e71142f587f39d9$var$LinkElement = function(_React$Component) {
    $3e71142f587f39d9$var$_inherits(LinkElement, _React$Component);
    function LinkElement() {
        var _ref;
        var _temp, _this, _ret;
        $3e71142f587f39d9$var$_classCallCheck(this, LinkElement);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $3e71142f587f39d9$var$_possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.render = function _ret() {
            return $3e71142f587f39d9$var$_react2.default.createElement("a", _this.props, _this.props.children);
        }, _temp), $3e71142f587f39d9$var$_possibleConstructorReturn(_this, _ret);
    }
    return LinkElement;
}($3e71142f587f39d9$var$_react2.default.Component);
$3e71142f587f39d9$exports.default = (0, $3e71142f587f39d9$var$_scrollLink2.default)($3e71142f587f39d9$var$LinkElement);


var $35ea8ec0273a7191$var$_Link2 = $35ea8ec0273a7191$var$_interopRequireDefault($3e71142f587f39d9$exports);
var $0a236455aa9e3057$exports = {};

var $bJtXW = parcelRequire("bJtXW");
"use strict";
Object.defineProperty($0a236455aa9e3057$exports, "__esModule", {
    value: true
});
var $0a236455aa9e3057$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQFEZ = parcelRequire("dQFEZ");
var $0a236455aa9e3057$var$_react2 = $0a236455aa9e3057$var$_interopRequireDefault($dQFEZ);

var $0a236455aa9e3057$var$_scrollLink2 = $0a236455aa9e3057$var$_interopRequireDefault($ca7090764f1f3151$exports);
function $0a236455aa9e3057$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a236455aa9e3057$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a236455aa9e3057$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0a236455aa9e3057$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0a236455aa9e3057$var$ButtonElement = function(_React$Component) {
    $0a236455aa9e3057$var$_inherits(ButtonElement, _React$Component);
    function ButtonElement() {
        $0a236455aa9e3057$var$_classCallCheck(this, ButtonElement);
        return $0a236455aa9e3057$var$_possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
    }
    $0a236455aa9e3057$var$_createClass(ButtonElement, [
        {
            key: "render",
            value: function render() {
                return $0a236455aa9e3057$var$_react2.default.createElement("button", this.props, this.props.children);
            }
        }
    ]);
    return ButtonElement;
}($0a236455aa9e3057$var$_react2.default.Component);
$0a236455aa9e3057$exports.default = (0, $0a236455aa9e3057$var$_scrollLink2.default)($0a236455aa9e3057$var$ButtonElement);


var $35ea8ec0273a7191$var$_Button2 = $35ea8ec0273a7191$var$_interopRequireDefault($0a236455aa9e3057$exports);
var $800d7dac71f9206b$exports = {};

var $bJtXW = parcelRequire("bJtXW");
"use strict";
Object.defineProperty($800d7dac71f9206b$exports, "__esModule", {
    value: true
});
var $800d7dac71f9206b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $800d7dac71f9206b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQFEZ = parcelRequire("dQFEZ");
var $800d7dac71f9206b$var$_react2 = $800d7dac71f9206b$var$_interopRequireDefault($dQFEZ);
var $d2ddcf8d40f58e21$exports = {};

var $bJtXW = parcelRequire("bJtXW");
"use strict";
Object.defineProperty($d2ddcf8d40f58e21$exports, "__esModule", {
    value: true
});
var $d2ddcf8d40f58e21$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d2ddcf8d40f58e21$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQFEZ = parcelRequire("dQFEZ");
var $d2ddcf8d40f58e21$var$_react2 = $d2ddcf8d40f58e21$var$_interopRequireDefault($dQFEZ);

var $d2ddcf8d40f58e21$var$_reactDom2 = $d2ddcf8d40f58e21$var$_interopRequireDefault($4288f0eb191085d1$exports);

var $d2ddcf8d40f58e21$var$_scroller2 = $d2ddcf8d40f58e21$var$_interopRequireDefault($e422d51e669d12fe$exports);

var $d2ddcf8d40f58e21$var$_propTypes2 = $d2ddcf8d40f58e21$var$_interopRequireDefault($6e2a5ed7e145fa83$exports);
function $d2ddcf8d40f58e21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d2ddcf8d40f58e21$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d2ddcf8d40f58e21$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d2ddcf8d40f58e21$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
$d2ddcf8d40f58e21$exports.default = function(Component) {
    var Element = function(_React$Component) {
        $d2ddcf8d40f58e21$var$_inherits(Element, _React$Component);
        function Element(props) {
            $d2ddcf8d40f58e21$var$_classCallCheck(this, Element);
            var _this = $d2ddcf8d40f58e21$var$_possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
            _this.childBindings = {
                domNode: null
            };
            return _this;
        }
        $d2ddcf8d40f58e21$var$_createClass(Element, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (typeof window === "undefined") return false;
                    this.registerElems(this.props.name);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (typeof window === "undefined") return false;
                    $d2ddcf8d40f58e21$var$_scroller2.default.unregister(this.props.name);
                }
            },
            {
                key: "registerElems",
                value: function registerElems(name) {
                    $d2ddcf8d40f58e21$var$_scroller2.default.register(name, this.childBindings.domNode);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $d2ddcf8d40f58e21$var$_react2.default.createElement(Component, $d2ddcf8d40f58e21$var$_extends({}, this.props, {
                        parentBindings: this.childBindings
                    }));
                }
            }
        ]);
        return Element;
    }($d2ddcf8d40f58e21$var$_react2.default.Component);
    Element.propTypes = {
        name: $d2ddcf8d40f58e21$var$_propTypes2.default.string,
        id: $d2ddcf8d40f58e21$var$_propTypes2.default.string
    };
    return Element;
};


var $800d7dac71f9206b$var$_scrollElement2 = $800d7dac71f9206b$var$_interopRequireDefault($d2ddcf8d40f58e21$exports);

var $800d7dac71f9206b$var$_propTypes2 = $800d7dac71f9206b$var$_interopRequireDefault($6e2a5ed7e145fa83$exports);
function $800d7dac71f9206b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $800d7dac71f9206b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $800d7dac71f9206b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $800d7dac71f9206b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $800d7dac71f9206b$var$ElementWrapper = function(_React$Component) {
    $800d7dac71f9206b$var$_inherits(ElementWrapper, _React$Component);
    function ElementWrapper() {
        $800d7dac71f9206b$var$_classCallCheck(this, ElementWrapper);
        return $800d7dac71f9206b$var$_possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
    }
    $800d7dac71f9206b$var$_createClass(ElementWrapper, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // Remove `parentBindings` and `name` from props
                var newProps = $800d7dac71f9206b$var$_extends({}, this.props);
                delete newProps.name;
                if (newProps.parentBindings) delete newProps.parentBindings;
                return $800d7dac71f9206b$var$_react2.default.createElement("div", $800d7dac71f9206b$var$_extends({}, newProps, {
                    ref: function ref(el) {
                        _this2.props.parentBindings.domNode = el;
                    }
                }), this.props.children);
            }
        }
    ]);
    return ElementWrapper;
}($800d7dac71f9206b$var$_react2.default.Component);
$800d7dac71f9206b$var$ElementWrapper.propTypes = {
    name: $800d7dac71f9206b$var$_propTypes2.default.string,
    id: $800d7dac71f9206b$var$_propTypes2.default.string
};
$800d7dac71f9206b$exports.default = (0, $800d7dac71f9206b$var$_scrollElement2.default)($800d7dac71f9206b$var$ElementWrapper);


var $35ea8ec0273a7191$var$_Element2 = $35ea8ec0273a7191$var$_interopRequireDefault($800d7dac71f9206b$exports);

var $35ea8ec0273a7191$var$_scroller2 = $35ea8ec0273a7191$var$_interopRequireDefault($e422d51e669d12fe$exports);

var $35ea8ec0273a7191$var$_scrollEvents2 = $35ea8ec0273a7191$var$_interopRequireDefault($6a0c7642e8f655f6$exports);

var $35ea8ec0273a7191$var$_scrollSpy2 = $35ea8ec0273a7191$var$_interopRequireDefault($35567781468e4e4b$exports);

var $35ea8ec0273a7191$var$_animateScroll2 = $35ea8ec0273a7191$var$_interopRequireDefault($05d177e2d8db84bb$exports);

var $35ea8ec0273a7191$var$_scrollLink2 = $35ea8ec0273a7191$var$_interopRequireDefault($ca7090764f1f3151$exports);

var $35ea8ec0273a7191$var$_scrollElement2 = $35ea8ec0273a7191$var$_interopRequireDefault($d2ddcf8d40f58e21$exports);
var $5c0682515a852bc7$exports = {};

var $bJtXW = parcelRequire("bJtXW");
"use strict";
/* DEPRECATED */ var $5c0682515a852bc7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5c0682515a852bc7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5c0682515a852bc7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5c0682515a852bc7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5c0682515a852bc7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $dQFEZ = parcelRequire("dQFEZ");






var $5c0682515a852bc7$var$protoTypes = {
    to: $6e2a5ed7e145fa83$exports.string.isRequired,
    containerId: $6e2a5ed7e145fa83$exports.string,
    container: $6e2a5ed7e145fa83$exports.object,
    activeClass: $6e2a5ed7e145fa83$exports.string,
    spy: $6e2a5ed7e145fa83$exports.bool,
    smooth: $6e2a5ed7e145fa83$exports.oneOfType([
        $6e2a5ed7e145fa83$exports.bool,
        $6e2a5ed7e145fa83$exports.string
    ]),
    offset: $6e2a5ed7e145fa83$exports.number,
    delay: $6e2a5ed7e145fa83$exports.number,
    isDynamic: $6e2a5ed7e145fa83$exports.bool,
    onClick: $6e2a5ed7e145fa83$exports.func,
    duration: $6e2a5ed7e145fa83$exports.oneOfType([
        $6e2a5ed7e145fa83$exports.number,
        $6e2a5ed7e145fa83$exports.func
    ]),
    absolute: $6e2a5ed7e145fa83$exports.bool,
    onSetActive: $6e2a5ed7e145fa83$exports.func,
    onSetInactive: $6e2a5ed7e145fa83$exports.func,
    ignoreCancelEvents: $6e2a5ed7e145fa83$exports.bool,
    hashSpy: $6e2a5ed7e145fa83$exports.bool,
    spyThrottle: $6e2a5ed7e145fa83$exports.number
};
var $5c0682515a852bc7$var$Helpers = {
    Scroll: function Scroll(Component, customScroller) {
        console.warn("Helpers.Scroll is deprecated since v1.7.0");
        var scroller = customScroller || $e422d51e669d12fe$exports;
        var Scroll = function(_React$Component) {
            $5c0682515a852bc7$var$_inherits(Scroll, _React$Component);
            function Scroll(props) {
                $5c0682515a852bc7$var$_classCallCheck(this, Scroll);
                var _this = $5c0682515a852bc7$var$_possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));
                _initialiseProps.call(_this);
                _this.state = {
                    active: false
                };
                return _this;
            }
            $5c0682515a852bc7$var$_createClass(Scroll, [
                {
                    key: "getScrollSpyContainer",
                    value: function getScrollSpyContainer() {
                        var containerId = this.props.containerId;
                        var container = this.props.container;
                        if (containerId) return document.getElementById(containerId);
                        if (container && container.nodeType) return container;
                        return document;
                    }
                },
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (this.props.spy || this.props.hashSpy) {
                            var scrollSpyContainer = this.getScrollSpyContainer();
                            if (!$35567781468e4e4b$exports.isMounted(scrollSpyContainer)) $35567781468e4e4b$exports.mount(scrollSpyContainer, this.props.spyThrottle);
                            if (this.props.hashSpy) {
                                if (!$8d06384719699c29$exports.isMounted()) $8d06384719699c29$exports.mount(scroller);
                                $8d06384719699c29$exports.mapContainer(this.props.to, scrollSpyContainer);
                            }
                            if (this.props.spy) $35567781468e4e4b$exports.addStateHandler(this.stateHandler);
                            $35567781468e4e4b$exports.addSpyHandler(this.spyHandler, scrollSpyContainer);
                            this.setState({
                                container: scrollSpyContainer
                            });
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        $35567781468e4e4b$exports.unmount(this.stateHandler, this.spyHandler);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var className = "";
                        if (this.state && this.state.active) className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                        else className = this.props.className;
                        var props = $5c0682515a852bc7$var$_extends({}, this.props);
                        for(var prop in $5c0682515a852bc7$var$protoTypes)if (props.hasOwnProperty(prop)) delete props[prop];
                        props.className = className;
                        props.onClick = this.handleClick;
                        return $dQFEZ.createElement(Component, props);
                    }
                }
            ]);
            return Scroll;
        }($dQFEZ.Component);
        var _initialiseProps = function _initialiseProps() {
            var _this2 = this;
            this.scrollTo = function(to, props) {
                scroller.scrollTo(to, $5c0682515a852bc7$var$_extends({}, _this2.state, props));
            };
            this.handleClick = function(event) {
                /*
         * give the posibility to override onClick
         */ if (_this2.props.onClick) _this2.props.onClick(event);
                /*
         * dont bubble the navigation
         */ if (event.stopPropagation) event.stopPropagation();
                if (event.preventDefault) event.preventDefault();
                /*
         * do the magic!
         */ _this2.scrollTo(_this2.props.to, _this2.props);
            };
            this.stateHandler = function() {
                if (scroller.getActiveLink() !== _this2.props.to) {
                    if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) _this2.props.onSetInactive();
                    _this2.setState({
                        active: false
                    });
                }
            };
            this.spyHandler = function(y) {
                var scrollSpyContainer = _this2.getScrollSpyContainer();
                if ($8d06384719699c29$exports.isMounted() && !$8d06384719699c29$exports.isInitialized()) return;
                var to = _this2.props.to;
                var element = null;
                var elemTopBound = 0;
                var elemBottomBound = 0;
                var containerTop = 0;
                if (scrollSpyContainer.getBoundingClientRect) {
                    var containerCords = scrollSpyContainer.getBoundingClientRect();
                    containerTop = containerCords.top;
                }
                if (!element || _this2.props.isDynamic) {
                    element = scroller.get(to);
                    if (!element) return;
                    var cords = element.getBoundingClientRect();
                    elemTopBound = cords.top - containerTop + y;
                    elemBottomBound = elemTopBound + cords.height;
                }
                var offsetY = y - _this2.props.offset;
                var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
                var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
                var activeLink = scroller.getActiveLink();
                if (isOutside) {
                    if (to === activeLink) scroller.setActiveLink(void 0);
                    if (_this2.props.hashSpy && $8d06384719699c29$exports.getHash() === to) $8d06384719699c29$exports.changeHash();
                    if (_this2.props.spy && _this2.state.active) {
                        _this2.setState({
                            active: false
                        });
                        _this2.props.onSetInactive && _this2.props.onSetInactive();
                    }
                    return $35567781468e4e4b$exports.updateStates();
                }
                if (isInside && activeLink !== to) {
                    scroller.setActiveLink(to);
                    _this2.props.hashSpy && $8d06384719699c29$exports.changeHash(to);
                    if (_this2.props.spy) {
                        _this2.setState({
                            active: true
                        });
                        _this2.props.onSetActive && _this2.props.onSetActive(to);
                    }
                    return $35567781468e4e4b$exports.updateStates();
                }
            };
        };
        Scroll.propTypes = $5c0682515a852bc7$var$protoTypes;
        Scroll.defaultProps = {
            offset: 0
        };
        return Scroll;
    },
    Element: function Element(Component) {
        console.warn("Helpers.Element is deprecated since v1.7.0");
        var Element = function(_React$Component2) {
            $5c0682515a852bc7$var$_inherits(Element, _React$Component2);
            function Element(props) {
                $5c0682515a852bc7$var$_classCallCheck(this, Element);
                var _this3 = $5c0682515a852bc7$var$_possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
                _this3.childBindings = {
                    domNode: null
                };
                return _this3;
            }
            $5c0682515a852bc7$var$_createClass(Element, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        if (typeof window === "undefined") return false;
                        this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps) {
                        if (this.props.name !== prevProps.name) this.registerElems(this.props.name);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        if (typeof window === "undefined") return false;
                        $e422d51e669d12fe$exports.unregister(this.props.name);
                    }
                },
                {
                    key: "registerElems",
                    value: function registerElems(name) {
                        $e422d51e669d12fe$exports.register(name, this.childBindings.domNode);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        return $dQFEZ.createElement(Component, $5c0682515a852bc7$var$_extends({}, this.props, {
                            parentBindings: this.childBindings
                        }));
                    }
                }
            ]);
            return Element;
        }($dQFEZ.Component);
        Element.propTypes = {
            name: $6e2a5ed7e145fa83$exports.string,
            id: $6e2a5ed7e145fa83$exports.string
        };
        return Element;
    }
};
$5c0682515a852bc7$exports = $5c0682515a852bc7$var$Helpers;


var $35ea8ec0273a7191$var$_Helpers2 = $35ea8ec0273a7191$var$_interopRequireDefault($5c0682515a852bc7$exports);
function $35ea8ec0273a7191$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$35ea8ec0273a7191$exports.Link = $35ea8ec0273a7191$var$_Link2.default;
$35ea8ec0273a7191$exports.Button = $35ea8ec0273a7191$var$_Button2.default;
$35ea8ec0273a7191$exports.Element = $35ea8ec0273a7191$var$_Element2.default;
$35ea8ec0273a7191$exports.scroller = $35ea8ec0273a7191$var$_scroller2.default;
$35ea8ec0273a7191$exports.Events = $35ea8ec0273a7191$var$_scrollEvents2.default;
$35ea8ec0273a7191$exports.scrollSpy = $35ea8ec0273a7191$var$_scrollSpy2.default;
$35ea8ec0273a7191$exports.animateScroll = $35ea8ec0273a7191$var$_animateScroll2.default;
$35ea8ec0273a7191$exports.ScrollLink = $35ea8ec0273a7191$var$_scrollLink2.default;
$35ea8ec0273a7191$exports.ScrollElement = $35ea8ec0273a7191$var$_scrollElement2.default;
$35ea8ec0273a7191$exports.Helpers = $35ea8ec0273a7191$var$_Helpers2.default;
$35ea8ec0273a7191$exports.default = {
    Link: $35ea8ec0273a7191$var$_Link2.default,
    Button: $35ea8ec0273a7191$var$_Button2.default,
    Element: $35ea8ec0273a7191$var$_Element2.default,
    scroller: $35ea8ec0273a7191$var$_scroller2.default,
    Events: $35ea8ec0273a7191$var$_scrollEvents2.default,
    scrollSpy: $35ea8ec0273a7191$var$_scrollSpy2.default,
    animateScroll: $35ea8ec0273a7191$var$_animateScroll2.default,
    ScrollLink: $35ea8ec0273a7191$var$_scrollLink2.default,
    ScrollElement: $35ea8ec0273a7191$var$_scrollElement2.default,
    Helpers: $35ea8ec0273a7191$var$_Helpers2.default
};


/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $baf9b2a64fedef68$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $grujF = parcelRequire("grujF");

var $2nwvT = parcelRequire("2nwvT");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $bJtXW = parcelRequire("bJtXW");
var $b8c3f91e5973f862$var$extendStatics = function extendStatics1(d, b) {
    $b8c3f91e5973f862$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b8c3f91e5973f862$var$extendStatics(d, b);
};
function $b8c3f91e5973f862$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b8c3f91e5973f862$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b8c3f91e5973f862$export$18ce0697a983be9b = function __assign1() {
    $b8c3f91e5973f862$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8c3f91e5973f862$export$18ce0697a983be9b.apply(this, arguments);
};
function $b8c3f91e5973f862$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b8c3f91e5973f862$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b8c3f91e5973f862$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b8c3f91e5973f862$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b8c3f91e5973f862$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b8c3f91e5973f862$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $bJtXW._)(x)) === "symbol" ? x : "".concat(x);
}
function $b8c3f91e5973f862$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b8c3f91e5973f862$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b8c3f91e5973f862$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b8c3f91e5973f862$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b8c3f91e5973f862$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b8c3f91e5973f862$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b8c3f91e5973f862$export$45d3717a4c69092e(o, m, p);
}
function $b8c3f91e5973f862$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b8c3f91e5973f862$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b8c3f91e5973f862$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b8c3f91e5973f862$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b8c3f91e5973f862$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b8c3f91e5973f862$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b8c3f91e5973f862$export$10c90e4f7922046c(v) {
    return this instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? (this.v = v, this) : new $b8c3f91e5973f862$export$10c90e4f7922046c(v);
}
function $b8c3f91e5973f862$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b8c3f91e5973f862$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b8c3f91e5973f862$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b8c3f91e5973f862$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b8c3f91e5973f862$export$19a8beecd37a4c45 === "function" ? $b8c3f91e5973f862$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b8c3f91e5973f862$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b8c3f91e5973f862$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b8c3f91e5973f862$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b8c3f91e5973f862$export$45d3717a4c69092e(result, mod, k);
    }
    $b8c3f91e5973f862$var$__setModuleDefault(result, mod);
    return result;
}
function $b8c3f91e5973f862$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b8c3f91e5973f862$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b8c3f91e5973f862$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b8c3f91e5973f862$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b8c3f91e5973f862$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b8c3f91e5973f862$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b8c3f91e5973f862$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b8c3f91e5973f862$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $b8c3f91e5973f862$export$2e2bcd8739ae039 = {
    __extends: $b8c3f91e5973f862$export$a8ba968b8961cb8a,
    __assign: $b8c3f91e5973f862$export$18ce0697a983be9b,
    __rest: $b8c3f91e5973f862$export$3c9a16f847548506,
    __decorate: $b8c3f91e5973f862$export$29e00dfd3077644b,
    __param: $b8c3f91e5973f862$export$d5ad3fd78186038f,
    __metadata: $b8c3f91e5973f862$export$f1db080c865becb9,
    __awaiter: $b8c3f91e5973f862$export$1050f835b63b671e,
    __generator: $b8c3f91e5973f862$export$67ebef60e6f28a6,
    __createBinding: $b8c3f91e5973f862$export$45d3717a4c69092e,
    __exportStar: $b8c3f91e5973f862$export$f33643c0debef087,
    __values: $b8c3f91e5973f862$export$19a8beecd37a4c45,
    __read: $b8c3f91e5973f862$export$8d051b38c9118094,
    __spread: $b8c3f91e5973f862$export$afc72e2116322959,
    __spreadArrays: $b8c3f91e5973f862$export$6388937ca91ccae8,
    __spreadArray: $b8c3f91e5973f862$export$1216008129fb82ed,
    __await: $b8c3f91e5973f862$export$10c90e4f7922046c,
    __asyncGenerator: $b8c3f91e5973f862$export$e427f37a30a4de9b,
    __asyncDelegator: $b8c3f91e5973f862$export$bbd80228419bb833,
    __asyncValues: $b8c3f91e5973f862$export$e3b29a3d6162315f,
    __makeTemplateObject: $b8c3f91e5973f862$export$4fb47efe1390b86f,
    __importStar: $b8c3f91e5973f862$export$c21735bcef00d192,
    __importDefault: $b8c3f91e5973f862$export$da59b14a69baef04,
    __classPrivateFieldGet: $b8c3f91e5973f862$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b8c3f91e5973f862$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b8c3f91e5973f862$export$81fdc39f203e4e04,
    __addDisposableResource: $b8c3f91e5973f862$export$88ac25d8e944e405,
    __disposeResources: $b8c3f91e5973f862$export$8f076105dc360e92
};



var $dQFEZ = parcelRequire("dQFEZ");

/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");


var $2us1u = parcelRequire("2us1u");

var $1EZOw = parcelRequire("1EZOw");

var $lngen = parcelRequire("lngen");


function $be547bb6c77acdb8$var$_extends() {
    $be547bb6c77acdb8$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be547bb6c77acdb8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $be547bb6c77acdb8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($be547bb6c77acdb8$export$e19cd5f9376f8cee || ($be547bb6c77acdb8$export$e19cd5f9376f8cee = {}));
var $be547bb6c77acdb8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $be547bb6c77acdb8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $be547bb6c77acdb8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $be547bb6c77acdb8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $be547bb6c77acdb8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $be547bb6c77acdb8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to);
    }
    return $be547bb6c77acdb8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $be547bb6c77acdb8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $be547bb6c77acdb8$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $be547bb6c77acdb8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $be547bb6c77acdb8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $be547bb6c77acdb8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $be547bb6c77acdb8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $be547bb6c77acdb8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $be547bb6c77acdb8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $be547bb6c77acdb8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $be547bb6c77acdb8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $be547bb6c77acdb8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $be547bb6c77acdb8$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $be547bb6c77acdb8$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $be547bb6c77acdb8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($be547bb6c77acdb8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
        var location = $be547bb6c77acdb8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $be547bb6c77acdb8$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
        var location = $be547bb6c77acdb8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $be547bb6c77acdb8$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $be547bb6c77acdb8$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $be547bb6c77acdb8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($be547bb6c77acdb8$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($be547bb6c77acdb8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $be547bb6c77acdb8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($be547bb6c77acdb8$var$ResultType || ($be547bb6c77acdb8$var$ResultType = {}));
var $be547bb6c77acdb8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $be547bb6c77acdb8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $be547bb6c77acdb8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2us1u._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $be547bb6c77acdb8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $be547bb6c77acdb8$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($be547bb6c77acdb8$var$isIndexRoute(route)) {
            var indexRoute = $be547bb6c77acdb8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $be547bb6c77acdb8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $be547bb6c77acdb8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $be547bb6c77acdb8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $be547bb6c77acdb8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $be547bb6c77acdb8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $be547bb6c77acdb8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $be547bb6c77acdb8$var$flattenRoutes(routes);
    $be547bb6c77acdb8$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = $be547bb6c77acdb8$export$30d21fd6d7295f52(pathname);
        matches = $be547bb6c77acdb8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $be547bb6c77acdb8$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $be547bb6c77acdb8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $be547bb6c77acdb8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $be547bb6c77acdb8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $be547bb6c77acdb8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $be547bb6c77acdb8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $be547bb6c77acdb8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $be547bb6c77acdb8$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $be547bb6c77acdb8$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $f625ca9f0dc92caa$export$71511d61b312f219)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $be547bb6c77acdb8$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2us1u._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2us1u._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $be547bb6c77acdb8$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $be547bb6c77acdb8$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $be547bb6c77acdb8$var$paramRe = /^:[\w-]+$/;
var $be547bb6c77acdb8$var$dynamicSegmentValue = 3;
var $be547bb6c77acdb8$var$indexRouteValue = 2;
var $be547bb6c77acdb8$var$emptySegmentValue = 1;
var $be547bb6c77acdb8$var$staticSegmentValue = 10;
var $be547bb6c77acdb8$var$splatPenalty = -2;
var $be547bb6c77acdb8$var$isSplat = function(s) {
    return s === "*";
};
function $be547bb6c77acdb8$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($be547bb6c77acdb8$var$isSplat)) initialScore += $be547bb6c77acdb8$var$splatPenalty;
    if (index) initialScore += $be547bb6c77acdb8$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$be547bb6c77acdb8$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($be547bb6c77acdb8$var$paramRe.test(segment) ? $be547bb6c77acdb8$var$dynamicSegmentValue : segment === "" ? $be547bb6c77acdb8$var$emptySegmentValue : $be547bb6c77acdb8$var$staticSegmentValue);
    }, initialScore);
}
function $be547bb6c77acdb8$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $be547bb6c77acdb8$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $be547bb6c77acdb8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $be547bb6c77acdb8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $be547bb6c77acdb8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $be547bb6c77acdb8$export$a5c6d149b50c1d86($be547bb6c77acdb8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $be547bb6c77acdb8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $be547bb6c77acdb8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $2nwvT._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $be547bb6c77acdb8$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $be547bb6c77acdb8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $2nwvT._)($be547bb6c77acdb8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $be547bb6c77acdb8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $be547bb6c77acdb8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $be547bb6c77acdb8$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        $be547bb6c77acdb8$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $be547bb6c77acdb8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $be547bb6c77acdb8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $be547bb6c77acdb8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $be547bb6c77acdb8$var$normalizeSearch(search),
        hash: $be547bb6c77acdb8$var$normalizeHash(hash)
    };
}
function $be547bb6c77acdb8$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $be547bb6c77acdb8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $be547bb6c77acdb8$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $be547bb6c77acdb8$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $be547bb6c77acdb8$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $be547bb6c77acdb8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $be547bb6c77acdb8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $be547bb6c77acdb8$var$_extends({}, toArg);
        $be547bb6c77acdb8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $be547bb6c77acdb8$var$getInvalidPathError("?", "pathname", "search", to));
        $be547bb6c77acdb8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $be547bb6c77acdb8$var$getInvalidPathError("#", "pathname", "hash", to));
        $be547bb6c77acdb8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $be547bb6c77acdb8$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $be547bb6c77acdb8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $be547bb6c77acdb8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $be547bb6c77acdb8$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $be547bb6c77acdb8$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $be547bb6c77acdb8$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $be547bb6c77acdb8$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $be547bb6c77acdb8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $be547bb6c77acdb8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $be547bb6c77acdb8$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $j6Mzi._)(AbortedDeferredError, Error1);
    var _super = (0, $lngen._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $grujF._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $1EZOw._)(Error));
var $be547bb6c77acdb8$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $grujF._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $be547bb6c77acdb8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $be547bb6c77acdb8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $2nwvT._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $72osQ._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $dhMkv._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $be547bb6c77acdb8$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
                    var aborted, onAbort;
                    return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $be547bb6c77acdb8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $2nwvT._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $72osQ._)({}, key, $be547bb6c77acdb8$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $be547bb6c77acdb8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $be547bb6c77acdb8$var$unwrapTrackedPromise(value) {
    if (!$be547bb6c77acdb8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $be547bb6c77acdb8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $be547bb6c77acdb8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $be547bb6c77acdb8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $be547bb6c77acdb8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $be547bb6c77acdb8$export$a6cd19cd1951a23c = function(url, init) {
    var response = $be547bb6c77acdb8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $be547bb6c77acdb8$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $grujF._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $be547bb6c77acdb8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $be547bb6c77acdb8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $be547bb6c77acdb8$var$validMutationMethods = new Set($be547bb6c77acdb8$var$validMutationMethodsArr);
var $be547bb6c77acdb8$var$validRequestMethodsArr = [
    "get"
].concat((0, $2us1u._)($be547bb6c77acdb8$var$validMutationMethodsArr));
var $be547bb6c77acdb8$var$validRequestMethods = new Set($be547bb6c77acdb8$var$validRequestMethodsArr);
var $be547bb6c77acdb8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $be547bb6c77acdb8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $be547bb6c77acdb8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $be547bb6c77acdb8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $be547bb6c77acdb8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $be547bb6c77acdb8$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $be547bb6c77acdb8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $be547bb6c77acdb8$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $be547bb6c77acdb8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $be547bb6c77acdb8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $be547bb6c77acdb8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.unstable_dataStrategy || $be547bb6c77acdb8$var$defaultDataStrategy;
    var patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    var future = $be547bb6c77acdb8$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $be547bb6c77acdb8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $be547bb6c77acdb8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $be547bb6c77acdb8$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $72osQ._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        var isRouteInitialized = function(m) {
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $be547bb6c77acdb8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    var pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $be547bb6c77acdb8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $be547bb6c77acdb8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $be547bb6c77acdb8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $be547bb6c77acdb8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $be547bb6c77acdb8$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2us1u._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $be547bb6c77acdb8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $be547bb6c77acdb8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $be547bb6c77acdb8$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $be547bb6c77acdb8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($be547bb6c77acdb8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $be547bb6c77acdb8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $be547bb6c77acdb8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $be547bb6c77acdb8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $be547bb6c77acdb8$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $be547bb6c77acdb8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $be547bb6c77acdb8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $be547bb6c77acdb8$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $72osQ._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $be547bb6c77acdb8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $be547bb6c77acdb8$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $be547bb6c77acdb8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            $be547bb6c77acdb8$var$findNearestBoundary(matches).route.id,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $be547bb6c77acdb8$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $2nwvT._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if ($be547bb6c77acdb8$var$isErrorResult(result) && $be547bb6c77acdb8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = $be547bb6c77acdb8$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = $be547bb6c77acdb8$var$createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $be547bb6c77acdb8$var$_extends({
                            matches: updatedMatches || matches
                        }, $be547bb6c77acdb8$var$getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, _handleDiscoverRouteError, boundaryId, error, _handleNavigational404, notFoundMatches, error1, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $be547bb6c77acdb8$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), boundaryId = _handleDiscoverRouteError.boundaryId, error = _handleDiscoverRouteError.error;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: $be547bb6c77acdb8$var$ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error1 = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: $be547bb6c77acdb8$var$ResultType.error,
                                            error: error1
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = $be547bb6c77acdb8$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: $be547bb6c77acdb8$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!$be547bb6c77acdb8$var$isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = $be547bb6c77acdb8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if ($be547bb6c77acdb8$var$isDeferredResult(result)) throw $be547bb6c77acdb8$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if ($be547bb6c77acdb8$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _handleDiscoverRouteError, boundaryId, error, _handleNavigational404, error1, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $be547bb6c77acdb8$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $be547bb6c77acdb8$var$getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState($be547bb6c77acdb8$var$_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), boundaryId = _handleDiscoverRouteError.boundaryId, error = _handleDiscoverRouteError.error;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, boundaryId, error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error1 = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, route.id, error1)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $2nwvT._)($be547bb6c77acdb8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $be547bb6c77acdb8$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, $be547bb6c77acdb8$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $be547bb6c77acdb8$var$findRedirect((0, $2us1u._)(loaderResults).concat((0, $2us1u._)(fetcherResults)));
                        if (!redirect) return [
                            3,
                            5
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        // Process and commit output from loaders
                        _processLoaderData = $be547bb6c77acdb8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, $2nwvT._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, $2nwvT._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, $72osQ._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $be547bb6c77acdb8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $be547bb6c77acdb8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $be547bb6c77acdb8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $be547bb6c77acdb8$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $be547bb6c77acdb8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = $be547bb6c77acdb8$var$getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $be547bb6c77acdb8$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = $be547bb6c77acdb8$var$getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", fetchRequest, [
                                match
                            ], requestMatches)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[0];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($be547bb6c77acdb8$var$isRedirectResult(actionResult) || $be547bb6c77acdb8$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $be547bb6c77acdb8$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($be547bb6c77acdb8$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $be547bb6c77acdb8$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $be547bb6c77acdb8$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($be547bb6c77acdb8$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($be547bb6c77acdb8$var$isDeferredResult(actionResult)) throw $be547bb6c77acdb8$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $be547bb6c77acdb8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $2nwvT._)($be547bb6c77acdb8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $be547bb6c77acdb8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $be547bb6c77acdb8$var$findRedirect((0, $2us1u._)(loaderResults).concat((0, $2us1u._)(fetcherResults)));
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $be547bb6c77acdb8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $be547bb6c77acdb8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $be547bb6c77acdb8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, results, result;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $be547bb6c77acdb8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = $be547bb6c77acdb8$var$getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", fetchRequest, [
                                match
                            ], matches)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[0];
                        if (!$be547bb6c77acdb8$var$isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            $be547bb6c77acdb8$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $be547bb6c77acdb8$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$be547bb6c77acdb8$var$isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $be547bb6c77acdb8$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if ($be547bb6c77acdb8$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $be547bb6c77acdb8$export$3e9cee6b33872309(!$be547bb6c77acdb8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $be547bb6c77acdb8$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        $be547bb6c77acdb8$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
                        location = $be547bb6c77acdb8$var$normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = $be547bb6c77acdb8$var$createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $be547bb6c77acdb8$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $be547bb6c77acdb8$export$e19cd5f9376f8cee.Replace : $be547bb6c77acdb8$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $be547bb6c77acdb8$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($be547bb6c77acdb8$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $be547bb6c77acdb8$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $be547bb6c77acdb8$var$_extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $be547bb6c77acdb8$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(type, request, matchesToLoad, matches) {
            var results, e;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            $be547bb6c77acdb8$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($be547bb6c77acdb8$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    return {
                                        type: $be547bb6c77acdb8$var$ResultType.redirect,
                                        response: $be547bb6c77acdb8$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                                    };
                                }
                                return $be547bb6c77acdb8$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        return [
                            2,
                            matchesToLoad.map(function() {
                                return {
                                    type: $be547bb6c77acdb8$var$ResultType.error,
                                    error: e
                                };
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var _ref, loaderResults, fetcherResults;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : []
                            ].concat((0, $2us1u._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) {
                                    var fetcherRequest = $be547bb6c77acdb8$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                                    return callDataStrategy("loader", fetcherRequest, [
                                        f.match
                                    ], f.matches).then(function(r) {
                                        return r[0];
                                    });
                                } else return Promise.resolve({
                                    type: $be547bb6c77acdb8$var$ResultType.error,
                                    error: $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                        pathname: f.path
                                    })
                                });
                            }))))
                        ];
                    case 1:
                        _ref = (0, $f625ca9f0dc92caa$export$71511d61b312f219).apply(void 0, [
                            _state.sent()
                        ]), loaderResults = _ref[0], fetcherResults = _ref.slice(1);
                        return [
                            4,
                            Promise.all([
                                $be547bb6c77acdb8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $be547bb6c77acdb8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2us1u._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $72osQ._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $be547bb6c77acdb8$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $be547bb6c77acdb8$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $be547bb6c77acdb8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $be547bb6c77acdb8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $be547bb6c77acdb8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $be547bb6c77acdb8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $be547bb6c77acdb8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $be547bb6c77acdb8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $2nwvT._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = $be547bb6c77acdb8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = $be547bb6c77acdb8$var$getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $be547bb6c77acdb8$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $be547bb6c77acdb8$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $be547bb6c77acdb8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $be547bb6c77acdb8$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                var fogMatches = $be547bb6c77acdb8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                var leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    var partialMatches = $be547bb6c77acdb8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(matches, pathname, signal) {
            var partialMatches, route, isNonHMR, routesToUse, e, newMatches, matchedSplat, leafRoute, newPartialMatches;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        partialMatches = matches;
                        route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            7
                        ];
                        isNonHMR = inFlightDataRoutes == null;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            $be547bb6c77acdb8$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            {
                                type: "error",
                                error: e,
                                partialMatches: partialMatches
                            }
                        ];
                    case 5:
                        // If we are not in the middle of an HMR revalidation and we changed the
                        // routes, provide a new identity so when we `updateState` at the end of
                        // this navigation/fetch `router.routes` will be a new identity and
                        // trigger a re-run of memoized `router.routes` dependencies.
                        // HMR will already update the identity and reflow when it lands
                        // `inFlightDataRoutes` in `completeNavigation`
                        if (isNonHMR) dataRoutes = (0, $2us1u._)(dataRoutes);
                        return [
                            7
                        ];
                    case 6:
                        if (signal.aborted) return [
                            2,
                            {
                                type: "aborted"
                            }
                        ];
                        newMatches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, pathname, basename);
                        matchedSplat = false;
                        if (newMatches) {
                            leafRoute = newMatches[newMatches.length - 1].route;
                            if (leafRoute.index) // If we found an index route, we can stop
                            return [
                                2,
                                {
                                    type: "success",
                                    matches: newMatches
                                }
                            ];
                            if (leafRoute.path && leafRoute.path.length > 0) {
                                if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                                // higher-scoring route down some partial matches trail so we need
                                // to check that out
                                matchedSplat = true;
                                else // If we found a non-splat route, we can stop
                                return [
                                    2,
                                    {
                                        type: "success",
                                        matches: newMatches
                                    }
                                ];
                            }
                        }
                        newPartialMatches = $be547bb6c77acdb8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                        // If we are no longer partially matching anything, this was either a
                        // legit splat match above, or it's a 404.  Also avoid loops if the
                        // second pass results in the same partial matches
                        if (!newPartialMatches || partialMatches.map(function(m) {
                            return m.route.id;
                        }).join("-") === newPartialMatches.map(function(m) {
                            return m.route.id;
                        }).join("-")) return [
                            2,
                            {
                                type: "success",
                                matches: matchedSplat ? newMatches : null
                            }
                        ];
                        partialMatches = newPartialMatches;
                        route = partialMatches[partialMatches.length - 1].route;
                        if (route.path === "*") // The splat is still our most accurate partial, so run with it
                        return [
                            2,
                            {
                                type: "success",
                                matches: partialMatches
                            }
                        ];
                        return [
                            3,
                            1
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $be547bb6c77acdb8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        $be547bb6c77acdb8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $2us1u._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $be547bb6c77acdb8$export$4d0306f8f6a4585b = Symbol("deferred");
function $be547bb6c77acdb8$export$3336b097a6fbc59a(routes, opts) {
    $be547bb6c77acdb8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $be547bb6c77acdb8$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $be547bb6c77acdb8$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $be547bb6c77acdb8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, unstable_dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $be547bb6c77acdb8$var$createLocation("", $be547bb6c77acdb8$export$fe53371bee54353d(url), null, "default");
                        matches = $be547bb6c77acdb8$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$be547bb6c77acdb8$var$isValidMethod(method) && method !== "HEAD") {
                            error = $be547bb6c77acdb8$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $be547bb6c77acdb8$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $be547bb6c77acdb8$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $be547bb6c77acdb8$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($be547bb6c77acdb8$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, _temp4) {
            var _ref, routeId, requestContext, unstable_dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $be547bb6c77acdb8$var$createLocation("", $be547bb6c77acdb8$export$fe53371bee54353d(url), null, "default");
                        matches = $be547bb6c77acdb8$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$be547bb6c77acdb8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $be547bb6c77acdb8$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $be547bb6c77acdb8$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $be547bb6c77acdb8$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $be547bb6c77acdb8$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $be547bb6c77acdb8$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($be547bb6c77acdb8$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$be547bb6c77acdb8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $be547bb6c77acdb8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$be547bb6c77acdb8$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $be547bb6c77acdb8$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $be547bb6c77acdb8$var$isResponse(result1) ? result1 : $be547bb6c77acdb8$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `HandlerResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if ($be547bb6c77acdb8$var$isHandlerResult(e) && $be547bb6c77acdb8$var$isResponse(e.result)) {
                            if (e.type === $be547bb6c77acdb8$var$ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($be547bb6c77acdb8$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $be547bb6c77acdb8$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) $be547bb6c77acdb8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($be547bb6c77acdb8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if ($be547bb6c77acdb8$var$isDeferredResult(result)) {
                            error1 = $be547bb6c77acdb8$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $be547bb6c77acdb8$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($be547bb6c77acdb8$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!$be547bb6c77acdb8$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $be547bb6c77acdb8$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({}, context, {
                                statusCode: $be547bb6c77acdb8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: $be547bb6c77acdb8$var$_extends({}, result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({}, context1, {
                                actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $be547bb6c77acdb8$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? $be547bb6c77acdb8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $72osQ._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $be547bb6c77acdb8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $be547bb6c77acdb8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $be547bb6c77acdb8$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
            var results;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $be547bb6c77acdb8$var$callDataStrategyImpl(unstable_dataStrategy || $be547bb6c77acdb8$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($be547bb6c77acdb8$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    // Throw redirects and let the server handle them with an HTTP redirect
                                    throw $be547bb6c77acdb8$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
                                }
                                if ($be547bb6c77acdb8$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                // directly without unwrapping
                                throw result;
                                return $be547bb6c77acdb8$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $be547bb6c77acdb8$export$fec11da027c70692(routes, context, error) {
    var newContext = $be547bb6c77acdb8$var$_extends({}, context, {
        statusCode: $be547bb6c77acdb8$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $72osQ._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $be547bb6c77acdb8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $be547bb6c77acdb8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $be547bb6c77acdb8$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $be547bb6c77acdb8$export$cae722b0cc860f13(to ? to : ".", $be547bb6c77acdb8$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $be547bb6c77acdb8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$be547bb6c77acdb8$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $be547bb6c77acdb8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $be547bb6c77acdb8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $be547bb6c77acdb8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$be547bb6c77acdb8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$be547bb6c77acdb8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $be547bb6c77acdb8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $be547bb6c77acdb8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $be547bb6c77acdb8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$be547bb6c77acdb8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, $2nwvT._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$be547bb6c77acdb8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $be547bb6c77acdb8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $be547bb6c77acdb8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $be547bb6c77acdb8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $be547bb6c77acdb8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $be547bb6c77acdb8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($be547bb6c77acdb8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $be547bb6c77acdb8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $be547bb6c77acdb8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $be547bb6c77acdb8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $be547bb6c77acdb8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $be547bb6c77acdb8$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingActionResult && $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    var boundaryMatches = boundaryId ? $be547bb6c77acdb8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($be547bb6c77acdb8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $be547bb6c77acdb8$var$shouldRevalidateLoader(match, $be547bb6c77acdb8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $be547bb6c77acdb8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $be547bb6c77acdb8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $be547bb6c77acdb8$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $be547bb6c77acdb8$var$shouldRevalidateLoader(fetcherMatch, $be547bb6c77acdb8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $be547bb6c77acdb8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $be547bb6c77acdb8$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $be547bb6c77acdb8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $be547bb6c77acdb8$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    return $be547bb6c77acdb8$var$_loadLazyRouteChildren.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_loadLazyRouteChildren() {
    $be547bb6c77acdb8$var$_loadLazyRouteChildren = /**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
        var key, pending;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = [
                        path
                    ].concat((0, $2us1u._)(matches.map(function(m) {
                        return m.route.id;
                    }))).join("-");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    pending = pendingRouteChildren.get(key);
                    if (!pending) {
                        pending = patchRoutesOnMissImpl({
                            path: path,
                            matches: matches,
                            patch: function(routeId, children) {
                                if (!signal.aborted) $be547bb6c77acdb8$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                            }
                        });
                        pendingRouteChildren.set(key, pending);
                    }
                    if (!(pending && $be547bb6c77acdb8$var$isPromise(pending))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        pending
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    pendingRouteChildren.delete(key);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_loadLazyRouteChildren.apply(this, arguments);
}
function $be547bb6c77acdb8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route_children;
        var _route$children;
        var route = manifest[routeId];
        $be547bb6c77acdb8$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        var dataChildren = $be547bb6c77acdb8$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) (_route_children = route.children).push.apply(_route_children, (0, $2us1u._)(dataChildren));
        else route.children = dataChildren;
    } else {
        var _routesToUse;
        var dataChildren1 = $be547bb6c77acdb8$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        (_routesToUse = routesToUse).push.apply(_routesToUse, (0, $2us1u._)(dataChildren1));
    }
}
function $be547bb6c77acdb8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $be547bb6c77acdb8$var$_loadLazyRouteModule.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_loadLazyRouteModule() {
    $be547bb6c77acdb8$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $be547bb6c77acdb8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $be547bb6c77acdb8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$be547bb6c77acdb8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $be547bb6c77acdb8$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_loadLazyRouteModule.apply(this, arguments);
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $be547bb6c77acdb8$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map(function(m) {
        return m.resolve();
    }));
}
function $be547bb6c77acdb8$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    return $be547bb6c77acdb8$var$_callDataStrategyImpl.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_callDataStrategyImpl() {
    $be547bb6c77acdb8$var$_callDataStrategyImpl = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
        var routeIdsToLoad, loadedMatches, results;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeIdsToLoad = matchesToLoad.reduce(function(acc, m) {
                        return acc.add(m.route.id);
                    }, new Set());
                    loadedMatches = new Set();
                    return [
                        4,
                        dataStrategyImpl({
                            matches: matches.map(function(match) {
                                var shouldLoad = routeIdsToLoad.has(match.route.id);
                                // `resolve` encapsulates the route.lazy, executing the
                                // loader/action, and mapping return values/thrown errors to a
                                // HandlerResult.  Users can pass a callback to take fine-grained control
                                // over the execution of the loader/action
                                var resolve = function(handlerOverride) {
                                    loadedMatches.add(match.route.id);
                                    return shouldLoad ? $be547bb6c77acdb8$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                                        type: $be547bb6c77acdb8$var$ResultType.data,
                                        result: undefined
                                    });
                                };
                                return $be547bb6c77acdb8$var$_extends({}, match, {
                                    shouldLoad: shouldLoad,
                                    resolve: resolve
                                });
                            }),
                            request: request,
                            params: matches[0].params,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    // Throw if any loadRoute implementations not called since they are what
                    // ensures a route is fully loaded
                    matches.forEach(function(m) {
                        return $be547bb6c77acdb8$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded.");
                    });
                    // Filter out any middleware-only matches for which we didn't need to run handlers
                    return [
                        2,
                        results.filter(function(_, i) {
                            return routeIdsToLoad.has(matches[i].route.id);
                        })
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_callDataStrategyImpl.apply(this, arguments);
}
function $be547bb6c77acdb8$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    return $be547bb6c77acdb8$var$_callLoaderOrAction.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_callLoaderOrAction() {
    $be547bb6c77acdb8$var$_callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<HandlerResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2us1u._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise;
                        if (handlerOverride) handlerPromise = handlerOverride(function(ctx) {
                            return actualHandler(ctx);
                        });
                        else handlerPromise = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
                            var val, e;
                            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $be547bb6c77acdb8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    _ref = (0, $2nwvT._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $be547bb6c77acdb8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $be547bb6c77acdb8$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $be547bb6c77acdb8$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $be547bb6c77acdb8$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // HandlerResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_callLoaderOrAction.apply(this, arguments);
}
function $be547bb6c77acdb8$var$convertHandlerResultToDataResult(handlerResult) {
    return $be547bb6c77acdb8$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_convertHandlerResultToDataResult() {
    $be547bb6c77acdb8$var$_convertHandlerResultToDataResult = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(handlerResult) {
        var result, type, status, data, contentType, e, _result$init, _result$init2;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = handlerResult.result, type = handlerResult.type, status = handlerResult.status;
                    if (!$be547bb6c77acdb8$var$isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === $be547bb6c77acdb8$var$ResultType.error) return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: new $be547bb6c77acdb8$export$6c6580e81da25755(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === $be547bb6c77acdb8$var$ResultType.error) return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.error,
                            error: result,
                            statusCode: $be547bb6c77acdb8$export$972111febbeef05b(result) ? result.status : status
                        }
                    ];
                    if ($be547bb6c77acdb8$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: result,
                            statusCode: status
                        }
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function $be547bb6c77acdb8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    $be547bb6c77acdb8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = $be547bb6c77acdb8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $be547bb6c77acdb8$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($be547bb6c77acdb8$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = $be547bb6c77acdb8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $be547bb6c77acdb8$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($be547bb6c77acdb8$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $be547bb6c77acdb8$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $be547bb6c77acdb8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $be547bb6c77acdb8$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $be547bb6c77acdb8$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $be547bb6c77acdb8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $be547bb6c77acdb8$export$3e9cee6b33872309(!$be547bb6c77acdb8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($be547bb6c77acdb8$var$isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $be547bb6c77acdb8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($be547bb6c77acdb8$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $72osQ._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $be547bb6c77acdb8$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $be547bb6c77acdb8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $be547bb6c77acdb8$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($be547bb6c77acdb8$var$isErrorResult(result)) {
            var boundaryMatch = $be547bb6c77acdb8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $be547bb6c77acdb8$var$_extends({}, errors, (0, $72osQ._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($be547bb6c77acdb8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $be547bb6c77acdb8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($be547bb6c77acdb8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $be547bb6c77acdb8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $be547bb6c77acdb8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $be547bb6c77acdb8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $be547bb6c77acdb8$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function $be547bb6c77acdb8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $be547bb6c77acdb8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $be547bb6c77acdb8$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2us1u._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $be547bb6c77acdb8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $be547bb6c77acdb8$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $be547bb6c77acdb8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $be547bb6c77acdb8$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($be547bb6c77acdb8$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $be547bb6c77acdb8$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(path) : path;
    return $be547bb6c77acdb8$export$fe53371bee54353d($be547bb6c77acdb8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $be547bb6c77acdb8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $be547bb6c77acdb8$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $be547bb6c77acdb8$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $be547bb6c77acdb8$var$ResultType.data || result.type === $be547bb6c77acdb8$var$ResultType.error);
}
function $be547bb6c77acdb8$var$isRedirectHandlerResult(result) {
    return $be547bb6c77acdb8$var$isResponse(result.result) && $be547bb6c77acdb8$var$redirectStatusCodes.has(result.result.status);
}
function $be547bb6c77acdb8$var$isDeferredResult(result) {
    return result.type === $be547bb6c77acdb8$var$ResultType.deferred;
}
function $be547bb6c77acdb8$var$isErrorResult(result) {
    return result.type === $be547bb6c77acdb8$var$ResultType.error;
}
function $be547bb6c77acdb8$var$isRedirectResult(result) {
    return (result && result.type) === $be547bb6c77acdb8$var$ResultType.redirect;
}
function $be547bb6c77acdb8$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $be547bb6c77acdb8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $be547bb6c77acdb8$var$isRedirectResponse(result) {
    if (!$be547bb6c77acdb8$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $be547bb6c77acdb8$var$isValidMethod(method) {
    return $be547bb6c77acdb8$var$validRequestMethods.has(method.toLowerCase());
}
function $be547bb6c77acdb8$var$isMutationMethod(method) {
    return $be547bb6c77acdb8$var$validMutationMethods.has(method.toLowerCase());
}
function $be547bb6c77acdb8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $be547bb6c77acdb8$var$_resolveDeferredResults.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_resolveDeferredResults() {
    $be547bb6c77acdb8$var$_resolveDeferredResults = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$be547bb6c77acdb8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($be547bb6c77acdb8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $be547bb6c77acdb8$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $be547bb6c77acdb8$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $b8c3f91e5973f862$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_resolveDeferredResults.apply(this, arguments);
}
function $be547bb6c77acdb8$var$resolveDeferredData(result, signal, unwrap) {
    return $be547bb6c77acdb8$var$_resolveDeferredData.apply(this, arguments);
}
function $be547bb6c77acdb8$var$_resolveDeferredData() {
    $be547bb6c77acdb8$var$_resolveDeferredData = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(result, signal, unwrap) {
        var aborted;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $be547bb6c77acdb8$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $be547bb6c77acdb8$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $be547bb6c77acdb8$var$_resolveDeferredData.apply(this, arguments);
}
function $be547bb6c77acdb8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $be547bb6c77acdb8$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $be547bb6c77acdb8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $be547bb6c77acdb8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $be547bb6c77acdb8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $be547bb6c77acdb8$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $be547bb6c77acdb8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $be547bb6c77acdb8$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $be547bb6c77acdb8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $be547bb6c77acdb8$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $be547bb6c77acdb8$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $be547bb6c77acdb8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($be547bb6c77acdb8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $be547bb6c77acdb8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2us1u._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($be547bb6c77acdb8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $be547bb6c77acdb8$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $lngen = parcelRequire("lngen");

var $dQFEZ = parcelRequire("dQFEZ");

function $8c3ad80f8a436e0f$var$_extends() {
    $8c3ad80f8a436e0f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c3ad80f8a436e0f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $8c3ad80f8a436e0f$export$3add0d5dce533e2e = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$145dfa71566a64dc = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$var$AwaitContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $8c3ad80f8a436e0f$export$26749e8557646306 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$c7914228fb69b0f5 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$9072aa6dd1f93057 = /*#__PURE__*/ $dQFEZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $8c3ad80f8a436e0f$var$RouteErrorContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $8c3ad80f8a436e0f$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $8c3ad80f8a436e0f$export$9c954a9d03d32f4a() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $8c3ad80f8a436e0f$export$45d76561a5302f2b() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $8c3ad80f8a436e0f$export$1b3f31771c5d07c() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $8c3ad80f8a436e0f$export$6c330e8992e8a295(pattern) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var pathname = $8c3ad80f8a436e0f$export$45d76561a5302f2b().pathname;
    return $dQFEZ.useMemo(function() {
        return (0, $be547bb6c77acdb8$export$81336c211d5ff295)(pattern, (0, $be547bb6c77acdb8$export$30d21fd6d7295f52)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $8c3ad80f8a436e0f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dQFEZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $8c3ad80f8a436e0f$export$9770f232ac06a008() {
    var isDataRoute = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $8c3ad80f8a436e0f$var$useNavigateStable() : $8c3ad80f8a436e0f$var$useNavigateUnstable();
}
function $8c3ad80f8a436e0f$var$useNavigateUnstable() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $be547bb6c77acdb8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $be547bb6c77acdb8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$OutletContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $8c3ad80f8a436e0f$export$4138103a3ae699cc() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(context) {
    var outlet = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef() {
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).future;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $be547bb6c77acdb8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $dQFEZ.useMemo(function() {
        return (0, $be547bb6c77acdb8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $8c3ad80f8a436e0f$export$5d3fca4a98652595(routes, locationArg) {
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var navigator = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).navigator;
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $8c3ad80f8a436e0f$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $be547bb6c77acdb8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $be547bb6c77acdb8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $8c3ad80f8a436e0f$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $8c3ad80f8a436e0f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $be547bb6c77acdb8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $8c3ad80f8a436e0f$var$DefaultErrorComponent() {
    var error = $8c3ad80f8a436e0f$export$ed527bf60f6e05f2();
    var message = (0, $be547bb6c77acdb8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dQFEZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dQFEZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $8c3ad80f8a436e0f$var$defaultErrorElement = /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DefaultErrorComponent, null);
var $8c3ad80f8a436e0f$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $lngen._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $grujF._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $dhMkv._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($dQFEZ.Component);
function $8c3ad80f8a436e0f$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $8c3ad80f8a436e0f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $8c3ad80f8a436e0f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $8c3ad80f8a436e0f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dQFEZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $8c3ad80f8a436e0f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($8c3ad80f8a436e0f$var$DataRouterHook || {});
var $8c3ad80f8a436e0f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($8c3ad80f8a436e0f$var$DataRouterStateHook || {});
function $8c3ad80f8a436e0f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $8c3ad80f8a436e0f$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    !ctx && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8c3ad80f8a436e0f$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext($8c3ad80f8a436e0f$export$145dfa71566a64dc);
    !state && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return state;
}
function $8c3ad80f8a436e0f$var$useRouteContext(hookName) {
    var route = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057);
    !route && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $8c3ad80f8a436e0f$var$useCurrentRouteId(hookName) {
    var route = $8c3ad80f8a436e0f$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $8c3ad80f8a436e0f$export$5fc8298006ad9e58() {
    return $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $8c3ad80f8a436e0f$export$d0fd4b7106de2769() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $8c3ad80f8a436e0f$export$600dc272ed516c15() {
    var dataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseRevalidator);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRevalidator);
    return $dQFEZ.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $8c3ad80f8a436e0f$export$2378eb7f5ff86053() {
    var _useDataRouterState = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $dQFEZ.useMemo(function() {
        return matches.map(function(m) {
            return (0, $be547bb6c77acdb8$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $8c3ad80f8a436e0f$export$1448a5050d252c4d() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $8c3ad80f8a436e0f$export$fd5d37484eab868d(routeId) {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $8c3ad80f8a436e0f$export$fdc00f3f26066d5e() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseActionData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $8c3ad80f8a436e0f$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $dQFEZ.useContext($8c3ad80f8a436e0f$var$RouteErrorContext);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$78a72ddb39bdd145() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$17f53340677d5831() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $8c3ad80f8a436e0f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $8c3ad80f8a436e0f$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $dQFEZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $8c3ad80f8a436e0f$var$_extends({}, currentLocation, {
                pathname: (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $8c3ad80f8a436e0f$var$_extends({}, nextLocation, {
                pathname: (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dQFEZ.useEffect(function() {
        var key = String(++$8c3ad80f8a436e0f$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dQFEZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $be547bb6c77acdb8$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $8c3ad80f8a436e0f$var$useNavigateStable() {
    var router = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseNavigateStable).router;
    var id = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $8c3ad80f8a436e0f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$alreadyWarned = {};
function $8c3ad80f8a436e0f$var$warningOnce(key, cond, message) {
    if (!cond && !$8c3ad80f8a436e0f$var$alreadyWarned[key]) $8c3ad80f8a436e0f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $8c3ad80f8a436e0f$var$START_TRANSITION = "startTransition";
var $8c3ad80f8a436e0f$var$startTransitionImpl = $dQFEZ[$8c3ad80f8a436e0f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8c3ad80f8a436e0f$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        if (v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl) $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $8c3ad80f8a436e0f$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $8c3ad80f8a436e0f$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $be547bb6c77acdb8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl ? $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $8c3ad80f8a436e0f$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $8c3ad80f8a436e0f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $be547bb6c77acdb8$export$cae722b0cc860f13)(to, (0, $be547bb6c77acdb8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $dQFEZ.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $8c3ad80f8a436e0f$export$910ae8079b2c2852(props) {
    return $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $8c3ad80f8a436e0f$export$e7b0ac011bb776c6(_props) {
    (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $8c3ad80f8a436e0f$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $be547bb6c77acdb8$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $dQFEZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $8c3ad80f8a436e0f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $be547bb6c77acdb8$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $dQFEZ.useMemo(function() {
        var trailingPathname = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $8c3ad80f8a436e0f$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $8c3ad80f8a436e0f$export$5d3fca4a98652595($8c3ad80f8a436e0f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $8c3ad80f8a436e0f$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$ResolveAwait, null, children));
}
var $8c3ad80f8a436e0f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($8c3ad80f8a436e0f$var$AwaitRenderStatus || {});
var $8c3ad80f8a436e0f$var$neverSettledPromise = new Promise(function() {});
var $8c3ad80f8a436e0f$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $lngen._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $grujF._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $dhMkv._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.error : "_data" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.success : $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && promise._error instanceof (0, $be547bb6c77acdb8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $8c3ad80f8a436e0f$var$neverSettledPromise;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($dQFEZ.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $8c3ad80f8a436e0f$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $8c3ad80f8a436e0f$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $8c3ad80f8a436e0f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $dQFEZ.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $dQFEZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2us1u._)(parentPath).concat([
            index
        ]);
        if (element.type === $dQFEZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $8c3ad80f8a436e0f$export$e7b0ac011bb776c6) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $8c3ad80f8a436e0f$export$daf73786167a7f72(matches) {
    return $8c3ad80f8a436e0f$var$_renderMatches(matches);
}
function $8c3ad80f8a436e0f$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dQFEZ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dQFEZ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dQFEZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $8c3ad80f8a436e0f$export$f30f7e456d254e83(routes, opts) {
    return (0, $be547bb6c77acdb8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8c3ad80f8a436e0f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $be547bb6c77acdb8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $8c3ad80f8a436e0f$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $fc41d09ddc03e3ec$var$_extends() {
    $fc41d09ddc03e3ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc41d09ddc03e3ec$var$_extends.apply(this, arguments);
}
function $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fc41d09ddc03e3ec$var$defaultMethod = "get";
var $fc41d09ddc03e3ec$var$defaultEncType = "application/x-www-form-urlencoded";
function $fc41d09ddc03e3ec$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fc41d09ddc03e3ec$var$isButtonElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fc41d09ddc03e3ec$var$isFormElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fc41d09ddc03e3ec$var$isInputElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fc41d09ddc03e3ec$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fc41d09ddc03e3ec$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fc41d09ddc03e3ec$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = null;
function $fc41d09ddc03e3ec$var$isFormDataSubmitterSupported() {
    if ($fc41d09ddc03e3ec$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = true;
    }
    return $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter;
}
var $fc41d09ddc03e3ec$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fc41d09ddc03e3ec$var$getFormEncType(encType) {
    if (encType != null && !$fc41d09ddc03e3ec$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($fc41d09ddc03e3ec$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fc41d09ddc03e3ec$var$isButtonElement(target) || $fc41d09ddc03e3ec$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("formenctype")) || $fc41d09ddc03e3ec$var$getFormEncType(form.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fc41d09ddc03e3ec$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fc41d09ddc03e3ec$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fc41d09ddc03e3ec$var$defaultMethod;
        action = null;
        encType = $fc41d09ddc03e3ec$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $fc41d09ddc03e3ec$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $fc41d09ddc03e3ec$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $fc41d09ddc03e3ec$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fc41d09ddc03e3ec$export$1f3f55432a00e06d(routes, opts) {
    return (0, $be547bb6c77acdb8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $be547bb6c77acdb8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $be547bb6c77acdb8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $be547bb6c77acdb8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fc41d09ddc03e3ec$var$_extends({}, state, {
        errors: $fc41d09ddc03e3ec$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fc41d09ddc03e3ec$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $be547bb6c77acdb8$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $fc41d09ddc03e3ec$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dQFEZ.createContext({
    isTransitioning: false
});
var $fc41d09ddc03e3ec$export$148fd98d095596d4 = /*#__PURE__*/ $dQFEZ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $fc41d09ddc03e3ec$var$START_TRANSITION = "startTransition";
var $fc41d09ddc03e3ec$var$startTransitionImpl = $dQFEZ[$fc41d09ddc03e3ec$var$START_TRANSITION];
var $fc41d09ddc03e3ec$var$FLUSH_SYNC = "flushSync";
var $fc41d09ddc03e3ec$var$flushSyncImpl = $4288f0eb191085d1$exports[$fc41d09ddc03e3ec$var$FLUSH_SYNC];
var $fc41d09ddc03e3ec$var$USE_ID = "useId";
var $fc41d09ddc03e3ec$var$useIdImpl = $dQFEZ[$fc41d09ddc03e3ec$var$USE_ID];
function $fc41d09ddc03e3ec$var$startTransitionSafe(cb) {
    if ($fc41d09ddc03e3ec$var$startTransitionImpl) $fc41d09ddc03e3ec$var$startTransitionImpl(cb);
    else cb();
}
function $fc41d09ddc03e3ec$var$flushSyncSafe(cb) {
    if ($fc41d09ddc03e3ec$var$flushSyncImpl) $fc41d09ddc03e3ec$var$flushSyncImpl(cb);
    else cb();
}
var $fc41d09ddc03e3ec$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $grujF._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fc41d09ddc03e3ec$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $2nwvT._)($dQFEZ.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $2nwvT._)($dQFEZ.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $2nwvT._)($dQFEZ.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $2nwvT._)($dQFEZ.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $2nwvT._)($dQFEZ.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $dQFEZ.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $dQFEZ.useCallback(function(cb) {
        if (v7_startTransition) $fc41d09ddc03e3ec$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $dQFEZ.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dQFEZ.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fc41d09ddc03e3ec$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
                return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dQFEZ.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $dQFEZ.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $fc41d09ddc03e3ec$var$MemoizedDataRoutes = /*#__PURE__*/ $dQFEZ.memo($fc41d09ddc03e3ec$var$DataRoutes);
function $fc41d09ddc03e3ec$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $8c3ad80f8a436e0f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fc41d09ddc03e3ec$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $be547bb6c77acdb8$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fc41d09ddc03e3ec$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $be547bb6c77acdb8$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fc41d09ddc03e3ec$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $fc41d09ddc03e3ec$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dQFEZ.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref7, $fc41d09ddc03e3ec$var$_excluded);
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fc41d09ddc03e3ec$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $8c3ad80f8a436e0f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $fc41d09ddc03e3ec$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dQFEZ.createElement("a", $fc41d09ddc03e3ec$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $fc41d09ddc03e3ec$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dQFEZ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref8, $fc41d09ddc03e3ec$var$_excluded2);
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var routerState = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    var _React_useContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fc41d09ddc03e3ec$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a6c7ac8248d6e38a, $fc41d09ddc03e3ec$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $fc41d09ddc03e3ec$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dQFEZ.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $fc41d09ddc03e3ec$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref9, $fc41d09ddc03e3ec$var$_excluded3);
    var submit = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var formAction = $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $dQFEZ.createElement("form", $fc41d09ddc03e3ec$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fc41d09ddc03e3ec$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $fc41d09ddc03e3ec$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fc41d09ddc03e3ec$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fc41d09ddc03e3ec$var$DataRouterHook || ($fc41d09ddc03e3ec$var$DataRouterHook = {}));
var $fc41d09ddc03e3ec$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fc41d09ddc03e3ec$var$DataRouterStateHook || ($fc41d09ddc03e3ec$var$DataRouterStateHook = {}));
// Internal hooks
function $fc41d09ddc03e3ec$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $fc41d09ddc03e3ec$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e));
    !ctx && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $fc41d09ddc03e3ec$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    !state && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fc41d09ddc03e3ec$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dQFEZ.useCallback(function(event) {
        if ($fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $be547bb6c77acdb8$export$fe53371bee54353d)(location) === (0, $be547bb6c77acdb8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fc41d09ddc03e3ec$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $dQFEZ.useRef($fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $dQFEZ.useRef(false);
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var searchParams = $dQFEZ.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fc41d09ddc03e3ec$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var setSearchParams = $dQFEZ.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fc41d09ddc03e3ec$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $fc41d09ddc03e3ec$var$fetcherId = 0;
var $fc41d09ddc03e3ec$var$getUniqueFetcherId = function() {
    return "__" + String(++$fc41d09ddc03e3ec$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fc41d09ddc03e3ec$export$47c85c6e3a081d3() {
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseSubmit).router;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var currentRouteId = (0, $8c3ad80f8a436e0f$export$5fc8298006ad9e58)();
    return $dQFEZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fc41d09ddc03e3ec$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $fc41d09ddc03e3ec$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var routeContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    !routeContext && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $2nwvT._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $fc41d09ddc03e3ec$var$_extends({}, (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $be547bb6c77acdb8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $be547bb6c77acdb8$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fc41d09ddc03e3ec$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseFetcher).router;
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $dQFEZ.useContext($fc41d09ddc03e3ec$export$148fd98d095596d4);
    var route = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    !route && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $fc41d09ddc03e3ec$var$useIdImpl ? $fc41d09ddc03e3ec$var$useIdImpl() : "";
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fc41d09ddc03e3ec$var$getUniqueFetcherId());
    // Registration/cleanup
    $dQFEZ.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $dQFEZ.useCallback(function(href, opts) {
        !routeId && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var submit = $dQFEZ.useCallback(function(target, opts) {
        submitImpl(target, $fc41d09ddc03e3ec$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $dQFEZ.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $dQFEZ.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a7fed597f4b8afd8, $fc41d09ddc03e3ec$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $be547bb6c77acdb8$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $dQFEZ.useMemo(function() {
        return $fc41d09ddc03e3ec$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fc41d09ddc03e3ec$export$fa996778a3a31087() {
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $2nwvT._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $fc41d09ddc03e3ec$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fc41d09ddc03e3ec$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fc41d09ddc03e3ec$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var matches = (0, $8c3ad80f8a436e0f$export$2378eb7f5ff86053)();
    var navigation = (0, $8c3ad80f8a436e0f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dQFEZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fc41d09ddc03e3ec$var$usePageHide($dQFEZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $fc41d09ddc03e3ec$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fc41d09ddc03e3ec$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fc41d09ddc03e3ec$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($fc41d09ddc03e3ec$var$_extends({}, location, {
                    pathname: (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fc41d09ddc03e3ec$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fc41d09ddc03e3ec$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $8c3ad80f8a436e0f$export$b273b3273281a049)(when);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fc41d09ddc03e3ec$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $dQFEZ.useContext($fc41d09ddc03e3ec$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $be547bb6c77acdb8$export$3e9cee6b33872309)(false);
    var basename = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $be547bb6c77acdb8$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $be547bb6c77acdb8$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $be547bb6c77acdb8$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $7369adae215afad1$exports = {};

$7369adae215afad1$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "dj.d8b8b825.png";



var $dQFEZ = parcelRequire("dQFEZ");
var $cd3d079ad12be02c$exports = {};

$cd3d079ad12be02c$exports = (parcelRequire("eh1Ad")).getBundleURL("6L7xj") + "dj_dark.84954af9.png";






var $c4021ea79fe238b3$var$useCalculateDuration = function(target) {
    var targetPosition = document.querySelector(target).offsetTop;
    var startPosition = window.scrollY;
    var distance = Math.abs(startPosition - targetPosition);
    var baseDuration = 400;
    var additionalDuration = Math.log(distance + 1) * 100;
    var duration = baseDuration + additionalDuration;
    var minDuration = 400;
    var maxDuration = 2000;
    duration = Math.min(Math.max(duration, minDuration), maxDuration);
    return duration;
};
var $c4021ea79fe238b3$export$2e2bcd8739ae039 = $c4021ea79fe238b3$var$useCalculateDuration;



var $dQFEZ = parcelRequire("dQFEZ");

var $2fef355e7ca2123a$var$NavBarMobile = function(param) {
    var nav = param.nav, isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var _useContext = (0, $dQFEZ.useContext)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039)), darkMode = _useContext.darkMode, setDarkMode = _useContext.setDarkMode;
    var toggleMenu = function() {
        setIsOpen(!isOpen);
    };
    var handleThemeToggle = function() {
        setDarkMode(!darkMode);
        toggleMenu();
    };
    if (isOpen) return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "fixed inset-0 dark:bg-[#121212]  bg-white z-50 flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                onClick: toggleMenu,
                className: "dark:text-white text-3xl font-extralight absolute top-4 right-4",
                children: "X"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("ul", {
                className: "font-poppins text-[#333333] text-2xl space-y-6 dark:text-[#e0e0e0]",
                children: nav.map(function(item, index) {
                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                        className: "transition-colors hover:text-[#9d9d9d]",
                        children: item.external ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                            onClick: toggleMenu,
                            to: item.link,
                            children: item.title
                        }) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $35ea8ec0273a7191$exports.Link), {
                            onClick: toggleMenu,
                            to: item.link,
                            smooth: "easeInOutQuad",
                            duration: function() {
                                return (0, $c4021ea79fe238b3$export$2e2bcd8739ae039)("#".concat(item.link));
                            },
                            children: item.title
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                onClick: handleThemeToggle,
                className: "mt-6 p-2 bg-gray-800 dark:bg-gray-200 dark:text-[#333333] text-[#e0e0e0]",
                children: darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"
            })
        ]
    });
};
var $2fef355e7ca2123a$export$2e2bcd8739ae039 = $2fef355e7ca2123a$var$NavBarMobile;



var $0f5cea3d9e590017$var$NavBar = function(param) {
    var nav = param.nav;
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var _useContext = (0, $dQFEZ.useContext)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039)), darkMode = _useContext.darkMode, setDarkMode = _useContext.setDarkMode;
    var toggleDarkMode = function() {
        setDarkMode(!darkMode);
    };
    (0, $dQFEZ.useEffect)(function() {
        if (isOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "auto";
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("nav", {
                className: "hidden items-center fixed top-0 left-0 w-full dark:bg-[#121212] bg-white shadow-lg dark:shadow-[#e53939] z-50 md:flex px-16 dark:text-[#e0e0e0]",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                    className: "w-full grid  grid-cols-3 items-center",
                    style: {
                        gridTemplateColumns: "1fr auto 1fr"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            children: darkMode ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                onClick: function() {
                                    navigate("/");
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cd3d079ad12be02c$exports))),
                                className: "h-20 w-20 bg-black hover:cursor-pointer"
                            }) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                onClick: function() {
                                    navigate("/");
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7369adae215afad1$exports))),
                                className: "h-20 w-20 hover:cursor-pointer"
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            className: "md:flex justify-center dark:text-[#e0e0e0]",
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("ul", {
                                className: "flex font-poppins text-[#333333] items-center space-x-10 dark:text-[#e0e0e0] h-20",
                                children: nav.map(function(item, index) {
                                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("li", {
                                        className: "transition-colors hover:text-[#9d9d9d] hover:cursor-pointer",
                                        children: item.external ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                            to: item.link,
                                            children: item.title
                                        }) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $35ea8ec0273a7191$exports.Link), {
                                            to: item.link,
                                            smooth: "easeInOutQuad",
                                            duration: function() {
                                                return (0, $c4021ea79fe238b3$export$2e2bcd8739ae039)("#".concat(item.link));
                                            },
                                            children: item.title
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            className: "flex justify-end relative",
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                onClick: toggleDarkMode,
                                className: " hover:cursor-pointer ".concat(darkMode ? "text-[#f0f0f0]" : "text-[#333333]", " text-xl"),
                                children: "\u2600"
                            })
                        })
                    ]
                })
            }),
            !isOpen && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "md:hidden shadow-lg z-50 dark:shadow-[#e53939] pt-2  px-5",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            children: darkMode ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cd3d079ad12be02c$exports))),
                                className: "h-16 w-16"
                            }) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7369adae215afad1$exports))),
                                className: "h-16 w-16"
                            })
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("i", {
                                style: {
                                    color: darkMode ? "#f0f0f0" : "#333333"
                                },
                                onClick: function() {
                                    return setIsOpen(true);
                                },
                                className: "fa-solid fa-bars fa-2x"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $2fef355e7ca2123a$export$2e2bcd8739ae039), {
                nav: nav,
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
};
var $0f5cea3d9e590017$export$2e2bcd8739ae039 = $0f5cea3d9e590017$var$NavBar;


var $9bc98fb187a3b925$var$nav = [
    {
        title: "Home",
        link: "home"
    },
    {
        title: "Projects",
        link: "projects"
    },
    {
        title: "Resume",
        link: "resume"
    },
    {
        title: "Skills",
        link: "skills"
    },
    {
        title: "Contact",
        link: "contact"
    }
];
var $9bc98fb187a3b925$export$2e2bcd8739ae039 = $9bc98fb187a3b925$var$nav;



var $bJtXW = parcelRequire("bJtXW");

var $4a8d0781ded8e672$exports = {};
"use strict";
function $4a8d0781ded8e672$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $dQFEZ = parcelRequire("dQFEZ");
var $4a8d0781ded8e672$var$React__default = $4a8d0781ded8e672$var$_interopDefault($dQFEZ);
function $4a8d0781ded8e672$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4a8d0781ded8e672$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4a8d0781ded8e672$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $4a8d0781ded8e672$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $4a8d0781ded8e672$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $4a8d0781ded8e672$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($dQFEZ.PureComponent);
        $4a8d0781ded8e672$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $4a8d0781ded8e672$var$_defineProperty(SideEffect, "canUseDOM", $4a8d0781ded8e672$var$canUseDOM);
        return SideEffect;
    };
}
$4a8d0781ded8e672$exports = $4a8d0781ded8e672$var$withSideEffect;


var $6a0658b34bb04ea2$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $6a0658b34bb04ea2$var$hasElementType = typeof Element !== "undefined";
var $6a0658b34bb04ea2$var$hasMap = typeof Map === "function";
var $6a0658b34bb04ea2$var$hasSet = typeof Set === "function";
var $6a0658b34bb04ea2$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $6a0658b34bb04ea2$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$6a0658b34bb04ea2$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($6a0658b34bb04ea2$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$6a0658b34bb04ea2$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($6a0658b34bb04ea2$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($6a0658b34bb04ea2$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($6a0658b34bb04ea2$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$6a0658b34bb04ea2$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$6a0658b34bb04ea2$exports = function isEqual(a, b) {
    try {
        return $6a0658b34bb04ea2$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $dQFEZ = parcelRequire("dQFEZ");
var $752ef8caa6a52fe6$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $752ef8caa6a52fe6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $752ef8caa6a52fe6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $752ef8caa6a52fe6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $752ef8caa6a52fe6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $752ef8caa6a52fe6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$752ef8caa6a52fe6$exports = $752ef8caa6a52fe6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $752ef8caa6a52fe6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($752ef8caa6a52fe6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($752ef8caa6a52fe6$var$getOwnPropertySymbols) {
            symbols = $752ef8caa6a52fe6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($752ef8caa6a52fe6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $da6bb92553a8e98c$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $da6bb92553a8e98c$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $da6bb92553a8e98c$var$VALID_TAG_NAMES = Object.keys($da6bb92553a8e98c$var$TAG_NAMES).map(function(name) {
    return $da6bb92553a8e98c$var$TAG_NAMES[name];
});
var $da6bb92553a8e98c$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $da6bb92553a8e98c$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $da6bb92553a8e98c$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $da6bb92553a8e98c$var$HTML_TAG_MAP = Object.keys($da6bb92553a8e98c$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$da6bb92553a8e98c$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $da6bb92553a8e98c$var$SELF_CLOSING_TAGS = [
    $da6bb92553a8e98c$var$TAG_NAMES.NOSCRIPT,
    $da6bb92553a8e98c$var$TAG_NAMES.SCRIPT,
    $da6bb92553a8e98c$var$TAG_NAMES.STYLE
];
var $da6bb92553a8e98c$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $da6bb92553a8e98c$var$_typeof = typeof Symbol === "function" && (0, $bJtXW._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj);
};
var $da6bb92553a8e98c$var$classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $da6bb92553a8e98c$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $da6bb92553a8e98c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $da6bb92553a8e98c$var$inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $bJtXW._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $da6bb92553a8e98c$var$objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $da6bb92553a8e98c$var$possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $da6bb92553a8e98c$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $da6bb92553a8e98c$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $da6bb92553a8e98c$var$getInnermostProperty(propsList, $da6bb92553a8e98c$var$TAG_NAMES.TITLE);
    var innermostTemplate = $da6bb92553a8e98c$var$getInnermostProperty(propsList, $da6bb92553a8e98c$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $da6bb92553a8e98c$var$getInnermostProperty(propsList, $da6bb92553a8e98c$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $da6bb92553a8e98c$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $da6bb92553a8e98c$var$getInnermostProperty(propsList, $da6bb92553a8e98c$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $da6bb92553a8e98c$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $da6bb92553a8e98c$var$_extends({}, tagAttrs, current);
    }, {});
};
var $da6bb92553a8e98c$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$da6bb92553a8e98c$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$da6bb92553a8e98c$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $da6bb92553a8e98c$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $da6bb92553a8e98c$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $da6bb92553a8e98c$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $da6bb92553a8e98c$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $da6bb92553a8e98c$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $da6bb92553a8e98c$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $da6bb92553a8e98c$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $da6bb92553a8e98c$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($752ef8caa6a52fe6$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $da6bb92553a8e98c$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $da6bb92553a8e98c$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $da6bb92553a8e98c$var$getBaseTagFromPropsList([
            $da6bb92553a8e98c$var$TAG_PROPERTIES.HREF,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $da6bb92553a8e98c$var$getAttributesFromPropsList($da6bb92553a8e98c$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $da6bb92553a8e98c$var$getInnermostProperty(propsList, $da6bb92553a8e98c$var$HELMET_PROPS.DEFER),
        encode: $da6bb92553a8e98c$var$getInnermostProperty(propsList, $da6bb92553a8e98c$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $da6bb92553a8e98c$var$getAttributesFromPropsList($da6bb92553a8e98c$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $da6bb92553a8e98c$var$getTagsFromPropsList($da6bb92553a8e98c$var$TAG_NAMES.LINK, [
            $da6bb92553a8e98c$var$TAG_PROPERTIES.REL,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $da6bb92553a8e98c$var$getTagsFromPropsList($da6bb92553a8e98c$var$TAG_NAMES.META, [
            $da6bb92553a8e98c$var$TAG_PROPERTIES.NAME,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.CHARSET,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.HTTPEQUIV,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.PROPERTY,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $da6bb92553a8e98c$var$getTagsFromPropsList($da6bb92553a8e98c$var$TAG_NAMES.NOSCRIPT, [
            $da6bb92553a8e98c$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $da6bb92553a8e98c$var$getOnChangeClientState(propsList),
        scriptTags: $da6bb92553a8e98c$var$getTagsFromPropsList($da6bb92553a8e98c$var$TAG_NAMES.SCRIPT, [
            $da6bb92553a8e98c$var$TAG_PROPERTIES.SRC,
            $da6bb92553a8e98c$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $da6bb92553a8e98c$var$getTagsFromPropsList($da6bb92553a8e98c$var$TAG_NAMES.STYLE, [
            $da6bb92553a8e98c$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $da6bb92553a8e98c$var$getTitleFromPropsList(propsList),
        titleAttributes: $da6bb92553a8e98c$var$getAttributesFromPropsList($da6bb92553a8e98c$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $da6bb92553a8e98c$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $da6bb92553a8e98c$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $da6bb92553a8e98c$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $da6bb92553a8e98c$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $da6bb92553a8e98c$var$rafPolyfill : $parcel$global.requestAnimationFrame || $da6bb92553a8e98c$var$rafPolyfill;
var $da6bb92553a8e98c$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $da6bb92553a8e98c$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $da6bb92553a8e98c$var$cafPolyfill;
var $da6bb92553a8e98c$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $da6bb92553a8e98c$var$_helmetCallback = null;
var $da6bb92553a8e98c$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($da6bb92553a8e98c$var$_helmetCallback) $da6bb92553a8e98c$var$cancelAnimationFrame($da6bb92553a8e98c$var$_helmetCallback);
    if (newState.defer) $da6bb92553a8e98c$var$_helmetCallback = $da6bb92553a8e98c$var$requestAnimationFrame(function() {
        $da6bb92553a8e98c$var$commitTagChanges(newState, function() {
            $da6bb92553a8e98c$var$_helmetCallback = null;
        });
    });
    else {
        $da6bb92553a8e98c$var$commitTagChanges(newState);
        $da6bb92553a8e98c$var$_helmetCallback = null;
    }
};
var $da6bb92553a8e98c$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $da6bb92553a8e98c$var$updateAttributes($da6bb92553a8e98c$var$TAG_NAMES.BODY, bodyAttributes);
    $da6bb92553a8e98c$var$updateAttributes($da6bb92553a8e98c$var$TAG_NAMES.HTML, htmlAttributes);
    $da6bb92553a8e98c$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $da6bb92553a8e98c$var$updateTags($da6bb92553a8e98c$var$TAG_NAMES.BASE, baseTag),
        linkTags: $da6bb92553a8e98c$var$updateTags($da6bb92553a8e98c$var$TAG_NAMES.LINK, linkTags),
        metaTags: $da6bb92553a8e98c$var$updateTags($da6bb92553a8e98c$var$TAG_NAMES.META, metaTags),
        noscriptTags: $da6bb92553a8e98c$var$updateTags($da6bb92553a8e98c$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $da6bb92553a8e98c$var$updateTags($da6bb92553a8e98c$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $da6bb92553a8e98c$var$updateTags($da6bb92553a8e98c$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $da6bb92553a8e98c$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $da6bb92553a8e98c$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $da6bb92553a8e98c$var$flattenArray(title);
    $da6bb92553a8e98c$var$updateAttributes($da6bb92553a8e98c$var$TAG_NAMES.TITLE, attributes);
};
var $da6bb92553a8e98c$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($da6bb92553a8e98c$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($da6bb92553a8e98c$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($da6bb92553a8e98c$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($da6bb92553a8e98c$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $da6bb92553a8e98c$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($da6bb92553a8e98c$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $da6bb92553a8e98c$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $da6bb92553a8e98c$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $da6bb92553a8e98c$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($da6bb92553a8e98c$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $da6bb92553a8e98c$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $da6bb92553a8e98c$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $da6bb92553a8e98c$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $da6bb92553a8e98c$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $da6bb92553a8e98c$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $da6bb92553a8e98c$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $da6bb92553a8e98c$var$HELMET_ATTRIBUTE + '="true">' + $da6bb92553a8e98c$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $da6bb92553a8e98c$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $da6bb92553a8e98c$var$TAG_PROPERTIES.INNER_HTML || attribute === $da6bb92553a8e98c$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $da6bb92553a8e98c$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $da6bb92553a8e98c$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $da6bb92553a8e98c$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $da6bb92553a8e98c$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$da6bb92553a8e98c$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $da6bb92553a8e98c$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$da6bb92553a8e98c$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $da6bb92553a8e98c$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$da6bb92553a8e98c$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $da6bb92553a8e98c$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($da6bb92553a8e98c$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $da6bb92553a8e98c$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$da6bb92553a8e98c$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $da6bb92553a8e98c$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $da6bb92553a8e98c$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $da6bb92553a8e98c$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(type, mappedTag);
    });
};
var $da6bb92553a8e98c$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $da6bb92553a8e98c$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $da6bb92553a8e98c$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $da6bb92553a8e98c$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $da6bb92553a8e98c$var$ATTRIBUTE_NAMES.BODY:
        case $da6bb92553a8e98c$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $da6bb92553a8e98c$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $da6bb92553a8e98c$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $da6bb92553a8e98c$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $da6bb92553a8e98c$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $da6bb92553a8e98c$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.META, metaTags, encode),
        noscript: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $da6bb92553a8e98c$var$getMethodsForTag($da6bb92553a8e98c$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $da6bb92553a8e98c$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $da6bb92553a8e98c$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $da6bb92553a8e98c$var$classCallCheck(this, HelmetWrapper);
            return $da6bb92553a8e98c$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($6a0658b34bb04ea2$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $da6bb92553a8e98c$var$TAG_NAMES.SCRIPT:
                case $da6bb92553a8e98c$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $da6bb92553a8e98c$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $da6bb92553a8e98c$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $da6bb92553a8e98c$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $da6bb92553a8e98c$var$TAG_NAMES.TITLE:
                    return $da6bb92553a8e98c$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $da6bb92553a8e98c$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $da6bb92553a8e98c$var$TAG_NAMES.BODY:
                    return $da6bb92553a8e98c$var$_extends({}, newProps, {
                        bodyAttributes: $da6bb92553a8e98c$var$_extends({}, newChildProps)
                    });
                case $da6bb92553a8e98c$var$TAG_NAMES.HTML:
                    return $da6bb92553a8e98c$var$_extends({}, newProps, {
                        htmlAttributes: $da6bb92553a8e98c$var$_extends({}, newChildProps)
                    });
            }
            return $da6bb92553a8e98c$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $da6bb92553a8e98c$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $da6bb92553a8e98c$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $da6bb92553a8e98c$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $da6bb92553a8e98c$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $da6bb92553a8e98c$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $da6bb92553a8e98c$var$TAG_NAMES.LINK:
                    case $da6bb92553a8e98c$var$TAG_NAMES.META:
                    case $da6bb92553a8e98c$var$TAG_NAMES.NOSCRIPT:
                    case $da6bb92553a8e98c$var$TAG_NAMES.SCRIPT:
                    case $da6bb92553a8e98c$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $da6bb92553a8e98c$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $da6bb92553a8e98c$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(Component, newProps);
        };
        $da6bb92553a8e98c$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($6e2a5ed7e145fa83$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $da6bb92553a8e98c$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $da6bb92553a8e98c$var$NullComponent = function NullComponent() {
    return null;
};
var $da6bb92553a8e98c$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($4a8d0781ded8e672$exports)))($da6bb92553a8e98c$var$reducePropsToState, $da6bb92553a8e98c$var$handleClientStateChange, $da6bb92553a8e98c$var$mapStateOnServer)($da6bb92553a8e98c$var$NullComponent);
var $da6bb92553a8e98c$export$dcef8f9bb9a41431 = $da6bb92553a8e98c$var$Helmet($da6bb92553a8e98c$var$HelmetSideEffects);
$da6bb92553a8e98c$export$dcef8f9bb9a41431.renderStatic = $da6bb92553a8e98c$export$dcef8f9bb9a41431.rewind;
var $da6bb92553a8e98c$export$2e2bcd8739ae039 = $da6bb92553a8e98c$export$dcef8f9bb9a41431;


parcelRequire("dQFEZ");
var $3849adb4905070fc$export$ca6dda5263526f75 = "https://api.damyantjain.com";
var $3849adb4905070fc$export$923ea8233b386e99 = "".concat($3849adb4905070fc$export$ca6dda5263526f75, "/api");
var $3849adb4905070fc$export$97d45f9fe2ff7963 = "".concat($3849adb4905070fc$export$923ea8233b386e99, "/analytics/home-visitor-count");
var $3849adb4905070fc$export$33946c87f7d00129 = "".concat($3849adb4905070fc$export$923ea8233b386e99, "/blogs");
var $3849adb4905070fc$export$ef523d22e5e75d61 = "".concat($3849adb4905070fc$export$923ea8233b386e99, "/publishedblogs");
var $3849adb4905070fc$export$86dcaf45db3d1606 = "".concat($3849adb4905070fc$export$923ea8233b386e99, "/login");
var $3849adb4905070fc$export$2a2261c5a58ac0 = "".concat($3849adb4905070fc$export$923ea8233b386e99, "/refresh-token");


var $c772a6d543c030fa$var$Portfolio = function() {
    // useEffect(() => {
    //   fetch(UPDATE_VIEWS, {
    //     method: "POST",
    //   });
    // }, []);
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)((0, $da6bb92553a8e98c$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("title", {
                        children: "Damyant Jain"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        name: "description",
                        content: "I'm all about turning cool ideas into awesome products and exploring the ever-evolving tech world. With over 3 years of experience, I'm passionate about solving real-world problems. When I'm not coding, you can find me enjoying sports."
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        name: "keywords",
                        content: "Damyant Jain, portfolio, blog, React, developer, resume, programmer"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:title",
                        content: "Damyant Jain"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:description",
                        content: "I'm all about turning cool ideas into awesome products and exploring the ever-evolving tech world. With over 3 years of experience, I'm passionate about solving real-world problems. When I'm not coding, you can find me enjoying sports."
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:url",
                        content: "https://damyantjain.com/"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $0f5cea3d9e590017$export$2e2bcd8739ae039), {
                nav: (0, $9bc98fb187a3b925$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "mx-5 md:mx-24 mb-5 lg:mx-44 dark:bg-[#121212]",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        id: "home",
                        className: "md:pt-24",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $ddde20b8c5d3de5c$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        id: "projects",
                        className: "md:pt-24",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $b4f6e7ba3c6a9b08$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        id: "resume",
                        className: "md:pt-24",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $da15a0edaf2d3d98$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        id: "skills",
                        className: "md:pt-20",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $4e662a4d1e085f92$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        id: "contact",
                        className: "md:pt-40",
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $7dbfc2620234cc5c$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $c772a6d543c030fa$export$2e2bcd8739ae039 = $c772a6d543c030fa$var$Portfolio;





var $2nwvT = parcelRequire("2nwvT");



var $dQFEZ = parcelRequire("dQFEZ");





var $8dc5be81629f5239$var$formatTitleForURL = function(title) {
    return title.toLowerCase().replace(/\s+/g, "-");
};
var $8dc5be81629f5239$var$BlogCard = function(param) {
    var post = param.post;
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
            to: "".concat($8dc5be81629f5239$var$formatTitleForURL(post === null || post === void 0 ? void 0 : post.title), "-").concat(post._id),
            children: [
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                    className: "flex justify-between hover:cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h2", {
                                    className: "text-xl md:text-2xl text-[#333333] dark:text-[#e0e0e0] font-bold",
                                    children: post === null || post === void 0 ? void 0 : post.title
                                }),
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                    className: "font-poppins text-gray-500 dark:text-gray-400 line-clamp-2",
                                    children: post === null || post === void 0 ? void 0 : post.description
                                }),
                                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                    className: "mt-5 text-gray-500 text-sm dark:text-gray-400",
                                    children: new Date(post === null || post === void 0 ? void 0 : post.updatedAt).toLocaleDateString("en-US", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric"
                                    })
                                })
                            ]
                        }),
                        (post === null || post === void 0 ? void 0 : post.image) && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                            className: "w-[80px] ml-5 md:ml-8 h-[53px] md:w-[160px] md:h-[107px] object-cover",
                            src: post === null || post === void 0 ? void 0 : post.image
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                    className: "h-[1px] mt-10 bg-[#e2e2e2]"
                })
            ]
        })
    });
};
var $8dc5be81629f5239$export$2e2bcd8739ae039 = $8dc5be81629f5239$var$BlogCard;


var $10bada8421dfc420$var$BlogCardList = function(param) {
    var posts = param.posts;
    var sortedPosts = posts.sort(function(a, b) {
        return new Date(b.updatedAt) - new Date(a.updatedAt);
    });
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        className: "pb-56",
        children: sortedPosts.map(function(post) {
            return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "pt-10",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8dc5be81629f5239$export$2e2bcd8739ae039), {
                    post: post
                })
            }, post === null || post === void 0 ? void 0 : post._id);
        })
    });
};
var $10bada8421dfc420$export$2e2bcd8739ae039 = $10bada8421dfc420$var$BlogCardList;



var $70f3ccc9b03ffa68$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "pt-10",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                className: "shimmer-line bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-4/12 h-4 mt-3"
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                className: "shimmer-line bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-7/12 h-3 mt-3"
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                                className: "bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-1/12 h-3 mt-8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                        className: "bg-gradient-to-r from-gray-200 to-gray-300 dark:from-zinc-800 dark:to-zinc-900 w-[80px] ml-5 md:ml-8 h-[53px] md:w-[160px] md:h-[107px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "h-[1px] mt-10 bg-gray-300  dark:bg-zinc-700"
            })
        ]
    });
};
var $70f3ccc9b03ffa68$var$BlogListShimmer = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)($70f3ccc9b03ffa68$var$Shimmer, {}),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)($70f3ccc9b03ffa68$var$Shimmer, {}),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)($70f3ccc9b03ffa68$var$Shimmer, {})
        ]
    });
};
var $70f3ccc9b03ffa68$export$2e2bcd8739ae039 = $70f3ccc9b03ffa68$var$BlogListShimmer;


var $50d67a8b1b1d2665$var$BlogHome = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), posts = _useState[0], setPosts = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        getBlogs();
    }, []);
    var getBlogs = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var response, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $3849adb4905070fc$export$ef523d22e5e75d61))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        setPosts([]);
                        return [
                            2
                        ];
                    case 2:
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        setPosts(data);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getBlogs() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
            className: "mx-5 md:mx-16 lg:mx-32 xl:mx-44",
            children: [
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
                    className: "text-xl md:text-2xl text-[#333333] dark:text-[#e0e0e0] font-poppins mt-5 mb-10",
                    children: "Reads"
                }),
                posts === null || posts.length === 0 ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $70f3ccc9b03ffa68$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $10bada8421dfc420$export$2e2bcd8739ae039), {
                    posts: posts
                })
            ]
        })
    });
};
var $50d67a8b1b1d2665$export$2e2bcd8739ae039 = $50d67a8b1b1d2665$var$BlogHome;




var $2nwvT = parcelRequire("2nwvT");




var $dQFEZ = parcelRequire("dQFEZ");


var $fb7e2decfdc4147a$var$BlogContent = function(param) {
    var blog = param.blog;
    var _blog_contentBlocks;
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        children: blog === null || blog === void 0 ? void 0 : (_blog_contentBlocks = blog.contentBlocks) === null || _blog_contentBlocks === void 0 ? void 0 : _blog_contentBlocks.map(function(block) {
            return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "mb-10",
                children: [
                    block.type === "text" && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                        className: "text-[20px] font-serif antialiased mt-4",
                        children: block.content
                    }),
                    block.type === "image" && /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                        className: "text-center flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("img", {
                                className: "",
                                src: block.content
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                                className: "text-sm font-poppins text-gray-500 mt-2",
                                children: block.caption
                            })
                        ]
                    })
                ]
            }, block._id);
        })
    });
};
var $fb7e2decfdc4147a$export$2e2bcd8739ae039 = $fb7e2decfdc4147a$var$BlogContent;



var $b2d9f955d57ee046$var$BlogView = function() {
    var titleAndId = (0, $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef)().titleAndId;
    var id = titleAndId.split("-").pop();
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)({}), 2), blog = _useState[0], setBlog = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), blogNotFound = _useState1[0], setBlogNotFound = _useState1[1];
    (0, $dQFEZ.useEffect)(function() {
        getBlog();
    }, []);
    var getBlog = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var response, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat((0, $3849adb4905070fc$export$33946c87f7d00129), "/").concat(id))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) {
                            setBlogNotFound(true);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        setBlog(data);
                        updateBlogViews(id);
                        return [
                            2
                        ];
                }
            });
        });
        return function getBlog() {
            return _ref.apply(this, arguments);
        };
    }();
    var updateBlogViews = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(id) {
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat((0, $3849adb4905070fc$export$33946c87f7d00129), "/").concat(id, "/visitor-count"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateBlogViews(id) {
            return _ref.apply(this, arguments);
        };
    }();
    if (blogNotFound) return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
            className: "text-3xl font-poppins text-[#333333] dark:text-[#e0e0e0] text-center mt-10",
            children: "Blog not found"
        })
    });
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "w-full flex items-center justify-center",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)((0, $da6bb92553a8e98c$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("title", {
                        children: blog.title || "Loading..."
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        name: "description",
                        content: blog.description || "Blog post description"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        name: "keywords",
                        content: blog.keywords || "blog, tech, React"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:title",
                        content: blog.title || "Blog Post Title"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:description",
                        content: blog.description || "Description of the blog post."
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:url",
                        content: "https://damyantjain.com/blog/".concat(id)
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("meta", {
                        property: "og:image",
                        content: blog.image
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "dark:bg-[#121212] text-[#333333] dark:text-[#e0e0e0] md:mx-0 sm:mx-10 mx-5 w-full md:w-[680px]",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
                        className: "text-[42px] font-bold",
                        children: blog.title
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("p", {
                        className: "text-sm text-gray-500",
                        children: new Date(blog.updatedAt).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric"
                        })
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fb7e2decfdc4147a$export$2e2bcd8739ae039), {
                        blog: blog
                    })
                ]
            })
        ]
    });
};
var $b2d9f955d57ee046$export$2e2bcd8739ae039 = $b2d9f955d57ee046$var$BlogView;



parcelRequire("dQFEZ");



var $f53405fd6d4e7906$var$BlogLayout = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $0f5cea3d9e590017$export$2e2bcd8739ae039), {
                nav: []
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "flex-grow md:pt-32 mb-20 mt-6 dark:bg-[#121212]",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c3ad80f8a436e0f$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "mx-5 mt-auto mb-5 lg:mx-44",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $7dbfc2620234cc5c$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $f53405fd6d4e7906$export$2e2bcd8739ae039 = $f53405fd6d4e7906$var$BlogLayout;






var $dQFEZ = parcelRequire("dQFEZ");



var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $dQFEZ = parcelRequire("dQFEZ");
var $f6758991d88cb14f$exports = {};
"use strict";

$f6758991d88cb14f$exports = (parcelRequire("6SnUj"));


var $d7d37dc522b09008$var$__defProp = Object.defineProperty;
var $d7d37dc522b09008$var$__defProps = Object.defineProperties;
var $d7d37dc522b09008$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d7d37dc522b09008$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d7d37dc522b09008$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d7d37dc522b09008$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d7d37dc522b09008$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d7d37dc522b09008$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d7d37dc522b09008$var$__hasOwnProp.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d7d37dc522b09008$var$__propIsEnum.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d7d37dc522b09008$var$__spreadProps = function(a, b) {
    return $d7d37dc522b09008$var$__defProps(a, $d7d37dc522b09008$var$__getOwnPropDescs(b));
};
var $d7d37dc522b09008$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($d7d37dc522b09008$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $d7d37dc522b09008$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $d7d37dc522b09008$var$React = // prettier-ignore
// @ts-ignore
"default" in $dQFEZ ? $dQFEZ["default"] : $dQFEZ;
// src/components/Context.ts
var $d7d37dc522b09008$var$ContextKey = Symbol.for("react-redux-context");
var $d7d37dc522b09008$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d7d37dc522b09008$var$getContext() {
    var _a;
    if (!$d7d37dc522b09008$var$React.createContext) return {};
    var contextMap = (_a = $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey]) != null ? _a : $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($d7d37dc522b09008$var$React.createContext);
    if (!realContext) {
        realContext = $d7d37dc522b09008$var$React.createContext(null);
        contextMap.set($d7d37dc522b09008$var$React.createContext, realContext);
    }
    return realContext;
}
var $d7d37dc522b09008$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d7d37dc522b09008$var$getContext();
// src/utils/useSyncExternalStore.ts
var $d7d37dc522b09008$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $d7d37dc522b09008$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $d7d37dc522b09008$var$React.useContext(context);
        return contextValue;
    };
}
var $d7d37dc522b09008$var$useReduxContext = /* @__PURE__ */ $d7d37dc522b09008$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $d7d37dc522b09008$var$useSyncExternalStoreWithSelector = $d7d37dc522b09008$var$notInitialized;
var $d7d37dc522b09008$var$initializeUseSelector = function(fn) {
    $d7d37dc522b09008$var$useSyncExternalStoreWithSelector = fn;
};
var $d7d37dc522b09008$var$refEquality = function(a, b) {
    return a === b;
};
function $d7d37dc522b09008$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : $d7d37dc522b09008$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $d7d37dc522b09008$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $d7d37dc522b09008$var$React.useRef(true);
        var wrappedSelector = $d7d37dc522b09008$var$React.useCallback((0, $72osQ._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $d7d37dc522b09008$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $d7d37dc522b09008$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $d7d37dc522b09008$export$2105062e25df4afe = /* @__PURE__ */ $d7d37dc522b09008$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $d7d37dc522b09008$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $d7d37dc522b09008$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $d7d37dc522b09008$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $d7d37dc522b09008$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $d7d37dc522b09008$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $d7d37dc522b09008$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $d7d37dc522b09008$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $d7d37dc522b09008$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $d7d37dc522b09008$var$ForwardRef = $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE;
var $d7d37dc522b09008$var$Memo = $d7d37dc522b09008$var$REACT_MEMO_TYPE;
function $d7d37dc522b09008$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE || type === $d7d37dc522b09008$var$REACT_PROFILER_TYPE || type === $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE || type === $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $d7d37dc522b09008$var$REACT_LAZY_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_MEMO_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_PROVIDER_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $d7d37dc522b09008$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d7d37dc522b09008$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE:
                        case $d7d37dc522b09008$var$REACT_PROFILER_TYPE:
                        case $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE:
                        case $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE:
                        case $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $d7d37dc522b09008$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $d7d37dc522b09008$var$REACT_CONTEXT_TYPE:
                                    case $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE:
                                    case $d7d37dc522b09008$var$REACT_LAZY_TYPE:
                                    case $d7d37dc522b09008$var$REACT_MEMO_TYPE:
                                    case $d7d37dc522b09008$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $d7d37dc522b09008$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $d7d37dc522b09008$var$isContextConsumer(object) {
    return $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE;
}
function $d7d37dc522b09008$var$isMemo(object) {
    return $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d7d37dc522b09008$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d7d37dc522b09008$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d7d37dc522b09008$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $d7d37dc522b09008$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d7d37dc522b09008$var$verify(mapStateToProps, "mapStateToProps");
    $d7d37dc522b09008$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d7d37dc522b09008$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d7d37dc522b09008$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $d7d37dc522b09008$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d7d37dc522b09008$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2us1u._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d7d37dc522b09008$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d7d37dc522b09008$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d7d37dc522b09008$var$isPlainObject(value)) $d7d37dc522b09008$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $d7d37dc522b09008$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d7d37dc522b09008$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d7d37dc522b09008$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $d7d37dc522b09008$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d7d37dc522b09008$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d7d37dc522b09008$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $d7d37dc522b09008$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) : $d7d37dc522b09008$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d7d37dc522b09008$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d7d37dc522b09008$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $d7d37dc522b09008$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d7d37dc522b09008$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $d7d37dc522b09008$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $d7d37dc522b09008$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d7d37dc522b09008$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d7d37dc522b09008$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d7d37dc522b09008$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $d7d37dc522b09008$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $d7d37dc522b09008$var$useIsomorphicLayoutEffect = $d7d37dc522b09008$var$canUseDOM || $d7d37dc522b09008$var$isReactNative ? $d7d37dc522b09008$var$React.useLayoutEffect : $d7d37dc522b09008$var$React.useEffect;
// src/utils/shallowEqual.ts
function $d7d37dc522b09008$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d7d37dc522b09008$export$d36bdfa510afb180(objA, objB) {
    if ($d7d37dc522b09008$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d7d37dc522b09008$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d7d37dc522b09008$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d7d37dc522b09008$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d7d37dc522b09008$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$_obj;
var $d7d37dc522b09008$var$TYPE_STATICS = ($d7d37dc522b09008$var$_obj = {}, (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$ForwardRef, $d7d37dc522b09008$var$FORWARD_REF_STATICS), (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$Memo, $d7d37dc522b09008$var$MEMO_STATICS), $d7d37dc522b09008$var$_obj);
function $d7d37dc522b09008$var$getStatics(component) {
    if ($d7d37dc522b09008$var$isMemo(component)) return $d7d37dc522b09008$var$MEMO_STATICS;
    return $d7d37dc522b09008$var$TYPE_STATICS[component["$$typeof"]] || $d7d37dc522b09008$var$REACT_STATICS;
}
var $d7d37dc522b09008$var$defineProperty = Object.defineProperty;
var $d7d37dc522b09008$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d7d37dc522b09008$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d7d37dc522b09008$var$getPrototypeOf = Object.getPrototypeOf;
var $d7d37dc522b09008$var$objectPrototype = Object.prototype;
function $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d7d37dc522b09008$var$objectPrototype) {
            var inheritedComponent = $d7d37dc522b09008$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d7d37dc522b09008$var$objectPrototype) $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $d7d37dc522b09008$var$getOwnPropertyNames(sourceComponent);
        if ($d7d37dc522b09008$var$getOwnPropertySymbols) keys = keys.concat($d7d37dc522b09008$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d7d37dc522b09008$var$getStatics(targetComponent);
        var sourceStatics = $d7d37dc522b09008$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d7d37dc522b09008$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d7d37dc522b09008$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d7d37dc522b09008$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $d7d37dc522b09008$var$useSyncExternalStore = $d7d37dc522b09008$var$notInitialized;
var $d7d37dc522b09008$var$initializeConnect = function(fn) {
    $d7d37dc522b09008$var$useSyncExternalStore = fn;
};
var $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d7d37dc522b09008$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2us1u._)(effectArgs));
    }, dependencies);
}
function $d7d37dc522b09008$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d7d37dc522b09008$var$strictEqual(a, b) {
    return a === b;
}
var $d7d37dc522b09008$var$hasWarnedAboutDeprecatedPureOption = false;
function $d7d37dc522b09008$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $d7d37dc522b09008$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $d7d37dc522b09008$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $d7d37dc522b09008$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $2nwvT._)($d7d37dc522b09008$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $d7d37dc522b09008$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $d7d37dc522b09008$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $d7d37dc522b09008$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $d7d37dc522b09008$var$React.useMemo(function() {
                return $d7d37dc522b09008$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $2nwvT._)($d7d37dc522b09008$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $d7d37dc522b09008$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $d7d37dc522b09008$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $d7d37dc522b09008$var$React.useRef(void 0);
            var lastWrapperProps = $d7d37dc522b09008$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $d7d37dc522b09008$var$React.useRef(void 0);
            var renderIsScheduled = $d7d37dc522b09008$var$React.useRef(false);
            var isMounted = $d7d37dc522b09008$var$React.useRef(false);
            var latestSubscriptionCallbackError = $d7d37dc522b09008$var$React.useRef(void 0);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $d7d37dc522b09008$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $d7d37dc522b09008$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs($d7d37dc522b09008$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $d7d37dc522b09008$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $d7d37dc522b09008$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $d7d37dc522b09008$var$React.createElement(WrappedComponent, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $d7d37dc522b09008$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $d7d37dc522b09008$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $d7d37dc522b09008$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $d7d37dc522b09008$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $d7d37dc522b09008$var$React.createElement(Connect, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d7d37dc522b09008$export$64605811ab45167f = $d7d37dc522b09008$var$connect;
// src/components/Provider.tsx
function $d7d37dc522b09008$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $d7d37dc522b09008$var$React.useMemo(function() {
        var subscription = $d7d37dc522b09008$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $d7d37dc522b09008$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $d7d37dc522b09008$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d7d37dc522b09008$export$2881499e37b75b9a = $d7d37dc522b09008$var$Provider;
// src/hooks/useStore.ts
function $d7d37dc522b09008$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : // @ts-ignore
    $d7d37dc522b09008$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $d7d37dc522b09008$export$6ccbb43953eebf8 = /* @__PURE__ */ $d7d37dc522b09008$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d7d37dc522b09008$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useStore2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$export$6ccbb43953eebf8 : $d7d37dc522b09008$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $d7d37dc522b09008$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d7d37dc522b09008$export$bc9b55530897c558();
// src/exports.ts
var $d7d37dc522b09008$export$712ea50be43a7858 = $d7d37dc522b09008$var$defaultNoopBatch;
// src/index.ts
$d7d37dc522b09008$var$initializeUseSelector((0, $f6758991d88cb14f$exports.useSyncExternalStoreWithSelector));
$d7d37dc522b09008$var$initializeConnect($dQFEZ.useSyncExternalStore);





var $dcJGd = parcelRequire("dcJGd");


var $grujF = parcelRequire("grujF");

var $8wAe0 = parcelRequire("8wAe0");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");


var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $lngen = parcelRequire("lngen");

// src/utils/formatProdErrorMessage.ts

var $72osQ = parcelRequire("72osQ");



var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
function $20ec22595b3da151$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $20ec22595b3da151$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $20ec22595b3da151$var$symbol_observable_default = $20ec22595b3da151$var$$$observable;
// src/utils/actionTypes.ts
var $20ec22595b3da151$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $20ec22595b3da151$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($20ec22595b3da151$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($20ec22595b3da151$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($20ec22595b3da151$var$randomString());
    }
};
var $20ec22595b3da151$export$4219e499db7ca678 = $20ec22595b3da151$var$ActionTypes;
// src/utils/isPlainObject.ts
function $20ec22595b3da151$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $20ec22595b3da151$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($20ec22595b3da151$var$isDate(val)) return "date";
    if ($20ec22595b3da151$var$isError(val)) return "error";
    var constructorName = $20ec22595b3da151$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $20ec22595b3da151$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $20ec22595b3da151$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $20ec22595b3da151$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $20ec22595b3da151$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(1));
        return enhancer($20ec22595b3da151$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$20ec22595b3da151$export$53b83ca8eaab0383(action)) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $20ec22595b3da151$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $72osQ._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $20ec22595b3da151$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $20ec22595b3da151$export$4219e499db7ca678.INIT
    });
    var store = (0, $72osQ._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $20ec22595b3da151$var$symbol_observable_default, observable);
    return store;
}
function $20ec22595b3da151$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $20ec22595b3da151$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $20ec22595b3da151$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $20ec22595b3da151$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$20ec22595b3da151$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($20ec22595b3da151$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $20ec22595b3da151$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $20ec22595b3da151$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(13));
    });
}
function $20ec22595b3da151$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $20ec22595b3da151$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $20ec22595b3da151$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $20ec22595b3da151$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $20ec22595b3da151$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2us1u._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $20ec22595b3da151$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2us1u._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $20ec22595b3da151$export$f672e0b6f7222cd7.apply(void 0, (0, $2us1u._)(chain))(store.dispatch);
            return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $20ec22595b3da151$export$b956e38827fca970(action) {
    return $20ec22595b3da151$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $kK8g8 = parcelRequire("kK8g8");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
var $b262cabcae0d8be6$var$__defProp = Object.defineProperty;
var $b262cabcae0d8be6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b262cabcae0d8be6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b262cabcae0d8be6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b262cabcae0d8be6$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b262cabcae0d8be6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b262cabcae0d8be6$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b262cabcae0d8be6$var$__hasOwnProp.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($b262cabcae0d8be6$var$__getOwnPropSymbols) try {
        for(var _iterator = $b262cabcae0d8be6$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($b262cabcae0d8be6$var$__propIsEnum.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $b262cabcae0d8be6$var$__publicField = function(obj, key, value) {
    $b262cabcae0d8be6$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b262cabcae0d8be6$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b262cabcae0d8be6$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2us1u._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b262cabcae0d8be6$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b262cabcae0d8be6$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($b262cabcae0d8be6$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b262cabcae0d8be6$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $b262cabcae0d8be6$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $bJtXW._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $bJtXW._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $b262cabcae0d8be6$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b262cabcae0d8be6$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b262cabcae0d8be6$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b262cabcae0d8be6$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, $b262cabcae0d8be6$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b262cabcae0d8be6$var$$REVISION = 0;
var $b262cabcae0d8be6$var$CURRENT_TRACKER = null;
var $b262cabcae0d8be6$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
        (0, $grujF._)(this, Cell);
        $b262cabcae0d8be6$var$__publicField(this, "revision", $b262cabcae0d8be6$var$$REVISION);
        $b262cabcae0d8be6$var$__publicField(this, "_value");
        $b262cabcae0d8be6$var$__publicField(this, "_lastValue");
        $b262cabcae0d8be6$var$__publicField(this, "_isEqual", $b262cabcae0d8be6$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $dhMkv._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$b262cabcae0d8be6$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $b262cabcae0d8be6$var$tripleEq(a, b) {
    return a === b;
}
var $b262cabcae0d8be6$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $grujF._)(this, TrackingCache);
        $b262cabcae0d8be6$var$__publicField(this, "_cachedValue");
        $b262cabcae0d8be6$var$__publicField(this, "_cachedRevision", -1);
        $b262cabcae0d8be6$var$__publicField(this, "_deps", []);
        $b262cabcae0d8be6$var$__publicField(this, "hits", 0);
        $b262cabcae0d8be6$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $dhMkv._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $b262cabcae0d8be6$var$CURRENT_TRACKER;
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2us1u._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $b262cabcae0d8be6$var$getValue(cell) {
    if (!(cell instanceof $b262cabcae0d8be6$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b262cabcae0d8be6$var$setValue(storage, value) {
    if (!(storage instanceof $b262cabcae0d8be6$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b262cabcae0d8be6$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
    return new $b262cabcae0d8be6$var$Cell(initialValue, isEqual);
}
function $b262cabcae0d8be6$var$createCache(fn) {
    $b262cabcae0d8be6$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b262cabcae0d8be6$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b262cabcae0d8be6$var$neverEq = function(a, b) {
    return false;
};
function $b262cabcae0d8be6$var$createTag() {
    return $b262cabcae0d8be6$var$createCell(null, $b262cabcae0d8be6$var$neverEq);
}
function $b262cabcae0d8be6$var$dirtyTag(tag, value) {
    $b262cabcae0d8be6$var$setValue(tag, value);
}
var $b262cabcae0d8be6$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b262cabcae0d8be6$var$createTag();
    $b262cabcae0d8be6$var$getValue(tag);
};
var $b262cabcae0d8be6$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $b262cabcae0d8be6$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b262cabcae0d8be6$var$REDUX_PROXY_LABEL = Symbol();
var $b262cabcae0d8be6$var$nextId = 0;
var $b262cabcae0d8be6$var$proto = Object.getPrototypeOf({});
var $b262cabcae0d8be6$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ObjectTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy(this, $b262cabcae0d8be6$var$objectProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) === "symbol") return childValue;
            if (key in $b262cabcae0d8be6$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b262cabcae0d8be6$var$createNode(childValue);
                if (childNode.tag) $b262cabcae0d8be6$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b262cabcae0d8be6$var$createTag();
                    tag.value = childValue;
                }
                $b262cabcae0d8be6$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $b262cabcae0d8be6$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b262cabcae0d8be6$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ArrayTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy([
        this
    ], $b262cabcae0d8be6$var$arrayProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        if (key === "length") $b262cabcae0d8be6$var$consumeCollection(node);
        return $b262cabcae0d8be6$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.has(node, prop);
    }
};
function $b262cabcae0d8be6$var$createNode(value) {
    if (Array.isArray(value)) return new $b262cabcae0d8be6$var$ArrayTreeNode(value);
    return new $b262cabcae0d8be6$var$ObjectTreeNode(value);
}
function $b262cabcae0d8be6$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b262cabcae0d8be6$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b262cabcae0d8be6$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $b262cabcae0d8be6$var$dirtyCollection(node);
            $b262cabcae0d8be6$var$dirtyTag(tags[key1], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if (typeof newChildValue1 === "object" && newChildValue1 !== null) $b262cabcae0d8be6$var$updateNode(childNode, newChildValue1);
        else {
            $b262cabcae0d8be6$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $b262cabcae0d8be6$var$deleteNode(node) {
    if (node.tag) $b262cabcae0d8be6$var$dirtyTag(node.tag, null);
    $b262cabcae0d8be6$var$dirtyCollection(node);
    for(var key in node.tags)$b262cabcae0d8be6$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$b262cabcae0d8be6$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $b262cabcae0d8be6$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b262cabcae0d8be6$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $b262cabcae0d8be6$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b262cabcae0d8be6$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b262cabcae0d8be6$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b262cabcae0d8be6$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b262cabcae0d8be6$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $b262cabcae0d8be6$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $b262cabcae0d8be6$var$createSingletonCache(comparator) : $b262cabcae0d8be6$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $b262cabcae0d8be6$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b262cabcae0d8be6$export$c8f9cf88d9fdee55(func) {
    var node = $b262cabcae0d8be6$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $b262cabcae0d8be6$var$createCacheKeyComparator($b262cabcae0d8be6$export$3f025202a230c6dd);
    var cache = $b262cabcae0d8be6$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b262cabcae0d8be6$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b262cabcae0d8be6$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $grujF._)(this, StrongRef);
        this.value = value;
    }
    (0, $dhMkv._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $b262cabcae0d8be6$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b262cabcae0d8be6$var$StrongRef;
var $b262cabcae0d8be6$var$UNTERMINATED = 0;
var $b262cabcae0d8be6$var$TERMINATED = 1;
function $b262cabcae0d8be6$var$createCacheNode() {
    return {
        s: $b262cabcae0d8be6$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b262cabcae0d8be6$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $b262cabcae0d8be6$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $b262cabcae0d8be6$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $b262cabcae0d8be6$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $b262cabcae0d8be6$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $b262cabcae0d8be6$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b262cabcae0d8be6$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b262cabcae0d8be6$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc), "]"));
        var combinedOptions = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $b262cabcae0d8be6$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $b262cabcae0d8be6$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2us1u._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2us1u._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $b262cabcae0d8be6$export$595d22ed68ca2841 = /* @__PURE__ */ $b262cabcae0d8be6$export$5943f4447f6ef248($b262cabcae0d8be6$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b262cabcae0d8be6$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$export$595d22ed68ca2841;
    $b262cabcae0d8be6$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $bJtXW._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $b262cabcae0d8be6$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $21ccc86701ec53ef$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $21ccc86701ec53ef$export$dd164f5517779f15 = $21ccc86701ec53ef$var$createThunkMiddleware();
var $21ccc86701ec53ef$export$16d06542a1949d9e = $21ccc86701ec53ef$var$createThunkMiddleware;



var $ca04af99794d5fdc$var$__defProp = Object.defineProperty;
var $ca04af99794d5fdc$var$__defProps = Object.defineProperties;
var $ca04af99794d5fdc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ca04af99794d5fdc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ca04af99794d5fdc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ca04af99794d5fdc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ca04af99794d5fdc$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $ca04af99794d5fdc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $ca04af99794d5fdc$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($ca04af99794d5fdc$var$__hasOwnProp.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($ca04af99794d5fdc$var$__propIsEnum.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $ca04af99794d5fdc$var$__spreadProps = function(a, b) {
    return $ca04af99794d5fdc$var$__defProps(a, $ca04af99794d5fdc$var$__getOwnPropDescs(b));
};
var $ca04af99794d5fdc$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($ca04af99794d5fdc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $ca04af99794d5fdc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $ca04af99794d5fdc$var$__publicField = function(obj, key, value) {
    $ca04af99794d5fdc$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
var $ca04af99794d5fdc$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $b262cabcae0d8be6$export$5943f4447f6ef248).apply(void 0, (0, $2us1u._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2us1u._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value
            ].concat((0, $2us1u._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $ca04af99794d5fdc$export$a5d3c27355e35910 = $ca04af99794d5fdc$export$aab6de9e3dbb1473((0, $b262cabcae0d8be6$export$8402dc26d96f6902));
var $ca04af99794d5fdc$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $20ec22595b3da151$export$f672e0b6f7222cd7;
    return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ca04af99794d5fdc$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $ca04af99794d5fdc$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2us1u._)(args));
            if (!prepared) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(0));
            return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $ca04af99794d5fdc$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $ca04af99794d5fdc$var$hasMatchFunction(action);
}
function $ca04af99794d5fdc$export$ebd532f9034651f3(action) {
    return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && Object.keys(action).every($ca04af99794d5fdc$var$isValidKey);
}
function $ca04af99794d5fdc$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $ca04af99794d5fdc$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $ca04af99794d5fdc$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $ca04af99794d5fdc$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $ca04af99794d5fdc$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $ca04af99794d5fdc$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $j6Mzi._)(_Tuple, Array1);
    var _super = (0, $lngen._)(_Tuple);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $grujF._)(this, _Tuple);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $2us1u._)(items)));
        Object.setPrototypeOf((0, $dcJGd._)(_this), _Tuple.prototype);
        return _this;
    }
    (0, $dhMkv._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $8665ac34acf389ad$export$71511d61b312f219)((0, $gyGuQ._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr[0].concat(this)));
                return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $1EZOw._)(Array));
function $ca04af99794d5fdc$var$freezeDraftable(val) {
    return (0, $kK8g8.isDraftable)(val) ? (0, $kK8g8.produce)(val, function() {}) : val;
}
function $ca04af99794d5fdc$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $ca04af99794d5fdc$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $ca04af99794d5fdc$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $ca04af99794d5fdc$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $ca04af99794d5fdc$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $ca04af99794d5fdc$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $ca04af99794d5fdc$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $ca04af99794d5fdc$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $ca04af99794d5fdc$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $20ec22595b3da151$export$53b83ca8eaab0383)(val);
}
function $ca04af99794d5fdc$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $ca04af99794d5fdc$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if (typeof nestedValue === "object") {
                foundNestedSerializable = $ca04af99794d5fdc$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $ca04af99794d5fdc$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ca04af99794d5fdc$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if (typeof nestedValue !== "object" || nestedValue === null) continue;
            if (!$ca04af99794d5fdc$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $ca04af99794d5fdc$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $ca04af99794d5fdc$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $ca04af99794d5fdc$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $ca04af99794d5fdc$export$1908877435b1d5e9();
        if (thunk) {
            if ($ca04af99794d5fdc$var$isBoolean(thunk)) middlewareArray.push((0, $21ccc86701ec53ef$export$dd164f5517779f15));
            else middlewareArray.push((0, $21ccc86701ec53ef$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $ca04af99794d5fdc$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ca04af99794d5fdc$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $72osQ._)({}, $ca04af99794d5fdc$export$8fb31c0f05df007b, true)
        };
    };
};
var $ca04af99794d5fdc$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $ca04af99794d5fdc$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ca04af99794d5fdc$var$createQueueWithTimer(10);
var $ca04af99794d5fdc$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2us1u._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $ca04af99794d5fdc$var$rAF : options.type === "callback" ? options.queueNotification : $ca04af99794d5fdc$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ca04af99794d5fdc$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $ca04af99794d5fdc$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $ca04af99794d5fdc$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($ca04af99794d5fdc$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $ca04af99794d5fdc$var$IS_PRODUCTION = true;
function $ca04af99794d5fdc$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $ca04af99794d5fdc$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $20ec22595b3da151$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducer);
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(1));
    if (!$ca04af99794d5fdc$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$ca04af99794d5fdc$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$ca04af99794d5fdc$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(4));
    var finalCompose = (0, $20ec22595b3da151$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ca04af99794d5fdc$var$composeWithDevTools($ca04af99794d5fdc$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$ca04af99794d5fdc$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var middlewareEnhancer = (0, $20ec22595b3da151$export$9ff26e0402cc7b7).apply(void 0, (0, $2us1u._)(finalMiddleware));
    var getDefaultEnhancers = $ca04af99794d5fdc$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$ca04af99794d5fdc$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$ca04af99794d5fdc$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(6));
    if (!$ca04af99794d5fdc$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(7));
    if (!$ca04af99794d5fdc$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $2us1u._)(storeEnhancers));
    return (0, $20ec22595b3da151$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $ca04af99794d5fdc$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ca04af99794d5fdc$var$isStateFunction(x) {
    return typeof x === "function";
}
function $ca04af99794d5fdc$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $2nwvT._)($ca04af99794d5fdc$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($ca04af99794d5fdc$var$isStateFunction(initialState)) getInitialState = function() {
        return $ca04af99794d5fdc$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $ca04af99794d5fdc$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2us1u._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $kK8g8.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $kK8g8.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $kK8g8.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $ca04af99794d5fdc$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ca04af99794d5fdc$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $ca04af99794d5fdc$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $ca04af99794d5fdc$var$matches = function(matcher, action) {
    if ($ca04af99794d5fdc$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ca04af99794d5fdc$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ca04af99794d5fdc$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ca04af99794d5fdc$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$872dec21e9a69476()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $ca04af99794d5fdc$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $ca04af99794d5fdc$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$fcc3388fb56de601()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
}
function $ca04af99794d5fdc$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$1da80a6ef1307441()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $ca04af99794d5fdc$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/createAsyncThunk.ts
var $ca04af99794d5fdc$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ca04af99794d5fdc$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $grujF._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $grujF._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $ca04af99794d5fdc$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ca04af99794d5fdc$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $ca04af99794d5fdc$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ca04af99794d5fdc$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$ca04af99794d5fdc$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $ca04af99794d5fdc$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $ca04af99794d5fdc$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $ca04af99794d5fdc$var$RejectWithValue) throw result;
                                            if (result instanceof $ca04af99794d5fdc$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $ca04af99794d5fdc$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($ca04af99794d5fdc$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $ca04af99794d5fdc$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $ca04af99794d5fdc$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ca04af99794d5fdc$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $ca04af99794d5fdc$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $ca04af99794d5fdc$export$343355ed40c51c46 = (0, $72osQ._)({}, $ca04af99794d5fdc$var$asyncThunkSymbol, $ca04af99794d5fdc$export$6abd22dc03e5063f);
var $ca04af99794d5fdc$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($ca04af99794d5fdc$export$23a094319a4b586 || {});
function $ca04af99794d5fdc$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $ca04af99794d5fdc$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$ca04af99794d5fdc$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(11));
        typeof $903353200bfa7e9a$exports === "undefined" ? "undefined" : (0, $bJtXW._)($903353200bfa7e9a$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($ca04af99794d5fdc$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $ca04af99794d5fdc$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $ca04af99794d5fdc$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $2nwvT._)(typeof options.extraReducers === "function" ? $ca04af99794d5fdc$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $ca04af99794d5fdc$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $ca04af99794d5fdc$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $ca04af99794d5fdc$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var _a2;
                        var map = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $2nwvT._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $ca04af99794d5fdc$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2us1u._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $ca04af99794d5fdc$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $ca04af99794d5fdc$export$affdea4146de9cf5();
function $ca04af99794d5fdc$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $ca04af99794d5fdc$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $72osQ._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2us1u._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $ca04af99794d5fdc$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareCallback) : $ca04af99794d5fdc$export$309c7a02b0b0bc62(type));
}
function $ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $ca04af99794d5fdc$var$noop,
        pending: pending || $ca04af99794d5fdc$var$noop,
        rejected: rejected || $ca04af99794d5fdc$var$noop,
        settled: settled || $ca04af99794d5fdc$var$noop
    });
}
function $ca04af99794d5fdc$var$noop() {}
// src/entities/entity_state.ts
function $ca04af99794d5fdc$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($ca04af99794d5fdc$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ca04af99794d5fdc$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $ca04af99794d5fdc$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $ca04af99794d5fdc$var$isDraftTyped = (0, $kK8g8.isDraft);
function $ca04af99794d5fdc$var$createSingleArgumentStateOperator(mutator) {
    var operator = $ca04af99794d5fdc$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ca04af99794d5fdc$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $ca04af99794d5fdc$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($ca04af99794d5fdc$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $kK8g8.produce)(state, runMutator);
    };
}
function $ca04af99794d5fdc$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $ca04af99794d5fdc$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ca04af99794d5fdc$var$getCurrent(value) {
    return (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value;
}
function $ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $ca04af99794d5fdc$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $ca04af99794d5fdc$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $ca04af99794d5fdc$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $ca04af99794d5fdc$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably),
        removeOne: $ca04af99794d5fdc$var$createStateOperator(removeOneMutably),
        removeMany: $ca04af99794d5fdc$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $ca04af99794d5fdc$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $ca04af99794d5fdc$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($ca04af99794d5fdc$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $ca04af99794d5fdc$var$getCurrent(state.entities);
        var currentIds = $ca04af99794d5fdc$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $ca04af99794d5fdc$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ca04af99794d5fdc$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $ca04af99794d5fdc$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, sortComparer) : $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $ca04af99794d5fdc$var$createSelectorsFactory();
    return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $ca04af99794d5fdc$var$task = "task";
var $ca04af99794d5fdc$var$listener = "listener";
var $ca04af99794d5fdc$var$completed = "completed";
var $ca04af99794d5fdc$var$cancelled = "cancelled";
var $ca04af99794d5fdc$var$taskCancelled = "task-".concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$taskCompleted = "task-".concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$var$listenerCancelled = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$listenerCompleted = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $grujF._)(this, TaskAbortError);
    this.code = code;
    $ca04af99794d5fdc$var$__publicField(this, "name", "TaskAbortError");
    $ca04af99794d5fdc$var$__publicField(this, "message");
    this.message = "".concat($ca04af99794d5fdc$var$task, " ").concat($ca04af99794d5fdc$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $ca04af99794d5fdc$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(32));
};
var $ca04af99794d5fdc$var$noop2 = function() {};
var $ca04af99794d5fdc$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ca04af99794d5fdc$var$noop2;
    promise.catch(onError);
    return promise;
};
var $ca04af99794d5fdc$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $ca04af99794d5fdc$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $ca04af99794d5fdc$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $ca04af99794d5fdc$export$cb1bdac908fed7f(reason);
    }
};
function $ca04af99794d5fdc$var$raceWithSignal(signal, promise) {
    var cleanup = $ca04af99794d5fdc$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $ca04af99794d5fdc$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ca04af99794d5fdc$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $ca04af99794d5fdc$var$noop2;
    });
}
var $ca04af99794d5fdc$var$runTask = function() {
    var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(task2, cleanUp) {
        var value, error;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $ca04af99794d5fdc$var$createPause = function(signal) {
    return function(promise) {
        return $ca04af99794d5fdc$var$catchRejection($ca04af99794d5fdc$var$raceWithSignal(signal, promise).then(function(output) {
            $ca04af99794d5fdc$var$validateActive(signal);
            return output;
        }));
    };
};
var $ca04af99794d5fdc$var$createDelay = function(signal) {
    var pause = $ca04af99794d5fdc$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $ca04af99794d5fdc$var$assign = Object.assign;
var $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN = {};
var $ca04af99794d5fdc$var$alm = "listenerMiddleware";
var $ca04af99794d5fdc$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $ca04af99794d5fdc$var$addAbortSignalListener(parentAbortSignal, function() {
            return $ca04af99794d5fdc$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $ca04af99794d5fdc$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $ca04af99794d5fdc$var$runTask(/*#__PURE__*/ (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var result2;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $ca04af99794d5fdc$var$validateActive(parentAbortSignal);
                        $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $ca04af99794d5fdc$var$createPause(childAbortController.signal),
                                delay: $ca04af99794d5fdc$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $ca04af99794d5fdc$var$abortControllerWithReason(childAbortController, $ca04af99794d5fdc$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($ca04af99794d5fdc$var$noop2));
        return {
            result: $ca04af99794d5fdc$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $ca04af99794d5fdc$var$abortControllerWithReason(childAbortController, $ca04af99794d5fdc$var$taskCancelled);
            }
        };
    };
};
var $ca04af99794d5fdc$var$createTakePattern = function(startListening, signal) {
    var take = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $ca04af99794d5fdc$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $ca04af99794d5fdc$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $ca04af99794d5fdc$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $ca04af99794d5fdc$var$catchRejection(take(predicate, timeout));
    };
};
var $ca04af99794d5fdc$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $ca04af99794d5fdc$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(21));
    $ca04af99794d5fdc$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ca04af99794d5fdc$var$createListenerEntry = Object.assign(function(options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $ca04af99794d5fdc$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $ca04af99794d5fdc$var$createListenerEntry;
    }
});
var $ca04af99794d5fdc$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $ca04af99794d5fdc$var$abortControllerWithReason(controller, $ca04af99794d5fdc$var$listenerCancelled);
    });
};
var $ca04af99794d5fdc$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($ca04af99794d5fdc$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $ca04af99794d5fdc$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $ca04af99794d5fdc$export$f03a6b845d3fb58b = Object.assign($ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/add")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$f03a6b845d3fb58b;
    }
});
var $ca04af99794d5fdc$export$b1b8022855fb2b71 = $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/removeAll"));
var $ca04af99794d5fdc$export$b03e9483f936dccb = Object.assign($ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/remove")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$b03e9483f936dccb;
    }
});
var $ca04af99794d5fdc$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($ca04af99794d5fdc$var$alm, "/error")
    ].concat((0, $2us1u._)(args)));
};
var $ca04af99794d5fdc$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $ca04af99794d5fdc$var$defaultErrorHandler : _middlewareOptions_onError;
    $ca04af99794d5fdc$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $ca04af99794d5fdc$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $ca04af99794d5fdc$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $ca04af99794d5fdc$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $ca04af99794d5fdc$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $ca04af99794d5fdc$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $ca04af99794d5fdc$var$createDelay(internalTaskController.signal),
                                pause: $ca04af99794d5fdc$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $ca04af99794d5fdc$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $ca04af99794d5fdc$var$abortControllerWithReason(controller, $ca04af99794d5fdc$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $ca04af99794d5fdc$var$abortControllerWithReason(internalTaskController, $ca04af99794d5fdc$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $ca04af99794d5fdc$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f)) $ca04af99794d5fdc$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $ca04af99794d5fdc$var$abortControllerWithReason(internalTaskController, $ca04af99794d5fdc$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $ca04af99794d5fdc$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $20ec22595b3da151$export$b956e38827fca970)(action)) return next(action);
                if ($ca04af99794d5fdc$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ca04af99794d5fdc$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ca04af99794d5fdc$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $ca04af99794d5fdc$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $ca04af99794d5fdc$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $ca04af99794d5fdc$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $ca04af99794d5fdc$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $ca04af99794d5fdc$export$4bb1606a79445586 = function() {
    var instanceId = $ca04af99794d5fdc$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($ca04af99794d5fdc$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $ca04af99794d5fdc$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $ca04af99794d5fdc$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $ca04af99794d5fdc$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(void 0, (0, $2us1u._)(appliedMiddleware));
    };
    var isWithMiddleware = $ca04af99794d5fdc$export$9dd1fb32974da385(withMiddleware, $ca04af99794d5fdc$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2us1u._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $ca04af99794d5fdc$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $ca04af99794d5fdc$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $ca04af99794d5fdc$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $ca04af99794d5fdc$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $ca04af99794d5fdc$var$isStateProxy = function(value) {
    return !!value && !!value[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $ca04af99794d5fdc$var$createStateProxy = function(state, reducerMap) {
    return $ca04af99794d5fdc$var$emplace($ca04af99794d5fdc$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $ca04af99794d5fdc$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $ca04af99794d5fdc$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $ca04af99794d5fdc$var$original = function(state) {
    if (!$ca04af99794d5fdc$var$isStateProxy(state)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(25));
    return state[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $ca04af99794d5fdc$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($ca04af99794d5fdc$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducerMap) : $ca04af99794d5fdc$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $903353200bfa7e9a$exports === "undefined" ? "undefined" : (0, $bJtXW._)($903353200bfa7e9a$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $ca04af99794d5fdc$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2us1u._)(args))) : state, reducerMap)
            ].concat((0, $2us1u._)(args)));
        };
    }, {
        original: $ca04af99794d5fdc$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $ca04af99794d5fdc$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $1d2e263d4aeda284$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $1d2e263d4aeda284$export$2e2bcd8739ae039 = {
    randomUUID: $1d2e263d4aeda284$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $e776aa47ab623267$var$getRandomValues;
var $e776aa47ab623267$var$rnds8 = new Uint8Array(16);
function $e776aa47ab623267$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e776aa47ab623267$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $e776aa47ab623267$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$e776aa47ab623267$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $e776aa47ab623267$var$getRandomValues($e776aa47ab623267$var$rnds8);
}


var $95d1738956a5f608$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $6e56373dfd412a98$var$validate(uuid) {
    return typeof uuid === "string" && (0, $95d1738956a5f608$export$2e2bcd8739ae039).test(uuid);
}
var $6e56373dfd412a98$export$2e2bcd8739ae039 = $6e56373dfd412a98$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $af01571352570be1$var$byteToHex = [];
for(var $af01571352570be1$var$i = 0; $af01571352570be1$var$i < 256; ++$af01571352570be1$var$i)$af01571352570be1$var$byteToHex.push(($af01571352570be1$var$i + 0x100).toString(16).slice(1));
function $af01571352570be1$export$8fb373d660548968(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($af01571352570be1$var$byteToHex[arr[offset + 0]] + $af01571352570be1$var$byteToHex[arr[offset + 1]] + $af01571352570be1$var$byteToHex[arr[offset + 2]] + $af01571352570be1$var$byteToHex[arr[offset + 3]] + "-" + $af01571352570be1$var$byteToHex[arr[offset + 4]] + $af01571352570be1$var$byteToHex[arr[offset + 5]] + "-" + $af01571352570be1$var$byteToHex[arr[offset + 6]] + $af01571352570be1$var$byteToHex[arr[offset + 7]] + "-" + $af01571352570be1$var$byteToHex[arr[offset + 8]] + $af01571352570be1$var$byteToHex[arr[offset + 9]] + "-" + $af01571352570be1$var$byteToHex[arr[offset + 10]] + $af01571352570be1$var$byteToHex[arr[offset + 11]] + $af01571352570be1$var$byteToHex[arr[offset + 12]] + $af01571352570be1$var$byteToHex[arr[offset + 13]] + $af01571352570be1$var$byteToHex[arr[offset + 14]] + $af01571352570be1$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $af01571352570be1$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = $af01571352570be1$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $6e56373dfd412a98$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $af01571352570be1$export$2e2bcd8739ae039 = $af01571352570be1$var$stringify;


function $a5f9c2b6ea4763c4$var$v4(options, buf, offset) {
    if ((0, $1d2e263d4aeda284$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $1d2e263d4aeda284$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $e776aa47ab623267$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $af01571352570be1$export$8fb373d660548968)(rnds);
}
var $a5f9c2b6ea4763c4$export$2e2bcd8739ae039 = $a5f9c2b6ea4763c4$var$v4;


var $0588dc3366c5632f$var$initialState = {
    blog: {
        title: "",
        description: ""
    },
    editedBlog: {
        title: "",
        description: "",
        image: "",
        contentBlocks: [],
        keywords: ""
    }
};
var $0588dc3366c5632f$var$blogSlice = (0, $ca04af99794d5fdc$export$4d8d9bd83c24ae8b)({
    name: "blogSlice",
    initialState: {
        blog: {
            title: "",
            description: ""
        },
        editedBlog: {
            title: "",
            description: "",
            image: "",
            contentBlocks: [],
            keywords: ""
        }
    },
    reducers: {
        //blog
        addBlog: function(state, action) {
            state.blog = action.payload;
            state.editedBlog = action.payload;
        },
        updateTitle: function(state, action) {
            state.editedBlog.title = action.payload;
        },
        updateDescription: function(state, action) {
            state.editedBlog.description = action.payload;
        },
        updatePreviewImage: function(state, action) {
            state.editedBlog.image = action.payload;
        },
        updateKeywords: function(state, action) {
            state.editedBlog.keywords = action.payload;
        },
        updateContent: function(state, action) {
            var index = state.editedBlog.contentBlocks.findIndex(function(x) {
                return x._id === action.payload._id;
            });
            state.editedBlog.contentBlocks[index].content = action.payload.content;
        },
        updateCaption: function(state, action) {
            var index = state.editedBlog.contentBlocks.findIndex(function(x) {
                return x._id === action.payload._id;
            });
            state.editedBlog.contentBlocks[index].caption = action.payload.caption;
        },
        resetEditedBlog: function(state) {
            state.editedBlog = $0588dc3366c5632f$var$initialState.editedBlog;
        },
        //block
        addBlock: function(state, action) {
            action.payload = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, action.payload), {
                _id: (0, $a5f9c2b6ea4763c4$export$2e2bcd8739ae039)()
            });
            if (state.editedBlog.contentBlocks === undefined) state.editedBlog.contentBlocks = [];
            state.editedBlog.contentBlocks.push(action.payload);
        },
        deleteBlock: function(state, action) {
            state.editedBlog.contentBlocks = state.editedBlog.contentBlocks.filter(function(x) {
                return x._id !== action.payload;
            });
        },
        reorderBlocks: function(state, action) {
            state.editedBlog.contentBlocks = action.payload;
        }
    }
});
var $0588dc3366c5632f$var$_blogSlice_actions = $0588dc3366c5632f$var$blogSlice.actions;
var $0588dc3366c5632f$export$a36094bd725add13 = $0588dc3366c5632f$var$_blogSlice_actions.addBlog, $0588dc3366c5632f$export$bf6f7165e46e2479 = $0588dc3366c5632f$var$_blogSlice_actions.updateTitle, $0588dc3366c5632f$export$989a858ef0c8fda5 = $0588dc3366c5632f$var$_blogSlice_actions.updateDescription, $0588dc3366c5632f$export$5143cc956eb9d8f6 = $0588dc3366c5632f$var$_blogSlice_actions.updateContent, $0588dc3366c5632f$export$af077dbfc4682e93 = $0588dc3366c5632f$var$_blogSlice_actions.addBlock, $0588dc3366c5632f$export$ed8baed65308f4ef = $0588dc3366c5632f$var$_blogSlice_actions.deleteBlock, $0588dc3366c5632f$export$624c2ec9f2cded85 = $0588dc3366c5632f$var$_blogSlice_actions.updateCaption, $0588dc3366c5632f$export$afbaf9de62621d7b = $0588dc3366c5632f$var$_blogSlice_actions.updatePreviewImage, $0588dc3366c5632f$export$9c6f66d1d405561d = $0588dc3366c5632f$var$_blogSlice_actions.updateKeywords, $0588dc3366c5632f$export$3c22e49343768f0d = $0588dc3366c5632f$var$_blogSlice_actions.reorderBlocks, $0588dc3366c5632f$export$b1e61d1688165092 = $0588dc3366c5632f$var$_blogSlice_actions.resetEditedBlog;
var $0588dc3366c5632f$export$2e2bcd8739ae039 = $0588dc3366c5632f$var$blogSlice.reducer;





var $075cb3b163bd999f$var$DescriptionEditor = function() {
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Description"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("textarea", {
                value: editedBlog === null || editedBlog === void 0 ? void 0 : editedBlog.description,
                onChange: function(e) {
                    return dispatch((0, $0588dc3366c5632f$export$989a858ef0c8fda5)(e.target.value));
                },
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter the description",
                rows: "3"
            })
        ]
    });
};
var $075cb3b163bd999f$export$2e2bcd8739ae039 = $075cb3b163bd999f$var$DescriptionEditor;





var $b946f8b49fc8c21d$var$TitleEditor = function() {
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Title"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                type: "text",
                value: editedBlog === null || editedBlog === void 0 ? void 0 : editedBlog.title,
                onChange: function(e) {
                    return dispatch((0, $0588dc3366c5632f$export$bf6f7165e46e2479)(e.target.value));
                },
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter the title"
            })
        ]
    });
};
var $b946f8b49fc8c21d$export$2e2bcd8739ae039 = $b946f8b49fc8c21d$var$TitleEditor;




var $2nwvT = parcelRequire("2nwvT");






var $2nwvT = parcelRequire("2nwvT");







var $74ab5e651e584cc3$var$EditorOption = function(param) {
    var blockId = param.blockId;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var handleDeleteClick = function() {
        var confirmation = confirm("Are you sure you want to delete this block?");
        if (confirmation) {
            console.log("Deleting block with ID: ", blockId);
            dispatch((0, $0588dc3366c5632f$export$ed8baed65308f4ef)(blockId));
        }
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("i", {
            onClick: handleDeleteClick,
            className: "fas fa-trash-alt text-red-600"
        })
    });
};
var $74ab5e651e584cc3$export$2e2bcd8739ae039 = $74ab5e651e584cc3$var$EditorOption;


var $ac006809569fdca9$var$TextBlock = function(param) {
    var contentBlock = param.contentBlock;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-3",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold",
                        children: "Text Block"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $74ab5e651e584cc3$export$2e2bcd8739ae039), {
                        blockId: contentBlock._id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("textarea", {
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                value: contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.content,
                onChange: function(e) {
                    dispatch((0, $0588dc3366c5632f$export$5143cc956eb9d8f6)({
                        content: e.target.value,
                        _id: contentBlock._id
                    }));
                },
                placeholder: "Enter text here",
                rows: "5"
            })
        ]
    });
};
var $ac006809569fdca9$export$2e2bcd8739ae039 = $ac006809569fdca9$var$TextBlock;






var $a8de80691e7c152c$var$ImageBlock = function(param) {
    var contentBlock = param.contentBlock;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-3",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold",
                        children: "Image Block"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $74ab5e651e584cc3$export$2e2bcd8739ae039), {
                        blockId: contentBlock._id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-1",
                        children: "URL"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                        type: "text",
                        placeholder: "https://example.com/image.jpg",
                        value: contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.content,
                        onChange: function(e) {
                            dispatch((0, $0588dc3366c5632f$export$5143cc956eb9d8f6)({
                                content: e.target.value,
                                _id: contentBlock._id
                            }));
                        },
                        className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                        className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-1",
                        children: "Caption"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                        type: "text",
                        placeholder: "Image Caption",
                        value: contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.caption,
                        onChange: function(e) {
                            dispatch((0, $0588dc3366c5632f$export$624c2ec9f2cded85)({
                                caption: e.target.value,
                                _id: contentBlock._id
                            }));
                        },
                        className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500"
                    })
                ]
            })
        ]
    });
};
var $a8de80691e7c152c$export$2e2bcd8739ae039 = $a8de80691e7c152c$var$ImageBlock;




var $dQFEZ = parcelRequire("dQFEZ");
function $2122a05a8b6d37ff$export$2e2bcd8739ae039(t, e) {
    return $2122a05a8b6d37ff$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $2122a05a8b6d37ff$export$2e2bcd8739ae039(t, e);
}


function $740fba40598542d2$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $2122a05a8b6d37ff$export$2e2bcd8739ae039)(t, o);
}


function $74f7f17f39e9b1de$export$2e2bcd8739ae039() {
    return $74f7f17f39e9b1de$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $74f7f17f39e9b1de$export$2e2bcd8739ae039.apply(null, arguments);
}



var $bJtXW = parcelRequire("bJtXW");
function $9b15e1883c7554bd$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9b15e1883c7554bd$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b15e1883c7554bd$export$2e2bcd8739ae039(o);
}



function $ee38838e28175fc1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $9b15e1883c7554bd$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $9b15e1883c7554bd$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $ea3d312a5e0b9706$export$2e2bcd8739ae039(t) {
    var i = (0, $ee38838e28175fc1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $9b15e1883c7554bd$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $03ecf0f1374bb892$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ea3d312a5e0b9706$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $8aba87488e001901$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8aba87488e001901$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8aba87488e001901$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $03ecf0f1374bb892$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8aba87488e001901$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $8639cd7605f70408$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $8639cd7605f70408$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $8639cd7605f70408$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $8639cd7605f70408$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $8639cd7605f70408$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $8639cd7605f70408$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $8639cd7605f70408$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $8639cd7605f70408$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $8639cd7605f70408$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($8639cd7605f70408$var$isDate(val)) return "date";
    if ($8639cd7605f70408$var$isError(val)) return "error";
    var constructorName = $8639cd7605f70408$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $8639cd7605f70408$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $8639cd7605f70408$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $8639cd7605f70408$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $8639cd7605f70408$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $8639cd7605f70408$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(1));
        return enhancer($8639cd7605f70408$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$8639cd7605f70408$var$isPlainObject(action)) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $8639cd7605f70408$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$8639cd7605f70408$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $8639cd7605f70408$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$8639cd7605f70408$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $8639cd7605f70408$export$8928921ea2d3b126 = $8639cd7605f70408$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $8639cd7605f70408$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $8639cd7605f70408$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $8639cd7605f70408$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$8639cd7605f70408$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $8639cd7605f70408$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $8639cd7605f70408$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $8639cd7605f70408$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $8639cd7605f70408$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $8639cd7605f70408$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($8639cd7605f70408$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $8639cd7605f70408$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $8639cd7605f70408$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($8639cd7605f70408$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $8639cd7605f70408$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $8639cd7605f70408$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $8639cd7605f70408$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($8639cd7605f70408$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $8639cd7605f70408$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $8639cd7605f70408$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $8639cd7605f70408$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($8639cd7605f70408$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $8639cd7605f70408$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $8aba87488e001901$export$2e2bcd8739ae039)((0, $8aba87488e001901$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $dQFEZ = parcelRequire("dQFEZ");


var $dQFEZ = parcelRequire("dQFEZ");
var $9f8af57f43e242f2$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createContext(null);
var $9f8af57f43e242f2$export$2e2bcd8739ae039 = $9f8af57f43e242f2$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $11767238ef725890$var$defaultNoopBatch(callback) {
    callback();
}
var $11767238ef725890$var$batch = $11767238ef725890$var$defaultNoopBatch; // Allow injecting another batching function later
var $11767238ef725890$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $11767238ef725890$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $11767238ef725890$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $11767238ef725890$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0e989ce1c645a8d9$var$createListenerCollection() {
    var batch = (0, $11767238ef725890$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $0e989ce1c645a8d9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $0e989ce1c645a8d9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $0e989ce1c645a8d9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0e989ce1c645a8d9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0e989ce1c645a8d9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $dQFEZ = parcelRequire("dQFEZ");
var $7a984790d944fcb2$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $dQFEZ.useLayoutEffect) : (0, $dQFEZ.useEffect);


function $841456b156e5436a$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $dQFEZ.useMemo)(function() {
        var subscription = (0, $0e989ce1c645a8d9$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $dQFEZ.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $7a984790d944fcb2$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $841456b156e5436a$export$2e2bcd8739ae039 = $841456b156e5436a$var$Provider;



function $d0c79cddee537c80$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $3fcc98485104aba5$exports = {};
"use strict";
var $6a98ce520f1d0d17$exports = {};
"use strict";

$6a98ce520f1d0d17$exports = (parcelRequire("bOebF"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3fcc98485104aba5$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3fcc98485104aba5$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3fcc98485104aba5$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3fcc98485104aba5$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3fcc98485104aba5$var$TYPE_STATICS = {};
$3fcc98485104aba5$var$TYPE_STATICS[$6a98ce520f1d0d17$exports.ForwardRef] = $3fcc98485104aba5$var$FORWARD_REF_STATICS;
$3fcc98485104aba5$var$TYPE_STATICS[$6a98ce520f1d0d17$exports.Memo] = $3fcc98485104aba5$var$MEMO_STATICS;
function $3fcc98485104aba5$var$getStatics(component) {
    // React v16.11 and below
    if ($6a98ce520f1d0d17$exports.isMemo(component)) return $3fcc98485104aba5$var$MEMO_STATICS;
     // React v16.12 and above
    return $3fcc98485104aba5$var$TYPE_STATICS[component["$$typeof"]] || $3fcc98485104aba5$var$REACT_STATICS;
}
var $3fcc98485104aba5$var$defineProperty = Object.defineProperty;
var $3fcc98485104aba5$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3fcc98485104aba5$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3fcc98485104aba5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3fcc98485104aba5$var$getPrototypeOf = Object.getPrototypeOf;
var $3fcc98485104aba5$var$objectPrototype = Object.prototype;
function $3fcc98485104aba5$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3fcc98485104aba5$var$objectPrototype) {
            var inheritedComponent = $3fcc98485104aba5$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3fcc98485104aba5$var$objectPrototype) $3fcc98485104aba5$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3fcc98485104aba5$var$getOwnPropertyNames(sourceComponent);
        if ($3fcc98485104aba5$var$getOwnPropertySymbols) keys = keys.concat($3fcc98485104aba5$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3fcc98485104aba5$var$getStatics(targetComponent);
        var sourceStatics = $3fcc98485104aba5$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3fcc98485104aba5$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3fcc98485104aba5$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3fcc98485104aba5$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3fcc98485104aba5$exports = $3fcc98485104aba5$var$hoistNonReactStatics;



var $dQFEZ = parcelRequire("dQFEZ");
var $f5117903d17eb799$exports = {};
"use strict";

$f5117903d17eb799$exports = (parcelRequire("h5Ho9"));





var $618f64b9ae6b5dfb$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $618f64b9ae6b5dfb$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $618f64b9ae6b5dfb$var$EMPTY_ARRAY = [];
var $618f64b9ae6b5dfb$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $618f64b9ae6b5dfb$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $618f64b9ae6b5dfb$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $618f64b9ae6b5dfb$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7a984790d944fcb2$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $618f64b9ae6b5dfb$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $618f64b9ae6b5dfb$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $618f64b9ae6b5dfb$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $618f64b9ae6b5dfb$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function getDisplayName(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $d0c79cddee537c80$export$2e2bcd8739ae039)(_ref2, $618f64b9ae6b5dfb$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $dQFEZ.useMemo) : function usePureOnlyMemo(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $dQFEZ.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $d0c79cddee537c80$export$2e2bcd8739ae039)(props, $618f64b9ae6b5dfb$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $dQFEZ.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $f5117903d17eb799$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $dQFEZ.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $dQFEZ.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $dQFEZ.useMemo)(function() {
                if (!shouldHandleStateChanges) return $618f64b9ae6b5dfb$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $0e989ce1c645a8d9$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $dQFEZ.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $dQFEZ.useReducer)($618f64b9ae6b5dfb$var$storeStateUpdatesReducer, $618f64b9ae6b5dfb$var$EMPTY_ARRAY, $618f64b9ae6b5dfb$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $dQFEZ.useRef)();
            var lastWrapperProps = (0, $dQFEZ.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $dQFEZ.useRef)();
            var renderIsScheduled = (0, $dQFEZ.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $618f64b9ae6b5dfb$var$useIsomorphicLayoutEffectWithArgs($618f64b9ae6b5dfb$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $618f64b9ae6b5dfb$var$useIsomorphicLayoutEffectWithArgs($618f64b9ae6b5dfb$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $dQFEZ.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(WrappedComponent, (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $dQFEZ.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(Connect, (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3fcc98485104aba5$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3fcc98485104aba5$exports)))(Connect, WrappedComponent);
    };
}




var $bJtXW = parcelRequire("bJtXW");



function $0b707e0155e813ba$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $0b707e0155e813ba$export$2e2bcd8739ae039(objA, objB) {
    if ($0b707e0155e813ba$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$0b707e0155e813ba$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $46c9c0f956aaa517$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $fa692e44dba31d77$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $eabd0bcf4c2db5bf$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $0a992698e2eaa43d$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $fa692e44dba31d77$export$2e2bcd8739ae039)(value)) (0, $eabd0bcf4c2db5bf$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $e764849b917065e2$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $e764849b917065e2$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $e764849b917065e2$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $e764849b917065e2$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $e764849b917065e2$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $d479b67dd58554db$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $e764849b917065e2$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $d479b67dd58554db$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $e764849b917065e2$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d479b67dd58554db$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $e764849b917065e2$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $46c9c0f956aaa517$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d479b67dd58554db$export$2e2bcd8739ae039 = [
    $d479b67dd58554db$export$a9f27b4b187c1166,
    $d479b67dd58554db$export$ba20d1a7aa0c4a90,
    $d479b67dd58554db$export$94a6e55709d4d961
];



function $80ca61cab0e84549$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $e764849b917065e2$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $80ca61cab0e84549$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $e764849b917065e2$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $80ca61cab0e84549$export$2e2bcd8739ae039 = [
    $80ca61cab0e84549$export$23fc470827b14aa,
    $80ca61cab0e84549$export$514bc8c1a53c1d66
];




function $ee11b418b98154a9$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $ee11b418b98154a9$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $ee11b418b98154a9$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $ee11b418b98154a9$export$5b105939c84b5234(mergeProps) : undefined;
}
function $ee11b418b98154a9$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $ee11b418b98154a9$export$691c327fc30bc857;
    } : undefined;
}
var $ee11b418b98154a9$export$2e2bcd8739ae039 = [
    $ee11b418b98154a9$export$d61b680184bc3f00,
    $ee11b418b98154a9$export$a13ba70ef50dda6d
];




function $8b57c2c838780cef$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $eabd0bcf4c2db5bf$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $8b57c2c838780cef$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $8b57c2c838780cef$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $8b57c2c838780cef$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $8b57c2c838780cef$var$verify(mergeProps, "mergeProps", displayName);
}


var $4039c1938ffc6a4e$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $4039c1938ffc6a4e$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $4039c1938ffc6a4e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $4039c1938ffc6a4e$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $d0c79cddee537c80$export$2e2bcd8739ae039)(_ref2, $4039c1938ffc6a4e$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $4039c1938ffc6a4e$export$d20c0c2ca6eb2b6f : $4039c1938ffc6a4e$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $826a110f13d0cc83$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $826a110f13d0cc83$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + (typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg)) + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $826a110f13d0cc83$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $826a110f13d0cc83$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $618f64b9ae6b5dfb$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $80ca61cab0e84549$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $d479b67dd58554db$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $ee11b418b98154a9$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $4039c1938ffc6a4e$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $826a110f13d0cc83$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $0b707e0155e813ba$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $0b707e0155e813ba$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $0b707e0155e813ba$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $d0c79cddee537c80$export$2e2bcd8739ae039)(_ref3, $826a110f13d0cc83$var$_excluded);
        var initMapStateToProps = $826a110f13d0cc83$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $826a110f13d0cc83$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $826a110f13d0cc83$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $826a110f13d0cc83$export$2e2bcd8739ae039 = /*#__PURE__*/ $826a110f13d0cc83$export$9f9feb656dec1fc4();




var $dQFEZ = parcelRequire("dQFEZ");


var $dQFEZ = parcelRequire("dQFEZ");

function $349068dbf3d007b7$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $dQFEZ.useContext)((0, $9f8af57f43e242f2$export$cc80c08dc91f1c00));
    return contextValue;
}


function $570ae36e4cc04faf$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00) ? (0, $349068dbf3d007b7$export$c1275ca9a6fd3ec5) : function useReduxContext() {
        return (0, $dQFEZ.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $570ae36e4cc04faf$export$6ccbb43953eebf8 = /*#__PURE__*/ $570ae36e4cc04faf$export$671dba69185d0304();


function $3bab9095076e7826$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00);
    var useStore = context === (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00) ? (0, $570ae36e4cc04faf$export$6ccbb43953eebf8) : (0, $570ae36e4cc04faf$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $3bab9095076e7826$export$8ad76b76a4c905f8 = /*#__PURE__*/ $3bab9095076e7826$export$bc9b55530897c558();



var $dQFEZ = parcelRequire("dQFEZ");




var $de3e4eb9ed16572e$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $de3e4eb9ed16572e$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $dQFEZ.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $dQFEZ.useMemo)(function() {
        return (0, $0e989ce1c645a8d9$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $dQFEZ.useRef)();
    var latestSelector = (0, $dQFEZ.useRef)();
    var latestStoreState = (0, $dQFEZ.useRef)();
    var latestSelectedState = (0, $dQFEZ.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $7a984790d944fcb2$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $7a984790d944fcb2$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $de3e4eb9ed16572e$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $9f8af57f43e242f2$export$cc80c08dc91f1c00) ? (0, $349068dbf3d007b7$export$c1275ca9a6fd3ec5) : function useReduxContext() {
        return (0, $dQFEZ.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $de3e4eb9ed16572e$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $de3e4eb9ed16572e$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $dQFEZ.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $de3e4eb9ed16572e$export$2105062e25df4afe = /*#__PURE__*/ $de3e4eb9ed16572e$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $11767238ef725890$export$4b9874722d0da7bc)((0, $4288f0eb191085d1$exports.unstable_batchedUpdates));



var $dQFEZ = parcelRequire("dQFEZ");
function $881077b909fec5f5$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $881077b909fec5f5$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $dQFEZ.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $dQFEZ.useRef)(true);
    var committed = (0, $dQFEZ.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $881077b909fec5f5$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $dQFEZ.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $881077b909fec5f5$export$33752cf3ee811995(callback, inputs) {
    return $881077b909fec5f5$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $881077b909fec5f5$export$1538c33de8887b59 = $881077b909fec5f5$export$b6feb8998cd9b342;
var $881077b909fec5f5$export$35808ee640e87ca7 = $881077b909fec5f5$export$33752cf3ee811995;


var $5398fcbfaf62e1cd$var$isProduction = true;
var $5398fcbfaf62e1cd$var$prefix = "Invariant failed";
function $5398fcbfaf62e1cd$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($5398fcbfaf62e1cd$var$isProduction) throw new Error($5398fcbfaf62e1cd$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($5398fcbfaf62e1cd$var$prefix, ": ").concat(provided) : $5398fcbfaf62e1cd$var$prefix;
    throw new Error(value);
}


var $08af6d26d62dfe67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $08af6d26d62dfe67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $08af6d26d62dfe67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $08af6d26d62dfe67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $08af6d26d62dfe67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $08af6d26d62dfe67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $08af6d26d62dfe67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $08af6d26d62dfe67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $08af6d26d62dfe67$var$noSpacing : _ref2$padding;
    var marginBox = $08af6d26d62dfe67$export$4b834cebd9e5cebe($08af6d26d62dfe67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $08af6d26d62dfe67$export$4b834cebd9e5cebe($08af6d26d62dfe67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $08af6d26d62dfe67$export$4b834cebd9e5cebe($08af6d26d62dfe67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $08af6d26d62dfe67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $08af6d26d62dfe67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $5398fcbfaf62e1cd$export$2e2bcd8739ae039)(false);
    return result;
};
var $08af6d26d62dfe67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $08af6d26d62dfe67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $08af6d26d62dfe67$var$shift(borderBox, change);
    return $08af6d26d62dfe67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $08af6d26d62dfe67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $08af6d26d62dfe67$var$getWindowScroll();
    return $08af6d26d62dfe67$export$cc800923e997bb8(original, scroll);
};
var $08af6d26d62dfe67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $08af6d26d62dfe67$var$parse(styles.marginTop),
        right: $08af6d26d62dfe67$var$parse(styles.marginRight),
        bottom: $08af6d26d62dfe67$var$parse(styles.marginBottom),
        left: $08af6d26d62dfe67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $08af6d26d62dfe67$var$parse(styles.paddingTop),
        right: $08af6d26d62dfe67$var$parse(styles.paddingRight),
        bottom: $08af6d26d62dfe67$var$parse(styles.paddingBottom),
        left: $08af6d26d62dfe67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $08af6d26d62dfe67$var$parse(styles.borderTopWidth),
        right: $08af6d26d62dfe67$var$parse(styles.borderRightWidth),
        bottom: $08af6d26d62dfe67$var$parse(styles.borderBottomWidth),
        left: $08af6d26d62dfe67$var$parse(styles.borderLeftWidth)
    };
    return $08af6d26d62dfe67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $08af6d26d62dfe67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $08af6d26d62dfe67$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $dc9500fecbfb8ad0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $dc9500fecbfb8ad0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($dc9500fecbfb8ad0$var$safeIsNaN(first) && $dc9500fecbfb8ad0$var$safeIsNaN(second)) return true;
    return false;
}
function $dc9500fecbfb8ad0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$dc9500fecbfb8ad0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $dc9500fecbfb8ad0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $dc9500fecbfb8ad0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $dc9500fecbfb8ad0$export$2e2bcd8739ae039 = $dc9500fecbfb8ad0$var$memoizeOne;


var $536157540d00934a$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $536157540d00934a$export$2e2bcd8739ae039 = $536157540d00934a$var$rafSchd;



var $bb4628016638410a$var$isProduction = true;
var $bb4628016638410a$var$spacesAndTabs = /[ \t]{2,}/g;
var $bb4628016638410a$var$lineStartWithSpaces = /^[ \t]*/gm;
var $bb4628016638410a$var$clean = function clean(value) {
    return value.replace($bb4628016638410a$var$spacesAndTabs, " ").replace($bb4628016638410a$var$lineStartWithSpaces, "").trim();
};
var $bb4628016638410a$var$getDevMessage = function getDevMessage(message) {
    return $bb4628016638410a$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $bb4628016638410a$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $bb4628016638410a$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $bb4628016638410a$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var $bb4628016638410a$var$isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function $bb4628016638410a$var$log(type, message) {
    var _console;
    if ($bb4628016638410a$var$isProduction) return;
    if (typeof window !== "undefined" && window[$bb4628016638410a$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $bb4628016638410a$var$getFormattedMessage(message));
}
var $bb4628016638410a$var$warning = $bb4628016638410a$var$log.bind(null, "warn");
var $bb4628016638410a$var$error = $bb4628016638410a$var$log.bind(null, "error");
function $bb4628016638410a$var$noop() {}
function $bb4628016638410a$var$getOptions(shared, fromBinding) {
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, shared, {}, fromBinding);
}
function $bb4628016638410a$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $bb4628016638410a$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $bb4628016638410a$var$isProduction$1 = true;
var $bb4628016638410a$var$prefix = "Invariant failed";
function $bb4628016638410a$var$RbdInvariant(message) {
    this.message = message;
}
$bb4628016638410a$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $bb4628016638410a$var$invariant(condition, message) {
    if (condition) return;
    if ($bb4628016638410a$var$isProduction$1) throw new $bb4628016638410a$var$RbdInvariant($bb4628016638410a$var$prefix);
    else throw new $bb4628016638410a$var$RbdInvariant($bb4628016638410a$var$prefix + ": " + (message || ""));
}
var $bb4628016638410a$var$ErrorBoundary = function(_React$Component) {
    (0, $740fba40598542d2$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $bb4628016638410a$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $bb4628016638410a$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $bb4628016638410a$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $bb4628016638410a$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).Component);
var $bb4628016638410a$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $bb4628016638410a$var$position = function position(index) {
    return index + 1;
};
var $bb4628016638410a$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $bb4628016638410a$var$position(start.source.index) + "\n";
};
var $bb4628016638410a$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $bb4628016638410a$var$position(source.index);
    var endPosition = $bb4628016638410a$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $bb4628016638410a$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $bb4628016638410a$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $bb4628016638410a$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $bb4628016638410a$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var $bb4628016638410a$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $bb4628016638410a$var$position(source.index) + "\n";
};
var $bb4628016638410a$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + $bb4628016638410a$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $bb4628016638410a$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $bb4628016638410a$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $bb4628016638410a$var$returnedToStart(result.source) + "\n  ";
};
var $bb4628016638410a$var$preset = {
    dragHandleUsageInstructions: $bb4628016638410a$var$dragHandleUsageInstructions,
    onDragStart: $bb4628016638410a$var$onDragStart,
    onDragUpdate: $bb4628016638410a$var$onDragUpdate,
    onDragEnd: $bb4628016638410a$var$onDragEnd
};
var $bb4628016638410a$var$origin = {
    x: 0,
    y: 0
};
var $bb4628016638410a$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $bb4628016638410a$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $bb4628016638410a$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $bb4628016638410a$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $bb4628016638410a$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var $bb4628016638410a$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $bb4628016638410a$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $bb4628016638410a$var$distance(target, point);
    }));
};
var $bb4628016638410a$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $bb4628016638410a$var$executeClip = function executeClip(frame, subject) {
    var result = (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $bb4628016638410a$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $bb4628016638410a$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $bb4628016638410a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $bb4628016638410a$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $bb4628016638410a$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $bb4628016638410a$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $bb4628016638410a$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $bb4628016638410a$var$executeClip(frame.pageMarginBox, target);
    return (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)(target);
};
var $bb4628016638410a$var$getSubject = function getSubject(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $bb4628016638410a$var$scroll(page.marginBox, frame);
    var increased = $bb4628016638410a$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $bb4628016638410a$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $bb4628016638410a$var$scrollDroppable = function scrollDroppable(droppable, newScroll) {
    !droppable.frame && $bb4628016638410a$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $bb4628016638410a$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $bb4628016638410a$var$negate(scrollDiff);
    var frame = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $bb4628016638410a$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $bb4628016638410a$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $bb4628016638410a$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $bb4628016638410a$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $bb4628016638410a$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $bb4628016638410a$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $bb4628016638410a$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $bb4628016638410a$var$toDroppableMap = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $bb4628016638410a$var$toDraggableMap = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $bb4628016638410a$var$toDroppableList = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(droppables) {
    return $bb4628016638410a$var$values(droppables);
});
var $bb4628016638410a$var$toDraggableList = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(draggables) {
    return $bb4628016638410a$var$values(draggables);
});
var $bb4628016638410a$var$getDraggablesInsideDroppable = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $bb4628016638410a$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $bb4628016638410a$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $bb4628016638410a$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $bb4628016638410a$var$removeDraggableFromList = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $bb4628016638410a$var$moveToNextCombine = function moveToNextCombine(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $bb4628016638410a$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $bb4628016638410a$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $bb4628016638410a$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $bb4628016638410a$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $bb4628016638410a$var$isHomeOf = function isHomeOf(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $bb4628016638410a$var$noDisplacedBy = {
    point: $bb4628016638410a$var$origin,
    value: 0
};
var $bb4628016638410a$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $bb4628016638410a$var$noImpact = {
    displaced: $bb4628016638410a$var$emptyGroups,
    displacedBy: $bb4628016638410a$var$noDisplacedBy,
    at: null
};
var $bb4628016638410a$var$isWithin = function isWithin(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $bb4628016638410a$var$isPartiallyVisibleThroughFrame = function isPartiallyVisibleThroughFrame(frame) {
    var isWithinVertical = $bb4628016638410a$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bb4628016638410a$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $bb4628016638410a$var$isTotallyVisibleThroughFrame = function isTotallyVisibleThroughFrame(frame) {
    var isWithinVertical = $bb4628016638410a$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bb4628016638410a$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $bb4628016638410a$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var $bb4628016638410a$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $bb4628016638410a$var$isTotallyVisibleThroughFrameOnAxis = function isTotallyVisibleThroughFrameOnAxis(axis) {
    return function(frame) {
        var isWithinVertical = $bb4628016638410a$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $bb4628016638410a$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $bb4628016638410a$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $bb4628016638410a$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $bb4628016638410a$var$origin;
    return $bb4628016638410a$var$offsetByPosition(target, displacement);
};
var $bb4628016638410a$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $bb4628016638410a$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $bb4628016638410a$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $bb4628016638410a$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $bb4628016638410a$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $bb4628016638410a$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $bb4628016638410a$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $bb4628016638410a$var$isVisible((0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $bb4628016638410a$var$isPartiallyVisibleThroughFrame
    }));
};
var $bb4628016638410a$var$isTotallyVisible = function isTotallyVisible(args) {
    return $bb4628016638410a$var$isVisible((0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $bb4628016638410a$var$isTotallyVisibleThroughFrame
    }));
};
var $bb4628016638410a$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $bb4628016638410a$var$isVisible((0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $bb4628016638410a$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $bb4628016638410a$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $bb4628016638410a$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)((0, $08af6d26d62dfe67$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $bb4628016638410a$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $bb4628016638410a$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $bb4628016638410a$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $bb4628016638410a$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $bb4628016638410a$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $bb4628016638410a$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $bb4628016638410a$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $bb4628016638410a$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $bb4628016638410a$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $bb4628016638410a$var$isHomeOf(draggable, destination);
    if (index == null) return $bb4628016638410a$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $bb4628016638410a$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $bb4628016638410a$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $bb4628016638410a$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $bb4628016638410a$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $bb4628016638410a$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $bb4628016638410a$var$fromCombine = function fromCombine(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $bb4628016638410a$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $bb4628016638410a$var$fromReorder = function fromReorder(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $bb4628016638410a$var$moveToNextIndex = function moveToNextIndex(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $bb4628016638410a$var$invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = $bb4628016638410a$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $bb4628016638410a$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $bb4628016638410a$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $bb4628016638410a$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $bb4628016638410a$var$getCombinedItemDisplacement = function getCombinedItemDisplacement(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($bb4628016638410a$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $bb4628016638410a$var$origin : $bb4628016638410a$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $bb4628016638410a$var$origin;
};
var $bb4628016638410a$var$whenCombining = function whenCombining(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $bb4628016638410a$var$tryGetCombine(impact);
    !combine && $bb4628016638410a$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $bb4628016638410a$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $bb4628016638410a$var$add(center, displaceBy);
};
var $bb4628016638410a$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $bb4628016638410a$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $bb4628016638410a$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $bb4628016638410a$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $bb4628016638410a$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $bb4628016638410a$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $bb4628016638410a$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $bb4628016638410a$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $bb4628016638410a$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $bb4628016638410a$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $bb4628016638410a$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $bb4628016638410a$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $bb4628016638410a$var$patch(axis.line, moveInto.contentBox[axis.start] + $bb4628016638410a$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $bb4628016638410a$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $bb4628016638410a$var$whenReordering = function whenReordering(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $bb4628016638410a$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $bb4628016638410a$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($bb4628016638410a$var$didStartAfterCritical(closestAfter, afterCritical)) return $bb4628016638410a$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $08af6d26d62dfe67$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $bb4628016638410a$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($bb4628016638410a$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $08af6d26d62dfe67$export$cc800923e997bb8)(last.page, $bb4628016638410a$var$negate(afterCritical.displacedBy.point));
        return $bb4628016638410a$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $bb4628016638410a$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $bb4628016638410a$var$withDroppableDisplacement = function withDroppableDisplacement(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $bb4628016638410a$var$add(point, frame.scroll.diff.displacement);
};
var $bb4628016638410a$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $bb4628016638410a$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $bb4628016638410a$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $bb4628016638410a$var$getPageBorderBoxCenterFromImpact = function getPageBorderBoxCenterFromImpact(args) {
    var withoutDisplacement = $bb4628016638410a$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $bb4628016638410a$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $bb4628016638410a$var$scrollViewport = function scrollViewport(viewport, newScroll) {
    var diff = $bb4628016638410a$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $bb4628016638410a$var$negate(diff);
    var frame = (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $bb4628016638410a$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $bb4628016638410a$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $bb4628016638410a$var$speculativelyIncrease = function speculativelyIncrease(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $bb4628016638410a$var$scrollViewport(viewport, $bb4628016638410a$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $bb4628016638410a$var$scrollDroppable(destination, $bb4628016638410a$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $bb4628016638410a$var$getDisplacementGroups({
        afterDragging: $bb4628016638410a$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $bb4628016638410a$var$getDisplacementGroups({
        afterDragging: $bb4628016638410a$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $bb4628016638410a$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $bb4628016638410a$var$withViewportDisplacement = function withViewportDisplacement(viewport, point) {
    return $bb4628016638410a$var$add(viewport.scroll.diff.displacement, point);
};
var $bb4628016638410a$var$getClientFromPageBorderBoxCenter = function getClientFromPageBorderBoxCenter(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $bb4628016638410a$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $bb4628016638410a$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $bb4628016638410a$var$add(draggable.client.borderBox.center, offset);
};
var $bb4628016638410a$var$isTotallyVisibleInNewLocation = function isTotallyVisibleInNewLocation(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $bb4628016638410a$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $bb4628016638410a$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $bb4628016638410a$var$isTotallyVisibleOnAxis(args) : $bb4628016638410a$var$isTotallyVisible(args);
};
var $bb4628016638410a$var$moveToNextPlace = function moveToNextPlace(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $bb4628016638410a$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $bb4628016638410a$var$isHomeOf(draggable, destination);
    var impact = $bb4628016638410a$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $bb4628016638410a$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $bb4628016638410a$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $bb4628016638410a$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $bb4628016638410a$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $bb4628016638410a$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $bb4628016638410a$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $bb4628016638410a$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $bb4628016638410a$var$invariant(false);
    return rect;
};
var $bb4628016638410a$var$getBestCrossAxisDroppable = function getBestCrossAxisDroppable(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $bb4628016638410a$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $bb4628016638410a$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $bb4628016638410a$var$isPartiallyVisibleThroughFrame(viewport.frame)($bb4628016638410a$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $bb4628016638410a$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $bb4628016638410a$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $bb4628016638410a$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $bb4628016638410a$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $bb4628016638410a$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $bb4628016638410a$var$getKnownActive(droppable)[axis.crossAxisStart] === $bb4628016638410a$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $bb4628016638410a$var$isWithin($bb4628016638410a$var$getKnownActive(droppable)[axis.start], $bb4628016638410a$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $bb4628016638410a$var$getKnownActive(a)[axis.start] - $bb4628016638410a$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $bb4628016638410a$var$closest(pageBorderBoxCenter, $bb4628016638410a$var$getCorners($bb4628016638410a$var$getKnownActive(a)));
        var second = $bb4628016638410a$var$closest(pageBorderBoxCenter, $bb4628016638410a$var$getCorners($bb4628016638410a$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $bb4628016638410a$var$getKnownActive(a)[axis.start] - $bb4628016638410a$var$getKnownActive(b)[axis.start];
    })[0];
};
var $bb4628016638410a$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $bb4628016638410a$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $bb4628016638410a$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $bb4628016638410a$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $bb4628016638410a$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $bb4628016638410a$var$offsetByPosition(original, $bb4628016638410a$var$negate(afterCritical.displacedBy.point)) : original;
};
var $bb4628016638410a$var$getClosestDraggable = function getClosestDraggable(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $bb4628016638410a$var$isTotallyVisible({
            target: $bb4628016638410a$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $bb4628016638410a$var$distance(pageBorderBoxCenter, $bb4628016638410a$var$withDroppableDisplacement(destination, $bb4628016638410a$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $bb4628016638410a$var$distance(pageBorderBoxCenter, $bb4628016638410a$var$withDroppableDisplacement(destination, $bb4628016638410a$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $bb4628016638410a$var$getDisplacedBy = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $bb4628016638410a$var$patch(axis.line, displacement)
    };
});
var $bb4628016638410a$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $bb4628016638410a$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $bb4628016638410a$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $bb4628016638410a$var$patch(axis.line, needsToGrowBy);
};
var $bb4628016638410a$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, frame, {
        scroll: (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, frame.scroll, {
            max: max
        })
    });
};
var $bb4628016638410a$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$bb4628016638410a$var$isHomeOf(draggable, droppable) && $bb4628016638410a$var$invariant(false);
    !!droppable.subject.withPlaceholder && $bb4628016638410a$var$invariant(false);
    var placeholderSize = $bb4628016638410a$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $bb4628016638410a$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $bb4628016638410a$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $bb4628016638410a$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $bb4628016638410a$var$withMaxScroll(frame, maxScroll);
    var subject = $bb4628016638410a$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $bb4628016638410a$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $bb4628016638410a$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $bb4628016638410a$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $bb4628016638410a$var$invariant(false);
    var newFrame = $bb4628016638410a$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $bb4628016638410a$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $bb4628016638410a$var$moveToNewDroppable = function moveToNewDroppable(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $bb4628016638410a$var$emptyGroups,
            displacedBy: $bb4628016638410a$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $bb4628016638410a$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $bb4628016638410a$var$isHomeOf(draggable, destination) ? destination : $bb4628016638410a$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $bb4628016638410a$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $bb4628016638410a$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $bb4628016638410a$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $bb4628016638410a$var$emptyGroups,
        index: proposedIndex
    });
};
var $bb4628016638410a$var$moveCrossAxis = function moveCrossAxis(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $bb4628016638410a$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $bb4628016638410a$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $bb4628016638410a$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $bb4628016638410a$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $bb4628016638410a$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $bb4628016638410a$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $bb4628016638410a$var$whatIsDraggedOver = function whatIsDraggedOver(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var $bb4628016638410a$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $bb4628016638410a$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $bb4628016638410a$var$moveInDirection = function moveInDirection(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $bb4628016638410a$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $bb4628016638410a$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $bb4628016638410a$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $bb4628016638410a$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $bb4628016638410a$var$isPositionInFrame(frame) {
    var isWithinVertical = $bb4628016638410a$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bb4628016638410a$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $bb4628016638410a$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $bb4628016638410a$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $bb4628016638410a$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $bb4628016638410a$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $bb4628016638410a$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $bb4628016638410a$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$bb4628016638410a$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($bb4628016638410a$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $bb4628016638410a$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $bb4628016638410a$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $bb4628016638410a$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)($bb4628016638410a$var$offsetByPosition(rect, point));
};
var $bb4628016638410a$var$withDroppableScroll = function withDroppableScroll(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $bb4628016638410a$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $bb4628016638410a$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $bb4628016638410a$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $bb4628016638410a$var$getReorderImpact = function getReorderImpact(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $bb4628016638410a$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $bb4628016638410a$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $bb4628016638410a$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $bb4628016638410a$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $bb4628016638410a$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $bb4628016638410a$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $bb4628016638410a$var$isHomeOf(draggable, destination)
    });
    return $bb4628016638410a$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $bb4628016638410a$var$combineThresholdDivisor = 4;
var $bb4628016638410a$var$getCombineImpact = function getCombineImpact(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $bb4628016638410a$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $bb4628016638410a$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $bb4628016638410a$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $bb4628016638410a$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $bb4628016638410a$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $bb4628016638410a$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $bb4628016638410a$var$getDragImpact = function getDragImpact(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $bb4628016638410a$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $bb4628016638410a$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $bb4628016638410a$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $bb4628016638410a$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $bb4628016638410a$var$withDroppableScroll(destination, pageBorderBox);
    return $bb4628016638410a$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $bb4628016638410a$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $bb4628016638410a$var$patchDroppableMap = function patchDroppableMap(droppables, updated) {
    var _extends2;
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $bb4628016638410a$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $bb4628016638410a$var$whatIsDraggedOver(previousImpact);
    var now = $bb4628016638410a$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $bb4628016638410a$var$removePlaceholder(lastDroppable);
    return $bb4628016638410a$var$patchDroppableMap(droppables, updated);
};
var $bb4628016638410a$var$recomputePlaceholders = function recomputePlaceholders(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $bb4628016638410a$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $bb4628016638410a$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($bb4628016638410a$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $bb4628016638410a$var$addPlaceholder(droppable, draggable, draggables);
    return $bb4628016638410a$var$patchDroppableMap(cleaned, patched);
};
var $bb4628016638410a$var$update = function update(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $bb4628016638410a$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $bb4628016638410a$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $bb4628016638410a$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $bb4628016638410a$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $bb4628016638410a$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $bb4628016638410a$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $bb4628016638410a$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $bb4628016638410a$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $bb4628016638410a$var$recompute = function recompute(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $bb4628016638410a$var$getDraggables$1(last.all, draggables);
    var displaced = $bb4628016638410a$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, impact, {
        displaced: displaced
    });
};
var $bb4628016638410a$var$getClientBorderBoxCenter = function getClientBorderBoxCenter(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $bb4628016638410a$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $bb4628016638410a$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $bb4628016638410a$var$refreshSnap = function refreshSnap(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && $bb4628016638410a$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $bb4628016638410a$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $bb4628016638410a$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $bb4628016638410a$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $bb4628016638410a$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $bb4628016638410a$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $bb4628016638410a$var$getHomeLocation = function getHomeLocation(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $bb4628016638410a$var$getLiftEffect = function getLiftEffect(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $bb4628016638410a$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $bb4628016638410a$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $bb4628016638410a$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $bb4628016638410a$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $bb4628016638410a$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $bb4628016638410a$var$patchDimensionMap = function patchDimensionMap(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $bb4628016638410a$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $bb4628016638410a$var$start = function start(key) {};
var $bb4628016638410a$var$finish = function finish(key) {};
var $bb4628016638410a$var$offsetDraggable = function offsetDraggable(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $08af6d26d62dfe67$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $08af6d26d62dfe67$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, draggable, {
        placeholder: (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $bb4628016638410a$var$getFrame = function getFrame(droppable) {
    var frame = droppable.frame;
    !frame && $bb4628016638410a$var$invariant(false);
    return frame;
};
var $bb4628016638410a$var$adjustAdditionsForScrollChanges = function adjustAdditionsForScrollChanges(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $bb4628016638410a$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $bb4628016638410a$var$add(windowScrollChange, droppableScrollChange);
        var moved = $bb4628016638410a$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $bb4628016638410a$var$publishWhileDraggingInVirtual = function publishWhileDraggingInVirtual(_ref) {
    var state = _ref.state, published = _ref.published;
    $bb4628016638410a$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $bb4628016638410a$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, state.dimensions.droppables, {}, $bb4628016638410a$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $bb4628016638410a$var$toDraggableMap($bb4628016638410a$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $bb4628016638410a$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $bb4628016638410a$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $bb4628016638410a$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $bb4628016638410a$var$finish();
    var draggingState = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
        phase: "DRAGGING"
    }, state, {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
        phase: "DROP_PENDING"
    }, draggingState, {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $bb4628016638410a$var$isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var $bb4628016638410a$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $bb4628016638410a$var$patchDimensionMap(state.dimensions, updated);
    if (!$bb4628016638410a$var$isSnapping(state) || isEnabledChanging) return $bb4628016638410a$var$update({
        state: state,
        dimensions: dimensions
    });
    return $bb4628016638410a$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $bb4628016638410a$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $bb4628016638410a$var$idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $bb4628016638410a$var$reducer = function reducer(state, action) {
    if (state === void 0) state = $bb4628016638410a$var$idle;
    if (action.type === "FLUSH") return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, $bb4628016638410a$var$idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $bb4628016638410a$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $bb4628016638410a$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $bb4628016638410a$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $bb4628016638410a$var$add(client.selection, viewport.scroll.initial),
                offset: $bb4628016638410a$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $bb4628016638410a$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $bb4628016638410a$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $bb4628016638410a$var$invariant(false);
        var _result = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
            phase: "COLLECTING"
        }, state, {
            phase: "COLLECTING"
        });
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $bb4628016638410a$var$invariant(false);
        return $bb4628016638410a$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$bb4628016638410a$var$isMovementAllowed(state) && $bb4628016638410a$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($bb4628016638410a$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $bb4628016638410a$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $bb4628016638410a$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $bb4628016638410a$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $bb4628016638410a$var$removeScrollJumpRequest(state);
        !$bb4628016638410a$var$isMovementAllowed(state) && $bb4628016638410a$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $bb4628016638410a$var$scrollDroppable(target, newScroll);
        return $bb4628016638410a$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$bb4628016638410a$var$isMovementAllowed(state) && $bb4628016638410a$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $bb4628016638410a$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $bb4628016638410a$var$invariant(false);
        var updated = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, _target, {
            isEnabled: isEnabled
        });
        return $bb4628016638410a$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$bb4628016638410a$var$isMovementAllowed(state) && $bb4628016638410a$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $bb4628016638410a$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $bb4628016638410a$var$invariant(false);
        var _updated = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $bb4628016638410a$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$bb4628016638410a$var$isMovementAllowed(state) && $bb4628016638410a$var$invariant(false);
        !state.isWindowScrollAllowed && $bb4628016638410a$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($bb4628016638410a$var$isEqual(state.viewport.scroll.current, _newScroll)) return $bb4628016638410a$var$removeScrollJumpRequest(state);
        var _viewport = $bb4628016638410a$var$scrollViewport(state.viewport, _newScroll);
        if ($bb4628016638410a$var$isSnapping(state)) return $bb4628016638410a$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $bb4628016638410a$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$bb4628016638410a$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($bb4628016638410a$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, state.viewport, {
            scroll: (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $bb4628016638410a$var$invariant(false);
        var _result2 = $bb4628016638410a$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $bb4628016638410a$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $bb4628016638410a$var$invariant(false);
        var newState = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
            phase: "DROP_PENDING"
        }, state, {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $bb4628016638410a$var$invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $bb4628016638410a$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var $bb4628016638410a$var$lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var $bb4628016638410a$var$initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var $bb4628016638410a$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var $bb4628016638410a$var$collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var $bb4628016638410a$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var $bb4628016638410a$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var $bb4628016638410a$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var $bb4628016638410a$var$move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var $bb4628016638410a$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var $bb4628016638410a$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var $bb4628016638410a$var$moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var $bb4628016638410a$var$moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var $bb4628016638410a$var$moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var $bb4628016638410a$var$moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var $bb4628016638410a$var$flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var $bb4628016638410a$var$animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var $bb4628016638410a$var$completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var $bb4628016638410a$var$drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var $bb4628016638410a$var$dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var $bb4628016638410a$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function $bb4628016638410a$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function $bb4628016638410a$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $bb4628016638410a$var$lift$1 = function lift$1(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($bb4628016638410a$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $bb4628016638410a$var$invariant(false);
                dispatch($bb4628016638410a$var$flush());
                dispatch($bb4628016638410a$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $bb4628016638410a$var$validateDimensions(critical, dimensions);
                dispatch($bb4628016638410a$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $bb4628016638410a$var$style = function style(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var $bb4628016638410a$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var $bb4628016638410a$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $bb4628016638410a$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $bb4628016638410a$var$outOfTheWayTiming = $bb4628016638410a$var$timings.outOfTheWay + "s " + $bb4628016638410a$var$curves.outOfTheWay;
var $bb4628016638410a$var$transitions = {
    fluid: "opacity " + $bb4628016638410a$var$outOfTheWayTiming,
    snap: "transform " + $bb4628016638410a$var$outOfTheWayTiming + ", opacity " + $bb4628016638410a$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $bb4628016638410a$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $bb4628016638410a$var$outOfTheWayTiming,
    placeholder: "height " + $bb4628016638410a$var$outOfTheWayTiming + ", width " + $bb4628016638410a$var$outOfTheWayTiming + ", margin " + $bb4628016638410a$var$outOfTheWayTiming
};
var $bb4628016638410a$var$moveTo = function moveTo(offset) {
    return $bb4628016638410a$var$isEqual(offset, $bb4628016638410a$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $bb4628016638410a$var$transforms = {
    moveTo: $bb4628016638410a$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $bb4628016638410a$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $bb4628016638410a$var$combine.scale.drop + ")";
    }
};
var $bb4628016638410a$var$minDropTime = $bb4628016638410a$var$timings.minDropTime, $bb4628016638410a$var$maxDropTime = $bb4628016638410a$var$timings.maxDropTime;
var $bb4628016638410a$var$dropTimeRange = $bb4628016638410a$var$maxDropTime - $bb4628016638410a$var$minDropTime;
var $bb4628016638410a$var$maxDropTimeAtDistance = 1500;
var $bb4628016638410a$var$cancelDropModifier = 0.6;
var $bb4628016638410a$var$getDropDuration = function getDropDuration(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $bb4628016638410a$var$distance(current, destination);
    if (distance$1 <= 0) return $bb4628016638410a$var$minDropTime;
    if (distance$1 >= $bb4628016638410a$var$maxDropTimeAtDistance) return $bb4628016638410a$var$maxDropTime;
    var percentage = distance$1 / $bb4628016638410a$var$maxDropTimeAtDistance;
    var duration = $bb4628016638410a$var$minDropTime + $bb4628016638410a$var$dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * $bb4628016638410a$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $bb4628016638410a$var$getNewHomeClientOffset = function getNewHomeClientOffset(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $bb4628016638410a$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $bb4628016638410a$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $bb4628016638410a$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $bb4628016638410a$var$getDropImpact = function getDropImpact(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = $bb4628016638410a$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, lastImpact, {
        displaced: $bb4628016638410a$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $bb4628016638410a$var$drop$1 = function drop$1(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($bb4628016638410a$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $bb4628016638410a$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $bb4628016638410a$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $bb4628016638410a$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $bb4628016638410a$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $bb4628016638410a$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $bb4628016638410a$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$bb4628016638410a$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($bb4628016638410a$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $bb4628016638410a$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($bb4628016638410a$var$animateDrop(args));
        };
    };
};
var $bb4628016638410a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $bb4628016638410a$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $bb4628016638410a$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($bb4628016638410a$var$getWindowScroll());
    }
    var scheduled = (0, $536157540d00934a$export$2e2bcd8739ae039)(updateScroll);
    var binding = $bb4628016638410a$var$getWindowScrollBinding(scheduled);
    var unbind = $bb4628016638410a$var$noop;
    function isActive() {
        return unbind !== $bb4628016638410a$var$noop;
    }
    function start() {
        !!isActive() && $bb4628016638410a$var$invariant(false);
        unbind = $bb4628016638410a$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $bb4628016638410a$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $bb4628016638410a$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $bb4628016638410a$var$shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $bb4628016638410a$var$scrollListener = function scrollListener(store) {
    var listener = $bb4628016638410a$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($bb4628016638410a$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $bb4628016638410a$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $bb4628016638410a$var$getExpiringAnnounce = function getExpiringAnnounce(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $bb4628016638410a$var$getAsyncMarshal = function getAsyncMarshal() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $bb4628016638410a$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $bb4628016638410a$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $bb4628016638410a$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $bb4628016638410a$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $bb4628016638410a$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $bb4628016638410a$var$withTimings = function withTimings(key, fn) {
    $bb4628016638410a$var$start();
    fn();
    $bb4628016638410a$var$finish();
};
var $bb4628016638410a$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $bb4628016638410a$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $bb4628016638410a$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $bb4628016638410a$var$getPublisher = function getPublisher(getResponders, announce) {
    var asyncMarshal = $bb4628016638410a$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $bb4628016638410a$var$invariant(false);
        $bb4628016638410a$var$withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $bb4628016638410a$var$invariant(false);
        $bb4628016638410a$var$withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($bb4628016638410a$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $bb4628016638410a$var$invariant(false);
        var data = $bb4628016638410a$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $bb4628016638410a$var$withTimings("onDragStart", function() {
                return $bb4628016638410a$var$execute(getResponders().onDragStart, data, announce, $bb4628016638410a$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $bb4628016638410a$var$tryGetDestination(impact);
        var combine = $bb4628016638410a$var$tryGetCombine(impact);
        !dragging && $bb4628016638410a$var$invariant(false);
        var hasCriticalChanged = !$bb4628016638410a$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$bb4628016638410a$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$bb4628016638410a$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, $bb4628016638410a$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $bb4628016638410a$var$withTimings("onDragUpdate", function() {
                return $bb4628016638410a$var$execute(getResponders().onDragUpdate, data, announce, $bb4628016638410a$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $bb4628016638410a$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $bb4628016638410a$var$invariant(false);
        dragging = null;
        $bb4628016638410a$var$withTimings("onDragEnd", function() {
            return $bb4628016638410a$var$execute(getResponders().onDragEnd, result, announce, $bb4628016638410a$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, $bb4628016638410a$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $bb4628016638410a$var$responders = function responders(getResponders, announce) {
    var publisher = $bb4628016638410a$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $bb4628016638410a$var$dropAnimationFinish = function dropAnimationFinish(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $bb4628016638410a$var$invariant(false);
            store.dispatch($bb4628016638410a$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $bb4628016638410a$var$dropAnimationFlushOnScroll = function dropAnimationFlushOnScroll(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($bb4628016638410a$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $bb4628016638410a$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $bb4628016638410a$var$dimensionMarshalStopper = function dimensionMarshalStopper(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $bb4628016638410a$var$focus = function focus(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $bb4628016638410a$var$shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $bb4628016638410a$var$autoScroll = function autoScroll(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($bb4628016638410a$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && $bb4628016638410a$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $bb4628016638410a$var$pendingDrop = function pendingDrop(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($bb4628016638410a$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $bb4628016638410a$var$composeEnhancers = (0, $8639cd7605f70408$export$f672e0b6f7222cd7);
var $bb4628016638410a$var$createStore = function createStore(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $8639cd7605f70408$export$f51a9068ac82ea43)($bb4628016638410a$var$reducer, $bb4628016638410a$var$composeEnhancers((0, $8639cd7605f70408$export$9ff26e0402cc7b7)($bb4628016638410a$var$style(styleMarshal), $bb4628016638410a$var$dimensionMarshalStopper(dimensionMarshal), $bb4628016638410a$var$lift$1(dimensionMarshal), $bb4628016638410a$var$drop$1, $bb4628016638410a$var$dropAnimationFinish, $bb4628016638410a$var$dropAnimationFlushOnScroll, $bb4628016638410a$var$pendingDrop, $bb4628016638410a$var$autoScroll(autoScroller), $bb4628016638410a$var$scrollListener, $bb4628016638410a$var$focus(focusMarshal), $bb4628016638410a$var$responders(getResponders, announce))));
};
var $bb4628016638410a$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $bb4628016638410a$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $bb4628016638410a$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $bb4628016638410a$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($bb4628016638410a$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $bb4628016638410a$var$clean$1();
            $bb4628016638410a$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $bb4628016638410a$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $bb4628016638410a$var$getMaxScroll = function getMaxScroll(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $bb4628016638410a$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $bb4628016638410a$var$getDocumentElement = function getDocumentElement() {
    var doc = document.documentElement;
    !doc && $bb4628016638410a$var$invariant(false);
    return doc;
};
var $bb4628016638410a$var$getMaxWindowScroll = function getMaxWindowScroll() {
    var doc = $bb4628016638410a$var$getDocumentElement();
    var maxScroll = $bb4628016638410a$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $bb4628016638410a$var$getViewport = function getViewport() {
    var scroll = $bb4628016638410a$var$getWindowScroll();
    var maxScroll = $bb4628016638410a$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $bb4628016638410a$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $bb4628016638410a$var$origin,
                displacement: $bb4628016638410a$var$origin
            }
        }
    };
    return viewport;
};
var $bb4628016638410a$var$getInitialPublish = function getInitialPublish(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $bb4628016638410a$var$start();
    var viewport = $bb4628016638410a$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $bb4628016638410a$var$toDraggableMap(draggables),
        droppables: $bb4628016638410a$var$toDroppableMap(droppables)
    };
    $bb4628016638410a$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $bb4628016638410a$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $bb4628016638410a$var$createDimensionMarshal = function createDimensionMarshal(registry, callbacks) {
    var collection = null;
    var publisher = $bb4628016638410a$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $bb4628016638410a$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $bb4628016638410a$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $bb4628016638410a$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $bb4628016638410a$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($bb4628016638410a$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($bb4628016638410a$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $bb4628016638410a$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $bb4628016638410a$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $bb4628016638410a$var$canStartDrag = function canStartDrag(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $bb4628016638410a$var$scrollWindow = function scrollWindow(change) {
    window.scrollBy(change.x, change.y);
};
var $bb4628016638410a$var$getScrollableDroppables = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(droppables) {
    return $bb4628016638410a$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $bb4628016638410a$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $bb4628016638410a$var$find($bb4628016638410a$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $bb4628016638410a$var$invariant(false);
        return $bb4628016638410a$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $bb4628016638410a$var$getBestScrollableDroppable = function getBestScrollableDroppable(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $bb4628016638410a$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $bb4628016638410a$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $bb4628016638410a$var$getDistanceThresholds = function getDistanceThresholds(container, axis) {
    var startScrollingFrom = container[axis.size] * $bb4628016638410a$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $bb4628016638410a$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $bb4628016638410a$var$getPercentage = function getPercentage(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $bb4628016638410a$var$minScroll = 1;
var $bb4628016638410a$var$getValueFromDistance = function getValueFromDistance(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $bb4628016638410a$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $bb4628016638410a$var$minScroll;
    var percentageFromMaxScrollValueAt = $bb4628016638410a$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $bb4628016638410a$var$config.maxPixelScroll * $bb4628016638410a$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $bb4628016638410a$var$accelerateAt = $bb4628016638410a$var$config.durationDampening.accelerateAt;
var $bb4628016638410a$var$stopAt = $bb4628016638410a$var$config.durationDampening.stopDampeningAt;
var $bb4628016638410a$var$dampenValueByTime = function dampenValueByTime(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $bb4628016638410a$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $bb4628016638410a$var$stopAt) return proposedScroll;
    if (runTime < $bb4628016638410a$var$accelerateAt) return $bb4628016638410a$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $bb4628016638410a$var$getPercentage({
        startOfRange: $bb4628016638410a$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $bb4628016638410a$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $bb4628016638410a$var$getValue = function getValue(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $bb4628016638410a$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($bb4628016638410a$var$dampenValueByTime(scroll, dragStartTime), $bb4628016638410a$var$minScroll);
};
var $bb4628016638410a$var$getScrollOnAxis = function getScrollOnAxis(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $bb4628016638410a$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $bb4628016638410a$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $bb4628016638410a$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $bb4628016638410a$var$adjustForSizeLimits = function adjustForSizeLimits(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $bb4628016638410a$var$clean$2 = $bb4628016638410a$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $bb4628016638410a$var$getScroll = function getScroll(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $bb4628016638410a$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $bb4628016638410a$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $bb4628016638410a$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $bb4628016638410a$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $bb4628016638410a$var$clean$2({
        x: x,
        y: y
    });
    if ($bb4628016638410a$var$isEqual(required, $bb4628016638410a$var$origin)) return null;
    var limited = $bb4628016638410a$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $bb4628016638410a$var$isEqual(limited, $bb4628016638410a$var$origin) ? null : limited;
};
var $bb4628016638410a$var$smallestSigned = $bb4628016638410a$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $bb4628016638410a$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $bb4628016638410a$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($bb4628016638410a$var$isEqual(overlap, $bb4628016638410a$var$origin)) return null;
        return overlap;
    };
}();
var $bb4628016638410a$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $bb4628016638410a$var$smallestSigned(change);
    var overlap = $bb4628016638410a$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $bb4628016638410a$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $bb4628016638410a$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $bb4628016638410a$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$bb4628016638410a$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $bb4628016638410a$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $bb4628016638410a$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $bb4628016638410a$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $bb4628016638410a$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$bb4628016638410a$var$canScrollDroppable(droppable, change)) return null;
    return $bb4628016638410a$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $bb4628016638410a$var$getWindowScrollChange = function getWindowScrollChange(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $bb4628016638410a$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $bb4628016638410a$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $bb4628016638410a$var$getDroppableScrollChange = function getDroppableScrollChange(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $bb4628016638410a$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $bb4628016638410a$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $bb4628016638410a$var$scroll$1 = function scroll$1(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $bb4628016638410a$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $bb4628016638410a$var$getBestScrollableDroppable({
        center: center,
        destination: $bb4628016638410a$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $bb4628016638410a$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $bb4628016638410a$var$createFluidScroller = function createFluidScroller(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $536157540d00934a$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $536157540d00934a$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $bb4628016638410a$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $bb4628016638410a$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $bb4628016638410a$var$start();
        !!dragging && $bb4628016638410a$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $bb4628016638410a$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $bb4628016638410a$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $bb4628016638410a$var$createJumpScroller = function createJumpScroller(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $bb4628016638410a$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$bb4628016638410a$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $bb4628016638410a$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $bb4628016638410a$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $bb4628016638410a$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$bb4628016638410a$var$canScrollWindow(viewport, change)) return change;
        var overlap = $bb4628016638410a$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $bb4628016638410a$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $bb4628016638410a$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $bb4628016638410a$var$whatIsDraggedOver(state.impact);
        !destination && $bb4628016638410a$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $bb4628016638410a$var$createAutoScroller = function createAutoScroller(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $bb4628016638410a$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $bb4628016638410a$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $bb4628016638410a$var$prefix$1 = "data-rbd";
var $bb4628016638410a$var$dragHandle = function() {
    var base = $bb4628016638410a$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $bb4628016638410a$var$draggable = function() {
    var base = $bb4628016638410a$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $bb4628016638410a$var$droppable = function() {
    var base = $bb4628016638410a$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $bb4628016638410a$var$scrollContainer = {
    contextId: $bb4628016638410a$var$prefix$1 + "-scroll-container-context-id"
};
var $bb4628016638410a$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var $bb4628016638410a$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var $bb4628016638410a$var$noPointerEvents = "pointer-events: none;";
var $bb4628016638410a$var$getStyles$1 = function getStyles$1(contextId) {
    var getSelector = $bb4628016638410a$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($bb4628016638410a$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $bb4628016638410a$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $bb4628016638410a$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($bb4628016638410a$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($bb4628016638410a$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $bb4628016638410a$var$getStyles(rules, "always"),
        resting: $bb4628016638410a$var$getStyles(rules, "resting"),
        dragging: $bb4628016638410a$var$getStyles(rules, "dragging"),
        dropAnimating: $bb4628016638410a$var$getStyles(rules, "dropAnimating"),
        userCancel: $bb4628016638410a$var$getStyles(rules, "userCancel")
    };
};
var $bb4628016638410a$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $dQFEZ.useLayoutEffect) : (0, $dQFEZ.useEffect);
var $bb4628016638410a$var$getHead = function getHead() {
    var head = document.querySelector("head");
    !head && $bb4628016638410a$var$invariant(false);
    return head;
};
var $bb4628016638410a$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $bb4628016638410a$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return $bb4628016638410a$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $dQFEZ.useRef)(null);
    var dynamicRef = (0, $dQFEZ.useRef)(null);
    var setDynamicStyle = (0, $881077b909fec5f5$export$35808ee640e87ca7)((0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $bb4628016638410a$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && $bb4628016638410a$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $bb4628016638410a$var$invariant(false);
        var always = $bb4628016638410a$var$createStyleEl(nonce);
        var dynamic = $bb4628016638410a$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($bb4628016638410a$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($bb4628016638410a$var$prefix$1 + "-dynamic", contextId);
        $bb4628016638410a$var$getHead().appendChild(always);
        $bb4628016638410a$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $bb4628016638410a$var$invariant(false);
                $bb4628016638410a$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $bb4628016638410a$var$getWindowFromEl = function getWindowFromEl(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $bb4628016638410a$var$isHtmlElement(el) {
    return el instanceof $bb4628016638410a$var$getWindowFromEl(el).HTMLElement;
}
function $bb4628016638410a$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $bb4628016638410a$var$dragHandle.contextId + '="' + contextId + '"]';
    var possible = $bb4628016638410a$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $bb4628016638410a$var$find(possible, function(el) {
        return el.getAttribute($bb4628016638410a$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$bb4628016638410a$var$isHtmlElement(handle)) return null;
    return handle;
}
function $bb4628016638410a$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $dQFEZ.useRef)({});
    var recordRef = (0, $dQFEZ.useRef)(null);
    var restoreFocusFrameRef = (0, $dQFEZ.useRef)(null);
    var isMountedRef = (0, $dQFEZ.useRef)(false);
    var register = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $bb4628016638410a$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($bb4628016638410a$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $bb4628016638410a$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $bb4628016638410a$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $bb4628016638410a$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $bb4628016638410a$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $bb4628016638410a$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $bb4628016638410a$var$useRegistry() {
    var registry = (0, $881077b909fec5f5$export$1538c33de8887b59)($bb4628016638410a$var$createRegistry, []);
    (0, $dQFEZ.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $bb4628016638410a$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createContext(null);
var $bb4628016638410a$var$getBodyElement = function getBodyElement() {
    var body = document.body;
    !body && $bb4628016638410a$var$invariant(false);
    return body;
};
var $bb4628016638410a$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $bb4628016638410a$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $bb4628016638410a$var$useAnnouncer(contextId) {
    var id = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return $bb4628016638410a$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $dQFEZ.useRef)(null);
    (0, $dQFEZ.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)(el.style, $bb4628016638410a$var$visuallyHidden);
        $bb4628016638410a$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $bb4628016638410a$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $bb4628016638410a$var$count = 0;
var $bb4628016638410a$var$defaults = {
    separator: "::"
};
function $bb4628016638410a$var$reset() {
    $bb4628016638410a$var$count = 0;
}
function $bb4628016638410a$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $bb4628016638410a$var$defaults;
    return (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return "" + prefix + options.separator + $bb4628016638410a$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $bb4628016638410a$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $bb4628016638410a$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $bb4628016638410a$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    var id = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return $bb4628016638410a$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $dQFEZ.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $bb4628016638410a$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $bb4628016638410a$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $bb4628016638410a$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createContext(null);
var $bb4628016638410a$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var $bb4628016638410a$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $bb4628016638410a$var$getVersion = function getVersion(value) {
    var result = $bb4628016638410a$var$semver.exec(value);
    !(result != null) && $bb4628016638410a$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $bb4628016638410a$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $bb4628016638410a$var$checkReactVersion = function checkReactVersion(peerDepValue, actualValue) {
    var peerDep = $bb4628016638410a$var$getVersion(peerDepValue);
    var actual = $bb4628016638410a$var$getVersion(actualValue);
    if ($bb4628016638410a$var$isSatisfied(peerDep, actual)) return;
};
var $bb4628016638410a$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $bb4628016638410a$var$checkDoctype = function checkDoctype(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $bb4628016638410a$var$useDev(useHook) {}
function $bb4628016638410a$var$useDevSetupWarning(fn, inputs) {
    $bb4628016638410a$var$useDev(function() {
        (0, $dQFEZ.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $bb4628016638410a$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $bb4628016638410a$var$useStartupValidation() {
    $bb4628016638410a$var$useDevSetupWarning(function() {
        $bb4628016638410a$var$checkReactVersion($bb4628016638410a$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).version);
        $bb4628016638410a$var$checkDoctype(document);
    }, []);
}
function $bb4628016638410a$var$usePrevious(current) {
    var ref = (0, $dQFEZ.useRef)(current);
    (0, $dQFEZ.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $bb4628016638410a$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $bb4628016638410a$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $bb4628016638410a$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $bb4628016638410a$var$tab = 9;
var $bb4628016638410a$var$enter = 13;
var $bb4628016638410a$var$escape = 27;
var $bb4628016638410a$var$space = 32;
var $bb4628016638410a$var$pageUp = 33;
var $bb4628016638410a$var$pageDown = 34;
var $bb4628016638410a$var$end = 35;
var $bb4628016638410a$var$home = 36;
var $bb4628016638410a$var$arrowLeft = 37;
var $bb4628016638410a$var$arrowUp = 38;
var $bb4628016638410a$var$arrowRight = 39;
var $bb4628016638410a$var$arrowDown = 40;
var $bb4628016638410a$var$_preventedKeys;
var $bb4628016638410a$var$preventedKeys = ($bb4628016638410a$var$_preventedKeys = {}, $bb4628016638410a$var$_preventedKeys[$bb4628016638410a$var$enter] = true, $bb4628016638410a$var$_preventedKeys[$bb4628016638410a$var$tab] = true, $bb4628016638410a$var$_preventedKeys);
var $bb4628016638410a$var$preventStandardKeyEvents = function preventStandardKeyEvents(event) {
    if ($bb4628016638410a$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $bb4628016638410a$var$supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $bb4628016638410a$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $bb4628016638410a$var$primaryButton = 0;
var $bb4628016638410a$var$sloppyClickThreshold = 5;
function $bb4628016638410a$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $bb4628016638410a$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $bb4628016638410a$var$sloppyClickThreshold;
}
var $bb4628016638410a$var$idle$1 = {
    type: "IDLE"
};
function $bb4628016638410a$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $bb4628016638410a$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $bb4628016638410a$var$invariant(false);
                var pending = phase.point;
                if (!$bb4628016638410a$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $bb4628016638410a$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $bb4628016638410a$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $bb4628016638410a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb4628016638410a$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $dQFEZ.useRef)($bb4628016638410a$var$idle$1);
    var unbindEventsRef = (0, $dQFEZ.useRef)($bb4628016638410a$var$noop);
    var startCaptureBinding = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $bb4628016638410a$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $bb4628016638410a$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $bb4628016638410a$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $bb4628016638410a$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $bb4628016638410a$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $bb4628016638410a$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $bb4628016638410a$var$_scrollJumpKeys;
function $bb4628016638410a$var$noop$1() {}
var $bb4628016638410a$var$scrollJumpKeys = ($bb4628016638410a$var$_scrollJumpKeys = {}, $bb4628016638410a$var$_scrollJumpKeys[$bb4628016638410a$var$pageDown] = true, $bb4628016638410a$var$_scrollJumpKeys[$bb4628016638410a$var$pageUp] = true, $bb4628016638410a$var$_scrollJumpKeys[$bb4628016638410a$var$home] = true, $bb4628016638410a$var$_scrollJumpKeys[$bb4628016638410a$var$end] = true, $bb4628016638410a$var$_scrollJumpKeys);
function $bb4628016638410a$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === $bb4628016638410a$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($bb4628016638410a$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $bb4628016638410a$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $bb4628016638410a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb4628016638410a$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $dQFEZ.useRef)($bb4628016638410a$var$noop$1);
    var startCaptureBinding = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $bb4628016638410a$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $bb4628016638410a$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $bb4628016638410a$var$bindEvents(window, $bb4628016638410a$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $bb4628016638410a$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $bb4628016638410a$var$idle$2 = {
    type: "IDLE"
};
var $bb4628016638410a$var$timeForLongPress = 120;
var $bb4628016638410a$var$forcePressThreshold = 0.15;
function $bb4628016638410a$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $bb4628016638410a$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $bb4628016638410a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb4628016638410a$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $bb4628016638410a$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $bb4628016638410a$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $bb4628016638410a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb4628016638410a$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $dQFEZ.useRef)($bb4628016638410a$var$idle$2);
    var unbindEventsRef = (0, $dQFEZ.useRef)($bb4628016638410a$var$noop);
    var getPhase = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $bb4628016638410a$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($bb4628016638410a$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $bb4628016638410a$var$bindEvents(window, $bb4628016638410a$var$getHandleBindings(args), options);
        var unbindWindow = $bb4628016638410a$var$bindEvents(window, $bb4628016638410a$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && $bb4628016638410a$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $bb4628016638410a$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $bb4628016638410a$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($bb4628016638410a$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $bb4628016638410a$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $bb4628016638410a$var$useValidateSensorHooks(sensorHooks) {
    $bb4628016638410a$var$useDev(function() {
        var previousRef = $bb4628016638410a$var$usePrevious(sensorHooks);
        $bb4628016638410a$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $bb4628016638410a$var$invariant(false);
        });
    });
}
var $bb4628016638410a$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $bb4628016638410a$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($bb4628016638410a$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $bb4628016638410a$var$isAnInteractiveElement(parent, current.parentElement);
}
function $bb4628016638410a$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$bb4628016638410a$var$isHtmlElement(target)) return false;
    return $bb4628016638410a$var$isAnInteractiveElement(draggable, target);
}
var $bb4628016638410a$var$getBorderBoxCenterPosition = function getBorderBoxCenterPosition(el) {
    return (0, $08af6d26d62dfe67$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $bb4628016638410a$var$isElement(el) {
    return el instanceof $bb4628016638410a$var$getWindowFromEl(el).Element;
}
var $bb4628016638410a$var$supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = $bb4628016638410a$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $bb4628016638410a$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$bb4628016638410a$var$supportedMatchesName](selector)) return el;
    return $bb4628016638410a$var$closestPonyfill(el.parentElement, selector);
}
function $bb4628016638410a$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $bb4628016638410a$var$closestPonyfill(el, selector);
}
function $bb4628016638410a$var$getSelector(contextId) {
    return "[" + $bb4628016638410a$var$dragHandle.contextId + '="' + contextId + '"]';
}
function $bb4628016638410a$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$bb4628016638410a$var$isElement(target)) return null;
    var selector = $bb4628016638410a$var$getSelector(contextId);
    var handle = $bb4628016638410a$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$bb4628016638410a$var$isHtmlElement(handle)) return null;
    return handle;
}
function $bb4628016638410a$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $bb4628016638410a$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($bb4628016638410a$var$dragHandle.draggableId);
}
function $bb4628016638410a$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $bb4628016638410a$var$draggable.contextId + '="' + contextId + '"]';
    var possible = $bb4628016638410a$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $bb4628016638410a$var$find(possible, function(el) {
        return el.getAttribute($bb4628016638410a$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$bb4628016638410a$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $bb4628016638410a$var$preventDefault(event) {
    event.preventDefault();
}
function $bb4628016638410a$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $bb4628016638410a$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$bb4628016638410a$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $bb4628016638410a$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $bb4628016638410a$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $bb4628016638410a$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $bb4628016638410a$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $bb4628016638410a$var$noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($bb4628016638410a$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && $bb4628016638410a$var$invariant(false);
        }
        store.dispatch($bb4628016638410a$var$lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $bb4628016638410a$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $bb4628016638410a$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($bb4628016638410a$var$drop({
                reason: reason
            }));
        }
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
            isActive: function isActive() {
                return $bb4628016638410a$var$_isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $536157540d00934a$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $bb4628016638410a$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($bb4628016638410a$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($bb4628016638410a$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($bb4628016638410a$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($bb4628016638410a$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $bb4628016638410a$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $bb4628016638410a$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $bb4628016638410a$var$_isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $bb4628016638410a$var$_isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $bb4628016638410a$var$defaultSensors = [
    $bb4628016638410a$export$2f59cd992b42195a,
    $bb4628016638410a$export$42b74264faad0714,
    $bb4628016638410a$export$ac235fd3a7bcf7b4
];
function $bb4628016638410a$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $bb4628016638410a$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $dQFEZ.useState)(function() {
        return $bb4628016638410a$var$create();
    })[0];
    var tryAbandonLock = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(draggableId) {
        return $bb4628016638410a$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(draggableId, forceStop, options) {
        return $bb4628016638410a$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(event) {
        return $bb4628016638410a$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($bb4628016638410a$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $881077b909fec5f5$export$35808ee640e87ca7)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $bb4628016638410a$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $bb4628016638410a$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $bb4628016638410a$var$getStore(lazyRef) {
    !lazyRef.current && $bb4628016638410a$var$invariant(false);
    return lazyRef.current;
}
function $bb4628016638410a$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $dQFEZ.useRef)(null);
    $bb4628016638410a$var$useStartupValidation();
    var lastPropsRef = $bb4628016638410a$var$usePrevious(props);
    var getResponders = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        return $bb4628016638410a$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $bb4628016638410a$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $bb4628016638410a$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $bb4628016638410a$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(action) {
        $bb4628016638410a$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return (0, $8639cd7605f70408$export$aea084d96e84da92)({
            publishWhileDragging: $bb4628016638410a$var$publishWhileDragging,
            updateDroppableScroll: $bb4628016638410a$var$updateDroppableScroll,
            updateDroppableIsEnabled: $bb4628016638410a$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $bb4628016638410a$var$updateDroppableIsCombineEnabled,
            collectionStarting: $bb4628016638410a$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $bb4628016638410a$var$useRegistry();
    var dimensionMarshal = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return $bb4628016638410a$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return $bb4628016638410a$var$createAutoScroller((0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({
            scrollWindow: $bb4628016638410a$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $8639cd7605f70408$export$aea084d96e84da92)({
            move: $bb4628016638410a$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $bb4628016638410a$var$useFocusMarshal(contextId);
    var store = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return $bb4628016638410a$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var current = $bb4628016638410a$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($bb4628016638410a$var$flush());
    }, []);
    var isDragging = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var state = $bb4628016638410a$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(id) {
        return $bb4628016638410a$var$canStartDrag($bb4628016638410a$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        return $bb4628016638410a$var$isMovementAllowed($bb4628016638410a$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $bb4628016638410a$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $dQFEZ.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement((0, $841456b156e5436a$export$2e2bcd8739ae039), {
        context: $bb4628016638410a$var$StoreContext,
        store: store
    }, props.children));
}
var $bb4628016638410a$var$count$1 = 0;
function $bb4628016638410a$var$reset$1() {
    $bb4628016638410a$var$count$1 = 0;
}
function $bb4628016638410a$var$useInstanceCount() {
    return (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return "" + $bb4628016638410a$var$count$1++;
    }, []);
}
function $bb4628016638410a$export$2bfe52350fc0150d() {
    $bb4628016638410a$var$reset$1();
    $bb4628016638410a$var$reset();
}
function $bb4628016638410a$export$237bd83162c14364(props) {
    var contextId = $bb4628016638410a$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $bb4628016638410a$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $bb4628016638410a$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $bb4628016638410a$var$isScroll = $bb4628016638410a$var$isEqual$1("scroll");
var $bb4628016638410a$var$isAuto = $bb4628016638410a$var$isEqual$1("auto");
var $bb4628016638410a$var$isVisible$1 = $bb4628016638410a$var$isEqual$1("visible");
var $bb4628016638410a$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $bb4628016638410a$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $bb4628016638410a$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $bb4628016638410a$var$isEither(overflow, $bb4628016638410a$var$isScroll) || $bb4628016638410a$var$isEither(overflow, $bb4628016638410a$var$isAuto);
};
var $bb4628016638410a$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $bb4628016638410a$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $bb4628016638410a$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$bb4628016638410a$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $bb4628016638410a$var$checkForNestedScrollContainers = function checkForNestedScrollContainers(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $bb4628016638410a$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $bb4628016638410a$var$getScroll$1 = function getScroll$1(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $bb4628016638410a$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var $bb4628016638410a$var$getEnv = function getEnv(start) {
    var closestScrollable = $bb4628016638410a$var$getClosestScrollable(start);
    var isFixedOnPage = $bb4628016638410a$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $bb4628016638410a$var$getDroppableDimension = function getDroppableDimension(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $bb4628016638410a$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $bb4628016638410a$var$origin,
                    displacement: $bb4628016638410a$var$origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? $bb4628016638410a$var$vertical : $bb4628016638410a$var$horizontal;
    var subject = $bb4628016638410a$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $bb4628016638410a$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $08af6d26d62dfe67$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $08af6d26d62dfe67$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $08af6d26d62dfe67$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $bb4628016638410a$var$getDimension = function getDimension(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $bb4628016638410a$var$getClient(ref, closestScrollable);
    var page = (0, $08af6d26d62dfe67$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $08af6d26d62dfe67$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $08af6d26d62dfe67$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $bb4628016638410a$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $bb4628016638410a$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $bb4628016638410a$var$immediate = {
    passive: false
};
var $bb4628016638410a$var$delayed = {
    passive: true
};
var $bb4628016638410a$var$getListenerOptions = function getListenerOptions(options) {
    return options.shouldPublishImmediately ? $bb4628016638410a$var$immediate : $bb4628016638410a$var$delayed;
};
function $bb4628016638410a$var$useRequiredContext(Context) {
    var result = (0, $dQFEZ.useContext)(Context);
    !result && $bb4628016638410a$var$invariant(false);
    return result;
}
var $bb4628016638410a$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $bb4628016638410a$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $dQFEZ.useRef)(null);
    var appContext = $bb4628016638410a$var$useRequiredContext($bb4628016638410a$var$AppContext);
    var uniqueId = $bb4628016638410a$var$useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $bb4628016638410a$var$usePrevious(args);
    var descriptor = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $dQFEZ.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $bb4628016638410a$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $bb4628016638410a$var$origin;
        return $bb4628016638410a$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return (0, $536157540d00934a$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $bb4628016638410a$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $bb4628016638410a$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && $bb4628016638410a$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $bb4628016638410a$var$invariant(false);
        var env = $bb4628016638410a$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $bb4628016638410a$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($bb4628016638410a$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $bb4628016638410a$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $bb4628016638410a$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $bb4628016638410a$var$invariant(false);
        return $bb4628016638410a$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $bb4628016638410a$var$invariant(false);
        var closest = $bb4628016638410a$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($bb4628016638410a$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $bb4628016638410a$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $bb4628016638410a$var$invariant(false);
        var closest = $bb4628016638410a$var$getClosestScrollableFromDrag(dragging);
        !closest && $bb4628016638410a$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $bb4628016638410a$var$noop$2() {}
var $bb4628016638410a$var$empty = {
    width: 0,
    height: 0,
    margin: $bb4628016638410a$var$noSpacing
};
var $bb4628016638410a$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $bb4628016638410a$var$empty;
    if (animate === "close") return $bb4628016638410a$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $bb4628016638410a$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $bb4628016638410a$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $bb4628016638410a$var$transitions.placeholder : null
    };
};
function $bb4628016638410a$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $dQFEZ.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $dQFEZ.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $bb4628016638410a$var$noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $bb4628016638410a$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $bb4628016638410a$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $bb4628016638410a$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $bb4628016638410a$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).memo($bb4628016638410a$var$Placeholder);
var $bb4628016638410a$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createContext(null);
function $bb4628016638410a$var$checkIsValidInnerRef(el) {
    !(el && $bb4628016638410a$var$isHtmlElement(el)) && $bb4628016638410a$var$invariant(false);
}
function $bb4628016638410a$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $bb4628016638410a$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $bb4628016638410a$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $bb4628016638410a$var$invariant(false);
        !(typeof props.droppableId === "string") && $bb4628016638410a$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$bb4628016638410a$var$isBoolean(props.isDropDisabled) && $bb4628016638410a$var$invariant(false);
        !$bb4628016638410a$var$isBoolean(props.isCombineEnabled) && $bb4628016638410a$var$invariant(false);
        !$bb4628016638410a$var$isBoolean(props.ignoreContainerClipping) && $bb4628016638410a$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $bb4628016638410a$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $bb4628016638410a$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $bb4628016638410a$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $bb4628016638410a$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $bb4628016638410a$var$invariant(false);
    }
];
function $bb4628016638410a$var$useValidation(args) {
    $bb4628016638410a$var$useDevSetupWarning(function() {
        $bb4628016638410a$var$runChecks(args, $bb4628016638410a$var$shared);
        if (args.props.mode === "standard") $bb4628016638410a$var$runChecks(args, $bb4628016638410a$var$standard);
        if (args.props.mode === "virtual") $bb4628016638410a$var$runChecks(args, $bb4628016638410a$var$virtual);
    });
}
var $bb4628016638410a$var$AnimateInOut = function(_React$PureComponent) {
    (0, $740fba40598542d2$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).PureComponent);
var $bb4628016638410a$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $bb4628016638410a$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $bb4628016638410a$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $bb4628016638410a$var$transitions.snap;
    return $bb4628016638410a$var$transitions.fluid;
};
var $bb4628016638410a$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $bb4628016638410a$var$combine.opacity.drop : $bb4628016638410a$var$combine.opacity.combining;
};
var $bb4628016638410a$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $bb4628016638410a$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $bb4628016638410a$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $bb4628016638410a$var$transforms.drop(offset, isCombining) : $bb4628016638410a$var$transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $bb4628016638410a$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $bb4628016638410a$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $bb4628016638410a$var$zIndexOptions.dropAnimating : $bb4628016638410a$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $bb4628016638410a$var$getSecondaryStyle(secondary) {
    return {
        transform: $bb4628016638410a$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function $bb4628016638410a$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $bb4628016638410a$var$getDraggingStyle(mapped) : $bb4628016638410a$var$getSecondaryStyle(mapped);
}
function $bb4628016638410a$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $bb4628016638410a$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $08af6d26d62dfe67$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $08af6d26d62dfe67$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $bb4628016638410a$var$useDraggablePublisher(args) {
    var uniqueId = $bb4628016638410a$var$useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $bb4628016638410a$var$invariant(false);
        return $bb4628016638410a$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $dQFEZ.useRef)(entry);
    var isFirstPublishRef = (0, $dQFEZ.useRef)(true);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $bb4628016638410a$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $bb4628016638410a$var$useValidation$1(props, contextId, getRef) {
    $bb4628016638410a$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $bb4628016638410a$var$invariant(false);
        !(typeof id === "string") && $bb4628016638410a$var$invariant(false);
        !$bb4628016638410a$var$isInteger(props.index) && $bb4628016638410a$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $bb4628016638410a$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$bb4628016638410a$var$findDragHandle(contextId, id) && $bb4628016638410a$var$invariant(false);
    });
}
function $bb4628016638410a$var$useClonePropValidation(isClone) {
    $bb4628016638410a$var$useDev(function() {
        var initialRef = (0, $dQFEZ.useRef)(isClone);
        $bb4628016638410a$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $bb4628016638410a$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $bb4628016638410a$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $bb4628016638410a$var$Draggable(props) {
    var ref = (0, $dQFEZ.useRef)(null);
    var setRef = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $bb4628016638410a$var$useRequiredContext($bb4628016638410a$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $bb4628016638410a$var$useRequiredContext($bb4628016638410a$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $bb4628016638410a$var$useValidation$1(props, contextId, getRef);
    $bb4628016638410a$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $bb4628016638410a$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $bb4628016638410a$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        var style = $bb4628016638410a$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $bb4628016638410a$var$isStrictEqual = function isStrictEqual(a, b) {
    return a === b;
};
var $bb4628016638410a$var$whatIsDraggedOverFromResult = function whatIsDraggedOverFromResult(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $bb4628016638410a$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $bb4628016638410a$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $bb4628016638410a$var$getDraggableSelector() {
    var memoizedOffset = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $bb4628016638410a$var$whatIsDraggedOver(state.impact);
            var combineWith = $bb4628016638410a$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $bb4628016638410a$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $bb4628016638410a$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $bb4628016638410a$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $bb4628016638410a$var$combine.opacity.drop : null,
                scale: _combineWith ? $bb4628016638410a$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $bb4628016638410a$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $bb4628016638410a$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $bb4628016638410a$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $bb4628016638410a$var$getSecondarySnapshot(null)
    }
};
function $bb4628016638410a$var$getSecondarySelector() {
    var memoizedOffset = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)($bb4628016638410a$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($bb4628016638410a$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $bb4628016638410a$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $bb4628016638410a$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $bb4628016638410a$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $bb4628016638410a$var$getDraggableSelector();
    var secondarySelector = $bb4628016638410a$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $bb4628016638410a$var$atRest;
    };
    return selector;
};
var $bb4628016638410a$var$mapDispatchToProps = {
    dropAnimationFinished: $bb4628016638410a$var$dropAnimationFinished
};
var $bb4628016638410a$var$ConnectedDraggable = (0, $826a110f13d0cc83$export$2e2bcd8739ae039)($bb4628016638410a$var$makeMapStateToProps, $bb4628016638410a$var$mapDispatchToProps, null, {
    context: $bb4628016638410a$var$StoreContext,
    pure: true,
    areStatePropsEqual: $bb4628016638410a$var$isStrictEqual
})($bb4628016638410a$var$Draggable);
function $bb4628016638410a$var$PrivateDraggable(props) {
    var droppableContext = $bb4628016638410a$var$useRequiredContext($bb4628016638410a$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$ConnectedDraggable, props);
}
function $bb4628016638410a$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$PrivateDraggable, (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $bb4628016638410a$var$Droppable(props) {
    var appContext = (0, $dQFEZ.useContext)($bb4628016638410a$var$AppContext);
    !appContext && $bb4628016638410a$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $dQFEZ.useRef)(null);
    var placeholderRef = (0, $dQFEZ.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    $bb4628016638410a$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $881077b909fec5f5$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $bb4628016638410a$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $bb4628016638410a$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $881077b909fec5f5$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4288f0eb191085d1$exports))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).createElement($bb4628016638410a$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $bb4628016638410a$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $bb4628016638410a$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $bb4628016638410a$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $74f7f17f39e9b1de$export$2e2bcd8739ae039)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $dc9500fecbfb8ad0$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$bb4628016638410a$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $bb4628016638410a$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $bb4628016638410a$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!$bb4628016638410a$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $bb4628016638410a$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $bb4628016638410a$var$whatIsDraggedOverFromResult(completed.result) === id, $bb4628016638410a$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$bb4628016638410a$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $bb4628016638410a$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $bb4628016638410a$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $bb4628016638410a$var$updateViewportMaxScroll
};
function $bb4628016638410a$var$getBody() {
    !document.body && $bb4628016638410a$var$invariant(false);
    return document.body;
}
var $bb4628016638410a$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $bb4628016638410a$var$getBody
};
var $bb4628016638410a$export$423ec2075359570a = (0, $826a110f13d0cc83$export$2e2bcd8739ae039)($bb4628016638410a$var$makeMapStateToProps$1, $bb4628016638410a$var$mapDispatchToProps$1, null, {
    context: $bb4628016638410a$var$StoreContext,
    pure: true,
    areStatePropsEqual: $bb4628016638410a$var$isStrictEqual
})($bb4628016638410a$var$Droppable);
$bb4628016638410a$export$423ec2075359570a.defaultProps = $bb4628016638410a$var$defaultProps;



var $36a7ae66d49c26bf$var$ContentBlock = function() {
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var handleDragEnd = function(result) {
        if (!result.destination) return;
        var reorderedBlocks = Array.from(editedBlog.contentBlocks);
        var _reorderedBlocks_splice = (0, $2nwvT._)(reorderedBlocks.splice(result.source.index, 1), 1), movedBlock = _reorderedBlocks_splice[0];
        reorderedBlocks.splice(result.destination.index, 0, movedBlock);
        dispatch((0, $0588dc3366c5632f$export$3c22e49343768f0d)(reorderedBlocks));
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $bb4628016638410a$export$237bd83162c14364), {
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $bb4628016638410a$export$423ec2075359570a), {
            droppableId: "contentBlocks",
            children: function(provided) {
                var _editedBlog_contentBlocks;
                return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, provided.droppableProps), {
                    ref: provided.innerRef,
                    children: [
                        editedBlog === null || editedBlog === void 0 ? void 0 : (_editedBlog_contentBlocks = editedBlog.contentBlocks) === null || _editedBlog_contentBlocks === void 0 ? void 0 : _editedBlog_contentBlocks.map(function(contentBlock, index) {
                            return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $bb4628016638410a$export$f2a139e5d18b9882), {
                                draggableId: contentBlock._id,
                                index: index,
                                children: function(provided) {
                                    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                                        ref: provided.innerRef
                                    }, provided.draggableProps, provided.dragHandleProps), {
                                        className: "mx-auto px-4 w-full dark:bg-[#2222222d] rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                                        children: (contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.type) === "text" ? /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $ac006809569fdca9$export$2e2bcd8739ae039), {
                                            contentBlock: contentBlock
                                        }) : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $a8de80691e7c152c$export$2e2bcd8739ae039), {
                                            contentBlock: contentBlock
                                        })
                                    }));
                                }
                            }, contentBlock._id);
                        }),
                        provided.placeholder
                    ]
                }));
            }
        })
    });
};
var $36a7ae66d49c26bf$export$2e2bcd8739ae039 = $36a7ae66d49c26bf$var$ContentBlock;



var $dQFEZ = parcelRequire("dQFEZ");









var $grujF = parcelRequire("grujF");

var $j6Mzi = parcelRequire("j6Mzi");

var $1EZOw = parcelRequire("1EZOw");

var $lngen = parcelRequire("lngen");
var $94ba88a157f9f26e$export$b9721ef022f71a68 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $j6Mzi._)(InvalidTokenError, Error1);
    var _super = (0, $lngen._)(InvalidTokenError);
    function InvalidTokenError() {
        (0, $grujF._)(this, InvalidTokenError);
        return _super.apply(this, arguments);
    }
    return InvalidTokenError;
}((0, $1EZOw._)(Error));
$94ba88a157f9f26e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $94ba88a157f9f26e$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $94ba88a157f9f26e$var$base64UrlDecode(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $94ba88a157f9f26e$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $94ba88a157f9f26e$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $94ba88a157f9f26e$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    var pos = options.header === true ? 0 : 1;
    var part = token.split(".")[pos];
    if (typeof part !== "string") throw new $94ba88a157f9f26e$export$b9721ef022f71a68("Invalid token specified: missing part #".concat(pos + 1));
    var decoded;
    try {
        decoded = $94ba88a157f9f26e$var$base64UrlDecode(part);
    } catch (e) {
        throw new $94ba88a157f9f26e$export$b9721ef022f71a68("Invalid token specified: invalid base64 for part #".concat(pos + 1, " (").concat(e.message, ")"));
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $94ba88a157f9f26e$export$b9721ef022f71a68("Invalid token specified: invalid json for part #".concat(pos + 1, " (").concat(e.message, ")"));
    }
}


var $ec58e7758362a5e1$export$84773cc9bf7dbe87 = function() {
    return localStorage.getItem("accessToken");
};
var $ec58e7758362a5e1$export$9bfe7023cfca0786 = function(token) {
    return localStorage.setItem("accessToken", token);
};
var $ec58e7758362a5e1$export$6f7d274070c97d7 = function() {
    return localStorage.removeItem("accessToken");
};
var $ec58e7758362a5e1$export$1c3df4d50873ab4b = function() {
    return document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*=\s*([^;]*).*$)|^.*$/, "$1");
};
var $ec58e7758362a5e1$export$b007d77a962aa175 = function(token) {
    if (!token) return true;
    var exp = (0, $94ba88a157f9f26e$export$fa1e2fb699b7861e)(token).exp;
    return Date.now() >= exp * 1000;
};








var $74dd6d6eb2c28884$var$customFetch = function() {
    var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(url) {
        var options, token;
        var _arguments = arguments;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    token = (0, $ec58e7758362a5e1$export$84773cc9bf7dbe87)();
                    if ((0, $ec58e7758362a5e1$export$b007d77a962aa175)(token)) {
                        token = (0, $dd6590e9b3c4f775$export$f8f36faf9a051362)();
                        if (!token) {
                            window.location.href = "/login";
                            return [
                                2
                            ];
                        }
                    }
                    options.headers = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, options.headers), {
                        Authorization: "Bearer ".concat(token),
                        "Content-Type": "application/json"
                    });
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function customFetch(url) {
        return _ref.apply(this, arguments);
    };
}();
var $74dd6d6eb2c28884$export$2e2bcd8739ae039 = $74dd6d6eb2c28884$var$customFetch;


var $dd6590e9b3c4f775$export$f8f36faf9a051362 = function() {
    var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
        var response, data;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch((0, $3849adb4905070fc$export$2a2261c5a58ac0), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            credentials: "include"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    (0, $ec58e7758362a5e1$export$9bfe7023cfca0786)(data.accessToken);
                    return [
                        2,
                        data.accessToken
                    ];
                case 3:
                    (0, $ec58e7758362a5e1$export$6f7d274070c97d7)();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function refreshAccessToken() {
        return _ref.apply(this, arguments);
    };
}();
var $dd6590e9b3c4f775$var$createBlog = function() {
    var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(editedBlog, publish) {
        var response;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $74dd6d6eb2c28884$export$2e2bcd8739ae039)((0, $3849adb4905070fc$export$33946c87f7d00129), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, editedBlog), {
                                published: publish
                            }))
                        })
                    ];
                case 1:
                    response = _state.sent();
                    console.log("API create response", response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function createBlog(editedBlog, publish) {
        return _ref.apply(this, arguments);
    };
}();
var $dd6590e9b3c4f775$var$updateBlog = function() {
    var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(editedBlog, publish) {
        var response;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $74dd6d6eb2c28884$export$2e2bcd8739ae039)("".concat((0, $3849adb4905070fc$export$33946c87f7d00129), "/").concat(editedBlog._id), {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, editedBlog), {
                                published: publish
                            }))
                        })
                    ];
                case 1:
                    response = _state.sent();
                    console.log("API update response", response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function updateBlog(editedBlog, publish) {
        return _ref.apply(this, arguments);
    };
}();
var $dd6590e9b3c4f775$export$fb5500896bf9f887 = function() {
    var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(param) {
        var editedBlog, publish;
        return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    editedBlog = param.editedBlog, publish = param.publish;
                    console.log(JSON.stringify((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, editedBlog), {
                        published: publish
                    })));
                    if (!!editedBlog._id) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $dd6590e9b3c4f775$var$createBlog(editedBlog, publish)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        4,
                        $dd6590e9b3c4f775$var$updateBlog(editedBlog, publish)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function saveBlog(_) {
        return _ref.apply(this, arguments);
    };
}();


var $b3481cf29e31c47a$var$BlogContent = function() {
    var darkMode = (0, $dQFEZ.useContext)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039)).darkMode;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)("text"), 2), blockType = _useState[0], setBlockType = _useState[1];
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    var id = (0, $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef)().id;
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var handleSaveBlog = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function(publish) {
            var response, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $dd6590e9b3c4f775$export$fb5500896bf9f887)({
                                editedBlog: editedBlog,
                                publish: publish
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        alert("Error saving blog");
                        return [
                            2
                        ];
                    case 2:
                        alert("Blog saved successfully");
                        if (!!id) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        navigate("/blog/edit/".concat(data._id), {
                            replace: true
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSaveBlog(publish) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $36a7ae66d49c26bf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex my-5",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("select", {
                        onChange: function(e) {
                            return setBlockType(e.target.value);
                        },
                        className: "border-2 mr-3 border-gray-300 p-2 w-32 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("option", {
                                value: "text",
                                children: "Text"
                            }),
                            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("option", {
                                value: "image",
                                children: "Image"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("i", {
                        onClick: function() {
                            return dispatch((0, $0588dc3366c5632f$export$af077dbfc4682e93)({
                                type: blockType,
                                content: ""
                            }));
                        },
                        className: "fas fa-plus-circle fa-2x cursor-pointer",
                        style: {
                            color: darkMode ? "green" : "green"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "mt-6 flex space-x-4",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                        onClick: function() {
                            return handleSaveBlog(false);
                        },
                        className: "flex-1 bg-gray-800 text-white py-3 rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                        children: "Save Draft"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                        onClick: function() {
                            return handleSaveBlog(true);
                        },
                        className: "flex-1 bg-gray-800 text-white py-3 rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                        children: "Publish"
                    })
                ]
            })
        ]
    });
};
var $b3481cf29e31c47a$export$2e2bcd8739ae039 = $b3481cf29e31c47a$var$BlogContent;





var $9517e04b1e91fd09$var$PreviewImageEditor = function() {
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Preview Image"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                type: "text",
                value: editedBlog === null || editedBlog === void 0 ? void 0 : editedBlog.image,
                onChange: function(e) {
                    return dispatch((0, $0588dc3366c5632f$export$afbaf9de62621d7b)(e.target.value));
                },
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter the image url"
            })
        ]
    });
};
var $9517e04b1e91fd09$export$2e2bcd8739ae039 = $9517e04b1e91fd09$var$PreviewImageEditor;






var $7adf1ed41712770d$var$KeywordsEditor = function() {
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("label", {
                className: "block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2",
                children: "Keywords"
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                type: "text",
                value: editedBlog === null || editedBlog === void 0 ? void 0 : editedBlog.keywords,
                onChange: function(e) {
                    return dispatch((0, $0588dc3366c5632f$export$9c6f66d1d405561d)(e.target.value));
                },
                className: "border-2 border-gray-300 dark:border-gray-700 p-2 w-full rounded-lg focus:outline-none focus:border-blue-500",
                placeholder: "Enter comma-separated keywords"
            })
        ]
    });
};
var $7adf1ed41712770d$export$2e2bcd8739ae039 = $7adf1ed41712770d$var$KeywordsEditor;


var $90f9e4dc55f58a4b$var$BlogEditHome = function() {
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var titleAndId = (0, $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef)().titleAndId;
    var id = titleAndId === null || titleAndId === void 0 ? void 0 : titleAndId.split("-").pop();
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var editedBlog = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(state) {
        return state.blog.editedBlog;
    });
    var handlePreviewClick = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var response, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $dd6590e9b3c4f775$export$fb5500896bf9f887)({
                                editedBlog: editedBlog,
                                publish: false
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        console.log("response", response);
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        return [
                            2
                        ];
                    case 2:
                        if (!!id) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        console.log("Redirecting to neww preview", data._id);
                        navigate("/blog/edit/".concat(data._id, "/preview"), {
                            replace: true
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        console.log("Redirecting to preview");
                        navigate("preview");
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePreviewClick() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $dQFEZ.useEffect)(function() {
        if (titleAndId) getBlog();
        else dispatch((0, $0588dc3366c5632f$export$a36094bd725add13)({
            title: "New Blog",
            description: "Some description",
            author: "Damyant Jain"
        }));
        return function() {
            dispatch((0, $0588dc3366c5632f$export$b1e61d1688165092)());
        };
    }, []);
    var getBlog = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var response, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat((0, $3849adb4905070fc$export$33946c87f7d00129), "/").concat(id))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) {
                            console.error("Blog not found");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        dispatch((0, $0588dc3366c5632f$export$a36094bd725add13)(data));
                        return [
                            2
                        ];
                }
            });
        });
        return function getBlog() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        className: "mx-5 md:mx-16 lg:mx-32 xl:mx-44 dark:bg-[#121212] min-h-screen",
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-5",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
                        className: "text-2xl font-bold text-gray-800 dark:text-gray-200",
                        children: "Edit Blog"
                    }),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                        onClick: handlePreviewClick,
                        className: "bg-gray-800 py-2 px-3 text-white rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                        children: "Save & Preview"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                className: "mx-auto px-4 w-full dark:bg-[#2222222d] rounded-xl p-6 border border-gray-200 dark:border-0 mb-6",
                children: [
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $b946f8b49fc8c21d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $075cb3b163bd999f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $9517e04b1e91fd09$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $7adf1ed41712770d$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $b3481cf29e31c47a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $90f9e4dc55f58a4b$export$2e2bcd8739ae039 = $90f9e4dc55f58a4b$var$BlogEditHome;




var $2nwvT = parcelRequire("2nwvT");






var $dQFEZ = parcelRequire("dQFEZ");

var $91cca51e203a854d$var$ProtectedComponent = function(param) {
    var children = param.children;
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), isAuthenticated = _useState[0], setIsAuthenticated = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(true), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    (0, $dQFEZ.useEffect)(function() {
        var checkToken = function() {
            var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
                var token;
                return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            token = (0, $ec58e7758362a5e1$export$84773cc9bf7dbe87)();
                            if (!(0, $ec58e7758362a5e1$export$b007d77a962aa175)(token)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $dd6590e9b3c4f775$export$f8f36faf9a051362)()
                            ];
                        case 1:
                            token = _state.sent();
                            if (!token) {
                                setIsAuthenticated(false);
                                setIsLoading(false);
                                return [
                                    2
                                ];
                            }
                            _state.label = 2;
                        case 2:
                            setIsAuthenticated(true);
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkToken() {
                return _ref.apply(this, arguments);
            };
        }();
        checkToken();
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        children: "Loading..."
    });
    return isAuthenticated ? children : /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c3ad80f8a436e0f$export$444b3ab0cb9aec40), {
        to: "/blog/login"
    });
};
var $91cca51e203a854d$export$2e2bcd8739ae039 = $91cca51e203a854d$var$ProtectedComponent;




var $2nwvT = parcelRequire("2nwvT");



var $dQFEZ = parcelRequire("dQFEZ");

var $fw6ZE = parcelRequire("fw6ZE");
var $0db69d41fd2e922e$export$5b0f6292f11d1d18 = function(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fw6ZE))).AES.encrypt(data, "thebloominggarden").toString();
};
var $0db69d41fd2e922e$export$e85a0c9a1067c5d3 = function(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fw6ZE))).AES.decrypt(data, "thebloominggarden").toString((0, (/*@__PURE__*/$parcel$interopDefault($fw6ZE))).enc.Utf8);
};





var $368fdb9c800dd3d5$var$Login = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(""), 2), username = _useState[0], setUsername = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(""), 2), password = _useState1[0], setPassword = _useState1[1];
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var handleLoginClick = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var encryptedPassword, encryptedUsername, response, body;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        encryptedPassword = (0, $0db69d41fd2e922e$export$5b0f6292f11d1d18)(password);
                        encryptedUsername = (0, $0db69d41fd2e922e$export$5b0f6292f11d1d18)(username);
                        return [
                            4,
                            fetch((0, $3849adb4905070fc$export$86dcaf45db3d1606), {
                                method: "POST",
                                body: JSON.stringify({
                                    username: encryptedUsername,
                                    password: encryptedPassword
                                }),
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        body = _state.sent();
                        (0, $ec58e7758362a5e1$export$9bfe7023cfca0786)(body.accessToken);
                        clearFields();
                        navigate("/blog/edit");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setPassword("");
                        showMessage("Login failed");
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoginClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var clearFields = function() {
        setUsername("");
        setPassword("");
    };
    var showMessage = function(message) {
        alert(message);
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        className: "flex items-center flex-col",
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
            className: "rounded-lg dark:bg-inherit text-right",
            children: [
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                    className: "font-poppins text-center mb-10 mt-6 text-2xl text-[#333333] dark:text-[#e0e0e0]",
                    children: "Reads"
                }),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                    type: "text",
                    value: username,
                    onChange: function(e) {
                        return setUsername(e.target.value);
                    },
                    placeholder: "Username",
                    className: "mb-4 px-3 py-2 w-72 font-opensans rounded-lg ring-1 ring-gray-300"
                }),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("input", {
                    type: "password",
                    value: password,
                    onChange: function(e) {
                        return setPassword(e.target.value);
                    },
                    placeholder: "Password",
                    className: "mb-4 px-3 py-2 w-72 font-opensans rounded-lg ring-1 ring-gray-300"
                }),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                    onClick: function() {
                        return handleLoginClick();
                    },
                    className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
                    children: "Login"
                })
            ]
        })
    });
};
var $368fdb9c800dd3d5$export$2e2bcd8739ae039 = $368fdb9c800dd3d5$var$Login;




var $fcef4b8c083fb04a$var$BlogPreview = function() {
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "w-full flex items-center justify-center",
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                    className: " bg-[#feeb73] text-xl text-[#333333] text-center md:mx-0 sm:mx-10 mx-5 w-full md:w-[680px]",
                    children: "This is just a preview of the blog."
                })
            }),
            /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $b2d9f955d57ee046$export$2e2bcd8739ae039), {})
        ]
    });
};
var $fcef4b8c083fb04a$export$2e2bcd8739ae039 = $fcef4b8c083fb04a$var$BlogPreview;




var $2nwvT = parcelRequire("2nwvT");



var $dQFEZ = parcelRequire("dQFEZ");




var $8af70b6ae527eb67$var$BlogEditHome = function(param) {
    var mode = param.mode;
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), posts = _useState[0], setPosts = _useState[1];
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    (0, $dQFEZ.useEffect)(function() {
        getBlogs();
    }, []);
    var getBlogs = function() {
        var _ref = (0, $baf9b2a64fedef68$export$71511d61b312f219)(function() {
            var response, data;
            return (0, $b8c3f91e5973f862$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $74dd6d6eb2c28884$export$2e2bcd8739ae039)((0, $3849adb4905070fc$export$33946c87f7d00129))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        setPosts([]);
                        return [
                            2
                        ];
                    case 2:
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        setPosts(data);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getBlogs() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNewBlog = function() {
        navigate("/blog/edit/new");
    };
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
            className: "mx-5 md:mx-16 lg:mx-32 xl:mx-44",
            children: [
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsxs)("div", {
                    className: "flex justify-between items-start  mt-5 mb-10",
                    children: [
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("h1", {
                            className: "text-xl md:text-2xl text-[#333333] dark:text-[#e0e0e0] font-poppins",
                            children: "Edit Blog"
                        }),
                        /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("button", {
                            onClick: handleNewBlog,
                            className: "bg-gray-800 py-2 px-3 text-white rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300 dark:bg-gray-700 dark:hover:bg-gray-600",
                            children: "New Blog"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $10bada8421dfc420$export$2e2bcd8739ae039), {
                    posts: posts
                })
            ]
        })
    });
};
var $8af70b6ae527eb67$export$2e2bcd8739ae039 = $8af70b6ae527eb67$var$BlogEditHome;


var $e033973bfe6f7ef9$var$blogRoute = {
    path: "blog",
    element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $f53405fd6d4e7906$export$2e2bcd8739ae039), {}),
    children: [
        {
            path: "",
            element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $50d67a8b1b1d2665$export$2e2bcd8739ae039), {})
        },
        {
            path: "login",
            element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $368fdb9c800dd3d5$export$2e2bcd8739ae039), {})
        },
        {
            path: "edit",
            children: [
                {
                    path: "",
                    element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $91cca51e203a854d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8af70b6ae527eb67$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: "new",
                    element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $91cca51e203a854d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $90f9e4dc55f58a4b$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: ":titleAndId",
                    children: [
                        {
                            path: "",
                            element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $91cca51e203a854d$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $90f9e4dc55f58a4b$export$2e2bcd8739ae039), {})
                            })
                        },
                        {
                            path: "preview",
                            element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $91cca51e203a854d$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fcef4b8c083fb04a$export$2e2bcd8739ae039), {})
                            })
                        }
                    ]
                }
            ]
        },
        {
            path: ":titleAndId",
            element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $b2d9f955d57ee046$export$2e2bcd8739ae039), {})
        }
    ]
};
var $e033973bfe6f7ef9$export$2e2bcd8739ae039 = $e033973bfe6f7ef9$var$blogRoute;






var $cd5723275f8fb0f1$var$appStore = (0, $ca04af99794d5fdc$export$7d8a5b498da695ac)({
    reducer: {
        blog: (0, $0588dc3366c5632f$export$2e2bcd8739ae039)
    }
});
var $cd5723275f8fb0f1$export$2e2bcd8739ae039 = $cd5723275f8fb0f1$var$appStore;



var $be4aacfa9ee5643d$var$AppLayout = function() {
    var getInitialMode = function() {
        return JSON.parse(localStorage.getItem("dark"));
    };
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(getInitialMode()), 2), darkMode = _useState[0], setDarkMode = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        localStorage.setItem("dark", darkMode);
        document.body.style.backgroundColor = darkMode ? "#121212" : "";
    }, [
        darkMode
    ]);
    return /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $d7d37dc522b09008$export$2881499e37b75b9a), {
        store: (0, $cd5723275f8fb0f1$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c2bad7b63af33e9$export$2e2bcd8739ae039).Provider, {
            value: {
                darkMode: darkMode,
                setDarkMode: setDarkMode
            },
            children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)("div", {
                className: "dark:bg-[#121212] ".concat(darkMode ? "dark" : "", " "),
                children: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c3ad80f8a436e0f$export$910ae8079b2c2852), {})
            })
        })
    });
};
var $be4aacfa9ee5643d$var$appRouter = (0, $fc41d09ddc03e3ec$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)($be4aacfa9ee5643d$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $c772a6d543c030fa$export$2e2bcd8739ae039), {})
            },
            (0, $e033973bfe6f7ef9$export$2e2bcd8739ae039),
            {
                path: "*",
                element: /*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $8c3ad80f8a436e0f$export$444b3ab0cb9aec40), {
                    to: "/"
                })
            }
        ]
    }
]);
var $be4aacfa9ee5643d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8dbfa3fee6dc40a7$exports))).createRoot(document.getElementById("root"));
$be4aacfa9ee5643d$var$root.render(/*#__PURE__*/ (0, $d8ffb49eb4cd7afd$exports.jsx)((0, $fc41d09ddc03e3ec$export$323e4fc2fa4753fb), {
    router: $be4aacfa9ee5643d$var$appRouter
}));

})();
//# sourceMappingURL=index.a31dfc3b.js.map
